(function() {
    'use strict';

    angular
        .module('fews', [
            'ngAnimate',
            'ngSanitize',
            'ngMessages',
            'ngAria',
            'ui.router',
            'ngMaterial',
            'satellizer',
            'nemLogging', // required by ui-leaflet
            'ui-leaflet',
            'angularMoment',
            'md.data.table',

            // Custom
            'rules',
            'ack', // needed for alerts
            'dashboard',
            'watchpoints'
        ]);

})();

(function() {
  'use strict';

  angular.module('fews').component('watchpointsLegend', {
    controller: wpLegendController,
    controllerAs: 'wpLegendVm',
    templateUrl: 'app/components/dashboard/dashpanel/components/watchpoints/watchpoints-legend/wp-legend.tmpl.html',
    bindings: {
      data: '<',
      dtmap: '<'
    }
  });

  /*@ngInject*/
  function wpLegendController() {
    var wpLegendVm = this;

    angular.extend(wpLegendVm, {
      $onChanges: changes,
      dtMap: undefined,
      types: undefined
    });

    function changes(changesobj){
      if (changesobj.hasOwnProperty('dtmap')) {
        wpLegendVm.dtMap = changesobj['dtmap'].currentValue;
      }
      if (changesobj.hasOwnProperty('data')) {
        wpLegendVm.types = changesobj['data'].currentValue.inputs;
        if (wpLegendVm.types) {
          wpLegendVm.types = wpLegendVm.types.filter(function(d){
            var type = wpLegendVm.dtMap[d].name.toLowerCase();
            var re = /flow/;
            return !re.test(type);
          });
        }
      }
      return;
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('fews')
    .factory('selectedFactory', selectedFactory);

  /*@ngInject*/
  function selectedFactory () {

    var factory = {
        chartConfig: chartConfig
    };

    return factory;

    function chartConfig(anchorName) {
      return {
        bindto: anchorName || '#wp-chart',
        data: {
          columns: [],
          order: null
        },
        axis: {
          x: {
            type: 'timeseries',
            tick: {
              fit: false,
              //format: function (d) {return moment.tz(d, timezone).format('HH:mm MM/DD');},
              format: '%H:%M %m/%d',
              width: 50,
              outer:false
            }
          },
          y: {
            tick: {
              format: d3.format('.1f'),
              outer:false
            },
            padding: { top:0, bottom:0 }
          }
        },
        legend: { show: false },
        grid: {
          x: {
            show:true,
            lines: []
          },
          y: { show:true }
        },
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 35
        },
        transition: { duration: null }
      };
    }

    // function xhrComplete(response) {
    //     return $q.resolve(response.data);
    // }

    // function xhrFailed(error) {
    //     $log.error(error);
    //     return $q.reject(error);
    // }

  }

})();

(function() {
    'use strict';
    angular
        .module('dashboard', ['afkl.lazyImage']);
})();

(function() {
  'use strict';

  var component = {
    controller: selectedWpController,
    controllerAs: 'vm',
    bindings: {
        point: '<'
    },
    templateUrl: 'app/components/dashboard/dashpanel/components/watchpoints/selected-point/selected.tmpl.html'
  };

  angular
    .module('dashboard')
    .component('selectedPoint', component);

  /*@ngInject*/
  function selectedWpController($scope, $timeout, wpFactory,
    notificationFactory, selectedFactory) {
    var vm = this;
    var chart, timer;

    angular.extend(vm, {
      loading: true,
      $onInit: activate,
      $onChanges: onChanges,
      $onDestroy: onDestroy
    })

    ////////////////

    function activate() { startTabListen(); }

    function onChanges(changesObj) {
      if (changesObj.point.previousValue.id === changesObj.point.currentValue.id) {
        return;
      } else if (angular.equals({}, changesObj.point.previousValue)) {
        initializeChart();
      } else {
        changePoint();
      }
    }

    function initializeChart() {
      if (!angular.equals({}, vm.point)) {
        var config = selectedFactory.chartConfig();

        angular.extend(config, {
          oninit: function() {vm.initialized = true;}
        });

        chart = c3.generate(config);
        updateChart();
        startTimer(updateChart);
      }
    }

    function changePoint() {
      vm.loading = true;
      wpFactory.rawData(vm.point.id).then(mergeData, errorData);
    }

    function updateChart() {
      if (!angular.equals({}, vm.point)) {
        wpFactory.rawData(vm.point.id).then(mergeData, errorData);
      }
    }

    function mergeData(raw) {
      var range = {
        min: {
          y: raw.axis.y.min
        },
        max: {
          y: raw.axis.y.max
        }
      };

      chart.xgrids([{
        value: new Date(),
        text: 'Now: ' + new moment().format('HH:mm')
      }]);
      raw.data.unload = true;
      chart.load(raw.data);
      chart.axis.range(range);
      $timeout(setRegions, 250);
      vm.loading = false;
    }

    function errorData() {
      vm.loading = false;
      vm.point.hasError = true;
      notificationFactory.sendGenericError();
    }

    function setRegions() {
      if (vm.point.stageWatchLevel !== null && vm.point.stageWarningLevel !== null) {
        chart.regions([
          {
            axis: 'y',
            start: vm.point.stageWatchLevel,
            end: vm.point.stageWarningLevel,
            class: 'wp-watch'
          },{
            axis: 'y',
            start: vm.point.stageWarningLevel,
            class: 'wp-warn'
          }
        ]);
      } else if (vm.point.stageWarningLevel !== null) {
        chart.regions([{
          axis: 'y',
          start: vm.point.stageWarningLevel,
          class: 'wp-warn'
        }]);
      } else if (vm.point.stageWatchLevel !== null) {
        chart.regions([{
          axis: 'y',
          start: vm.point.stageWatchLevel,
          class: 'wp-watch'
        }]);
      } else {
        chart.regions.remove();
      }
    }

    function startTimer(cb) {
      var startTime = new Date();

      if (startTime.getMinutes() % 5 === 0) {
        timer = $timeout(loop, 60000);
      } else {
        loop();
      }

      function loop() {
        var now = new Date();
        if (now.getMinutes() % 5 === 0) {
            cb();
        }
        now = new Date(); // allow for time passing
        var delay = 300000 - (now % 300000) + 2000; // exact ms to next 5 minute 2 second interval
        timer = $timeout(loop, delay);
      }
    }

    function onDestroy() {
      $timeout.cancel(timer);
    }

    function startTabListen() {
      $scope.$on('dpanelTab:components', function () {
        if (vm.initialized) chart.flush();
      });
    }
  }
})();

(function() {
  'use strict';

  var component = {
    controller: watchpointsController,
    controllerAs: 'wpVm',
    bindings: {
      nowTime: '<'
    },
    templateUrl: 'app/components/dashboard/dashpanel/components/watchpoints/watchpoints.tmpl.html'
  };

  angular
    .module('dashboard')
    .component('watchPoints', component);

  /*@ngInject*/
  function watchpointsController(
      $scope, $document, $interval, $window, $timeout, $compile, $httpParamSerializer,
      $mdDialog, $mdMedia, leafletData, $mdPanel, $auth, API_URL,
      wpFactory, replayFactory, notificationFactory, projectInfo, prefFactory) {
    var wpVm = this;
    angular.extend(wpVm, {
      wpGIF: false,
      accesstoken: $auth.getToken(),
      isSmartPhone: SmartPhone.isAny,
      selected: {},
      wpPopSelected: {},
      container: {
          width: 400
      },
      showGrid: $mdMedia('gt-xs'),
      updateCheck: undefined,
      cacheControl: updateCacheString(),
      infoDialog: infoDialog,
      locateOnMap: locateOnMap,
      selectPoint: selectPoint,
      basinMap: {},
      $onInit: activate,
      $onChanges: onChanges,
      $onDestroy: onDestroy,
      $mdMedia: $mdMedia,
      startListeners: startListeners,
      listeners: [],
      map: undefined,
      timeParams: {
        ani: {},
        static: {}
      },
      replay: replayFactory,
      openSortMenu: openSortMenu,
      watchPoints: [],
      windowFocus: false,
      thumbsUrl: thumbsUrl,
      thumbsWidth: thumbsWidth,
      sortOptions: {
        direction: true,
        selected: undefined,
        options: [
          {
            name: 'Status',
            value: 'sortStatus'
          },
          {
            name: 'Name',
            value: 'displayName'
          },
          {
            name: 'Watershed',
            value: 'basinDCM'
          },
          {
            name: 'Gauge Owner',
            value: 'owner'
          }
        ]
      }
    });

    ////////////////

    function activate() {
      if (prefFactory.isSaved()) {
        var wpIsGif = prefFactory.getPreferenceByID('wp-gif');
        wpVm.wpGIF = wpIsGif.value;
      }

      wpVm.sortOptions.selected = wpVm.sortOptions.options[0];
      wpVm.sortOptions.direction = true;

      wpFactory.retrieve().then(wpLoad, wpError);
      projectInfo.getDetails().then(function(data){
        wpVm.basinsMap = data.basins;
      });

      setPanelWidth();

      angular.element($window).on('resize', onResize);
      angular.element($window).on('focus', onFocus);
      angular.element($window).on('blur', onBlur);
      $scope.$on('toggle-components', function(e, a) {
        if(a.panelOpen === true)
          $timeout(function(){
            setPanelWidth();
          });
      });

      leafletData.getMap('dashmap').then(function(d){
        wpVm.map = d;
        startListeners();
      });

    }

    function startListeners() {
      wpVm.listeners.push($scope.$on('wpClick', function(event, data) {
        wpVm.popSelected = wpVm.watchPoints.find(function(d){
          return d.id === data.model.id;
        });

        data.model.status = transformStatus(wpVm.popSelected.status);
        data.model.basin = wpVm.basinsMap[wpVm.popSelected.basin].description;
        data.model.owner = wpVm.popSelected.owner;

        // var e = $compile('<wp-pop model="wpVm.popSelected"></wp-pop>')($scope);
        var e = $compile(
          '<div class="chart-popup wp">' +
            '<h3>'+ data.model.name +'</h3>' +
            '<p><span>'+ data.model.id +'</span><span>'+ data.model.basin +'</span><span class="no-line">'+ data.model.owner +'</span><br /><span class="no-line">Status: '+ data.model.status +'</span></p>' +
            '<div class="md-whiteframe-1dp chart" ng-click="wpVm.infoDialog(wpVm.popSelected, $event)">'+
              '<img src="assets/images/loading_icon.gif" ng-src="' + wpVm.popSelected.endpoint.url + '.png?' + wpVm.popSelected.endpoint.static +'&style=THUMBNAIL&height=124&width=280&r=' + Date.now() + '&accesstoken='+ wpVm.accesstoken +'" err-src="/assets/images/error_icon.png" width="280" />' +
              '<div class="md-icon-help"><md-icon>fullscreen</md-icon><md-tooltip>More Info</md-tooltip></div>'+
            '</div>'+
          '</div>'
        )($scope);
        var wpPop = L.popup().setContent(e[0]);

        data.leafletObject.bindPopup(wpPop).openPopup();
      }));
    }

    function onChanges(changesObj) {
      if (changesObj.nowTime) {
        var time = wpVm.nowTime;
        wpVm.timeParams = {
          ani: {
            start: time - (1000 * 60 * 60 * 6),
            fakeNowStart: time - (1000 * 60 * 60 * 2),
            fakeNowEnd: time,
            end: time + (1000 * 60 * 60 * 14)
          },
          static: {
            start: time - (1000 * 60 * 60 * 6),
            fakeNow: time,
            end: time + (1000 * 60 * 60 * 14)
          }
        };

        if (!changesObj.nowTime.isFirstChange()) {
          wpVm.loadingNewTime = true;
          wpVm.cacheControl = updateCacheString();
          updateUrls();
          updateStatuses();
        }

        if (replayFactory.isActive() && angular.isDefined(wpVm.updateCheck)) {
            startUpdateCheck();
        } else if (!replayFactory.isActive() && angular.isUndefined(wpVm.updateCheck)) {
            startUpdateCheck();
        }
      }
    }

    function wpLoad (data) {
      angular.extend(wpVm, data);
      updateStatuses();
      updateUrls();
    }

    function wpError () {
      notificationFactory.sendGenericError();
    }

    function selectPoint(point, ev) {
      wpVm.selected = {};
      // needs timeout to wait for digest
      // to trigger loading gif on image
      $timeout(function() {
        if (angular.isUndefined(point)) {
          point = wpVm.watchpoints[0];
          for (var i = 1; i < wpVm.watchpoints.length; i++) {
            if (wpVm.watchpoints[i].sortStatus > point.sortStatus) {
              point = wpVm.watchPoints[i];
            }
          }
        }

        wpVm.selected = point;

        if($mdMedia('xs')) {
          infoDialog(wpVm.selected, ev);
          return;
        }

        $document[0].querySelectorAll("#wp-container")[0].scrollTop = 0;
      });
    }

    function updateCacheString() {
      wpVm.cacheTime = new Date().getTime();
      return '&r=' + wpVm.cacheTime;
    }

    function updateStatuses() {
      if (replayFactory.isActive()) {
        var timeParams = wpVm.timeParams.static;
      }

      wpFactory.statusUpdate(false, timeParams).then(function(data) {
        var reverseKeyValues = {};
        var topStatusWP;

        angular.forEach(data.typePriority, function(value, key) {
          reverseKeyValues[value] = +key;
        });

        wpVm.watchPoints = wpVm.watchPoints.map(function(d) {
          d.sortStatus = reverseKeyValues[data.status[d.id].status];
          d.status = data.status[d.id].status;
          d.maximums = Object.keys(data.status[d.id].maximums).map(function(key){ return data.status[d.id].maximums[key]; });

          if (angular.isUndefined(topStatusWP) || d.sortStatus >= topStatusWP.sortStatus) {
            topStatusWP = d;
          }

          return d;
        });

        if (angular.equals({}, wpVm.selected) && $mdMedia('gt-xs')) selectPoint(topStatusWP);
      });
    }

    function thumbsUrl() {
      var dpr = $window.devicePixelRatio;
      wpVm.checkedDPR = dpr < 1 ? 1 : Math.floor(dpr);

      var params = $httpParamSerializer({
        ghostLines: true,
        pixelRatio: wpVm.checkedDPR,
        style: 'THUMBNAIL',
        height: 75,
        width: thumbsWidth(),
        accesstoken: $auth.getToken()
      });

      params += '&' + $httpParamSerializer(wpVm.timeParams.static);

      var url = API_URL + 'hydrographs/height_chart.png?' + params;

      return url;
    }

    function thumbsWidth() {
      if(wpVm.container.width > 48) {
        return (wpVm.container.width / 2) - 24;
      } else {
        return null;
      }
    }

    function updateUrls() {
      wpVm.watchPoints.forEach(function(point) {
        point.endpoint = wpFactory.imageUrl(point, wpVm.timeParams);
        //angular.extend(point, { endpoint: wpFactory.imageUrl(point, wpVm.timeParams) });
      });

      // need digest cycle for loaders to show, hence the timeout
      $timeout(function() {wpVm.loadingNewTime = false;});
    }

    function startUpdateCheck () {
      if (angular.isDefined(wpVm.updateCheck)) {
        $interval.cancel(wpVm.updateCheck);
        wpVm.updateCheck = undefined;
        return;
      }

      wpVm.updateCheck = $interval(fn, (1000 * 60 * 2.5), false);

      function fn () {
        wpVm.cacheControl = updateCacheString();
        updateStatuses();
      }
    }

    function setPanelWidth () {
      var selection = $document[0].querySelectorAll('watch-points')[0];

      if (!selection || selection.clientWidth < 2) return;

      var width = selection.clientWidth;
      if(width % 2 === 1) width--;

      wpVm.container.width = width;
    }

    function onResize() {
      if(angular.isDefined(wpVm.resizeTimer))
        $timeout.cancel(wpVm.resizeTimer);

      wpVm.resizeTimer = $timeout(function() {
        setPanelWidth();
      }, 500);

    }

    function onFocus() {wpVm.windowFocus = true;}
    function onBlur() {wpVm.windowFocus = false;}

    function openSortMenu(ev) {
      var position = $mdPanel.newPanelPosition()
        .relativeTo('.sort-button')
        .addPanelPosition($mdPanel.xPosition.ALIGN_END, $mdPanel.yPosition.BELOW);

        var config = {
          attachTo: angular.element($document[0].body),
          controller: sortMenuCtrl,
          controllerAs: 'ctrl',
          template:
              '<div class="sort-menu" ' +
              '    aria-label="Sort watchpoints options." ' +
              '    role="listbox">' +
              '  <div class="sort-menu--item" ' +
              '      aria-selected="{{option == ctrl.sortOptions.options}}" ' +
              '      tabindex="-1" ' +
              '      role="option" ' +
              '      ng-repeat="option in ctrl.sortOptions.options" ' +
              '      ng-click="ctrl.selectOption(option)">' +
              '    {{ option.name }}' +
              '    <md-icon ng-show="ctrl.sortOptions.selected.value == option.value">{{ctrl.sortOptions.direction ? "arrow_downward" : "arrow_upward"}}</md-icon>' +
              '  </div>' +
              '</div>',
          panelClass: 'sort-menu',
          position: position,
          locals: {
            'sortOptions': wpVm.sortOptions
          },
          openFrom: ev,
          clickOutsideToClose: true,
          escapeToClose: true,
          focusOnOpen: false,
          zIndex: 100
        };

        $mdPanel.open(config);
    }

    function sortMenuCtrl(){
      this.selectOption = function(option){
        if (option !== wpVm.sortOptions.selected) {
          wpVm.sortOptions.direction = false;
        } else {
          wpVm.sortOptions.direction = !wpVm.sortOptions.direction;
        }
        wpVm.sortOptions.selected = option;
      }
    }

    function infoDialog(point, ev) {
      $mdDialog.show({
        controller: watchpointInfoController,
        controllerAs: 'wpInfoVm',
        templateUrl: 'app/components/dashboard/dashpanel/components/watchpoints/infoDialog.tmpl.html',
        parent: angular.element($document[0].body),
        targetEvent: ev,
        fullscreen: $mdMedia('gt-sm') ? false : true,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          accesstoken: wpVm.accesstoken,
          mdDialog: $mdDialog,
          point: point,
          cacheControl: wpVm.cacheControl,
          basinDisplayName: wpVm.basinsMap[point.basin].description,
          mdMedia: $mdMedia
        },
        bindToController: true
      });
    }

    function locateOnMap(point) {
      wpVm.map.setZoom(18, {
          animate: false
        }).panTo([point.latitude, point.longitude], {
          animate: true,
          duration: 0.75
      });
    }

    /*@ngInject*/
    function watchpointInfoController ($scope, $document, $timeout, wpFactory) {
      var wpInfoVm = this;
      angular.extend(wpInfoVm, {
        $onInit: activate,
        chart: undefined,
        ready: false,
        switchChart: switchChart,
        interactive: {
          ready: false,
          show: false
        }
      });

      function activate() {

        wpInfoVm.endpoint = wpFactory.imageUrl(wpInfoVm.point, wpVm.timeParams);

        wpInfoVm.point.currentStatus = transformStatus(wpInfoVm.point.status);
        wpInfoVm.ready = true;
        $timeout(function(){
          setWidth();
        });

      }

      function setWidth() {
        wpInfoVm.chartWidth = $document[0].getElementById('wp-chart').clientWidth;
      }

      function switchChart() {
        var timeParams;
        var nowTime = new Date();
        var replay = replayFactory.isActive();
        if(wpInfoVm.interactive.show === true) {
          wpInfoVm.interactive.ready = false;
          if (replay) {
            timeParams = wpVm.timeParams.static;
            nowTime = new Date(timeParams.fakeNow);
          }
          wpFactory.rawData(wpInfoVm.point.id, timeParams).then(function(raw) {
            var config = wpFactory.chartConfig('#c3Hydro');
            angular.merge(config, {
              oninit: function() {
                wpInfoVm.interactive.ready = true;
              },
              data: raw.data,
              axis: {
                y: {
                  label: 'Stage (ft)',
                  min: raw.axis.y.min,
                  max:raw.axis.y.max
                }
              },
              grid: {
                x: {
                  lines: [{
                    value: nowTime,
                    text: 'Now: ' + new moment(nowTime).format('HH:mm')
                  }]
                },
                y: raw.grid ? { lines: raw.grid.y.lines.map(function(l) {
                  l.class = 'rule';
                  return l;
                }) } : {}
              },
              regions: [
                {
                  axis: 'y',
                  start: wpInfoVm.point.stageWatchLevel,
                  end: wpInfoVm.point.stageWarningLevel,
                  class: 'wp-watch'
                },{
                  axis: 'y',
                  start: wpInfoVm.point.stageWarningLevel,
                  class: 'wp-warn'
                }
              ],
              zoom: { enabled: true }
            });

            wpInfoVm.chart = c3.generate(config);
          });
        }
      }
    }

    function transformStatus(statusString) {
      return statusString.replace(/([A-Z])/g, ' $1').replace(/^./, function(str){ return str.toUpperCase(); }).trim();
    }

    function onDestroy() {
      if(angular.isDefined(wpVm.updateCheck)) {
        startUpdateCheck();
      }
      angular.element($window).off('resize', onResize);
      angular.element($window).off('focus', onFocus);
      angular.element($window).off('blur', onBlur);
      wpVm.listeners = [];
      $interval.cancel(wpVm.updateCheck);
    }
  }
})();

(function() {
  'use strict';

  angular.module('fews')
    .factory('previeuxFactory', previeuxFactory);

  function previeuxFactory($http, $log, $q, API_URL, VDS_URL) {
    var factory = {
      getBasinCenter: getBasinCenter,
      getRadar: getRadar,
      getMask: getMask,
      getBounds: getBounds,
      getMaxbounds: getMaxbounds,
      getInfo: getInfo,
      projectDetails: projectDetails,
      calcCenterFromBounds: calcCenterFromBounds,
      getVisibleTileCoords: getVisibleTileCoords
    };

    return factory;

    //////////////////////

    function getBasinCenter(mapWidth, mapHeight) {

      var req = {
        method: 'GET',
        url: API_URL + VDS_URL + 'previeux/basins/center',
        headers: {
          'Content-Type': 'application/json'
        },
        params: {
          width: mapWidth,
          height: mapHeight
        }
      };

      /* gets map center info */
      return $http(req).then(function(response) {
        response.data.zoom = Math.round(response.data.zoom);
        return xhrComplete(response);
      }, xhrFailed);
    }

    function getRadar(mapId) {

      var req = {
        method: 'GET',
        url: API_URL + VDS_URL + 'previeux/legacy/' + mapId + '/input.json',
        headers: {
          'Content-Type': 'application/json'
        }
      };

      /* gets map center info */
      return $http(req).then(xhrComplete, xhrFailed);
    }

    function getMask(mapId) {
      /* gets geojson of domain boundary */
      return $http.get(API_URL + VDS_URL + 'map/radar/' + mapId + '/rangering').then(function(response) {
        var domain = {
          'data': response.data,
          'style': {
            'fillColor': "black",
            'stroke': false,
            'fillOpacity': 0.35
          }
        };
        domain.data.properties = {};
        return $q.resolve(domain);
      }, xhrFailed);
    }

    function getBounds(mapId) {

      var req = {
        method: 'GET',
        url: API_URL + VDS_URL + 'map/radar/' + mapId + '/bounds',
        headers: {
          'Content-Type': 'application/json'
        }
      };

      /* gets map center info */
      return $http(req).then(xhrComplete, xhrFailed);
    }

    // only works for North American latlongs
    function getMaxbounds(bounds) {

      var latSize = (bounds.southWest.lat - bounds.northEast.lat) / 2;
      var lngSize = (bounds.southWest.lng - bounds.northEast.lng) / 2;

      var maxbounds = {
        northEast: {
          lat: bounds.northEast.lat - latSize,
          lng: bounds.northEast.lng - lngSize
        },
        southWest: {
          lat: bounds.southWest.lat + latSize,
          lng: bounds.southWest.lng + lngSize
        }
      }

      return maxbounds;
    }

    function getInfo(mapId) {
      var req = {
        method: 'GET',
        url: API_URL + VDS_URL + 'previeux/' + mapId + '/latest/info',
        headers: {
          'Content-Type': 'application/json'
        }
      };

      return $http(req).then(xhrComplete, xhrFailed);
    }

    function projectDetails(mapId) {
      var req = {
        method: 'GET',
        url: API_URL + VDS_URL + 'previeux/' + mapId + '/projectdetails',
        headers: {
          'Content-Type': 'application/json'
        }
      };

      return $http(req).then(xhrComplete, xhrFailed);
    }

    // only works for North American latlongs
    function calcCenterFromBounds(bounds) {

      var latPoint = (bounds.southWest.lat + bounds.northEast.lat) / 2;
      var lngPoint = (bounds.southWest.lng + bounds.northEast.lng) / 2;

      var center = {
        lat: latPoint,
        lng: lngPoint
      }

      return $q.resolve(center);
    }

    function getVisibleTileCoords(map) {

      // get bounds, zoom and tileSize
      var bounds = map.getPixelBounds();
      var zoom = map.getZoom();
      var tileSize = 256;
      var tileCoordsContainer = [];

      // get NorthWest and SouthEast points
      var nwTilePoint = new L.Point(Math.floor(bounds.min.x / tileSize), Math.floor(bounds.min.y / tileSize));

      var seTilePoint = new L.Point(Math.floor(bounds.max.x / tileSize), Math.floor(bounds.max.y / tileSize));

      // get max number of tiles in this zoom level
      var max = map.options.crs.scale(zoom) / tileSize;

      // enumerate visible tiles
      for (var x = nwTilePoint.x; x <= seTilePoint.x; x++) {
        for (var y = nwTilePoint.y; y <= seTilePoint.y; y++) {
          var xTile = Math.abs(x % max);
          var yTile = Math.abs(y % max);

          tileCoordsContainer.push({'x': xTile, 'y': yTile});
        }
      }

      return $q.resolve(tileCoordsContainer);

    }

    function xhrComplete(response) {
      return $q.resolve(response.data);
    }

    function xhrFailed(error) {
      return $q.reject(error);
    }
  }
})();

(function() {
  'use strict';
  angular.module('fews').factory('p2nMapFactory', p2nMapFactory);

  /*@ngInject*/
  function p2nMapFactory($rootScope, $q, $http, $log, API_URL) {
    var scenario;
    var service = {
      broadcastScenario: broadcastScenario,
      getScenario: getScenario,
      getVisibleTileCoords: getVisibleTileCoords,
      getBasinSummaries: getBasinSummaries
    };
    return service;
    ////////////////
    function broadcastScenario(utfBin) {
      scenario = angular.copy(utfBin);
      $rootScope.$broadcast('Scenario');
    }

    function getScenario() {
      var deferred = $q.defer();
      if (angular.isDefined(scenario)) {
        deferred.resolve(scenario);
      } else {
        deferred.reject();
      }
      return deferred.promise;
    }

    function getBasinSummaries(timeOfSummary) {
      var req = {
        method: 'GET',
        url: API_URL + 'scenario/basin/summaries',
        headers: {
          'Content-Type':'application/json'
        }
      };

      if (timeOfSummary) {
        angular.extend(req, {
          params: {
            'datetime': timeOfSummary.getTime()
          }
        })
      }

      return $http(req).then(xhrComplete, xhrFailed);
    }

    function getVisibleTileCoords(map) {

      // get bounds, zoom and tileSize
      var bounds = map.getPixelBounds();
      var zoom = map.getZoom();
      var tileSize = 256;
      var tileCoordinateObject = {
        zoom: zoom,
        xy: []
      };

      // get NorthWest and SouthEast points
      var nwTilePoint = new L.Point(Math.floor(bounds.min.x / tileSize), Math.floor(bounds.min.y / tileSize));

      var seTilePoint = new L.Point(Math.floor(bounds.max.x / tileSize), Math.floor(bounds.max.y / tileSize));

      // get max number of tiles in this zoom level
      var max = map.options.crs.scale(zoom) / tileSize;

      // enumerate visible tiles
      for (var x = nwTilePoint.x; x <= seTilePoint.x; x++) {
        for (var y = nwTilePoint.y; y <= seTilePoint.y; y++) {
          var xTile = Math.abs(x % max);
          var yTile = Math.abs(y % max);

          tileCoordinateObject.xy.push({'x': xTile, 'y': yTile});
        }
      }

      return $q.resolve(tileCoordinateObject);

    }

    function xhrComplete(response) {
      return $q.resolve(response.data.summariesByBasin);
    }

    function xhrFailed(error) {
      $log.error(error);
      return $q.reject(error);
    }

  }
})();

(function() {

  'use strict';

  var component = {
    controller: p2nMapController,
    controllerAs: 'p2nVm',
    bindings: {
      nowTime: '<'
    },
    templateUrl: 'app/components/dashboard/dashpanel/components/p2n-map/p2nMap.tmpl.html'
  };

  angular.module('dashboard')
    .component('p2nMap', component);

  /*@ngInject*/
  function p2nMapController(
      $q, $log, $rootScope, $scope, $compile, $interval, $timeout,
      $mdMedia, $auth, leafletData, projectInfo, baselayerFactory, timeFactory,
      basinGeo, ddfFactory, prefFactory, p2nMapFactory, previeuxFactory,
      replayFactory, tileFactory, API_URL, VDS_URL) {

    var p2nVm = this,
      deregCallbacks = [],
      map = undefined,
      updateCheck = undefined,
      model2Bag = {},
      sixtyMin = (1000 * 60 * 60);

    angular.extend(p2nVm, {
      $onInit: activate,
      $onChanges: onChanges,
      $onDestroy: onDestroy,
      $postLink: refreshMap,
      timeParams: {
        start: undefined,
        end: undefined
      },
      ddfStatus: {},
      threatCategories: {},
      activateScenario: activateScenario,
      hoveredBasin: '',
      checkDuration: (1000 * 60 * 2.5),
      defaults: {
        zoomControl: false,
        minZoom: 8,
        attributionControl: false,
        tap: false,
        fadeAnimation: false
      },
      layers: {
        baselayers: {},
        overlays: {}
      },
      selected: {},
      scaleUrl: API_URL + VDS_URL + 'ddf/scale/142/32/172.png?accesstoken=' + $auth.getToken(),
      lastInterval: undefined,
      loading: true,
      flashing: L.layerGroup(),
      activateDDF: activateDDF,
      activatePrevieux: activatePrevieux,
      stopPrevieux: stopPrevieux,
      animatePrevieux: animatePrevieux,
      preActive: false,
      replayActive: replayFactory.isActive,
      getStatus: getStatus,
      previeux: {
        basinID: 'pv_rv_basin_master',
        animation: undefined,
        radars: [
          {id: 'austin_pv',status: 1}],
        activeRadar: 'austin_pv',
        frame: 0,
        visibleTime: undefined,
        basinGeojson: undefined,
        preloadImages: []
      }
    })

    ////////////////

    function activate() {
      var starterRequests = [
        leafletData.getMap('p2n'),
        projectInfo.getBasins('Vflo'),
        baselayerFactory.getDirectory(),
        previeuxFactory.projectDetails(p2nVm.previeux.activeRadar),
        previeuxFactory.getInfo(p2nVm.previeux.activeRadar),
        basinGeo.getGeo(p2nVm.previeux.basinID),
        projectInfo.getDetails()
      ];

      startMapListeners();

      // need this $timeout for layers to get
      // added when navigating away and back
      $timeout(function() {
        $q.all(starterRequests).then(prepMap);
      });
    }

    function onChanges(changesObj) {
      if (changesObj.nowTime) {
        var time;

        if (replayFactory.isActive()) {
          time = p2nVm.nowTime;
          if (map) map.closePopup();
          if (p2nVm.preActive) activateDDF();
          if (angular.isDefined(updateCheck)) toggleUpdateCheck();
        } else {
          time = timeFactory.getLastInterval(15).getTime();
          if (angular.isUndefined(updateCheck)) toggleUpdateCheck();
        }

        p2nVm.timeParams.start = time - sixtyMin;
        p2nVm.timeParams.end = time;

        updateTableStatuses();

        if (!changesObj.nowTime.isFirstChange()) {
          angular.forEach(p2nVm.layers.overlays, function(overlay) {
            overlay.doRefresh = true;
          });
        }
      }
    }

    function prepMap(data) {
      p2nVm.previeux.bounds = data[3].bounds;
      p2nVm.previeux.radarInfo = data[4];
      model2Bag = data[6].vdsconfiguration.basinModelKeyToBAGIDMap;
      p2nVm.previeux.activeRadar = p2nVm.previeux.radars[0].id;
      p2nVm.previeux.radars[0].active = 1;
      p2nVm.previeux.basinGeojson = L.geoJson(data[5].data, {
        style: function(){
          return {
            fillColor: 'transparent',
            weight: 0.5,
            opacity: 1,
            color: 'white',
            fillOpacity: 0
          }
        }
      });

      map = data[0];
      p2nVm.flashing.addTo(map);
      map.invalidateSize();

      projectInfo.getDomainBounds(data[1]).then(function(domainBounds) {
        var maxBounds = [
          [domainBounds[0][0] - 0.5, domainBounds[0][1] - 1],
          [domainBounds[1][0] + 0.5, domainBounds[1][1] + 1]
        ];

        // prep map position
        map.fitBounds(domainBounds);
        map.setMaxBounds(maxBounds);

        // set up baselayer
        var bls = data[2];

        var style = bls.styles[0];
        if (prefFactory.isSaved()) {
          $q.resolve(prefFactory.getBaselayer()).then(function(data) {
            style = data.baselayer;
          });
        }

        baselayerFactory.buildLayer(style).then(function(data) {
          p2nVm.layers.baselayers['base'] = data;
        });

        // set up overlay
        p2nVm.lastInterval = timeFactory.getLastInterval(15).getTime();

        p2nVm.layers.overlays.p2nLayer1 = {
          name: 'ddfZone1',
          url: API_URL + 'vieux-data-services/austin/ddf/tiles/142/{start}/{end}/{z}/{x}/{y}.png?accesstoken={accesstoken}',
          type: 'xyz',
          visible: true,
          layerParams: angular.extend(p2nVm.timeParams, {
            accesstoken: $auth.getToken(),
            showOnSelector: false
          }),
          options: {
            opacity: 1,
            bounds: domainBounds
          }
        };
        p2nVm.layers.overlays.p2nLayer2 = {
          name: 'ddfZone2',
          url: API_URL + 'vieux-data-services/austin/ddf/tiles/143/{start}/{end}/{z}/{x}/{y}.png?accesstoken={accesstoken}',
          type: 'xyz',
          visible: true,
          layerParams: angular.extend(p2nVm.timeParams, {
            accesstoken: $auth.getToken(),
            showOnSelector: false
          }),
          options: {
            opacity: 1,
            bounds: domainBounds
          }
        };

        p2nVm.layers.overlays.utf = {
          name: 'utfBasins',
          url: API_URL + 'layers/ddf_basin_master/tiles/{z}/{x}/{y}.json?accesstoken={accesstoken}',
          type: 'utfGrid',
          visible: true,
          pluginOptions: {
            bounds: domainBounds,
            useJsonP: false,
            accesstoken: $auth.getToken()
          },
          layerParams: { showOnSelector: false }
        };

        activateDDF();
      });
    }

    function toggleUpdateCheck() {
      if (angular.isDefined(updateCheck)) {
        $interval.cancel(updateCheck);
        updateCheck = undefined;
        return;
      }

      updateCheck = $interval(fn, p2nVm.checkDuration, false);

      function fn() {

        if (p2nVm.preActive) {
          var previeuxRequests = [
            previeuxFactory.getInfo(p2nVm.previeux.activeRadar),
            p2nMapFactory.getVisibleTileCoords(map)
          ];

          $q.all(previeuxRequests).then(function(data){
            loadNewPrevieux(data[0], data[1]);
          });
        }

        var lastInterval = timeFactory.getLastInterval(15).getTime();
        updateTableStatuses();

        var ddfLayer = p2nVm.layers.overlays.p2nLayer1;
        if (ddfLayer.layerParams.end < lastInterval) {
          ddfLayer.layerParams.start = lastInterval - sixtyMin;
          ddfLayer.layerParams.end = lastInterval;
          ddfLayer.doRefresh = true;
          p2nVm.layers.overlays.p2nLayer1.doRefresh = true;
        }
        var ddfLayer2 = p2nVm.layers.overlays.p2nLayer2;
        if (ddfLayer2.layerParams.end < lastInterval) {
          ddfLayer2.layerParams.start = lastInterval - sixtyMin;
          ddfLayer2.layerParams.end = lastInterval;
          ddfLayer2.doRefresh = true;
          p2nVm.layers.overlays.p2nLayer2.doRefresh = true;
        }

        return;
      }
    }

    function utfGridClick(event, leafletEvent) {
      // the UTFGrid information is on leafletEvent.data
      if (leafletEvent.target._container.id === 'p2n' && leafletEvent.data !== null) {
        p2nVm.selected = angular.extend({}, leafletEvent.data, p2nVm.ddfStatus[model2Bag[leafletEvent.data.id]]);
        var content = '<div class="p2n-popup-inner" layout layout-align="start center" ng-include="\'app/components/dashboard/dashpanel/components/p2n-map/popup.tmpl.html\'"></div>';
        var compiled = $compile(content)($scope);
        var popupOptions = {
          closeButton: false,
          autoPan: true,
          className: 'p2n-popup',
          minWidth: 180
        };

        L.popup(popupOptions).setLatLng(leafletEvent.latlng).setContent(compiled[0]).openOn(map);

        ddfFactory.tabs().then(function(t) {
          angular.extend(p2nVm.threatCategories, t.tables[0].legend.categories);
        });
      }
    }

    function activateScenario(utfBin) {
      angular.forEach(model2Bag, function(val, key) {
        if (val === utfBin.id) utfBin.id = key;
      });

      p2nMapFactory.broadcastScenario(utfBin);

      if ($mdMedia('xs')) {
        $rootScope.$broadcast('toggle-panel');
      }
      // give enough time for button ink & main map overlay to show
      $timeout(function() {
        map.closePopup();
      }, 300);
    }

    function utfMouseover(event, leafletEvent) {
      p2nVm.hoveredBasin = leafletEvent.data.displayId;
    }

    function utfMouseout() {
      p2nVm.hoveredBasin = '';
    }

    function startMapListeners() {
      deregCallbacks.push($scope.$on('leafletDirectiveMap.utfgridClick', utfGridClick));
      deregCallbacks.push($scope.$on('leafletDirectiveMap.utfgridMouseover', utfMouseover));
      deregCallbacks.push($scope.$on('leafletDirectiveMap.utfgridMouseout', utfMouseout));
      deregCallbacks.push($scope.$on('leafletDirectiveMap.p2n.layeradd', previeuxTileError));
    }

    function updateTableStatuses() {
      //DDF table IDs
      //We should store these in configuration somewhere
      var ddfTableIds = [142, 143];
      ddfTableIds.forEach(function (ddfTableId) {
        updateTableStatus(ddfTableId);
      });
    }

    function updateTableStatus(ddfTableId) {
      var deferred = $q.defer();

      var statusOptions = {
        id: ddfTableId,
        startDate: new Date(p2nVm.timeParams.start),
        endDate: new Date(p2nVm.timeParams.end)
      };

      ddfFactory.status(statusOptions).then(function(data) {
        p2nVm.flashing.clearLayers();
        data[0].ids.forEach(function(d) {
          p2nVm.ddfStatus[d.id] = d;
          var fallbackCheck = d.percentToNextFrequency >= 90 || d.percentToNextThreat >= 90;
          if (fallbackCheck) {
            var colorID = angular.isDefined(d.frequencyId) ? d.frequencyId : d.threatId;
            ddfFactory.getOutline(ddfTableId, d.id).then(function(b) {
              flashBasin(b.data, colorID);
            })
          }
        });

        deferred.resolve(data[0]);
      }, function(data) {
        deferred.reject(data);
      });

      return deferred.promise;
    }

    function flashBasin(basinGeojson, colorID) {
      var outline = L.geoJson(basinGeojson, {
        style: function() {
          return {
            stroke: true,
            weight: 2,
            fillOpacity: 1,
            className: 'flash-ddf cat-' + colorID
          }
        }
      });
      p2nVm.flashing.addLayer(outline);
    }

    function activateDDF() {
      if (p2nVm.preActive === false) return;

      map.closePopup();
      p2nVm.flashing.addTo(map);
      p2nVm.preActive = false;
      p2nVm.scaleUrl = API_URL + VDS_URL + 'ddf/scale/142/32/172.png?accesstoken=' + $auth.getToken();

      if (p2nVm.layers.overlays.p2nLayer1) {
        p2nVm.layers.overlays.p2nLayer1.visible = true;
      }
      if (p2nVm.layers.overlays.p2nLayer2) {
        p2nVm.layers.overlays.p2nLayer2.visible = true;
      }

      removeOldPrevieux();
      if (p2nVm.previeux.basinGeojson) {
        map.removeLayer(p2nVm.previeux.basinGeojson);
      }
      if (p2nVm.previeux.animation) {
        stopPrevieux();
      }
      p2nVm.loading = false;

    }

    function activatePrevieux() {
      map.closePopup();
      map.removeLayer(p2nVm.flashing);

      p2nVm.preActive = true;
      p2nVm.layers.overlays.p2nLayer1.visible = false;
      p2nVm.layers.overlays.p2nLayer2.visible = false;

      p2nVm.scaleUrl = API_URL + VDS_URL + 'previeux/scale/image/32/172.png?accesstoken=' + $auth.getToken();
      p2nVm.previeux.basinGeojson.addTo(map);

      var requests = [
        previeuxFactory.getInfo(p2nVm.previeux.activeRadar),
        p2nMapFactory.getVisibleTileCoords(map)
      ];

      $q.all(requests).then(function(data){
        var previeuxInfo = data[0];
        var coordinates = data[1];

        removeOldPrevieux();

        loadNewPrevieux(previeuxInfo, coordinates).then(function(previeuxData){
          angular.extend(p2nVm.layers.overlays, previeuxData.overlays);
          p2nVm.previeux.frame = 0;
          p2nVm.previeux.visibleTime = p2nVm.layers.overlays.previeux0.layerParams.frame;
          p2nVm.previeux.radars[getIndex(p2nVm.previeux.activeRadar)].status = 1;
          tileFactory.preloadImages(previeuxData.preloadImages).catch(previeuxError);
        }, previeuxError);

      }, previeuxError);

    }

    function loadNewPrevieux(radarInfo, coordinates) {
      if (p2nVm.previeux.animation) {
        stopPrevieux();
      }

      p2nVm.previeux.radarInfo = radarInfo;
      p2nVm.previeux.radarInfo.numberOfFiles = p2nVm.previeux.radarInfo.readings.length;
      var previeuxData = {
        preloadImages: [],
        overlays: {}
      };
      var overlayURL = API_URL + VDS_URL + 'previeux/{id}/{scanTime}/frames/{frame}/basins/{basin}/{z}/{x}/{y}.png?accum={isAccum}&accesstoken={accesstoken}';
      var layerObject = {
        type: 'xyz',
        visible: true,
        layerOptions: {
          opacity: 0,
          errorTileUrl: 'assets/images/error-tile.png'
        },
        layerParams: {
          isAccum: false,
          basin: 'austin-basin',
          showOnSelector: false,
          transparent: true,
          accesstoken: $auth.getToken()
        }
      };
      var accesstoken = $auth.getToken();
      p2nVm.previeux.radarInfo.readings.forEach(function(d, i) {
        coordinates.xy.forEach(function(d){
          var imageUrl = API_URL + VDS_URL + 'previeux/'+ p2nVm.previeux.activeRadar +'/'+ p2nVm.previeux.radarInfo.scanTime +'/frames/'+ p2nVm.previeux.radarInfo.readings[i].time +'/basins/austin-basin/'+ coordinates.zoom +'/'+ d.x +'/'+ d.y +'.png?accum=false&accesstoken=' + accesstoken;
          previeuxData.preloadImages.push(imageUrl);
        });

        previeuxData.overlays['previeux' + i] = angular.merge({}, layerObject, {
          name: 'previeux' + i,
          url: overlayURL,
          layerParams: {
            scanTime: p2nVm.previeux.radarInfo.scanTime,
            id: p2nVm.previeux.activeRadar,
            frame: d.time
          }
        });
        if (i === 0) {
          previeuxData.overlays['previeux' + i].layerOptions.opacity = 0.75;
        }
      });

      return $q.resolve(previeuxData);
    }

    function removeOldPrevieux() {
      var preReg = /previeux\d+/;
      for (var variable in p2nVm.layers.overlays) {
        if (p2nVm.layers.overlays.hasOwnProperty(variable) && preReg.test(variable)) {
          delete p2nVm.layers.overlays[variable];
        }
      }
    }

    function animatePrevieux() {
      animatePrevieuxLoop();
    }

    function animatePrevieuxLoop() {
      if (p2nVm.previeux.frame < p2nVm.previeux.radarInfo.numberOfFiles - 1) {
        p2nVm.previeux.frame++;
        changeFrame(p2nVm.previeux.frame);
      } else {
        p2nVm.previeux.frame = 0;
        changeFrame(p2nVm.previeux.frame);
      }

      var delay = p2nVm.previeux.frame === p2nVm.previeux.radarInfo.numberOfFiles - 1 ? 2250 : 750;

      p2nVm.previeux.animation = $timeout(animatePrevieuxLoop, delay);
    }

    function stopPrevieux() {
      $timeout.cancel(p2nVm.previeux.animation);
      p2nVm.previeux.animation = undefined;
      return;
    }

    function changeFrame(frame) {
      var prevFrame = frame - 1 >= 0 ? frame - 1 : p2nVm.previeux.radarInfo.numberOfFiles - 1;
      var current = 'previeux' + frame;
      var previous = 'previeux' + prevFrame;

      p2nVm.previeux.visibleTime = p2nVm.layers.overlays[current].layerParams.frame;

      p2nVm.layers.overlays[current].layerOptions.opacity = 0.75;
      p2nVm.layers.overlays[current].doRefresh = true;
      $timeout(function(){
        p2nVm.layers.overlays[previous].layerOptions.opacity = 0;
        p2nVm.layers.overlays[previous].doRefresh = true;
        return;
      });
    }

    function getStatus(id) {
      return p2nVm.previeux.radars[getIndex(id)].status;
    }

    function getIndex(id) {
      return p2nVm.previeux.radars.findIndex(function(d){ return d.id === id; });
    }

    function previeuxError(error) {
      removeOldPrevieux();
      p2nVm.layers.overlays.previeux0 = {
        name: 'previeux0',
        type: 'imageOverlay',
        url: '/assets/images/error-tile.png',
        bounds: map.getBounds(),
        visible: true,
        doRefresh: false,
        layerParams: {
          format: 'image/png',
          opacity: 1,
          transparent: true,
          showOnSelector: false
        }
      };
      var search = p2nVm.previeux.radars.findIndex(function(d){
        return d.id === p2nVm.previeux.activeRadar;
      });
      p2nVm.previeux.radars[search].status = 0;
      p2nVm.scaleUrl = '';

      $log.error(error);
    }

    function previeuxTileError(event, data) {
      var layer = data.leafletEvent.layer;
      if (layer instanceof L.TileLayer && !layer.options.isBaselayer) {
        layer.on('tileerror', previeuxError);
      }
    }

    function onDestroy() {
      deregCallbacks.forEach(function(d){ return d(); });
      $timeout.cancel(p2nVm.previeux.animation);
      $interval.cancel(updateCheck);
    }

    function refreshMap() {
      activate();
    }

  }
})();

(function() {
  'use strict';

  var component = {
    controller: statusController,
    controllerAs: 'statusVm',
    bindings: {
      checkTime: '<',
      errors: '<',
      checkDuration: '<'
    },
    templateUrl: 'app/components/dashboard/dashpanel/components/status/status.tmpl.html'
  };

  angular
    .module('dashboard')
    .component('status', component);

  /*@ngInject*/
  function statusController($log, $interval, $mdPanel, $document, prefFactory) {
    var statusVm = this,
        progress;

    angular.extend(statusVm, {
      $onInit: activate,
      $onDestroy: onDestroy,
      lookupByID: lookupByID,
      calcTime: 1,
      dictionary: {},
      openErrorMore: openErrorMore
    });

    ////////////////

    function activate() {
      updateProgress();

      prefFactory.getPreferences().then(function(directory){
        var directoryArray = directory.dashboard
        directoryArray.forEach(function(d){
          statusVm.dictionary[ d.id ] = d;
        });
      });
    }

    function updateProgress(){
      progress = $interval(function(){
        var now = moment( new Date() );
        var timeLeft = now.diff( moment(statusVm.checkTime) );
        var ratio = parseInt( (timeLeft / statusVm.checkDuration) * 100);
        statusVm.calcTime = ratio;
        if (statusVm.calcTime > 99) {
          statusVm.calcTime = 1;
        }
      }, 1500);
    }

    function openErrorMore(errors, id, ev) {
      var button = '.error-more';
      var attachTo = angular.element($document[0].querySelectorAll('dashpanel'));
      var position = $mdPanel.newPanelPosition()
          .relativeTo(button)
          .addPanelPosition($mdPanel.xPosition.ALIGN_END, $mdPanel.yPosition.BELOW);

      var animation = $mdPanel.newPanelAnimation()
          .openFrom(button)
          .closeTo(button)
          .withAnimation($mdPanel.animation.SCALE);

      var config = {
        animation: animation,
        attachTo: attachTo,
        controller: statusPanelCtrl,
        controllerAs: 'statusPanelCtrl',
        templateUrl: 'app/components/dashboard/dashpanel/components/status/statusPanel.tmpl.html',
        panelClass: 'error-menu',
        position: position,
        locals: {
          'errors': statusVm.errors,
          'lookupByID': statusVm.lookupByID
        },
        openFrom: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 150,
        hasBackdrop: false,
        clickEscapeToClose: true
      };

      $log.error(statusVm.errors);

      $mdPanel.open(config);
    }

    function statusPanelCtrl() {
      return this;
    }

    function lookupByID(id) {
      return statusVm.dictionary[id];
    }

    function onDestroy() {
      $interval.cancel(progress);
    }

  }
})();

(function() {
  'use strict';

  var component = {
    controller: alertFeedController,
    controllerAs: 'afVm',
    bindings: {
      addOverlay: '&',
      removeOverlay: '&',
      nowTime: '<'
    },
    templateUrl: 'app/components/dashboard/dashpanel/components/alert-feed/alertFeed.tmpl.html'
  };

  angular.module('dashboard').component('alertFeed', component);

  /*@ngInject*/
  function alertFeedController($rootScope, $scope, $timeout, $interval, $cacheFactory,
      $log, $q, $document, $window, $auth, $mdMedia, $mdDialog, leafletData,
      alertFeedFactory, wpFactory, projectInfo, replayFactory, alertStatusFactory,
      notificationFactory, API_URL) {

    var afVm = this;
    var updatesTimeout, map;
    var MIN = 1000 * 60;

    angular.extend(afVm, {
      $onInit: activate,
      $onDestroy: onDestroy,
      $onChanges: onChanges,
      componentInfo: componentInfo,
      dataTimes: {
        start: null,
        end: null
      },
      itemInfo: itemInfo,
      locateOnMap: locateOnMap,
      flyToLocation: flyToLocation,
      miscNotifications: {},
      dataset: [],
      ruleMap: {},
      loading: true,
      loadingAtx: false,
      loading311: false,
      loadingBuildings: false,
      loadingBridges: false,
      initialized: false,
      checkFreq: 5, // in minutes
      onMapAlerts: {},
      showMapAlerts: true,
      toggleMapAlerts: toggleMapAlerts,
      mapAlertsGroup: L.layerGroup(),
      changeAlertLayer: changeAlertLayer,
      showType: showType,
      isEmpty: isEmpty,
      // pretend: 1496703600000, // pretend
      svg: {
        watch: '<svg class="watch" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>',
        warn: '<svg class="warn" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>'
      },
      fifteenMinutes: 900000, // in milliseconds
      countdownTimers: [],
      selected: undefined,
      equals: angular.equals,
      accesstoken: $auth.getToken(),
      types: {
        map: ['Low Water Crossings', 'Rule Alerts', '311 Calls', 'Flooded Structures'],
        items: ['atx', 'alert', '_311', 'structure'],
        selected: ['atx', 'alert', '_311', 'structure']
      }
    });

    ////////////////

    function activate() {
      leafletData.getMap('dashmap').then(function(m) {
        map = m;
        afVm.mapAlertsGroup.addTo(map);
      });
    }

    $scope.$on('notificationsUpdated', addMiscNotifications);
    $scope.$on('alerts', addMiscNotifications);
    $scope.$on('notificationsReady', notify);
    $scope.$on('loadAtxStart', function() { afVm.loadingAtx = true; });
    $scope.$on('loadAtxEnd', function() { afVm.loadingAtx = false; });
    $scope.$on('load311Start', function() { afVm.loading311 = true; });
    $scope.$on('load311End', function() { afVm.loading311 = false; });
    $scope.$on('loadBuildingsStart', function() { afVm.loadingBuildings = true; });
    $scope.$on('loadBuildingsEnd', function() { afVm.loadingBuildings = false; });
    $scope.$on('loadBridgesStart', function() { afVm.loadingBridges = true; });
    $scope.$on('loadBridgesEnd', function() { afVm.loadingBridges = false; });

    function notify() {
      notificationFactory.sendNotifications();
    }

    function addMiscNotifications() {
      notificationFactory.clearNotifications();
      var notifications = [];
      var cache = $cacheFactory.get('notificationsItems')
      var atx = cache.get('atx');
      var _311 = cache.get('311');
      var bridges = cache.get('bridges');
      var buildings = cache.get('buildings');

      // we need some consistent formatting
      if (atx) {
        atx = Object.keys(atx).map(function(d) {
          atx[d].notifyTime = atx[d].changedTime;
          atx[d].type = 'atx';
          return atx[d];
        });
        if (atx.length > 0) {
          notifications = notifications.concat(atx);
          notificationFactory.addNotification('LWC', atx.length);
        }
      }

      if (_311) {
        var ackCount311 = 0;
        _311.forEach(function(d) {
          d.notifyTime = new Date(d.requested_datetime).getTime();
          d.type = '_311';
          if (d.isAck) {
            ackCount311++;
          }
        });
        if (_311.length > 0) {
          notifications = notifications.concat(_311);
          notificationFactory.addNotification('\'311\'', ackCount311 + ':' + _311.length)
        }
      }

      //Inundated structures (bridges and buildings)
      var structures = [];
      structures = structures.concat(getFormattedStructureNotifications(buildings, 'building'));
      structures = structures.concat(getFormattedStructureNotifications(bridges, 'bridge'));
      if (structures.length > 0) {
        //Push to the notifications feed
        notifications = notifications.concat(structures);
        notificationFactory.addNotification('Structures', structures.length);
      }

      afVm.dataset = afVm.dataset
        .filter(function(d){ return d.type === 'alert'; })
        .concat(notifications)
        .sort(function(a, b){
          //Sort the notifications in this order:
          //  1. Rule alerts, 311 calls, ATX road closures, and all other non-structure alerts
          //    (latest to oldest by notification time)
          //  2. Buildings
          //    (ties resolved alphanumerically)
          //  3. Bridges
          //    (over high chord, then over low chord; ties resolved alphanumerically)
          //This is done because buildings/bridges do not have a notification time, otherwise we could sort the whole
          //  list by notification time

          if (a.type === 'structure' && b.type === 'structure') {
            //Sort structures by building first, bridges last
            if (a.structureType === 'bridge' && b.structureType === 'bridge') {
              //Sort bridge alerts by over-high-chord first, over-low-chord last
              if (a.status === 'OVER_HIGH_CHORD' && b.status !== 'OVER_HIGH_CHORD') {
                return -1;
              } else if (b.status === 'OVER_HIGH_CHORD' && a.status !== 'OVER_HIGH_CHORD') {
                return 1;
              } else {
                //Sort bridge alerts of the same status by physical address
                return a.streetAddress.localeCompare(b.streetAddress);
              }
            } else if (a.structureType === 'bridge') {
              //Bridge alerts come after building alerts
              return 1;
            } else if (b.structureType === 'bridge') {
              return -1;
            } else {
                //Sort building alerts by physical address
              return a.streetAddress.localeCompare(b.streetAddress);
            }
          } else if (a.type === 'structure') {
            //Structure alerts come after other alerts
            return 1;
          } else if (b.type === 'structure') {
            return -1;
          } else {
            //All other alerts are ordered based off of notification times
            return b.notifyTime - a.notifyTime;
          }
        });

      $timeout(function () {
        $scope.$emit('notificationsReady')
      }, 2000);
    }

    function getFormattedStructureNotifications(evalJson, structureType) {
      // Format the structure eval JSON response to be suitable for inclusion in the live notifications feed
      // evalJson: The response from the bridge_evals.json or building_evals.json structure API endpoint
      // structureType: 'bridge' or 'building'
      if (!evalJson) {
        return [];
      } else {
        //Add the required properties to each entry - type, time, and lat/lon coordinates
        return Object.keys(evalJson.features).map(function(d) {
          var feature = structuredClone(evalJson.features[d]);
          feature.properties.type = 'structure';
          feature.properties.structureType = structureType;
          feature.properties.longitude = feature.geometry.coordinates[0];
          feature.properties.latitude = feature.geometry.coordinates[1];
          return feature.properties;
        });
      }
    }

    function onChanges(changesObj) {

      if (changesObj.nowTime) {
        if (replayFactory.isActive()) {
          var params = {
            start: afVm.nowTime - (MIN * 60 * 6),
            end: afVm.nowTime
          };

          afVm.loading = true;
          afVm.dataset.length = 0;

          alertFeedFactory.retreive(params).then(loadAlerts, retrieveError);
          if(angular.isDefined(updatesTimeout)) stopTimeChecks();

        } else if (angular.isUndefined(updatesTimeout)) {

          afVm.loading = true;
          afVm.dataset.length = 0;

          alertFeedFactory.retreive({
            start: Date.now() - (MIN * 60 * 6)
            // start: afVm.pretend - (MIN * 60 * 2),
            // end: afVm.pretend
          }).then(loadAlerts, retrieveError);

          startUpdates();

        }
      }
    }

    function loadAlerts(data) {
      var deferred = $q.defer();
      var alertSize = data.timeline.length;
      afVm.initialized = true;

      if (afVm.dataTimes.start === null) afVm.dataTimes.start = afVm.nowTime - (MIN * 60 * 6);
      afVm.dataTimes.end = alertFeedFactory.lastChecked;

      if (Object.keys(afVm.onMapAlerts).length > 0 || afVm.mapAlertsGroup.getLayers().length > 0) {
        afVm.onMapAlerts = {};
        afVm.mapAlertsGroup.clearLayers();
      }

      if (alertSize > 0) {
        afVm.checkFreq = 1;
        angular.merge(afVm.ruleMap, data.ruleMap);

        afVm.dataset = afVm.dataset
          .concat(data.timeline.map(function(d){
            d.hasGeoJson = data.ruleMap[d.ruleID].payload.length !== 16;
            d.type = 'alert';
            return d;
          }))
          .sort(function(a, b){ return b.notifyTime - a.notifyTime; });

        // structure and render relevant map alerts
        afVm.onMapAlerts = structureAlerts(afVm.dataset);

        for (var i in afVm.onMapAlerts) {
          if (afVm.onMapAlerts.hasOwnProperty(i)) {
            renderMapAlerts( afVm.onMapAlerts[i], i );
          }
        }

        var ackCount = 0;
        for (var j = 0; j < data.timeline.length; j++) {
          if (data.timeline[j].isAck) ackCount++;
        }

        afVm.loading = false;
        if (!replayFactory.isActive()) notificationToast( ackCount + ':' + alertSize);
        broadcastAlerts();
        deferred.resolve();
      } else {
        afVm.checkFreq = 5;
        afVm.loading = false;
        deferred.resolve();
      }

      return deferred.promise;
    }

    /**
     * Structure the alert data based upon the alert timeline dataset.
     * This structure has been designed with rendering individual geojson features
     * and their required data in mind.
     *
     * @param  {array} array - array of alerts
     * @return {object} - object map of rule id with their structured alert data
     */
    function structureAlerts(array) {
      var object = {};

      array.forEach(function(a) {
        if (!needsAlert(a)) return;

        if (!object[a.ruleID]) {
          object[a.ruleID] = angular.fromJson(afVm.ruleMap[a.ruleID].payload);

          // marker and polygons will be 2 dimensional arrays
          // the top array is indexed to the feature index
          // the next is an array of markers for each feature
          object[a.ruleID].mapAlerts.forEach(function(d){
            d.layer = {
              popup: undefined,
              markers: [],
              polygons: [],
              timer: undefined
            };
          });
        }

        if (!object[a.ruleID].alerts) {
          object[a.ruleID].alerts = [a];
          object[a.ruleID].alerts.crossThresh = a.crossThreshAt;
          object[a.ruleID].alerts.notifyTime = a.notifyTime;
          object[a.ruleID].alerts.mostRecent = a;
        } else {
          object[a.ruleID].alerts.push(a);
          if (a.crossThreshAt > object[a.ruleID].alerts.crossThresh || a.notifyTime > object[a.ruleID].alerts.notifyTime) {
            object[a.ruleID].alerts.crossThresh = a.crossThreshAt;
            object[a.ruleID].alerts.notifyTime = a.notifyTime;
            object[a.ruleID].alerts.mostRecent = a;
          }
        }
      });

      // if most recent notification is not above threshold
      // then cancel map alert
      for (var check in object) {
        if (object.hasOwnProperty(check)) {
          if (!object[check].alerts.mostRecent.aboveThresh) {

            // remove any map layers if exist
            if (object[check].mapAlerts.length) {
              object[check].mapAlerts.forEach(function(d){
                [].concat(d.layer.polygons)
                  .concat(d.layer.markers)
                  .forEach(function(l){
                    afVm.mapAlertsGroup.removeLayer(l);
                  });
                $interval.cancel(d.layer.timer);
              });
            }

            delete object[check];
          }
        }
      }

      return object;
    }

    /**
     * Depending on the threshold crossing this function determins if a map alert
     * is needed.
     *
     * @param  {object} alert - alert object
     * @return {boolean} - true if meets requirements, else false
     */
    function needsAlert(alert) {
      if (!alert.hasGeoJson) return false;
      if (!alert.crossThreshAt || !alert.new) return true;

      // 2 hours before
      var beforeRange = 7.2e+6;
      // 6 hours after
      var afterRange = 2.16e+7;

      var crossingTime = alert.crossThreshAt;

      var timeCheck = Date.now();
      // var timeCheck = afVm.pretend; // pretend --> average between start and end date

      // time is greater than two hours after crossing time
      if (timeCheck > (crossingTime + beforeRange)) return false;

      // crossing time is plus or minus x hours from current
      if (crossingTime < (timeCheck - beforeRange) || crossingTime > (timeCheck + afterRange)) return false;
      return true;
    }

    /**
     * Loop through map alerts and then loop through geojson features to
     * render the map alerts with their necessary data.
     *
     * @param  {object} ruleAlerts - rule object with array of alerts and array of map alerts
     * @param  {string} ruleID - rule ID
     * @return {undefined}
     */
    function renderMapAlerts(ruleAlerts, ruleID) {

      ruleAlerts.mapAlerts.forEach(function(mapAlert, i){
        var shortCrossThresh = ruleAlerts.alerts.crossThresh;
        var shortTiming = mapAlert.timing;
        var shortDelay = +mapAlert.delay; // coerce to integer , units = minutes

        var timeRemaining = getTimeRemaining(shortCrossThresh, shortTiming, shortDelay);
        var type = getType(timeRemaining);

        update(type, timeRemaining);
        if (timeRemaining <= 0) {
          return;
        }

        // countdown timer logic
        var flag = true;
        var timer = $interval(function() {
          if (timeRemaining < 0) {
            update('warn', 0);
            $interval.cancel(timer);
            return;
          }
          var countdownTime = getTimerSeconds(timeRemaining);
          if (timeRemaining < afVm.fifteenMinutes && type === 'watch' && flag) {
            flag = false;
            update('warn', timeRemaining);
          }
          mapAlert.layer.markers.forEach(function(f){
            f.forEach(function(d){
              d.label.setContent(countdownTime);
            });
          });
          timeRemaining -= 1000;
        }, 1000);

        if (mapAlert.layer.timer) {
          $interval.cancel(mapAlert.layer.timer);
        }
        mapAlert.layer.timer = timer;
        afVm.countdownTimers.push(timer);

        function update(type, timeRemaining){
          updatePopup(type, ruleID, i);
          mapAlert.geoJSON.features.forEach(function(feature, featureIndex) {
            updateMarker(feature, type, ruleID, timeRemaining, featureIndex, i);
            if (feature.geometry.type !== 'Point' && feature.geometry.type !== 'MultiPoint') {
              updatePolygon(feature, type, ruleID, featureIndex, i);
            }
          });
        }
      });
    }

    /**
     * Create or update popup with watch/warn style and content.
     *
     * @param  {string} type - 'watch' or 'warn' to style markers/polygons/popups
     * @param  {string} ruleID - rule ID
     * @param  {number} mapAlertIndex - map alert index
     * @return {undefined}
     */
    function updatePopup(type, ruleID, mapAlertIndex) {
      var layerData = afVm.onMapAlerts[ruleID].mapAlerts[mapAlertIndex];
      var alert = afVm.onMapAlerts[ruleID].alerts.mostRecent;
      var alertData = {
        name: layerData.name,
        crossTime: alert.crossThreshAt
      };

      layerData.layer.popup = L.popup.angular({
        template: '<h3>{{alertPop.$content.alertData.name}}</h3>' +
          "<p>at <strong>{{alertPop.$content.alertData.crossTime | date:'H:mm'}}</strong> <span>{{alertPop.$content.alertData.crossTime | date:'yyyy/MM/dd'}}</span></p>" +
          '<md-button class="btn" ng-click="alertPop.itemInfo(alertPop.$content.alert, $event)"><md-icon>info_outline</md-icon><span>DETAILS</span></div>',
        controllerAs: 'alertPop',
        controller: popupController,
        closeOnClick: false,
        maxWidth: 125,
        className: 'map-alert-popup ' + type
      }).setContent({'alertData': alertData, 'alert': alert});

      return;
    }

    /**
     * Create or update marker with watch/warning style and bound popup and/or label.
     *
     * @param  {object} feature - geojson feature
     * @param  {string} type - 'watch' or 'warn' to style markers/polygons/popups
     * @param  {string} ruleID - rule ID
     * @param  {number} timeRemaining - time remaining in milliseconds
     * @param  {number} featureIndex - geojson feature index
     * @param  {number} mapAlertIndex - map alert index
     * @return {undefined}
     */
    function updateMarker(feature, type, ruleID, timeRemaining, featureIndex, mapAlertIndex) {
      var config = {
        centroid: L.geoJson(feature).getBounds().getCenter(),
        hidden: {
          icon: L.divIcon({
            className: 'hidden-marker',
            iconSize: 18,
            popupAnchor: [0, -10],
            html: '<div class="pulse count-1 size-1 '+ type +'"></div>'
          }),
          zIndexOffset: 1000
        },
        visible: {
          icon: L.divIcon({
            className: 'custom-marker ' + type,
            iconSize: 18,
            popupAnchor: [0, -10],
            html: afVm.svg[type] + '<div class="pulse count-1 size-1 '+ type +'"></div>'
          }),
          zIndexOffset: 1000
        },
        hiddenLabel: {
          className: 'timer ' + type,
          noHide: true,
          clickable: false,
          offset: [-18, 4]
        },
        visibleLabel: {
          className: 'timer ' + type,
          noHide: true,
          clickable: false,
          offset: [-18, 22]
        }
      };

      var layerData = afVm.onMapAlerts[ruleID].mapAlerts[mapAlertIndex].layer;
      if( angular.isDefined(layerData.markers[featureIndex]) ) {
        layerData.markers[featureIndex].forEach(function(d){
          afVm.mapAlertsGroup.removeLayer(d);
        });
      }
      layerData.markers[featureIndex] = [];
      var marker = undefined;
      var markers = [];

      if(feature.geometry.type === 'Point') {
        marker = L.marker(config.centroid, config.visible)
          .bindPopup(layerData.popup)
          .bindLabel(getTimerSeconds(timeRemaining), config.visibleLabel);

        markers.push(marker);
      } else if (feature.geometry.type === 'MultiPoint') {
        feature.geometry.coordinates.forEach(function(d){
          var copy = [];
          angular.copy(d, copy);
          marker = L.marker(copy.reverse(), config.visible)
            .bindPopup(layerData.popup)
            .bindLabel(getTimerSeconds(timeRemaining), config.visibleLabel);
          markers.push(marker);
        });
      } else {
        marker = L.marker(config.centroid, config.hidden)
          .bindPopup(layerData.popup)
          .bindLabel(getTimerSeconds(timeRemaining), config.hiddenLabel);

        markers.push(marker);
      }

      markers.forEach(function(marker){
        layerData.markers[featureIndex].push(marker);
        afVm.mapAlertsGroup.addLayer(marker);
      });
    }

    /**
     * Create or update polygon with watch/warn styling.
     *
     * @param  {object} feature - geojson feature
     * @param  {string} type - 'watch' or 'warn' to style markers/polygons/popups
     * @param  {string} ruleID - rule ID
     * @param  {number} featureIndex - geojson feature index
     * @param  {number} mapAlertIndex - map alert index
     * @return {undefined}
     */
    function updatePolygon(feature, type, ruleID, featureIndex, mapAlertIndex) {

      var layerData = afVm.onMapAlerts[ruleID].mapAlerts[mapAlertIndex].layer;
      if ( angular.isDefined(layerData.polygons[featureIndex]) ) {
        layerData.polygons[featureIndex].forEach(function(d){
          afVm.mapAlertsGroup.removeLayer(d);
        });
      }

      layerData.polygons[featureIndex] = [];

      var polygon = L.geoJson(feature, {
        style: function(){
          return {
            fillOpacity: .5,
            stroke: true,
            weight: 1,
            className: 'custom-polygon ' + type
          }
        }}).bindPopup(layerData.popup);

      layerData.polygons[featureIndex].push(polygon);
      afVm.mapAlertsGroup.addLayer(polygon);
      return;
    }

    function getTimeRemaining(crossThresh, timing, delay) {
      var remaining = 0;
      delay *= (1000 * 60);
      if (timing === 'before') {
        remaining = (crossThresh - delay) - Date.now();
        // remaining = (crossThresh - delay) - afVm.pretend; // pretend
      } else if (timing === 'during') {
        remaining = crossThresh - Date.now();
        // remaining = crossThresh - afVm.pretend; // pretend
      } else {
        remaining = (crossThresh + delay) - Date.now();
        // remaining = (crossThresh + delay) - afVm.pretend; // pretend
      }
      return remaining > 0 ? remaining : 0;
    }

    function getType(timeRemaining) {
      if (timeRemaining > afVm.fifteenMinutes) return 'watch';
      return 'warn';
    }

    function getTimerSeconds(timeDiff) {
      var formattedLabel;
      var hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
      if (hours > 0) {
        formattedLabel = hours + ':' + ("0" + minutes).slice(-2) + ':' + ("0" + seconds).slice(-2);
      } else {
        formattedLabel = ("0" + minutes).slice(-2) + ':' + ("0" + seconds).slice(-2);
      }

      return formattedLabel;
    }

    function retrieveError() {
      afVm.loading = false;
      afVm.initialized = true;
      afVm.error = true;
    }

    function locateOnMap(alert) {
      var isSelected = angular.equals(alert, afVm.selected);
      var isMapAlert = angular.isDefined(afVm.onMapAlerts[alert.ruleID]);

      if (isSelected) { // is selected
        afVm.selected = undefined;
        if (!isMapAlert) { // is not map alert
          afVm.removeOverlay();
        }
      } else { // else is not selected
        afVm.selected = alert;
        var small = $mdMedia('xs');
        if (small) {
          $rootScope.$broadcast('toggle-panel');
        }

        if (isMapAlert) { // is map alert
          var grouping = new L.FeatureGroup();
          afVm.onMapAlerts[alert.ruleID].mapAlerts.forEach(function(d){
            L.geoJson(d.geoJSON, {
              onEachFeature: function(feature, layer) {
                grouping.addLayer(layer);
              }
            });
          });
          map.fitBounds(grouping);
          grouping = undefined;
        } else { // else is not map alert
          var params = {
            $payload: afVm.ruleMap[alert.ruleID].payload,
            $alert: alert
          };

          afVm.addOverlay(params);
        }

      }
    }

    function flyToLocation(latlng) {
      map.setView(latlng, 16);
    }

    function componentInfo(ev) {
      $mdDialog.show({
        templateUrl: 'app/components/dashboard/dashpanel/components/alert-feed/alertInfo.tmpl.html',
        targetEvent: ev,
        controller: nfInfoController,
        controllerAs: 'nfiVm',
        locals: {
          checkFreq: afVm.checkFreq,
          dataTimes: afVm.dataTimes,
          dataset: afVm.dataset,
          types: afVm.types
        },
        bindToController: false
      }).then(function(selected) {
        afVm.types.selected = selected;
      });
    }

    function showType(type) {
      return afVm.types.selected.indexOf(type) >= 0;
    }

    function itemInfo(alert, ev) {
      var tmplUrl = 'app/components/dashboard/dashpanel/components/alert-feed/';
      var config = {
        _311: {
          templateUrl: tmplUrl + '311AlertItem.tmpl.html',
          controller: ItemController
        },
        alert: {
          templateUrl: tmplUrl + 'alertItem.tmpl.html',
          controller: nfItemController
        },
        atx: {
          templateUrl: tmplUrl + 'atxAlertItem.tmpl.html',
          controller: ItemController
        },
        structure: {
          templateUrl: tmplUrl + 'structureAlertItem.tmpl.html',
          controller: ItemController
        }
      };

      if (alert.type === 'alert') {
        projectInfo.getDetails().then(function(data) {
          afVm.basins = data.basins;
        });

        afVm.selected = {
          id: afVm.ruleMap[alert.ruleID].source.id,
          imageUrl: '',
          startTime: alert.notifyTime - (60000 * 60 * 2),
          endTime: alert.notifyTime + (60000 * 60 * 6),
          referenceTime: alert.referenceTime
        };
      }

      getItemDialogComponent(alert, config[alert.type], ev);
    }

    function getItemDialogComponent(alert, config, ev) {
      $mdDialog.show({
        clickOutsideToClose: true,
        templateUrl: config.templateUrl,
        scope: $scope,
        locals: {
          alert: alert
        },
        preserveScope: true,
        targetEvent: ev,
        controller: config.controller,
        fullscreen: $mdMedia('xs'),
        onComplete: (alert.type === 'alert') ? setChartUrl : null
      });
    }

    function setChartUrl() {
      var chartSize = $document[0].querySelector('.alert-chart').clientWidth,
          dpr = $window.devicePixelRatio,
          checkedDPR = dpr < 1 ? 1 : Math.floor(dpr);
          afVm.selected.imageUrl = API_URL + 'hydrographs/' +
              afVm.selected.id + '/height_chart.png?style=COMPLICATED&' +
              'width=' + chartSize + '&height=300&pixelRatio=' + checkedDPR +
              '&ghostLines=true&start=' + afVm.selected.startTime +
              '&end=' + afVm.selected.endTime +
              '&fakeNow=' + afVm.selected.referenceTime +
              '&accesstoken=' + afVm.accesstoken;
    }

    function startUpdates() {
      var delay = MIN * afVm.checkFreq;
      updatesTimeout = $timeout(loop, delay);

      function loop() {
        afVm.loading = true;
        var alertParams = {
          start: afVm.dataTimes.end,
          filterPriorToStart: true
        };

        alertFeedFactory.retreive(alertParams).then(function(data) {
          loadAlerts(data).then(function() {
            updatesTimeout = $timeout(loop, delay);
            afVm.loading = false;
          });
        }, function() {
          delay = MIN * 0.25;
          updatesTimeout = $timeout(loop, delay);
          afVm.loading = false;
          notificationFactory.sendGenericError();
        });
      }
    }

    function notificationToast(notificationNumber) {
      notificationFactory.addNotification('rule(s)', notificationNumber);
      $timeout(function () {
        $scope.$emit('notificationsReady')
      }, 2000);
    }

    function onDestroy() {
      stopTimeChecks();
    }

    function stopTimeChecks() {
      if($timeout.cancel(updatesTimeout)) updatesTimeout = undefined;
      afVm.countdownTimers.forEach(function(d){
        $interval.cancel(d);
      });
    }

    function broadcastAlerts() {
      $rootScope.$broadcast('alerts');
    }

    /**
     * mddialog/popup controllers
     */

     /*@ngInject*/
    function nfItemController(alert) {
      $scope.alert = alert;
      wpFactory.retrieve().then(function(data) {
        afVm.wps = data;
      });
      $scope.close = function() {
        $mdDialog.cancel();
      };
    }

    /*@ngInject*/
    function ItemController(alert) {
      $scope.alert = alert;
      $scope.close = function() {
        $mdDialog.cancel();
      };
    }

    /*@ngInject*/
    function nfInfoController($mdDialog, checkFreq, dataTimes, dataset, types) {
      var nfiVm = this;
      angular.extend(nfiVm, {
        checkFreq: checkFreq,
        dataTimes: dataTimes,
        dataset: dataset,
        types: angular.copy(types),
        close: close,
        toggleAll: toggleAll,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        exists: exists,
        toggle: toggle
      });

      function toggleAll() {
        if (nfiVm.types.selected.length === nfiVm.types.items.length) {
          nfiVm.types.selected = [];
        } else if (nfiVm.types.selected.length === 0 || nfiVm.types.selected.length > 0) {
          nfiVm.types.selected = nfiVm.types.items.slice(0);
        }
      }

      function isChecked() {
        return nfiVm.types.selected.length === nfiVm.types.items.length;
      }

      function isIndeterminate() {
        return (nfiVm.types.selected.length !== 0 &&
            nfiVm.types.selected.length !== nfiVm.types.items.length);
      }

      function exists (item, list) {
        return list.indexOf(item) > -1;
      }

      function toggle(item, list) {
        var idx = list.indexOf(item);
        if (idx > -1) {
          list.splice(idx, 1);
        }
        else {
          list.push(item);
        }
      }

      function close() {
        $mdDialog.hide(nfiVm.types.selected);
      }
    }

    /*@ngInject*/
    function popupController() {
      this.itemInfo = afVm.itemInfo;
    }

    function changeAlertLayer() {
      if (afVm.showMapAlerts) {
        afVm.mapAlertsGroup.addTo(map);
      } else {
        map.removeLayer(afVm.mapAlertsGroup);
      }
    }

    function isEmpty(object) {
      return Object.keys(object).length;
    }

    function toggleMapAlerts(showAlerts) {
      afVm.showMapAlerts = !showAlerts;
      if (afVm.showMapAlerts) {
        afVm.mapAlertsGroup.addTo(map);
      } else {
        map.removeLayer(afVm.mapAlertsGroup);
      }
    }

    afVm.getStatus = function(alert) {
        return alertStatusFactory.getThreshStatus(alert);
    }

    afVm.getIcon = function(alert) {
        return alertStatusFactory.getIcon(alert);
    }

    afVm.getMessage = function(alert) {
        return alertStatusFactory.getMessage(alert);
    }

    afVm.getATXClass = function(alert) {
      if (alert && alert.comment) {
        if (alert.comment.includes('open')) {
          return 'atx_open'
        } else {
          return 'atx'
        }
      } else {
        return 'atx'
      }
    }

    afVm.getStructureClass = function(alert) {
      switch (alert.structureType) {
        case 'bridge':
          switch (alert.status) {
            case 'OVER_HIGH_CHORD':
              return 'bridge-over-high-chord';
            case 'OVER_LOW_CHORD':
              return 'bridge-over-low-chord';
            default:
              return 'bridge';
          }
        case 'building':
          return 'building';
        default:
          $log.error('Alert has unexpected structureType: ' + alert.structureType);
          return '';
      }
    }

    afVm.getStructureIcon = function(alert) {
      switch (alert.structureType) {
        case 'bridge':
          return 'fort';
        case 'building':
          return 'apartment';
        default:
          $log.error('Alert has unexpected structureType: ' + alert.structureType);
          return 'home';
      }
    }

    afVm.getStructureTypeDisplay = function(alert) {
      switch (alert.structureType) {
        case 'bridge':
          return 'Bridge';
        case 'building':
          return 'Building';
        default:
          $log.error('Alert has unexpected structureType: ' + alert.structureType);
          return 'Unknown Structure Type';
      }
    }

    afVm.getBridgeStatusDisplay = function(alert) {
      switch (alert.status) {
        case 'OVER_HIGH_CHORD':
          return 'Over High Chord';
        case 'OVER_LOW_CHORD':
          return 'Over Low Chord';
        case 'UNDER_LOW_CHORD':
          return 'Under Low Chord';
        default:
          $log.error('Alert has unexpected status: ' + alert.status);
          return 'Unknown Status';
      }
    }

    afVm.isLoading = function() {
      return afVm.loading || afVm.loadingAtx || afVm.loading311 || afVm.loadingBuildings || afVm.loadingBridges;
    }

  }
})();

(function(){
    'use strict';

    angular
        .module('dashboard')
        .controller('layersDialogController', layersDialogController);

    /*@ngInject*/
    function layersDialogController ($mdDialog, overlays) {
        var vm = this;

        angular.extend(vm, {
            overlays: angular.copy(overlays),
            submit: submit,
            cancel: $mdDialog.cancel
        });

        function submit() {
            $mdDialog.hide({ overlays: vm.overlays });
        }
    }

}());

(function() {
    'use strict';

    var component = {
        controller: vaiPlayerController,
        controllerAs: 'playerVm',
        bindings: {
            frames: '=',
            toggleAni: '&',
            toNext: '&',
            toPrev: '&',
            openReplayDialog: '&',
            timeline: '<',
            preloading: '<',
            overlays: '<',
            disableControls: '<',
            nowTime: '<'
        },
        templateUrl: 'app/components/dashboard/dashmap/vai-player/vai-player.tmpl.html'
    };

    angular
        .module('dashboard')
        .component('vaiPlayer', component);

    /*@ngInject*/
    function vaiPlayerController($scope, $timeout, $document, leafletFactory) {
        var playerVm = this;
        angular.extend(playerVm, {
            playing: false,
            $onInit: activate,
            togglePlay: togglePlay
        });

        ////////////////

        function activate() {
            leafletFactory.disableInteraction($document[0].querySelector( '#vai-player' ));
        }

        function togglePlay() {
            playerVm.playing = !playerVm.playing;
            playerVm.toggleAni();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('fews')
        .factory('searchFactory', searchFactory);

    function searchFactory($http, $q) {
        var factory = {
            getPlaces: getPlaces
        };

        return factory;

        //////////////////////

        function getPlaces(query, center) {
            var req = {
                method: 'GET',
                url: 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + query + '.json',
                headers: {
                    'Content-Type': 'application/json'
                },
                params: {
                    access_token: "pk.eyJ1IjoiamVhbnZpZXV4IiwiYSI6Iksxc0Z3dTAifQ.enIr_jXRCpLAfZQa8rmdjA",
                    proximity: center.lng + "," + center.lat,
                    country: 'us'
                }
            };

            return $http(req)
                .then(xhrComplete, xhrFailed);
        }

        function xhrComplete(response) {
            return $q.resolve(response.data.features);
        }

        function xhrFailed(error) {
            return $q.reject(error);
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('fews')
    .factory('searchService', searchService);


    function searchService() {
      var service = {
        searchController: searchController
      }

      return service;


    /*@ngInject*/
    function searchController ($q, $mdDialog, searchFactory, center, gauges, mapBounds) {

      var scVm = this;

      scVm.cancel = function() {
          $mdDialog.cancel();
      };

      scVm.selectedItemChange = selectedItemChange;
      scVm.querySearch = querySearch;

      function selectedItemChange(item) {
          $mdDialog.hide(item);
      }

      function querySearch(query) {

          var deferred = $q.defer();

          searchFactory.getPlaces(query, center)
              .then(function(results) {

                  // must count down for splicing
                  for (var i = results.length - 1; i >= 0; i--) {
                      if(outOfBounds(results[i].center)) {
                          results.splice(i, 1);
                      }
                  }

                  var reformattedArray = results.map(function(obj){
                      var name;
                      var address = obj.properties.address


                      if (obj.place_type[0] == 'poi') {
                        name = obj.text;
                      } else if (obj.place_type[0] == 'address') {
                        name = (angular.isDefined(obj.address) ? obj.address : '') + ' ' + obj.text;
                      }

                      var rObj = {
                          name: angular.isDefined(name) ? name : '',
                          id: address,
                          lat: obj.center[1],
                          lng: obj.center[0]
                      };
                      return rObj;
                  });

                    for (var gauge in gauges) {
                      var gaugeName = gauges[gauge].name.toLowerCase(),
                          gaugeId = gauges[gauge].id.toLowerCase(),
                          searchQuery = query.toLowerCase();

                      if(gaugeName.indexOf(searchQuery) > -1 || gaugeId.indexOf(searchQuery) > -1)
                          reformattedArray.unshift(gauges[gauge]);
                  }

                  deferred.resolve(reformattedArray);
              });

          return deferred.promise;
      }

      function outOfBounds(obj) {
          var southWest = mapBounds[1];
          var northEast = mapBounds[0];

          return obj[1] > southWest[0] ||
                 obj[1] < northEast[0] ||
                 obj[2] > southWest[1] ||
                 obj[2] < northEast[1];
      }
    }
  }
})();

(function() {
  'use strict';
  angular
    .module('fews')
    .factory('overlayFactory', overlayFactory);

  /*@ngInject*/
  function overlayFactory($rootScope, $http, $q, API_URL, $cacheFactory, $auth,
      atxFactory, afdFactory, nowcoast, gaugeMarkersFactory, timeFactory,
      austin311Factory, wpFactory, afdStationsFactory,
      jurisdictionFactory, prefFactory) {

    var token = $auth.getToken();
    var prebuilt = {};
    var bounds = [
      [30.640, -97.424],
      [29.943, -98.088]
    ]; // [NE, SW]
    var cache = $cacheFactory('notificationsItems');
    var maxtimeGARR = 0;
    var service = {
      loadwatchpoints: loadwatchpoints,
      loadaustin311: loadaustin311,
      loadafdstations: loadafdstations,
      loadatx: loadatx,
      loadNowCOAST: loadNowCOAST,
      loadinundation: loadinundation,
      loadvaiStructures: loadvaiStructures,
      loadgauges: loadgauges,
      loadafdflood: loadafdflood,
      loadgarr: loadgarr,
      loadreflectivity: loadreflectivity
    };


    return service;
    ////////////////

    function loadwatchpoints(nowTime) {
      // set nowTime to last 5 minute interval
      nowTime.setMinutes(nowTime.getMinutes() - (nowTime.getMinutes() % 5));
      nowTime.setSeconds(0,0);

      var deferred = $q.defer();
      var timeStamp = nowTime.getTime();

      var requests = [
        wpFactory.retrieve(),
        prefFactory.getClustering()
      ]

        $q.all(requests).then(function(response) {
          var unformatted = response[0];
          var clustering = response[1];
          wpFactory.getReadings(timeStamp - (1000*60*60*2), timeStamp)
            .then(function(readings){
              unformatted.readings = readings;
              wpFactory.markers(unformatted, clustering)
                .then(function(formatted) {
                  wpFactory.updateWithRecent(formatted.markers, readings);
                  prebuilt.watchpoints = formatted;
                  deferred.resolve(prebuilt.watchpoints);
                });
          });
        }, function(error) {
          deferred.reject(error);
      });

      return deferred.promise;
    }

    function loadaustin311(x, y, z, replay) {
      var deferred = $q.defer();

      
      $rootScope.$broadcast('load311Start');
      austin311Factory.get(replay ? x : false)
        .then(function(unformatted) {
          cache.put('311', unformatted);
          $rootScope.$broadcast('load311End');
          $rootScope.$broadcast('notificationsUpdated');
          austin311Factory.markers(unformatted)
            .then(function(formatted) {
              deferred.resolve(formatted);
            });
        }, function(error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function loadafdstations(x, y, overlay) {
      var deferred = $q.defer();
      var promises = [
        afdStationsFactory.getMeta(),
        afdStationsFactory.getLocations()
      ];

      $q.all(promises).then(function(response) {
        angular.forEach(response[1], function (val1) {
          var keepGoing = true;
          angular.forEach(response[0], function (val0) {
            if (keepGoing && val1.name === val0.station_name) {
              angular.merge(val1, val0);
            }
          });
        });

        var overlayInfo = {
          type: 'afdstations',
          overlay: overlay,
          markers: response[1]
        };

        afdStationsFactory.formatResponse(overlayInfo).then(function(data) {
          deferred.resolve(data);
        });
      });

      return deferred.promise;
    }

    function loadgauges(overlayTime, duration_hours) {
      var deferred = $q.defer();
      overlayTime = timeFactory
                      .getLastInterval(15, overlayTime)
                      .getTime();

      if(overlayTime > maxtimeGARR) {
        getMaxtime().then(finishLoadGauges);
      } else {
        finishLoadGauges(overlayTime);
      }

      return deferred.promise;

      function finishLoadGauges(max) {
        var maxtime = parseInt(max.data);
        maxtimeGARR = maxtime;

        if(overlayTime > maxtime) {
          overlayTime = maxtime;
        }

        var start = overlayTime - (duration_hours * 1000 * 60 * 60);
        var requests = [
          gaugeMarkersFactory.getGauges(),
          prefFactory.getClustering(),
          gaugeMarkersFactory.getAccumulation(start, overlayTime)
        ];

        $q.all(requests).then(function(response) {
          gaugeMarkersFactory.formatMarkers(response[0].data, response[1]).then(function(formatted) {
            gaugeMarkersFactory.updateWithAccumulation(formatted.markers, response[2].data);
            formatted.overlay.layerOptions.time = overlayTime;
            prebuilt.gauges = formatted;

            deferred.resolve(prebuilt.gauges);
          });
        });
      }
    }

    function loadafdflood() {

      var deferred = $q.defer();

      function bindPop(feature, layer) {
        var popup = L.popup().setContent(
          '<a target="_blank" href="'+ feature.properties.URL +'">'+ feature.properties.Name +'</a>'
        );
        layer.bindPopup(popup);
      }

      afdFactory.getAFDFlood().then(function(data){

        deferred.resolve({
          type: 'afdflood',
          overlay: {
            id: 'afdflood',
            name: 'AFD Flood Maps',
            type: 'geoJSONShape',
            data: data,
            layerOptions: {
              style: {
                "color": "#d1dbbd",
                "fillColor": "#d1dbbd",
                "weight": 1,
                "opacity": 0.6,
                "fillOpacity": .2
              },
              onEachFeature: bindPop
            }
          }
        });
      }, function(error){
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function loadatx(time, layer, layerConfigObject, replay) {
      var deferred = $q.defer();

      if (angular.isDate(time)) {
        time = time.getTime();
      }

      if (layerConfigObject.legend.settings.params[0].value !== true) {
        jurisdictionFactory.setJurisdiction();
      } else {
        jurisdictionFactory.toggleDefaultJurisdictions();
      }

      $rootScope.$broadcast('loadAtxStart');
      atxFactory.getLatest(time, layer, replay)
        .then(function(unformatted) {
          cache.put('atx', unformatted);
          $rootScope.$broadcast('loadAtxEnd');
          $rootScope.$broadcast('notificationsUpdated');
          atxFactory.formatMarkers(unformatted, layerConfigObject)
            .then(function(formatted) {
              deferred.resolve(formatted);
            });
        }, function(error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function loadNowCOAST(activeLayer, layerConfigObject) {
      var deferred = $q.defer();
      var services = layerConfigObject.service;
      var layerID = activeLayer.toString();
      var opacity = angular.isDefined(layerConfigObject.legend.settings.opacityValue) ? layerConfigObject.legend.settings.opacityValue : 0.65;

      nowcoast.getProdTime({service: services[0]}).then(function(res){
        var prodTime = (res.prodTime || res.layers[0].prodTime);
        var overlay = {
          type: 'wms',
          doRefresh: true,
          layerParams: {
            version: '1.3.0',
            format: 'png32',
            f: 'image',
            transparent: true,
            showOnSelector: false
          },
          layerOptions: {
            zIndex: layerConfigObject.layerParams.zIndex,
            opacity: opacity
          }
        };

        var response = {type: layerConfigObject.id};

        var merge = {
          name: layerConfigObject.name,
          id: layerConfigObject.id,
          url: API_URL.slice(0, -4) + 'arcgis/rest/services/nowcoast/' + layerConfigObject.service[0] + '/MapServer/export',
          layerParams: {
            time: prodTime,
            layers: layerID
          }
        };

        if (services.length > 1) {
          var layerDictionary = {
            'wwa_meteoceanhydro_shortduration_hazards_watches_time': {
              layers: 'visible:0,1,2',
              name: 'shortWatches'
            },
            'wwa_meteoceanhydro_shortduration_hazards_warnings_time': {
              layers: 'visible:1,3,4',
              name: 'shortWarnings'
            }
          };

          var layers = services.map(function(d) {
            return angular.merge({}, overlay, {
              name: layerDictionary[d].name,
              url: API_URL.slice(0, -4) + 'arcgis/rest/services/nowcoast/' + d + '/MapServer/export',
              layerParams: {
                "layers": layerDictionary[d].layers
              }
            });

          });

          var group = {
            id: 'watchWarn',
            name: 'Watches and Warnings',
            type: 'group',
            visible: layerConfigObject.visible,
            doRefresh: true,
            layerOptions: {
              layers: layers,
              time: new Date(prodTime).getTime()
            }
          };
          response.overlay = group;
        } else {
          response.overlay = angular.merge({}, overlay, merge);
        }
        deferred.resolve(response);
      });

      return deferred.promise;
    }

    function loadinundation(time, activeLayer, layerConfigObject, replay) {
      if (angular.isDate(time)) time = time.getTime();
      if (time === 0) return $q.reject('time was 0');
      var tileLayer = {
        id: 'inundation',
        name: 'Inundation',
        type: 'xyz',
        url: API_URL + 'inundation/tile/{z}/{x}/{y}.png?contour={contour}&'+ (replay?'time-of-forecast':'r') + '={time}&accesstoken={accesstoken}',
        minZoom: 12,
        visible: layerConfigObject.visible,
        doRefresh: true,
        layerOptions: {
          opacity: layerConfigObject.legend.settings.opacityValue,
          zIndex: layerConfigObject.layerParams.zIndex,
          errorTileUrl: 'assets/images/error-tile.png',
          bounds: bounds,
          minZoom: 10,
          maxZoom: 18,
          contour: layerConfigObject.legend.settings.params[0].value,
          time: time,
          accesstoken: token
        }
      };

      var response = {
        type: 'inundation',
        overlay: tileLayer
      }

      return $q.resolve(response);
    }

    function loadreflectivity(time, activeLayer, layerConfigObject, replay) {
      if (angular.isDate(time)) time = time.getTime();
      if (time === 0) return $q.reject('time was 0');
      //Hardcoded VDS-style auth token for the austin.admin VIP user
      var authToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJ3d3cudmlldXhpbmMuY29tIiwic3ViIjoiYXVzdGluLmFkbWluIiwiZXhwIjozMzMwNDQxMDAwMH0.gyzV7TMNta7fgIxCCG9kUnYi5kwZeaZQX34MpQsSQjU';
      var tileLayer = {
        id: 'reflectivity',
        name: 'Reflectivity',
        type: 'xyz',
        url: 'https://vip.vieuxinc.com/api/reflectivity/tiles/{z}/{x}/{y}.png?'+ (replay?'time':'r') + '={time}&accesstoken={accesstoken}',
        minZoom: 12,
        visible: layerConfigObject.visible,
        doRefresh: true,
        layerOptions: {
          opacity: layerConfigObject.legend.settings.opacityValue,
          zIndex: layerConfigObject.layerParams.zIndex,
          errorTileUrl: 'assets/images/error-tile.png',
          time: time,
          accesstoken: authToken
        }
      };

      var response = {
        type: 'reflectivity',
        overlay: tileLayer
      }

      return $q.resolve(response);
    }

    function loadvaiStructures(time, layer, layerConfigObject, replay) {
      if (replay) time = time.getTime();
      if (time === 0) return $q.reject('time was 0');
      var structureBounds = [
        [30.111300, -97.961740],
        [30.502901, -97.597732]
      ];
      var tileLayer = {
        id: 'vaiStructures',
        name: 'Structures',
        type: 'xyz',
        url: API_URL + 'structures/' + (layer || '') + 'eval_tiles/{z}/{x}/{y}.png?'+(replay?'timeOfSimulation':'r')+'={time}&onlyInundated={onlyInundated}&accesstoken={accesstoken}',
        visible: layerConfigObject.visible,
        doRefresh: true,
        layerOptions: {
          time: time,
          opacity: layerConfigObject.legend.settings.opacityValue,
          errorTileUrl: 'assets/images/error-tile.png',
          bounds: structureBounds,
          minZoom: 10,
          maxZoom: 18,
          onlyInundated: layerConfigObject.legend.settings.params[0].value,
          accesstoken: token
        }
      };

      var response = {
        type: 'vaiStructures',
        overlay: tileLayer
      };

      //Load inundated structure data and cache them for the benefit of the live alert feed
      $rootScope.$broadcast('loadBridgesStart');
      loadInundatedBridges(replay ? time : -1).then(function(response) {
        if (response.status == 200) {
          cache.put('bridges', response.data);
        }
        $rootScope.$broadcast('loadBridgesEnd');
      });
      $rootScope.$broadcast('loadBuildingsStart');
      loadInundatedBuildings(replay ? time : -1).then(function(response) {
        if (response.status == 200) {
          cache.put('buildings', response.data);
        }
        $rootScope.$broadcast('loadBuildingsEnd');
      });

      return $q.resolve(response);
    }

    function loadInundatedBridges(timeOfSimulation) {
      var req = {
        method: 'GET',
        url: API_URL + 'structures/bridge_evals.json',
        cache: true,
        params: {
          onlyInundated: true,
          timeOfSimulation: timeOfSimulation
        }
      };

      return $http(req);
    }

    function loadInundatedBuildings(timeOfSimulation) {
      var req = {
        method: 'GET',
        url: API_URL + 'structures/building_evals.json',
        cache: true,
        params: {
          onlyInundated: true,
          timeOfSimulation: timeOfSimulation
        }
      };

      return $http(req);
    }

    function loadgarr(time, selectedHours, layerConfigObject) {
      var deferred = $q.defer();
      var timeMill = time.getTime();

      var tileLayer = {
        id: 'garr',
        name: 'GARR',
        type: 'xyz',
        url: API_URL + 'vieux-data-services/{project}/rainvieux/mosaic/{mosaic}/range/{startTime}/{endTime}/tiles/{z}/{x}/{y}.png?accesstoken={accesstoken}',
        visible: layerConfigObject.visible,
        doRefresh: true,
        layerOptions: {
          project: 'austin',
          mosaic: 'austin-grid',
          accesstoken: token
        }
      };

      if(timeMill > maxtimeGARR) {
        getMaxtime().then(processLayer);
      } else {
        processLayer(maxtimeGARR);
      }

      return deferred.promise;

      function processLayer(res) {
        var maxtime = parseInt(res.data);
        maxtimeGARR = maxtime;

        if(timeMill > maxtime) {
          timeMill = maxtime;
        }

        angular.extend(tileLayer.layerOptions, {
          startTime: timeMill - (6e4 * 60 * (selectedHours || 3)),
          endTime: timeMill
        });

        var response = {
          type: 'garr',
          overlay: tileLayer
        };

        deferred.resolve(response);
      }
    }

    function getMaxtime() {
      var req = {
        method: 'GET',
        url: API_URL + 'vieux-data-services/austin/rainvieux/mosaic/austin-grid/maxtime',
        cache: true,
        params: {
          r: timeFactory.getLastInterval()
        }
      };

      return $http(req);
    }
  }
})();

(function() {
    'use strict';
    angular
        .module('fews')
        .factory('nowcoast', nowcoast);

    /*@ngInject*/
    function nowcoast($http, $q, $log, $httpParamSerializer, API_URL) {

        var service = {
            getService: getService,
            getProdTime: getProdTime,
            imageOverlays: imageOverlays,
            wmsOverlays: wmsOverlays,
            radar: radar
        };

        return service;
        ////////////////

        function getService (service) {
            var req = {
                method: 'JSONP',
                url: API_URL.slice(0, -4) + 'arcgis/rest/services/nowcoast/' + service + '/MapServer',
                params: {
                    f: 'pjson',
                    returnUpdates: true,
                    callback: 'JSON_CALLBACK'
                }
            };

            return $http(req).then(xhrComplete, xhrFailed);
        }

        function getProdTime(params) {
            var config = {
                method: 'JSONP',
                url: API_URL.slice(0, -4) + 'layerinfo',
                params: {
                    request: 'prodtime',
                    service: 'sat_meteo_imagery_time',
                    layers: 3,
                    format: 'jsonp',
                    padded: true,
                    callback: 'JSON_CALLBACK'
                }
            }
            angular.extend(config.params, params);
            return $http(config).then(xhrComplete, xhrFailed);
        }

        function imageOverlays (service, map, customSettings) {
            var overlays = {};
            for (var i = 0; i < service.timeStops.length; i++) {
                var size = map.getSize(),
                    bounds = map.getBounds(),
                    bboxNE = map.options.crs.project(bounds._northEast),
                    bboxSW = map.options.crs.project(bounds._southWest),
                    params = {
                        transparent: true,
                        time: new Date(service.timeStops[i]).getTime(),
                        format: 'png8',
                        layers: 'show:3',
                        bbox: bboxNE + ',' + bboxSW,
                        size: size.x + ',' + size.y,
                        f: 'image'
                    };

                overlays[service.aniId + '_' + service.timeStops[i]] = {
                    name: service.name,
                    type: 'imageOverlay',
                    visible: false,
                    url: API_URL.slice(0, -4) + 'arcgis/rest/services/' + service.id + '/MapServer/export?' + $httpParamSerializer(params),
                    bounds: map.getBounds(),
                    layerOptions: {
                        showOnSelector: false,
                        opacity: .65,
                        aniOverlay: service.service,
                        zIndex: service.zIndex
                    },
                    layerParams: {
                        zIndex: service.zIndex
                    }
                };

                if (customSettings !== null)
                    angular.merge(overlays[service.aniId + '_' + service.timeStops[i]], customSettings);
            }

            return $q.resolve(overlays);
        }

        function wmsOverlays (service, customSettings) {
            var overlays = {};
            for (var i = 0; i < service.timeStops.length; i++) {

                overlays[service.aniId + '_' + service.timeStops[i]] = {
                    name: service.name,
                    type: 'wms',
                    visible: false,
                    url: API_URL.slice(0, -4) + 'arcgis/services/' + service.id + '/MapServer/WmsServer',
                    layerParams: {
                        time: new Date(service.timeStops[i]).toISOString(),
                        version: '1.3.0',
                        layers: service.layer,
                        format: 'image/png',
                        transparent: true,
                        opacity: .65,
                        showOnSelector: false,
                        zIndex: service.zIndex,
                        aniOverlay: service.service
                    }
                };

                if (customSettings !== null)
                    angular.merge(overlays[service.aniId + '_' + service.timeStops[i]], customSettings);
            }

            return $q.resolve(overlays);
        }

        function radar(time) {
            return {
                name: 'NOAA NWS NEXRAD MRMS Weather Radar Imagery',
                type: 'wms',
                visible: true,
                url: API_URL.slice(0, -4) + 'arcgis/services/nowcoast/radar_meteo_imagery_time/MapServer/WmsServer',
                layerParams: {
                    time: new Date(time).toISOString(),
                    version: '1.3.0',
                    layers: 1,
                    format: 'image/png',
                    transparent: true,
                    opacity: .75,
                    showOnSelector: false
                }
            };
        }

        function xhrComplete(response) {
            return $q.resolve(response.data);
        }

        function xhrFailed(error) {
            $log.error(error);
            return $q.reject(error);
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('fews')
        .factory('markerFactory', markerFactory);

    /*@ngInject*/
    function markerFactory() {
        var service = {
            getLatestTime: getLatestTime
        };
        return service;
        ////////////////

        function getLatestTime (markers, type) {
            var latestTime = null;
            var keyMap = {
                'atx':'changedTime'
            };
            var objKey = keyMap[type];

            angular.forEach(markers, function (value) {
                if (value[objKey] > latestTime)
                    latestTime = value[objKey];
            });

            return latestTime;
        }
    }
})();

(function() {
  'use strict';
  angular
    .module('fews')
    .factory('inundationFactory', inundationFactory);

  /*@ngInject*/
  function inundationFactory($rootScope, $q, $http, $timeout, API_URL, timeFactory) {
    var gridTimes = null;
    var structureTimes = null;
    var timeChecked = Date.now();
    var simTimes = null;
    var service = {
      checkTimes: checkTimes
    };

    loop(); // starts loop

    return service;
    ////////////////

    // public
    function checkTimes() {
      var deferred = new $q.defer();
      if (simTimes === null) {
        getSimTimes().then(function(response) {
          gridTimes = angular.copy(response.data.Grid);
          structureTimes = angular.copy(response.data.Structure);
          deferred.resolve(response.data);
        });
      } else {
        deferred.resolve(simTimes);
      }
      return deferred.promise;
    }

    // private
    function getSimTimes() {
      var req = {
        method: 'GET',
        url: API_URL + 'inundation/latest-time-of-simulation',
        headers: {'Content-Type':'application/json'},
        params: {r:timeChecked},
        cache: true
      };
      return $http(req).then(modelResponse);
    }

    function modelResponse(response) {
      var gridArr = Object.values(response.data.Grid);
      var structureArr = Object.values(response.data.Structure);
      var d = response.data;

      angular.extend(d, {
        oldestTime: Math.min.apply(null, gridArr.concat(structureArr)),
        newestTime: Math.max.apply(null, gridArr.concat(structureArr)),
        timesMatch: function() { return this.oldestTime === this.newestTime; },
        hasUpdate: false
      });

      if (structureTimes === null && gridTimes === null) {
        d.hasUpdate = true;
      } else {
        angular.forEach(d.Grid, function(_, key) {
          if (d.Structure[key] !== structureTimes[key] || d.Grid[key] !== gridTimes[key])
            d.hasUpdate = true;
        });
      }

      return $q.resolve(response);
    }

    /*
     *  If all sim times are the same and the time matches the
     *  interval before the last 15 minute interval, it waits 7.5 min
     *  after the following interval before requesting an update,
     *  otherwise keep checking every 2.5 minutes.
     */
    function loop() {
      getSimTimes().then(function(res) {
        var delay = 6e4 * 2.5;

        if (res.data.hasUpdate) {
          var lastInterval = timeFactory.getLastInterval(15).getTime();
          var prevInterval = lastInterval - (15 * 6e4); // interval before the last interval

          gridTimes = angular.copy(res.data.Grid);
          structureTimes = angular.copy(res.data.Structure);
          $rootScope.$broadcast('updateInundation', res.data);

          if (res.data.timesMatch()) {
            if (res.data.oldestTime === prevInterval) {
              if ((lastInterval + (6e4 * 10) - Date.now()) > 0) {
                delay = lastInterval + (6e4 * 10) - Date.now();
              }
            } else if (res.data.oldestTime === lastInterval) {
              delay = (lastInterval + (6e4 * 25)) - Date.now();
            }
          }
        }

        timeChecked = Date.now();
        simTimes = res.data;

        $timeout(loop, delay);
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('fews')
    .factory('identifyFactory', identifyFactory);

  function identifyFactory($http, $log, API_URL) {
    var factory = {
      locationService: locationService
    };

    return factory;

    //////////////////////
    function locationService(params) {
      var req = {
        method: 'GET',
        url: API_URL + 'inundation/location',
        headers: {
          'Content-Type': 'application/json'
        },
        params: {
          latitude: params.lat,
          longitude: params.lng
          //'time-of-simulation': params.time
        }
      };

      return $http(req)
        .then(xhrComplete, xhrFailed);
    }

    function xhrComplete(response) {
      return response.data;
    }

    function xhrFailed(error) {
      $log.error(error.status + " (" + error.statusText + ")");
    }
  }
})();

(function() {
  'use strict';
  angular.module('fews').factory('gaugeMarkersFactory', gaugeMarkersFactory);

  /*@ngInject*/
  function gaugeMarkersFactory($http, $q, $log, $filter, $injector, API_URL, gaugeFactory) {
    var service = {
      formatMarkers: formatMarkers,
      updateWithAccumulation: updateWithAccumulation,
      getGauges: gaugeFactory.getGaugeMarkers,
      getAccumulation: gaugeFactory.getGaugeByTime
    };
    return service;
    ////////////////

    function iconCreateFunction(cluster) {
        var childCount = cluster.getChildCount();
        var markers = cluster.getAllChildMarkers();
        var maxVal = 0;

        for (var i = markers.length - 1; i >= 0; i--) {
          var tempVal = parseFloat(markers[i].label._content);
          if (tempVal > maxVal)
            maxVal = tempVal;
        }

        return new L.DivIcon({
          html: '<div><span>' + childCount +
                '</span><div class="label-val">' +
                (maxVal === 0 ? maxVal.toFixed(2) : maxVal) +
                '</div></div>',
          className: 'marker-cluster gauge',
          iconSize: new L.Point(32, 32) });
    }

    function formatMarkers(gauges, clusterRadius) {
      var response = {
        type: 'gauges',
        markers: {},
        overlay: {
          layerOptions: {
              iconCreateFunction: iconCreateFunction,
              disableClusteringAtZoom: clusterRadius ? false : 0.1
          },
          legend: {
            markerCount: gauges.length
          }
        }
      };

      angular.forEach(gauges, function(d){
        var formattedId = d.id.replace(/\W+/g, '').toLowerCase();

        response.markers['gauges' + formattedId] = {
          name: d.name,
          title: d.name,
          id: d.id,
          feed: d.feed,
          lat: d.lat,
          lng: d.lng,
          layer: 'gauges',
          icon: {
            type: 'div',
            iconSize: [15, 15], // + 2 pixel border
            iconAnchor: [9, 9],
            popupAnchor: [0, 0],
            className: 'gauge-marker'
          },
          label: {
            message: '',
            options: {
              clickable: false,
              noHide: true,
              className: 'accumulation',
              offset: [-15, -25]
            }
          }
        };

      });

      return $q.resolve(response);
    }

    function updateWithAccumulation(gauges, accumulation) {
      accumulation.forEach(function(d){
        if (d.value >= 0) {
          var markerKey = 'gauges' + d.id.replace(/\W+/g, '').toLowerCase();
          var value = $filter('number')(d.value, 2);
          // if marker exists
          if (gauges[markerKey]) {
            // replace message
            gauges[markerKey].label.message = value.toString();
          }
        }
      });

      return gauges;
    }
  }
})();

(function() {
  'use strict';
  angular.module('fews')
    .factory('baselayerFactory', baselayerFactory);

  /*@ngInject*/
  function baselayerFactory($q, $log, screenFactory, MAPBOX_TOKEN) {
    var mapConfig = {
      "mapboxUrl": "https://api.mapbox.com/styles/v1/jeanvieux/",
      "defaults": {
        "type": "xyz",
        "layerOptions": {
          "showOnSelector": false,
          "reuseTiles": true,
          "isBaselayer": true,
          "opacity": 1,
          'access_token': MAPBOX_TOKEN
        }
      },
      "styles": [
        {
          "id": "dark",
          "name": "Dark",
          "styleUrl": "ciwnwi97g00522pplqboi9i91"
        }, {
          "id": "light",
          "name": "Light",
          "styleUrl": "cihezdxeo00lijnkxn9sshjl2"
        }, {
          "id": "outdoors",
          "name": "Outdoors",
          "styleUrl": "ciqcpdtye0010bxnn2i22y58c"
        }, {
          "id": "satellite",
          "name": "Satellite",
          "styleUrl": "cihezy2vk00n26vm53rpa7q4w"
        }, {
          "id": "streams",
          "name": "Streams",
          "styleUrl": "cj4y9l56z3lre2so26addel84"
        }, {
          "id": "watersheds",
          "name": "COA Watersheds",
          "styleUrl": "cj6tbtqgz0ka32rmgodlr3hkr"
        }
      ]
    };

    var service = {
      getDirectory: getDirectory,
      buildLayer: buildLayer,
      getMap: getMap
    };
    return service;

    ////////////////

    function getDirectory() {
      return $q.when(mapConfig);
    }

    function buildLayerObject(style) {
      var baselayer = {
        name: style.name,
        url: mapConfig.mapboxUrl + style.styleUrl + '/tiles/256/{z}/{x}/{y}{isRetina}?access_token={access_token}',
        layerOptions: {
          isRetina: (screenFactory.isHighDensity() ? '@2x' : '')
        }
      };

      return angular.merge(baselayer, mapConfig.defaults);
    }

    function buildLayer(style) {
      return $q.when(buildLayerObject(style));
    }

    // get map by style name
    function getMap(name) {

      var search = mapConfig.styles.find(function(d) {
        return name === d.id;
      });

      if (!search) {
        $log.error('The baselayer '+ name +' is not listed in the directory.');
        search = mapConfig.styles[0];
      }

      return buildLayerObject(search);
    }

  }
})();

(function() {
  'use strict';
  angular
    .module('fews')
    .factory('austin311Factory', austin311Factory);

  /*@ngInject*/
  function austin311Factory($http, $q, $log, $httpParamSerializer, API_URL) {
    var service = {
      get: get,
      markers: markers
    };
    return service;
    ////////////////
    function get(time) {
      if (angular.isDate(time)) {
        time = time.getTime();
      }

      // last 6 hours
      var end_date = time ? new Date(time) : new Date();
      var start_date = new Date(end_date);
      start_date.setHours(start_date.getHours() - 6);

      // angular http request object
      var req = {
        method: 'GET',
        url: API_URL + '311/requests.json',
        params: {
          start_date: start_date.toISOString(),
          end_date: end_date.toISOString()
        }
      };

      return $http(req).then(function(res) {
        for (var i = 0; i < res.data.length; i++) {
          angular.extend(res.data[i], {
            agency_responsible: res.data[i].agencyResponsible,
            lat: res.data[i].latitude,
            long: res.data[i].longitude,
            requested_datetime: res.data[i].requestedDateTime,
            service_code: res.data[i].serviceCode,
            service_name: res.data[i].serviceName,
            service_request_id: res.data[i].serviceRequestID,
            updated_datetime: res.data[i].updatedDateTime,
            status_notes: res.data[i].statusNotes
          });

          res.data[i].ackStatus = res.data[i].threeOneOneStatus || [];
          res.data[i].isAck = (res.data[i].ackStatus.length > 0) &&
                              (res.data[i].ackStatus[res.data[i].ackStatus.length - 1].status === 'ACKNOWLEDGED');
        }

        return $q.resolve(res.data);
      });
    }

    function getLatestTime(array) {
      var mostRecentTime = 0;

      for (var i = 0; i < array.length; i++) {
        var thisTime = new Date(array[i].requestedDateTime).getTime();
        if (thisTime > mostRecentTime) {
          mostRecentTime = thisTime;
        }
      }

      return mostRecentTime;
    }

    function markers(markerData) {
      var austin311Markers = {};
      var latestTime = getLatestTime(markerData);
      var overlay = {
        layerOptions: {
          maxClusterRadius: 16,
          iconCreateFunction: iconCreateFunction
        },
        legend: {
          markerCount: markerData.length
        }
      };

      if(latestTime > 0) {
        overlay.layerOptions.time = new Date(latestTime);
      }

      angular.forEach(markerData, function(marker) {
        if (angular.isNumber(marker.lat) && angular.isNumber(marker.long)) {
          austin311Markers['austin311' + marker.service_request_id.replace('-', '')] = {
            layer: 'austin311',
            lat: marker.lat,
            lng: marker.long,
            message: getMessage(marker),
            name: marker.address,
            icon: {
              type: 'div',
              iconSize: [12, 12],
              className: 'md-whiteframe-1dp austin-311',
              iconAnchor: [6, 6]
            },
            popupOptions: {
              maxWidth: 300,
              autoPan: false,
              closeButton: false,
              offset: [0, -2],
              className: 'popup-311'
            }
          }
        }
      });

      var response = {
        type: 'austin311',
        overlay: overlay,
        markers: austin311Markers
      };

      return $q.resolve(response);

      /////////////////

      function iconCreateFunction(cluster) {
        var childCount = cluster.getChildCount();

        return new L.DivIcon({
          html: '<div><span>' + childCount + '</span></div>',
          className: 'marker-cluster cluster-311',
          iconSize: new L.Point(32, 32)
        });
      }

      function getMessage(data) {
        var html = '<div class="austin-311-marker-info" layout="column">' +
          (data.description ? '<div class="info">' + data.description + '</div>' : '') +
          (data.status_notes ? '<div class="info">' + data.status_notes + '</div>' : '') +
          ('<div class="address">' + data.address + '</div>') +
          '<div class="title" layout="column">' +
          data.agency_responsible +
          '<span>' + moment(data.requested_datetime).format('HH:mm YYYY/MM/DD') + '</span>' +
          '</div>' +
          '</div>';

        return html;
      }
    }
  }
})();

(function() {
    'use strict';
    angular
        .module('fews')
        .factory('atxFactory', atxFactory);

    /*@ngInject*/
    function atxFactory($http, $q, $log, markerFactory, jurisdictionFactory, API_URL) {
        var service = {
            getLatest: getLatest,
            formatMarkers: formatMarkers
        };
        return service;
        ////////////////
        function getLatest(time, include, replay) {
            var diff = (1000 * 60 * 60 * 24 * 3);
            var jurisdictions = jurisdictionFactory.getJurisdiction();
            var req = {
                method: 'GET',
                url: API_URL + 'atx-lowwater-crossings/latest',
                cache:true,
                params: {
                  jurisdictions: jurisdictions ? jurisdictions.join() : null
                }
            };

            angular.extend(req.params, {
              after: replay ? (time - diff) : ((time || new Date().getTime()) - diff),
              fakeNow: replay ? time : null,
              include: include
            });

            return $http(req)
                .then(xhrComplete, xhrFailed);
        }

        function formatMarkers (atxlwc) {
            var latestTime = markerFactory.getLatestTime(atxlwc, 'atx');
            var markers = {};
            var overlay = {
                name: 'ATX Low Water Crossings',
                type: 'markercluster',
                layerParams: {
                    showOnSelector: false
                },
                layerOptions: {
                    maxClusterRadius: 16,
                    iconCreateFunction: iconCreateFunction,
                    type: 'atx'
                },
                legend: {
                    markerCount: Object.keys(atxlwc).length
                }
            };

            if (latestTime > 0) {
              overlay.layerOptions.time = new Date(latestTime);
            }

            angular.forEach(atxlwc, function (value, key) {
                var status = value.state || (value.caution ?
                    'caution' : (value.open ? 'open' : 'closed'));

                markers['atx' + key] = {
                    layer: 'atx',
                    lat: value.latitude,
                    lng: value.longitude,
                    message: getMessage(value),
                    name: value.name,
                    icon: {
                        type: 'div',
                        iconSize: [12, 12],
                        className: 'md-whiteframe-1dp atxlwc ' + status,
                        iconAnchor:  [6, 6]
                    }
                };
            });

            var response = {
                type: 'atx',
                overlay: overlay,
                markers: markers
            };

            return $q.resolve(response);

            /////////////////

            function iconCreateFunction(cluster) {
                var childCount = cluster.getChildCount();

                return new L.DivIcon({ html: '<div><span>' + childCount + '</span></div>', className: 'marker-cluster atx', iconSize: new L.Point(32, 32) });
            }

            function getMessage (data) {
                var changedTime = '<br><strong>Changed to ' +
                    data.state || (data.caution ? 
                        'caution' : (data.open ? 'open' : 'closed')) +
                    '</strong> at ' + moment(data.changedTime + (1000 * 60 * 5))
                        .format('HH:mm on YYYY/MM/DD');

                return '<strong>Name:</strong> ' + data.name +
                    '<br><strong>Jurisdiction:</strong> ' + data.jurisdiction +
                    changedTime +
                    (data.comment !== null ? '<br><strong>Comment:</strong> ' + data.comment : '');
            }
        }

        function xhrComplete(response) {
            return $q.resolve(response.data);
        }

        function xhrFailed(error) {
            $log.error(error);
            return $q.reject(error);
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('fews')
        .factory('afdStationsFactory', afdStationsFactory);

    /* @ngInject */
    function afdStationsFactory($http, $q, $log) {
        var austinUrl = '//data.austintexas.gov/resource/';
        var locationsHasError = false;
        var metaHasError = false;
        var endMetaLoop;
        var endLocationsLoop;
        var service = {
            getLocations: getLocations,
            getMeta: getMeta,
            formatResponse: formatResponse
        };
        return service;
        ////////////////
        function getLocations() {
            var url = austinUrl + 'szku-46rx.json';
            var fallbackUrl = 'app/components/dashboard/dashmap/overlay-services/afd-fallback-locations.json';
            var req = {
                method: 'GET',
                url: locationsHasError ? fallbackUrl : url,
                headers: { 'Content-Type': 'application/json' },
                skipAuthorization: !locationsHasError,
                cache: true
            }
            endLocationsLoop = !locationsHasError;

            return $http(req)
                .then(xhrLocationsComplete, xhrLocationsFailed);
        }

        function getMeta() {
            var url = austinUrl + 'szku-46rx.json';
            var fallbackUrl = 'app/components/dashboard/dashmap/overlay-services/afd-fallback-meta.json';
            var req = {
                method: 'GET',
                url: metaHasError ? fallbackUrl : url,
                headers: { 'Content-Type': 'application/json' },
                skipAuthorization: !metaHasError,
                cache: true
            }
            endMetaLoop = !metaHasError;

            return $http(req)
                .then(xhrMetaComplete, xhrMetaFailed);
        }

        function formatResponse(overlayInfo) {
            var markers = {};
            var overlay = {
                layerParams: {
                    showOnSelector: false
                },
                layerOptions: {
                    maxClusterRadius: 16,
                    type: 'afdstations'
                },
                legend: {
                    markerCount: Object.keys(overlayInfo.markers).length
                }
            };

            angular.forEach(overlayInfo.markers, function (value) {
                markers['afdstations' + value.name] = {
                    layer: 'afdstations',
                    lat: Number(value.location_1.latitude),
                    lng: Number(value.location_1.longitude),
                    message: getMessage(value),
                    name: value.name,
                    icon: {
                        type: 'div',
                        iconSize: [12, 12],
                        className: 'md-whiteframe-1dp station',
                        iconAnchor:  [6, 6]
                    }
                };
            });

            var response = {
                type: overlayInfo.type,
                overlay: angular.merge({}, overlayInfo.overlay, overlay),
                markers: markers
            };

            return $q.resolve(response);

            /////////////////

            function getMessage (data) {
                return '<strong>ID:</strong> ' + data.name +
                    '<br><strong>Address:</strong> ' + data.location_1.human_address.split(',')[0].split(':')[1].replace(/['"]+/g, ''); // +
                    //'<br><strong>Unit:</strong> ' + data.station_unit;
            }
        }

        function xhrMetaComplete(response) {
            metaHasError = false;
            return $q.resolve(response.data);
        }

        function xhrLocationsComplete(response) {
            locationsHasError = false;
            return $q.resolve(response.data);
        }

        function xhrMetaFailed(error) {
            metaHasError = true;
            $log.error(error);
            return endMetaLoop ? getMeta() : $q.reject(error);
        }

        function xhrLocationsFailed(error) {
            locationsHasError = true;
            $log.error(error);
            return endLocationsLoop ? getLocations() : $q.reject(error);
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('fews')
        .factory('afdFactory', afdFactory);

    /*@ngInject*/
    function afdFactory($http, $q, $log, API_URL) {
        var service = {
            getAFDFlood: getAFDFlood
        };
        return service;
        
        function getAFDFlood() {
          var req = {
              method: 'GET',
              url: API_URL + 'layers/afd_maps/outline.json',
              headers: {'Content-Type':'application/json'}
          };

          return $http(req).then(xhrComplete, xhrFailed);
        }

        function xhrComplete(response) {
            return $q.resolve(response.data);
        }

        function xhrFailed(error) {
            $log.error(error);
            return $q.reject(error);
        }
    }
})();

/* globals moment */
(function() {
  'use strict';

  angular
    .module('fews')
    .factory('hyetoFactory', hyetoFactory);

  function hyetoFactory($http, $log, API_URL, VDS_URL) {
    var factory = {
      getBin: getBin,
      getGauge: getGauge,
      getChartWidth: getChartWidth,
      getChartSettings: getChartSettings,
      getChart: getChart,
      round: round,
      baseUrl: API_URL + VDS_URL
    };

    return factory;

    //////////////////////

    function getBin(binId, range, mosaic) {
      var startTime = range.fromDate.getTime(),
        endTime = range.toDate.getTime(),
        req = {
          method: 'GET',
          url: factory.baseUrl + 'rainvieux/mosaic/' + mosaic + '/range/' + startTime + '/' + endTime + '/bin/' + binId + '/hyetograph.json',
          headers: {
            'Content-Type': 'application/json'
          }
        };

      return $http(req)
        .then(xhrComplete, xhrFailed);
    }

    function getGauge(gaugeId, range) {
      var startTime = range.fromDate.getTime(),
        endTime = range.toDate.getTime(),
        req = {
          method: 'GET',
          url: factory.baseUrl + 'rainvieux/gaugedata/range/' + startTime + '/' + endTime + '/gauge/' + gaugeId + '/hyetograph.json',
          headers: {
            'Content-Type': 'application/json'
          }
        };

      return $http(req)
        .then(xhrComplete, xhrFailed);
    }

    function getChartWidth(range) {
      var hourDiff = (range.toDate.getTime() - range.fromDate.getTime()) / 1000 / 60 / 60;
      if (hourDiff <= 4) {
        return 300;
      } else if (hourDiff > 24) {
        return 600;
      } else {
        var addVal = hourDiff / 24 * 300;
        return round(300 + addVal, 2);
      }
    }

    function getChartSettings(timezone) {
      return {
        bindto: '#chart',
        data: {
          keys: {
            x: 'millis',
            value: ['cumulative', 'incremental']
          },
          type: 'bar',
          types: {
            cumulative: 'line'
          },
          axes: {
            cumulative: 'y',
            incremental: 'y2'
          },
          colors: {
            cumulative: '#FF8F00',
            incremental: '#FFC107'
          },
          names: {
            cumulative: 'Cumulative',
            incremental: 'Incremental'
          }
        },
        padding: {
          top: 0,
          right: 60,
          bottom: 35,
          left: 60
        },
        tooltip: {
          format: {
            title: function (d) {return moment.tz(d, timezone).format('YYYY/MM/DD HH:mm');}
          }
        },
        axis: {
          x: {
            type: 'timeseries',
            localtime: false,
            tick: {
              culling: true,
              fit: false,
              format: function(d) {
                return moment.tz(d, timezone).format('HH:mm MM/DD');
              },
              // format: '%H:%M %m/%d',
              rotate: -60,
              width: 50
            }
          },
          y: {
            padding: {
              top: 2,
              bottom: 2
            },
            label: {
              text: 'cumulative (in)',
              position: 'outer-middle'
            }
          },
          y2: {
            padding: {
              top: 5,
              bottom: 0
            },
            show: true,
            label: {
              text: 'incremental (in)',
              position: 'outer-middle'
            },
            inverted: true
          },
          zoom: {
            enabled: true,
            rescale: true
          }
        }
      }
    }

    function round(num, places) {
      if (num < 0 || num === null)
        return null;
      else {
        var multiplier = Math.pow(10, places);
        var rounded = Math.round(num * multiplier) / multiplier;
        return rounded;
      }
    }

    function getChart(data, range) {

      var chartWidth = getChartWidth(range);
      var timezone = 'America/Chicago';
      var xFormat = (chartWidth === 600) ? 'HH:mm MM/DD' : 'HH:mm';
      var rangeDiffHrs = (range.toDate.getTime() - range.fromDate.getTime()) / 1000 / 60 / 60;
      var IntervalsInHr = 4;
      var chartSettings = getChartSettings(timezone);

      var barWidth = Math.floor(
        (chartWidth - 100) / // chart width (accounting for side axis data)
        (rangeDiffHrs * IntervalsInHr) // number of intervals in an hour
      );

      var hyetoObj = {};
      var jsonData = [];

      if (data.gaugeHyetograph !== null) {
        data.gaugeHyetograph.forEach(function(d) {
          d.cumulative = round(d.cumulative, 3);
          d.incremental = round(d.incremental, 3);
          hyetoObj['m' + d.millis] = d;
        })
      }

      if (data.intersectingHyetograph !== null) {
        data.intersectingHyetograph.forEach(function(d) {
          d.cumulativeBin = round(d.cumulative, 3);
          d.incrementalBin = round(d.incremental, 3);
          delete d.cumulative;
          delete d.incremental;
          hyetoObj['m' + d.millis] = angular.merge({}, hyetoObj['m' + d.millis], d);
        })
      }

      jsonData = Object.keys(hyetoObj).map(function(key) {
        return hyetoObj[key]
      }).sort(compareMillis);

      for (var k = jsonData.length - 1; k >= 0; k--) {
        if (jsonData.length - 1 !== k) {
          if (angular.isUndefined(jsonData[k].cumulativeBin) && angular.isDefined(jsonData[k + 1].cumulativeBin))
            jsonData[k].cumulativeBin = jsonData[k + 1].cumulativeBin;

          if (angular.isUndefined(jsonData[k].cumulative) && angular.isDefined(jsonData[k + 1].cumulative))
            jsonData[k].cumulative = jsonData[k + 1].cumulative;
        }
      }

      if (data.intersectingHyetograph !== null) {

        angular.merge(chartSettings, {
          data: {
            keys: {
              value: ['cumulative', 'incremental', 'cumulativeBin', 'incrementalBin']
            },
            types: {
              cumulativeBin: 'line'
            },
            axes: {
              cumulativeBin: 'y',
              incrementalBin: 'y2'
            },
            colors: {
              cumulative: '#00838F',
              incremental: '#00BCD4',
              cumulativeBin: '#FF8F00',
              incrementalBin: '#FFC107'
            },
            names: {
              cumulative: 'Gauge Cumulative',
              incremental: 'Gauge Incremental',
              cumulativeBin: 'Grid Cumulative',
              incrementalBin: 'Grid Incremental'
            }
          },
          bar: {
            width: ((barWidth / 2) > 2) ? ((barWidth / 2) - 0.5) : 1
          },
          axis: {
            x: {
              tick: {
                format: function(d) {
                  return moment.tz(d, timezone).format(xFormat);
                }
              }
            }
          }
        });
      } else {
        angular.merge(chartSettings, {
          data: {
            keys: {
              value: ['cumulative', 'incremental']
            },
            colors: {
              cumulative: '#00838F',
              incremental: '#00BCD4'
            },
            names: {
              cumulative: 'Gauge Cumulative',
              incremental: 'Gauge Incremental'
            }
          },
          bar: {
            width: ((barWidth / 2) > 2) ? ((barWidth / 2) - 0.5) : 1
          },
          axis: {
            x: {
              tick: {
                format: function(d) {
                  return moment.tz(d, timezone).format(xFormat);
                }
              }
            }
          }
        });
      }

      chartSettings.data.json = jsonData;

      return chartSettings;
    }

    function compareMillis(a, b) {
      if (a.millis < b.millis)
        return -1;
      if (a.millis > b.millis)
        return 1;
      return 0;
    }

    function xhrComplete(response) {
      return response.data;
    }

    function xhrFailed(error) {
      $log.error(error.status + " (" + error.statusText + ")");
    }
  }
})();

(function() {
  'use strict';

  var component = {
    controller: mapClickPopupController,
    controllerAs: 'popVm',
    templateUrl: 'app/components/dashboard/dashmap/components/map-popup.tmpl.html',
    bindings: {
      results: '<',
      basins: '<',
      nowTime: '<'
    }
  };

  angular.module('fews').component('mapClickPop', component);

  /*@ngInject*/
  function mapClickPopupController($auth, API_URL, replayFactory) {

    var popVm = this;

    angular.extend(popVm, {
      isReplay: replayFactory.isActive
    });

    angular.extend(popVm, { API_URL: API_URL });

    angular.extend(popVm, {
      token: $auth.getToken()
    });
  }
})();

(function() {
  'use strict';

  angular.module('fews').factory('resourcesFactory', resourcesFactory);

  /*@ngInject*/
  function resourcesFactory($http, $q, $log, API_URL) {
    var service = {
      getResources: getResources
    };

    return service;
    ////////////////

    function getResources(){
      var req = {
        method: 'GET',
        url: API_URL + 'resources',
        headers: {'Content-Type':'application/json'},
        cache: true
      }

      return $http(req).then(xhrComplete, xhrFailed);
    }

    function xhrComplete(response) {
      return $q.resolve(response.data);
    }

    function xhrFailed(error) {
      $log.error(error);
      return $q.reject(error);
    }

  }
})();

(function(){
    'use strict';

    angular
        .module('dashboard')
        .controller('ResourcesController', resourcesController);

    /*@ngInject*/
    function resourcesController ($mdMedia, $mdDialog, list) {
        var vm = this;

        angular.extend(vm, {
          $mdMedia: $mdMedia,
          list: list,
          close: function() {
            return $mdDialog.hide();
          }
        });

    }

}());

(function() {
	'use strict';

	var component = {
		controller: roleListController,
		controllerAs: 'rlVm',
		bindings: { group: '<?rlGroup', roleType: '@?rlRoleType' },
		templateUrl: 'app/components/user-manager/role-list/role-list.tmpl.html'
	};

	angular
		.module('fews')
		.component('roleList', component);

	/*@ngInject*/
	function roleListController($mdDialog, $mdMedia, $mdToast, $timeout, userFactory, userManagerFactory) {
		var rlVm = this;
		angular.extend(rlVm, {
			$onInit: activate,
			loading: [],
			factory: userManagerFactory,
			openMemberDialog: openMemberDialog,
			deleteMemberDialog: deleteMemberDialog,
			listFilter: function(m) { return m.role.includes(rlVm.roleType); },
			roleMap: {
				'Proj_Admin': { name: 'Project Administrator', icon:'person' },
				'Admin': { name: 'Administrator', icon:'person' },
				'User': { name: 'User', icon:'person_outline' }
			}
		});

		////////////////

		function activate() {
			userFactory.getMe().then(function(res) {rlVm.me = res.data;});
		}

		function openMemberDialog(ev, member) {
			$mdDialog.show({
				templateUrl: 'app/components/user-manager/member-dialog/member.tmpl.html',
				controller: 'MemberController',
				controllerAs: 'mcVm',
				targetEvent: ev,
				fullscreen: $mdMedia('xs'),
				multiple: $mdMedia('xs'),
				bindToController: true,
				clickOutsideToClose: true,
				locals: {
					model: angular.copy(member),
					role: rlVm.roleType,
					groupPermissions: angular.copy(rlVm.group.permissions)
				}
			}).then(function(res) {
				if(angular.isDefined(res.memberId)) {
					updateMember(res);
				} else {
					addListMember(res);
				}
			});
		}

        function deleteMemberDialog(ev, member) {
			var dialogParams = {
				title: 'Delete ' + member.firstName + ' ' + member.lastName + '?',
				textContent: 'This member will be permanently deleted.'
			};

			$mdDialog
				.show(rlVm.factory.getConfirmDialog(ev, dialogParams))
				.then(function(res){
					if(res) removeListMember(member);
				});
        }

        function removeListMember(member) {
			var loadMark = 'member:' + member.memberId;
			addLoader(loadMark);
			var index = rlVm.group.members.findIndex(function(item) {
				return member.memberId === item.memberId;
			});
			rlVm.factory.deleteMember(rlVm.group.groupId, member.username)
				.then(function() {
					removeLoader(loadMark);
					rlVm.group.members.splice(index, 1);
					$mdToast.show($mdToast
						.simple()
						.textContent(
							'Deleted ' + rlVm.roleMap[member.role].name + ': ' +
							member.firstName + ' ' + member.lastName)
					);
				});
		}

		function addListMember(member) {
			addLoader('member:new');
			member.groupId = rlVm.group.groupId;
			if(member.groupId === '10' && member.role === 'Admin') {
				member.role = 'Proj_Admin';
			}
			var index = rlVm.group.members.push(member) - 1;
			rlVm.factory.addMember(member).then(
				function() {
					removeLoader('member:new');
					$mdToast.show($mdToast
						.simple()
						.textContent(
							'Added New ' + rlVm.roleMap[member.role].name +
							': ' + member.firstName + ' ' + member.lastName)
					);
				},
				function() {
					removeLoader('member:new');
					rlVm.group.members.splice(index, 1);
					$mdToast.show($mdToast
						.simple()
						.textContent('There was a problem. Try again.')
						.toastClass('error')
					);
				}
			);
		}

		function addLoader(el) { rlVm.loading.push(el); }
		function removeLoader(el) {
			var loadingIndex = rlVm.loading.indexOf(el);
			if (loadingIndex !== -1) rlVm.loading.splice(loadingIndex, 1);
		}

		function updateMember(member) {
			addLoader('member:' + member.memberId);
			var index = rlVm.group.members.findIndex(function(item) {
				return member.memberId === item.memberId;
			});
			rlVm.factory.updateMember(member).then(
				function(res) {
					if(res.member.memberId === rlVm.me.memberId) {
						userFactory.getMe(false).then(function(res) {rlVm.me = res.data;});
					}
					rlVm.group.members[index] = res.member;
					$mdToast.show($mdToast
						.simple()
						.textContent(
							'Updated ' + rlVm.roleMap[member.role].name + ': ' +
							member.firstName + ' ' + member.lastName)
					);
					removeLoader('member:' + member.memberId);
				},
				function() {
					$mdToast.show($mdToast
						.simple()
						.textContent('There was a problem updating ' +
							member.firstName + ' ' + member.lastName +
							'. Try again later.')
						.toastClass('error')
					);
					removeLoader('member:' + member.memberId);
				}
			);
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('fews')
		.controller('MemberController', memberController);
  
	/*@ngInject*/
	function memberController(userFactory, $mdDialog, userManagerFactory) {
		var vm = this;
		angular.extend(vm, {
			$onInit: activate,
			factory: userManagerFactory,
			isNew: false,
			closeDialog: $mdDialog.cancel,
			saveChanges: saveChanges,
			rePatterns: {
				username: /^([a-z]|[A-Z]|[0-9]|[\-\.])*$/,
				name: /^([a-z]|[A-Z]|[0-9]|[\(\)\:\;\'\-\.\,\&\s\\])*$/,
				email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			},
			roles: [
				{
					displayName: 'User',
					value: 'User'
				},
				{
					displayName: 'Administrator',
					value: 'Admin'
				}
			],
			loading: []
		});
  
		////////////////

		function activate() {
			userFactory.getMe().then(function(res) {vm.me = res.data;});
			if(angular.isUndefined(vm.model))
				vm.factory.getNewMember().then(function(res) {
					vm.model = angular.extend({}, res.data, {
						permissions: angular.copy(vm.groupPermissions),
						role: vm.role
					});
					vm.isNew = true;
			});
		}

		function saveChanges() {
			$mdDialog.hide(vm.model);
		}
	}
})();
  
(function() {
	'use strict';

	var component = {
		controller: permissionPickerController,
		controllerAs: 'ppVm',
		bindings: { model: '<?ppModel', id: '<?ppId', type: '@?ppType', toShow: '<?ppToShow' },
		templateUrl: 'app/components/user-manager/permission-picker/permission-picker.tmpl.html'
	};

	angular
		.module('fews')
		.component('permissionPicker', component);

	/*@ngInject*/
	function permissionPickerController(userFactory, userManagerFactory) {
		var ppVm = this;
		angular.extend(ppVm, {
			$onInit: activate,
			factory: userManagerFactory,
			listItems: [],
			switchEdit: switchEdit,
			loading: [],
			disableAll: false
		});

		////////////////

		function activate() {
			userFactory.getMe().then(function(res) {
				ppVm.me = res.data;
				if(ppVm.type === 'group') {
					ppVm.disableAll = disableAllForGroup();
				}
			});
			ppVm.factory.getPermissionsList()
				.then(function(res) {
					ppVm.listItems = res.data;
				});
		}

		function switchEdit(item) {
			if(item.view === false && angular.isDefined(item.edit)) {
				item.edit = false;
			}
		}

		function disableAllForGroup() {
			if(ppVm.me.role === 'Proj_Admin') {
				return false;
			} else if(ppVm.me.role === 'Admin' && ppVm.me.groupId === '10') {
				return false;
			}

			return true;
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('fews')
		.controller('GroupDialogController', controller);
  
	/*@ngInject*/
	function controller(userFactory, $mdMedia, $mdDialog, userManagerFactory) {
		var vm = this;
		
		angular.extend(vm, {
			$onInit: activate,
			cancel: $mdDialog.cancel,
			submit: submit,
			factory: userManagerFactory,
			isNew: false,
			hasMembers: hasMembers,
			reName: /^([a-z]|[A-Z]|[0-9]|[\(\)\:\;\'\-\.\,\&\s\\])*$/,
			deleteGroup: deleteGroup
		});
  
		function activate() {
			userFactory.getMe().then(function(res) {vm.me = res.data;});
            if(angular.isUndefined(vm.model)) {
				vm.isNew = true;
                vm.factory.getNewGroup().then(
                    function(res) {
						vm.model = res.data;
                    }
                );
			}
		}

		function hasMembers() {
			return !vm.isNew && vm.model.members.length > 0;
		}
	
		function submit() {
			$mdDialog.hide(vm.model);
		}

		function deleteGroup(ev) {
			var confirm = $mdDialog.confirm()
				.multiple(true)
				.fullscreen($mdMedia('xs'))
				.title('Are you sure?')
				.textContent('This will completely remove the group.')
				.ariaLabel('Are you sure?')
				.targetEvent(ev)
				.ok('Yes')
				.cancel('No');

			$mdDialog.show(confirm).then(function() {
				$mdDialog.cancel();
				vm.factory.deleteGroup(vm.model.groupId, ev);
			});
		}
	}
})();
  
(function() {
	'use strict';
  
	var component = {
		controller: groupDetailsController,
		controllerAs: 'gdVm',
		bindings: { group: '<' },
		templateUrl: 'app/components/user-manager/group-details/group-details.tmpl.html'
	};
  
	angular
		.module('fews')
		.component('groupDetails', component);
  
	/*@ngInject*/
	function groupDetailsController($mdMedia, $mdDialog, userFactory, userManagerFactory) {
		var gdVm = this;
		angular.extend(gdVm, {
			$onInit: activate,
			$mdMedia: $mdMedia,
			factory: userManagerFactory,
			editGroupDialog: editGroupDialog,
			loading: []
		});
  
		////////////////

		function activate() {
			userFactory.getMe().then(function(res) {gdVm.me = res.data;});
		}

		function editGroupDialog(ev) {
			$mdDialog.show({
				controller: 'GroupDialogController',
				controllerAs: 'ngVm',
				templateUrl: 'app/components/user-manager/group-dialog/group-dialog.tmpl.html',
				targetEvent: ev,
				bindToController: true,
				locals: {
					model: angular.copy(gdVm.group)
				},
				multiple: $mdMedia('xs'),
				fullscreen: $mdMedia('xs')
			})
			.then(function(group) {
				var loadEl = 'updatingGroup';
				delete group.members;
				addLoader(loadEl);
				gdVm.factory.updateGroup(group).then(function() {
					angular.extend(gdVm.group, group);
					removeLoader(loadEl);
				}, function() {
					removeLoader(loadEl);
					gdVm.factory.alertDialog('Unable to save changes. Please try again.');
				});
			});
		}

		function addLoader(el) { gdVm.loading.push(el); }
		function removeLoader(el) {
			var loadingIndex = gdVm.loading.indexOf(el);
			if (loadingIndex !== -1) gdVm.loading.splice(loadingIndex, 1);
		}
	}
})();
  
(function() {
    'use strict';

    angular
        .module('fews')
        .controller('RequestController', RequestController);

    /*@ngInject*/
    function RequestController(userFactory) {
        var vm = this;

        angular.extend(vm, {
          email: '',
          submit: submitReset
        });

        activate();

        function activate() {}

        function submitReset() {
          userFactory.requestReset(vm.email).then(function() {
            vm.hideForm = true;
            vm.message = "A link has been sent to your email address."
          }, function(error) {
            vm.hideForm = false;

            switch(error.status) {
              case 422:
                // can't use error.data.message because
                // it says "Unknown username" and not "Unknown email"
                vm.error = "That email address does not match our records.";
                break;
              default:
                vm.error = error.data.message;
            }
          });
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('fews')
    .controller('ResetController', ResetController);

  /*@ngInject*/
  function ResetController($interval, $location, $timeout, $state, userFactory) {
    var vm = this;

    angular.extend(vm, {
      password: '',
      submit: submit
    });

    activate();

    function activate() {
      var qparams = $location.search();
      if (qparams.key) {
        vm.key = qparams.key;
        userFactory.tokenCheck(qparams.key).then(null, tokenError);
      } else {
        tokenError();
      }
    }

    function tokenError() {
      vm.hideForm = true;
      vm.badToken = true;
      vm.seconds = 5;

      var countdown = $interval(function(){vm.seconds--;}, 1000, 4);

      $timeout(function () {
        $interval.cancel(countdown);
        $state.go('login');
      }, 5000);
    }

    function submit() {
      var reqData = {
        password: vm.passwordOne,
        key: vm.key
      };

      userFactory.setPassword(reqData).then(function() {
        vm.hideForm = true;
        vm.success = true;
        $timeout(function(){
          $state.go('login');
        }, 7000);
      }, function(error) {
        switch(error.status) {
          case 422:
            tokenError();
            break;
          default:
            vm.hideForm = true;
            vm.error = error.data.message;
        }
      });
    }
  }
})();

(function() {
    'use strict';
    angular
        .module('rules', []);
})();
(function(){
    'use strict';

    angular
        .module('rules')
        .controller('newRuleDialogController', newRuleDialogController);

    /*@ngInject*/
    function newRuleDialogController ($mdDialog, rulesVm) {

      var vm = this;

      angular.extend(vm, {
        continueDialog: continueDialog,
        cancelDialog: cancelDialog,
        rulesVm: rulesVm,
        isNew: isNew
      });

      function isNew(selected) {
        return angular.isUndefined(selected.id);
      }

      function continueDialog () {
        if (rulesVm.selected.location !== null) {
          $mdDialog.hide();
        }
      }

      function cancelDialog () {
        $mdDialog.hide();
        rulesVm.closeDetails();
      }

    }

}());

/* globals moment */
(function() {
  'use strict';

  angular.module('fews')
    .controller('gaugeDetailController', gaugeDetailController);

  /* @ngInject */
  function gaugeDetailController($scope, $mdDialog, gaugeFactory, orderedGauges, timezone, index, hyetoFactory) {
    var vm = this;
    vm.ready = false;
    vm.interactive = false;
    vm.timezone = timezone;
    vm.loadDetails = loadDetails;
    vm.orderedGauges = orderedGauges;
    vm.keyListener = keyListener;


    function keyListener(event) {
      if (event.key === 'ArrowLeft' && angular.isUndefined(vm.previous)) {
        loadDetails(orderedGauges[vm.index - 1].vaiId, vm.index - 1);
        vm.index = vm.index--;
      } else if (event.key === 'ArrowRight' && angular.isUndefined(vm.next)) {
        loadDetails(orderedGauges[vm.index + 1].vaiId, vm.index + 1);
        vm.index = vm.index++;
      } else {
        return;
      }
    }

    loadDetails(orderedGauges[index].vaiId, index);

    function loadDetails(id, index) {
      vm.interactiveReady = false;
      vm.previous = index - 1 < 0 ? undefined : index - 1;
      vm.next = index + 1 >= vm.orderedGauges.length ? undefined : index + 1;
      vm.index = index;
      gaugeFactory.getGauge(id).then(function(details) {
        vm.gauge = details.data;
        vm.ready = true;

        var now = new Date();
        var past = new Date();
        past.setDate(past.getDate() - 3);
        vm.range = {
          fromDate: past,
          toDate: now
        };
        vm.chartWidth = hyetoFactory.getChartWidth(vm.range);

        hyetoFactory.getGauge(id, vm.range).then(setHyetoChart);
      });
    }

    function setHyetoChart(data) {
      var xFormat = (vm.chartWidth === 600) ? 'HH:mm MM/DD' : 'HH:mm';
      var rangeDiffHrs = (vm.range.toDate.getTime() - vm.range.fromDate.getTime()) / 1000 / 60 / 60;
      var IntervalsInHr = 60 / 15;
      var chartSettings = hyetoFactory.getChartSettings(vm.timezone);

      var barWidth = Math.floor((vm.chartWidth - 50) / // chart width (accounting for side axis data)
          (rangeDiffHrs * IntervalsInHr) // number of intervals in an hour
      );

      var hyetoObj = {};
      var jsonData = [];

      if (data.gaugeHyetograph !== null) {
        for (var i = data.gaugeHyetograph.length - 1; i >= 0; i--) {
          data.gaugeHyetograph[i].cumulative = hyetoFactory.round(data.gaugeHyetograph[i].cumulative, 3);
          data.gaugeHyetograph[i].incremental = hyetoFactory.round(data.gaugeHyetograph[i].incremental, 3);
          hyetoObj['m' + data.gaugeHyetograph[i].millis] = data.gaugeHyetograph[i];
        }
      }

      if (data.intersectingHyetograph !== null) {
        for (var j = data.intersectingHyetograph.length - 1; j >= 0; j--) {
          data.intersectingHyetograph[j].cumulativeBin = hyetoFactory.round(data.intersectingHyetograph[j].cumulative, 3);
          data.intersectingHyetograph[j].incrementalBin = hyetoFactory.round(data.intersectingHyetograph[j].incremental, 3);
          delete data.intersectingHyetograph[j].cumulative;
          delete data.intersectingHyetograph[j].incremental;
          hyetoObj['m' + data.intersectingHyetograph[j].millis] = angular.merge({}, hyetoObj['m' + data.intersectingHyetograph[j].millis], data.intersectingHyetograph[j]);
        }
      }

      jsonData = Object.keys(hyetoObj).map(function(key) {
        return hyetoObj[key]
      });

      function compareMillis(a, b) {
        if (a.millis < b.millis)
          return -1;
        if (a.millis > b.millis)
          return 1;
        return 0;
      }

      jsonData.sort(compareMillis);

      for (var k = jsonData.length - 1; k >= 0; k--) {
        if (jsonData.length - 1 !== k) {
          if (angular.isUndefined(jsonData[k].cumulativeBin) && angular.isDefined(jsonData[k + 1].cumulativeBin)) {
            jsonData[k].cumulativeBin = jsonData[k + 1].cumulativeBin;
          }
          if (angular.isUndefined(jsonData[k].cumulative) && angular.isDefined(jsonData[k + 1].cumulative)) {
            jsonData[k].cumulative = jsonData[k + 1].cumulative;
          }
        }
      }

      if (data.intersectingHyetograph !== null) {

        angular.merge(chartSettings, {
          data: {
            keys: {
              value: ['cumulative', 'incremental', 'cumulativeBin', 'incrementalBin']
            },
            types: {
              cumulativeBin: 'line'
            },
            axes: {
              cumulativeBin: 'y',
              incrementalBin: 'y2'
            },
            colors: {
              cumulative: '#00838F',
              incremental: '#00BCD4',
              cumulativeBin: '#FF8F00',
              incrementalBin: '#FFC107'
            },
            names: {
              cumulative: 'Gauge Cumulative',
              incremental: 'Gauge Incremental',
              cumulativeBin: 'Grid Cumulative',
              incrementalBin: 'Grid Incremental'
            }
          },
          bar: {
            width: ((barWidth / 2) > 2) ? ((barWidth / 2) - 0.5) : 1
          },
          axis: {
            x: {
              tick: {
                format: function(d) {
                  return moment.tz(d, vm.timezone).format(xFormat);
                }
              }
            }
          }
        });
      } else {
        angular.merge(chartSettings, {
          data: {
            keys: {
              value: ['cumulative', 'incremental']
            },
            colors: {
              cumulative: '#00838F',
              incremental: '#00BCD4'
            },
            names: {
              cumulative: 'Gauge Cumulative',
              incremental: 'Gauge Incremental'
            }
          },
          bar: {
            width: ((barWidth / 2) > 2) ? ((barWidth / 2) - 0.5) : 1
          },
          axis: {
            x: {
              tick: {
                format: function(d) {
                  return moment.tz(d, vm.timezone).format(xFormat);
                }
              }
            }
          }
        });
      }

      vm.interactiveReady = true;

      chartSettings.data.json = jsonData;
      chartSettings.padding.right = 57;
      c3.generate(chartSettings);

      // move y label to right 6 pixels
      var yOrigin = d3.select(".c3-axis-y-label").attr('dy');
      d3.select(".c3-axis-y-label").attr('dy', Number(yOrigin) + 6);

      // move y2 label to left 8 pixels
      var y2Origin = d3.select(".c3-axis-y2-label").attr('dy');
      d3.select(".c3-axis-y2-label").attr('dy', Number(y2Origin) - 8);
    }

    vm.closeDialog = function() {
      $mdDialog.cancel();
    };
  }
})();

(function() {
  'use strict';
  angular.module('fews').factory('alertFactory', alertFactory);

  /*@ngInject*/
  function alertFactory($q, $http, $log, API_URL) {
    var service = {
      processTime: processTime,
      getEmptyAlert: getEmptyAlert,
      getPresets: getPresets
    };
    return service;
    ////////////////
    function processTime(alert) {
      if (alert.timing === 'during')
        alert.delay = 0;
      else if (alert.timing === 'before')
        alert.delay = alert.delay * -1;

      return $q.resolve(alert);
    }

    function getEmptyAlert() {
      return {
        timing: 'during',
        delay: null,
        message: '',
        name: '',
        alertType: "custom",
        geoJSON: {
          type: "FeatureCollection",
          features: {
            properties: {},
            geometry: {
              coordinates: [],
              type: ''
            }
          }
        }
      };
    }

    function getPresets() {
      var url = 'https://data.austintexas.gov/api/geospatial/juvk-qass?method=export&format=GeoJSON';
      var req = {
        method: 'GET',
        url: API_URL + 'urlrequestforward',
        headers: {
          'Content-Type': 'application/json'
        },
        params: {
          url: url,
          useCache: true
        }
      }

      return $http(req).then(xhrComplete, xhrFailed);
    }

    function xhrComplete(response) {
      return $q.resolve(response.data);
    }

    function xhrFailed(error) {
      $log.error(error);
      return $q.reject(error);
    }
  }
})();

(function(){
    'use strict';

    angular
        .module('rules')
        .controller('AlertController', AlertController);

    L.Icon.Default.imagePath = '/assets/images/leaflet-help';

    /*@ngInject*/
    function AlertController ($scope, $q, $mdDialog, lat, lon, leafletData,
            leafletDrawEvents, alert, alertFactory, baselayerFactory) {
        var vm = this,
            drawnItems = new L.FeatureGroup(),
            emptyAlert = alertFactory.getEmptyAlert(),
            originalAlert, deregCallback = [];

        angular.extend(vm, {
            cancel: cancel,
            submit: submit,
            disableAlertSave: disableAlertSave,
            needsMap: needsMap,
            isNew: alert === null,
            alert: alert ? angular.copy(alert) : angular.copy(emptyAlert),
            locationTypes: [
                {
                    displayName:'Road Closure',
                    systemName: 'lwc'
                },
                {
                    displayName:'Custom Location',
                    systemName: 'custom'
                }
            ],
            threshTiming: [
                {
                    displayName: 'Before Threshold',
                    systemName: 'before'
                },
                {
                    displayName: 'During Threshold',
                    systemName: 'during'
                },
                {
                    displayName: 'After Threshold',
                    systemName: 'after'
                }
            ],
            lwcs: undefined,
            presets: {
              onMap: L.layerGroup(),
              chosen: []
            },
            updatePresets: updatePresets,
            map: {
                isInit: false,
                states: ['UNCHANGED', 'CHANGING', 'CHANGED'],
                state: 'UNCHANGED',
                featureCount: 0,
                pristine: true,
                center: {
                    lat: lat,
                    lng: lon,
                    zoom: 15
                },
                defaults: {
                    attrubution: false
                },
                drawOptions: {
                    position: "topleft",
                    draw: {
                        polyline: {
                            shapeOptions: {
                                color: '#0033ff'
                            }
                        },
                        polygon: {
                            shapeOptions: {
                                color: '#0033ff'
                            }
                        },
                        circle: false,
                        rectangle: {
                            shapeOptions: {
                                color: '#0033ff'
                            }
                        },
                        marker: {}
                    },
                    edit: {
                        featureGroup: drawnItems,
                        remove: true
                    }
                },
                layers: {
                    baselayers: {
                        outdoors: baselayerFactory.getMap('outdoors')
                    },
                    overlays: {}
                }
            }
        });

        activate();
        ////////////////////

        function activate() {

          var requests = [
            alertFactory.getPresets(),
            leafletData.getMap('alertmap')
          ];

          $q.all(requests).then(function(data){
            vm.lwcs = data[0].features;
            var map = data[1];

            if (alert) {
              originalAlert = angular.copy(alert);

              L.geoJson(alert.geoJSON, {
                onEachFeature: function (f, layer) {
                  if (f.geometry.type === 'Point') {
                    var check = [f.geometry.coordinates[1], f.geometry.coordinates[0]];
                    var search = vm.lwcs.find(function(d){
                      var latlng = [ d.geometry.coordinates[1], d.geometry.coordinates[0] ];
                      return angular.equals(latlng, check);
                    });
                    if (search) {
                      layer.bindPopup(search.properties.crossing_d);
                      vm.presets.chosen.push(angular.toJson(search));
                      vm.presets.onMap.addLayer(layer);
                    }
                  }
                  drawnItems.addLayer(layer);
                }
              });

              vm.map.featureCount = drawnItems.getLayers().length;
              vm.map.isInit = true;

              map.fitBounds(drawnItems.getBounds());
            }
          });
        }

        function updatePresets() {
          vm.presets.onMap.getLayers().forEach(function(d){
            drawnItems.removeLayer(d);
            vm.presets.onMap.removeLayer(d);
          });

          vm.presets.chosen.forEach(function(d){
            d = angular.fromJson(d);
            var latlng = [ d.geometry.coordinates[1], d.geometry.coordinates[0] ];
            var marker = L.marker(latlng);
            marker.bindPopup(d.name);
            vm.presets.onMap.addLayer(marker);
            drawnItems.addLayer(marker);
          });

          vm.map.featureCount = drawnItems.getLayers().length;
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function submit(isNew) {
            vm.alert.geoJSON = drawnItems.toGeoJSON();
            $mdDialog.hide({
                original: originalAlert,
                updated: vm.alert,
                isNew: isNew
            });
        }

        function disableAlertSave (pristineForm) {
            var disable = true;
            if(vm.map.featureCount > 0) {
                if (pristineForm) {
                    if (vm.map.state === vm.map.states[2])
                        disable = false;
                } else {
                    if (vm.map.state !== vm.map.states[1])
                        disable = false;
                }
            }

            return disable;
        }

        function needsMap () {
            return vm.alert.features.properties.alertType === 'custom';
        }

        /* -------------------------------
         * event handling for leaflet draw
         * ------------------------------- */
        var drawEvents = leafletDrawEvents.getAvailableEvents(),
            changeStart,
            handle = {
                created: function(e,leafletEvent) {
                    drawnItems.addLayer(leafletEvent.layer);
                    vm.map.featureCount = drawnItems.getLayers().length;
                    vm.map.state = changeStart = vm.map.states[2];
                },
                edited: function() {
                    vm.map.state = changeStart = vm.map.states[2];
                },
                deleted: function(arg, a) {
                    a.layers.getLayers().forEach(function(d){
                      if (d instanceof L.Marker && vm.presets.onMap.hasLayer(d)) {
                        vm.presets.chosen = vm.presets.chosen.filter(function(c){
                          c = angular.fromJson(c);
                          return !angular.equals(L.marker( c.geometry.coordinates.reverse() ).getLatLng(), d.getLatLng());
                        });
                      }
                    });
                    var layer;
                    vm.map.state = changeStart = vm.map.states[2];
                    layer = arg.layers;
                    drawnItems.removeLayer(layer);
                    vm.map.featureCount = drawnItems.getLayers().length;
                },
                drawstart: function() {
                    changeStart = vm.map.state;
                    vm.map.state = vm.map.states[1];
                },
                drawstop: function() {vm.map.state = changeStart;},
                editstart: function() {
                    changeStart = vm.map.state;
                    vm.map.state = vm.map.states[1];
                },
                editstop: function() {vm.map.state = changeStart;},
                deletestart: function() {
                    changeStart = vm.map.state;
                    vm.map.state = vm.map.states[1];
                },
                deletestop: function() {vm.map.state = changeStart;}
            };

        drawEvents.forEach(function(eventName){
            deregCallback.push(
                $scope.$on('leafletDirectiveDraw.alertmap.' + eventName, function(e, payload) {
                    //{leafletEvent, leafletObject, model, modelName} = payload
                    var leafletEvent, leafletObject, model, modelName; //destructuring not supported by chrome yet :(
                    leafletEvent = payload.leafletEvent, leafletObject = payload.leafletObject,
                    model = payload.model, modelName = payload.modelName;
                    handle[eventName.replace('draw:','')](e, leafletEvent, leafletObject, model, modelName);
                })
            );
        });
        /* -------------------------------
         * end leaflet draw event handling
         * ------------------------------- */

        $scope.$on('$destroy',function(){
            for (var i = deregCallback.length - 1; i >= 0; i--) {
                deregCallback[i]();
            }
        });
    }

}());

(function() {
  'use strict';

  var component = {
    controller: dashpanelController,
    controllerAs: 'dpanelVm',
    bindings: {
      directory: '=',
      overlays: '=',
      lfmarkers: '=',
      baselayer: '<',
      layerClick: '&',
      showPanel: '=',
      basins: '<',
      nowTime: '<',
      checkTime: '<',
      addBaselayer: '&',
      refreshMarkers: '&',
      togglePanel: '&',
      errors: '<',
      checkDuration: '<',
      latestInundationTime: '<',
      replayActive: '<'
    },
    templateUrl: 'app/components/dashboard/dashpanel/dashpanel.tmpl.html'
  };

  angular
    .module('dashboard')
    .component('dashpanel', component);

  /*@ngInject*/
  function dashpanelController( $q, $log,
      $rootScope, $document, $timeout, $mdDialog, $mdPanel, $mdMedia,
      $auth, leafletData, API_URL, baselayerFactory, overlayFactory, userFactory,
      prefFactory) {
    var dpanelVm = this;
    var map;
    angular.extend(dpanelVm, {
      API_URL: API_URL,
      $onInit: activate,
      toggleLayer: toggleLayer,
      openLayersDialog: openLayersDialog,
      overlayClass: overlayClass,
      getScale: getScale,
      openSettings: openSettings,
      displayDataTime: displayDataTime,
      getLegendMessage: getLegendMessage,
      getLegendTooltip: getLegendTooltip,
      onTabSelected: onTabSelected,
      currentBaselayer: {},
      setBaselayer: setBaselayer,
      addOverlay: addOverlay,
      removeOverlay: removeOverlay,
      settings: {
          selected: {}
      },
      needsMarkerList: needsMarkerList,
      centerMarker: centerMarker,
      accesstoken: $auth.getToken(),
      iconClick: iconClick
    });

    ////////////////


    function activate() {
      userFactory.getMe().then(function(res) {
        dpanelVm.myInfo = res.data;
        initBaselayer();
        leafletData.getMap('dashmap')
          .then(function(response) {
            map = response;
        });
      });
    }

    function initBaselayer() {
      baselayerFactory.getDirectory().then(function(data) {

        if (prefFactory.isSaved()) {
          $q.resolve(prefFactory.getBaselayer()).then(function(data) {
            setBaselayer(data.baselayer);
          });
        }

        dpanelVm.availableBaselayers = data.styles;
      });
    }

    function removeOverlay() {
      dpanelVm.overlays.geojson.visible = false;
    }

    function addOverlay(payload, alert) {
      var geoJson = angular.fromJson(payload);
      var layers = [];
      var mapAlerts = new L.FeatureGroup();

      for (var i = 0; i < geoJson.mapAlerts.length; i++) {

        for (var j = 0; j < geoJson.mapAlerts[i].geoJSON.features.length; j++) {
          angular.extend(geoJson.mapAlerts[i].geoJSON.features[j].properties, {
            vaiName: geoJson.mapAlerts[i].name,
            vaiMessage: geoJson.mapAlerts[i].message,
            timing: geoJson.mapAlerts[i].timing,
            delay: geoJson.mapAlerts[i].delay,
            crossThreshAt: alert.crossThreshAt
          });
        }

        L.geoJson(geoJson.mapAlerts[i].geoJSON, {
          onEachFeature: function(feature, layer) {
            mapAlerts.addLayer(layer);
          }
        });

        layers.push({
          name: 'alert-' + i,
          data: geoJson.mapAlerts[i].geoJSON,
          type: 'geoJSONShape',
          visible: true,
          layerOptions: {
            onEachFeature: onEachFeature,
            style: {
              weight: 2,
              color: "#ffb103",
              opacity: 1,
              fillColor: "#ffe37c",
              fillOpacity: 0.4,
              dashArray: 3
            }
          }
        });
      }

      dpanelVm.overlays.geojson = {
        name: 'Rule Alerts',
        type: 'group',
        visible: true,
        doRefresh: true,
        legend: {
          icon: 'place'
        },
        layerParams: {
          showOnSelector: false
        },
        layerOptions: {
          layers: layers
        }
      };

      centerJSON(mapAlerts);

      function onEachFeature(feature, layer) {
        var prop = feature.properties;
        var time = moment(prop.crossThreshAt).format('HH:mm YYYY/MM/DD');
        var html = '<h4>' + prop.vaiName + '</h4><p>' +
          (prop.vaiMessage ? (prop.vaiMessage + '<br/>') : '') +
          (prop.timing === 'during' ? ('At ' + time) : (prop.delay + ' minutes ' + prop.timing + ' ' + time)) + '</p>';
        layer.bindPopup(html, {
          className: 'alert-popup'
        });
      }
    }

    function centerJSON(geoJson) {
        map.fitBounds(geoJson);
    }

    function setBaselayer(style) {
      dpanelVm.currentBaselayer = style;
      dpanelVm.addBaselayer({
        $style: style
      });
    }

    function toggleLayer(layer) {
      layer.visible = !layer.visible;
    }

    function displayDataTime(overlay) {
      var dataTime = (overlay.layerParams.time || overlay.layerOptions.time || overlay.layerParams.endTime || overlay.layerOptions.endTime);

      return dataTime;
    }

    function getLegendMessage(overlay) {
      var dataTime = displayDataTime(overlay);
      var time = moment(dataTime);
      var msg = time.fromNow();

      if (overlay.legend.markerCount === 0) {
        msg = 'No ' + overlay.name + (dpanelVm.replayActive ? '.' : (' in the last ' + overlay.legend.checkDuration) + '.');
      } else if (angular.isUndefined(dataTime)) {
        msg = '';
      }

      return msg;
    }

    function getLegendTooltip(overlay) {
      var time = displayDataTime(overlay);
      var msg = time ? "Last data at " + moment(time).format('HH:mm YYYY/MM/DD') : '';

      return msg;
    }

    function openLayersDialog(ev) {
      $mdDialog.show({
          controller: 'layersDialogController',
          controllerAs: 'vm',
          locals: {
            overlays: dpanelVm.overlays
          },
          templateUrl: 'app/components/dashboard/dashpanel/layers-dialog/layers.tmpl.html',
          parent: angular.element($document[0].body),
          targetEvent: ev,
          clickOutsideToClose: true,
          escapeToClose: true
        })
        .then(function(response) {
          angular.extend(dpanelVm.overlays, response.overlays);
        });
    }

    function overlayClass(layer) {
      var hasOptions = angular.isDefined(layer.layerOptions),
        layerTime = layer[hasOptions ? 'layerOptions' : 'layerParams'].time,
        oneHourMilli = 1000 * 60 * 60,
        twoHourMilli = oneHourMilli * 2,
        ngClasses = '';

      if (moment().diff(layerTime) > twoHourMilli)
        ngClasses += 'age-high ';
      else if (moment().diff(layerTime) > oneHourMilli)
        ngClasses += 'age-low ';

      if (layer.visible == false)
        ngClasses += 'off';

      return ngClasses;
    }

    function getScale() {
      return API_URL + 'scale/image/' + (300 - 20) + '/40.png?accesstoken=' + dpanelVm.accesstoken;
    }

    function openSettings(overlay, ix, ev) {
      dpanelVm.settings.overlay = overlay;
      var button = '.layer-settings-' + ix;
      var position = $mdPanel.newPanelPosition()
        .relativeTo(button)
        .addPanelPosition($mdPanel.xPosition.ALIGN_END, $mdPanel.yPosition.BELOW);

      var animation = $mdPanel.newPanelAnimation()
        .openFrom(button)
        .closeTo(button)
        .withAnimation($mdPanel.animation.SCALE);

      var config = {
        animation: animation,
        attachTo: angular.element($document[0].querySelectorAll('dashpanel')),
        controller: layerSettingsController,
        controllerAs: 'ctrl',
        templateUrl: 'app/components/dashboard/dashpanel/layer-settings/layer-settings.tmpl.html',
        panelClass: 'md-whiteframe-4dp layer-settings-panel',
        position: position,
        locals: {
          changeOpacity: changeOpacity,
          overlay: overlay,
          list: dpanelVm.overlays
        },
        openFrom: ev,
        zIndex: 150,
        hasBackdrop: false,
        clickOutsideToClose: true,
        clickEscapeToClose: true,
        escapeToClose: true
      };

      $mdPanel.open(config);
    }

    /*@ngInject*/
    function layerSettingsController(mdPanelRef, $scope) {
      var vm = this;

      activateLayerSettings();

      function activateLayerSettings() {
        angular.extend(vm, {
          overlay: dpanelVm.settings.overlay,
          list: dpanelVm.overlays,
          options: dpanelVm.settings.overlay.legend.settings,
          changeParam: changeParam,
          infoButton: infoButton
        });

        if(vm.overlay.id === 'garr') {
          vm.options.activeLayers = vm.list.gauges.legend.settings.activeLayers;
          vm.options.layers = vm.list.gauges.legend.settings.layers;
        }
      }

      if (angular.isDefined(vm.overlay.layerOptions.opacity)) {
        vm.opacity = vm.overlay.layerOptions.opacity * 100;
      } else if (angular.isDefined(vm.overlay.layerOptions.layers)) {
        vm.opacity = vm.overlay.layerOptions.layers[0].layerOptions.opacity * 100;
      }

      function infoButton(ev) {
        infoDialog(dpanelVm.settings.overlay, ev);
        close();
      }

      function changeParam(p) {
        vm.overlay.layerOptions[p.key] = p.arrayValue || p.value;
        if (p.type !== 'switch' && angular.isArray(vm.overlay.layerOptions.layers)) {
          for (var i = vm.overlay.layerOptions.layers.length - 1; i >= 0; i--) {
            vm.overlay.layerOptions.layers[i].layerOptions[p.key] = p.value;
          }
        }
        if (p.key == 'jurisdictions') {
          changeOverlayLayer(vm.overlay.legend.settings.activeLayers)
        }
        vm.overlay.doRefresh = true;
        close();
      }

      function close() {
        $timeout(function() {
          mdPanelRef.close().then(function() {
            mdPanelRef.destroy();
          });
        }, 200);
      }

      $scope.$watch('ctrl.options.activeLayers', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          changeOverlayLayer(newVal);
          close();
        }
      });

      $scope.$watch('ctrl.opacity', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.changeOpacity(angular.copy(newVal));
        }
      });
    }

    function infoDialog(overlay, ev) {
      $mdDialog.show({
        controller: function($scope, $mdDialog, layer) {
          angular.extend($scope, {
            $mdDialog: $mdDialog,
            layer: layer
          });
        },
        templateUrl: 'app/components/dashboard/dashpanel/layer-info/layer-info.tmpl.html',
        parent: angular.element($document[0].body),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          $mdDialog: $mdDialog,
          layer: overlay
        }
      });
    }

    function changeOpacity(opacity) {
      if( angular.isDefined(dpanelVm.settings.overlay.layerOptions.opacity) ) {
        if (angular.isDefined(dpanelVm.settings.overlay.layerOptions.layers) && angular.isArray(dpanelVm.settings.overlay.layerOptions.layers)) {
           dpanelVm.settings.overlay.layerOptions.layers[0].layerOptions.opacity = opacity / 100;
        } else {
          dpanelVm.settings.overlay.layerOptions.opacity = opacity / 100;
        }
          dpanelVm.settings.overlay.doRefresh = true;
      }
    }

    function changeOverlayLayer(layer) {
      var overlay = dpanelVm.settings.overlay;
      var layerIDs = [overlay.id];

      if(overlay.id === 'garr') {
        dpanelVm.overlays.gauges.legend.settings.activeLayers = overlay.legend.settings.activeLayers;
        layerIDs = ['garr', 'gauges'];
      } else if (overlay.id === 'gauges') {
        dpanelVm.overlays.garr.legend.settings.activeLayers = overlay.legend.settings.activeLayers;
        layerIDs = ['garr', 'gauges'];
      }


      if (overlay.layerType === 'nowcoast') {

        overlayFactory.loadNowCOAST(new Date(dpanelVm.nowTime), layer, overlay).then(function(data) {
          angular.merge(dpanelVm.overlays[overlay.id], data.overlay);
        });

      } else if (overlay.layerType === 'inundation') {

        dpanelVm.overlays[overlay.id].url = API_URL + 'structures/' + (layer || '') + 'eval_tiles/{z}/{x}/{y}.png?r={time}&onlyInundated={onlyInundated}&accesstoken=' + $auth.getToken();
        dpanelVm.overlays[overlay.id].doRefresh = true;

      } else {
        angular.forEach(layerIDs, function(val) {
          overlayFactory['load' + val](dpanelVm.nowTime, layer, dpanelVm.overlays[val], dpanelVm.replayActive)
            .then(function(data) {
              angular.merge(dpanelVm.overlays[val], data.overlay);
              if (data.markers) {
                var tempMarkers = angular.copy(dpanelVm.lfmarkers[val]);
                var overlayId = new RegExp( '^' + val );

                dpanelVm.lfmarkers[val] = {}; // clear markers to update values

                angular.forEach(tempMarkers, function(value, key){
                  if (overlayId.test(key)) {
                    delete tempMarkers[key];
                  }
                });

              // wait for markers to clear before adding new
              $timeout(function() {
                dpanelVm.lfmarkers[val] = angular.extend({}, tempMarkers, data.markers);
              });
            }
          });
        });
      }
    }

    function onTabSelected(tab) {
      $rootScope.$broadcast('dpanelTab:' + tab);
    }

    function needsMarkerList(overlay) {
      if (overlay.layerType == 'marker') {
        if (overlay.legend.markerCount > 0) return true;
        return false;
      }
      return false;
    }

    function centerMarker(marker) {
      var small = $mdMedia('xs');
      if (small) {
        $rootScope.$broadcast('toggle-panel');
      }

      // chain the setZoom and panTo
      map.setZoom(18, {
        animate: false
      }).panTo([marker.lat, marker.lng], {
        animate: true,
        duration: 0.75
      });
    }

    function iconClick(data) {
      data.legend.hide = !data.legend.hide;
      data.visible = !data.visible;
    }
  }
})();

(function() {
  'use strict';

  var component = {
    controller: DashmapController,
    controllerAs: 'dashmapVm',
    templateUrl: 'app/components/dashboard/dashmap/dashmap.tmpl.html'
  };

  angular
    .module('dashboard')
    .component('dashmap', component);

  /*@ngInject*/
  function DashmapController(
    //angular
    $scope, $compile, $timeout, $interval, $window, $document, $log, $q,
    $rootScope,
    //3rd party
    $mdMedia, $mdDialog, $mdSidenav, leafletData, $mdPanel, $auth,
    //internal
    hyetoFactory, menuFactory, leafletFactory, projectInfo, searchService,
    baselayerFactory, inundationFactory, basinGeo, prefFactory, overlayFactory,
    timeFactory, p2nMapFactory, mapClickHandler, jurisdictionFactory,
    replayFactory, notificationFactory, ESRI102739) {

    var dashmapVm = this,
      deregCallbacks = [],
      hyetoChart = null,
      infoPopup = {},
      map, p2nMap, updateCheck,
      isMarkerClicked = false;

    // define texas central state plane crs
    // https://epsg.io/102739
    proj4.defs("ESRI:102739", ESRI102739);

    angular.extend(dashmapVm, {
      $onInit: activate,
      $postLink: readyDOM,
      $onDestroy: onDestroy,
      mdMedia: $mdMedia,
      latestInundationTime: 0, // millis
      loading: [],
      showPanel: $mdMedia('gt-xs'),
      basins: [],
      basinsFull: [],
      openReplayDialog: openReplayDialog,
      replay: {
        isActive: false,
        mdSwitch: false,
        toggleReplay: toggleReplay
      },
      mapBounds: [],
      center: { // default center (austin)
        lat: 30.2680561,
        lng: -97.7427394,
        zoom: 6
      },
      defaults: {
        scrollWheelZoom: $mdMedia('gt-xs') ? true : false,
        attributionControl: false,
        tap: false,
        fadeAnimation: false,
        maxZoom: 18,
        minZoom: 1
      },
      markers: {},
      layers: {
        baselayers: {},
        overlays: {},
        errors: []
      },
      layerVisibilityCache: {},
      basinMask: undefined,
      removeScenario: removeScenario,
      saveBounds: saveBounds,
      reorientBounds: reorientBounds,
      hasBookmark: hasBookmark,
      flashSuccess: false,
      addScenario: addScenario,
      scenarioSummaries: undefined,
      selectedScenario: undefined,
      checkDuration: (1000 * 60 * 2.5),
      menu: menuFactory,
      disableControls: disableControls,
      togglePanel: togglePanel,
      showBasins: showBasins,
      searchAddress: searchAddress,
      showCoordinates: [],
      showCoordinatesDiv: false,
      addBaselayer: addBaselayer,
      loadOverlays: loadOverlays,
      frameChange: frameChange,
      openNav: openNav,
      reorientMap: reorientMap,
      accesstoken: $auth.getToken()
    });

    ////////////////


    function activate() {
      var storedTime = sessionStorage.getItem('rp');
      if (storedTime) {
        startReplay(new Date(storedTime));
      } else {
        dashmapVm.replay.isActive = replayFactory.isActive();
        dashmapVm.nowTime = new Date(timeFactory.getLastInterval());
        dashmapVm.checkTime = Date.now();
      }

      if(dashmapVm.sidebar === false) {
        dashmapVm.showPanel = !dashmapVm.showPanel;
      }

      startMapListeners();
      startUpdateCheck();

      var mapPromises = [
        leafletData.getMap('dashmap').then(setDashmap),
        leafletData.getMap('p2n').then(setP2NMap),
        projectInfo.getBasins('Inundation').then(setBasins),
        projectInfo.getDetails().then(setBasinMap),
        prefFactory.getPreferences()
      ];

      function setDashmap(m) { map = m; }
      function setP2NMap(m) { p2nMap = m; }
      function setBasins(b) { dashmapVm.basins = b; }
      function setBasinMap(b) { dashmapVm.basinMap = b.basins; }

      $q.all(mapPromises).then(function(data) {
        projectInfo.getDomainBounds(dashmapVm.basins).then(function(response) {
          dashmapVm.mapBounds = response;
          reorientMap();
        });

        dashmapVm.directory = data[4];

        for (var x = 0; x < dashmapVm.directory.general.length; x++) {
          var object = dashmapVm.directory.general[x];
          if (object.id === 'sidebar' && object.value === false) {
            dashmapVm.showPanel = false;
          }
        }
        loadOverlays(dashmapVm.directory);
      });

      basinGeo.getList().then(function(d) {
        dashmapVm.basinsFull = d.reverse();
      });

      updateBasinSummaries();
    }

    function readyDOM() {
      var els = [
        '#save-location', '.dash-toolbar', '#reorient-map', '.dashpanel-toggle', '.show-summary'
      ];

      for (var i = els.length - 1; i >= 0; i--) {
        var el = $document[0].querySelector(els[i]);
        leafletFactory.disableInteraction(el);
      }
    }

    function updateBasinSummaries(time) {
      return p2nMapFactory.getBasinSummaries(time).then(function(summaries) {
        dashmapVm.scenarioSummaries = summaries;
      });
    }

    function loadOverlays(directory) {
      //Save which layers are currently visible
      saveLayerVisibility();

      var opacityLookup = {};
      dashmapVm.layers.overlays = {};
      dashmapVm.markers = {};

      prefFactory.getPreferences().then(function(data) {
        var preferencesArray = directory.dashboard || data.dashboard;
        preferencesArray.forEach(function(d) {
          if (d.legend.settings.opacity) {
            opacityLookup[d.id] = d.legend.settings.opacityValue;
          } else {
            opacityLookup[d.id] = null;
          }
        });
          
        inundationFactory.checkTimes().then(function(times) {
          $timeout(function() {inundationUpdateCheck(null, times)});
        });

        angular.forEach(preferencesArray, function(val) {
          val.legend.loading = true;
          val.layerParams.attribution = val.id; // for loading id
          if (val.id === 'atx') {
            angular.forEach(val.legend.settings.params, function(param) {
              if(param.key === 'jurisdictions') {
                jurisdictionFactory.getJurisdictionOptions().then(function(data){
                  angular.extend(param, {arrayValue: data.groups.default});
                  jurisdictionFactory.setJurisdiction(data.groups.default);
                  jurisdictionFactory.setDefaultJurisdictions(data.groups.default);
                  loadOverlay(dashmapVm.nowTime);
                });
              }
            });
          } else {
            loadOverlay(dashmapVm.nowTime);
          }

          function loadOverlay(overlayTime) {
            if (dashmapVm.replay.isActive) overlayTime = dashmapVm.replay.time;
            var activeLayer = val.legend.settings.activeLayers;

            if (val.layerType === 'nowcoast') {
              overlayFactory.loadNowCOAST(activeLayer, val)
                .then(overlaySuccess, overlayFail);
            } else {
              overlayFactory['load' + val.id](overlayTime, activeLayer, val, dashmapVm.replay.isActive)
                .then(overlaySuccess, overlayFail);
            }
          }

          function overlayFail(error) {
            updateError({
              'error': error,
              'id': val.id
            });
          }

          function overlaySuccess(data) {
            updateError({ 'id': val.id });

            if (val.legend.settings.opacity && prefFactory.isSaved()) {
              data.overlay.layerOptions.opacity = opacityLookup[val.id];
            }

            if (angular.isDefined(data.overlay.layerOptions.layers)) {
              angular.forEach(data.overlay.layerOptions.layers, function(d) {
                if (d.layerParams) {
                  d.layerParams.attribution = val.id;
                } else {
                  d.layerParams = { attribution: val.id };
                }
              });
            }

            dashmapVm.layers.overlays[data.type] = angular.merge({}, val, data.overlay);

            if (angular.isDefined(data.markers)) {
              if (!isEmpty(data.markers)) {
                dashmapVm.markers[data.type] = {};
                $timeout(function(){
                  angular.extend(dashmapVm.markers[data.type], data.markers);
                  dashmapVm.layers.overlays[data.type].legend.loading = false;
                });
              } else {
                dashmapVm.layers.overlays[data.type].legend.loading = false;
              }
            }
            
            //Set this layer's visibility, as saved earlier
            loadLayerVisibility(dashmapVm.layers.overlays[data.type]);
          }
        });
      });
    }

    function saveLayerVisibility () {
      //Clear the cached of layer visibilities
      dashmapVm.layerVisibilityCache = {};
      //Save each layer's visibility setting
      angular.forEach(dashmapVm.layers.overlays, function(layer) {
        dashmapVm.layerVisibilityCache[layer.id] = layer.visible;
      });
    }

    function loadLayerVisibility (layer) {
      var visible = dashmapVm.layerVisibilityCache[layer.id];
      //If this layer's visibility setting is cached, apply it
      if (angular.isDefined(visible)) {
        layer.visible = visible;
        layer.legend.visible = visible;
      }
    }

    function isEmpty(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          return false;
        }
      }
      return true;
    }

    function startUpdateCheck(runNow) {
      if (runNow) fn();
      if (updateCheck) return;
      updateCheck = $interval(fn, dashmapVm.checkDuration, 0, false);

      function fn() {
        dashmapVm.nowTime = new Date(timeFactory.getLastInterval());
        dashmapVm.checkTime = Date.now();
        updateBasinSummaries();
        var layers = getMapLayers();
        rainvieuxUpdateCheck(layers.rainvieux);
        nowcoastUpdateCheck(layers.nowcoast);
        markersUpdateCheck(layers.marker);
      }
    }

    function stopUpdateCheck() {
      $interval.cancel(updateCheck);
      updateCheck = undefined;
    }

    function getMapLayers() {
      var layers = {};
      var dir = dashmapVm.directory.dashboard;

      for (var i = dir.length - 1; i >= 0; i--) {
        if (angular.isUndefined(layers[dir[i].layerType])) {
          layers[dir[i].layerType] = [];
        }
        layers[dir[i].layerType].push(dir[i]);
      }

      return layers;
    }

    function rainvieuxUpdateCheck(layers) {
      for (var i = 0; i < layers.length; i++) {
        if(dashmapVm.layers.overlays[layers[i].id].visible) {
          var activeLayer = dashmapVm.layers.overlays[layers[i].id].legend.settings.activeLayers;
          overlayFactory['load' + layers[i].id](dashmapVm.nowTime, activeLayer, dashmapVm.layers.overlays[layers[i].id])
            .then(function(data) {
              updateError({ id: 'garr' });
              angular.merge(dashmapVm.layers.overlays[data.overlay.id], data.overlay);
            }, function(error) {
              updateError({
                'error': error,
                'id': 'garr'
              });
          });
        }
      }
    }

    function inundationUpdateCheck(e, basinTimes) {
      if (angular.isUndefined(dashmapVm.directory)) return;
      var layers = getMapLayers().inundation;
      var promises = [];
      var activeLayer;
      dashmapVm.latestInundationTime = basinTimes.newestTime;

      for (var j = 0; j < dashmapVm.basins.length; j++) {
        dashmapVm.basins[j].latestTimeOfSimulation = basinTimes.Grid[dashmapVm.basins[j].id];
      }
      
      if (!dashmapVm.replay.isActive) {
        for (var i = layers.length - 1; i >= 0; i--) {
          var layerConfig = dashmapVm.layers.overlays[layers[i].id];
          if (layerConfig) {
            activeLayer = layerConfig.legend.settings.activeLayers;
          } else {
            activeLayer = layers[i].legend.settings.activeLayers;
          }
          
          promises.push(overlayFactory['load' + layers[i].id](dashmapVm.latestInundationTime, activeLayer, layerConfig));
        }

        $q.all(promises).then(function(data) {
            for (var i = data.length - 1; i >= 0; i--) {
              updateError({ id: 'inundation' });
              angular.merge(dashmapVm.layers.overlays[data[i].overlay.id], data[i].overlay);
            }
          }, function(error) {
            updateError({
              'error': error,
              'id': 'inundation'
            });
        });
      }
    }

    function markersUpdateCheck(markers) {
      var promises = [];
      for (var i = markers.length - 1; i >= 0; i--) {
        var activeLayer = dashmapVm.layers.overlays[markers[i].id].legend.settings.activeLayers;
        dashmapVm.layers.overlays[markers[i].id].legend.loading = true;
        markers[i].legend.visible = dashmapVm.layers.overlays[markers[i].id].legend.visible;
        markers[i].visible = dashmapVm.layers.overlays[markers[i].id].visible;
        promises.push(overlayFactory['load' + markers[i].id](dashmapVm.nowTime, activeLayer, markers[i], dashmapVm.replay.isActive));
      }

      $q.all(promises).then(successFn, errorFn);

      function successFn(data) {
        angular.forEach(data, function(val1) {
          dashmapVm.markers[val1.type] = {}; // clear markers
          angular.forEach(val1.markers, function(val2) {
            updateError({
              'id': val2.layer
            });
          });
          // wait for markers to clear and then add back to list
          $timeout(function(){
            angular.extend(dashmapVm.markers[val1.type], val1.markers);
            angular.merge(dashmapVm.layers.overlays[val1.type], val1.overlay);
            dashmapVm.layers.overlays[val1.type].legend.loading = false;
          });
        });
      }

      function errorFn(error) {
        var match = error.url.match(/a(?:tx|fd)/)[0];
        updateError({
          'error': error,
          'id': match
        });
        for (var i = markers.length - 1; i >= 0; i--) {
          dashmapVm.layers.overlays[markers[i].id].legend.loading = false;
        }
      }
    }

    function nowcoastUpdateCheck(layers) {
      var requests = [];
      var activeLayer;

      angular.forEach(layers, function(layer) {
        if(dashmapVm.layers.overlays[layer.id]) {
          activeLayer = dashmapVm.layers.overlays[layer.id].legend.settings.activeLayers;
          requests.push(overlayFactory.loadNowCOAST(activeLayer, dashmapVm.layers.overlays[layer.id]));
        }
      });

      $q.all(requests).then(success, function(error) {
        var IDlookup = {
          'radar_meteo_imagery_nexrad_time': 'rmint',
          'sat_meteo_imagery_time': 'smigt',
          'wwa_meteoceanhydro_shortduration_hazards_watches_time': 'watches',
          'wwa_meteoceanhydro_shortduration_hazards_warnings_time': 'warnings'
        };
        updateError({
          'error': error,
          'id': IDlookup[error.config.params.service]
        });
      });

      function success(data) {
        for (var j = data.length - 1; j >= 0; j--) {
          // check to see if new data time is the same as the old

          if (data[j].overlay.type === 'group') {
            updateError({
              id: data[j].overlay.id
            });
            angular.merge(dashmapVm.layers.overlays[data[j].overlay.id], data[j].overlay);
            return;
          }

          if (dashmapVm.layers.overlays[data[j].overlay.id].layerParams.time !== data[j].overlay.layerParams.time) {
            updateError({
              id: data[j].overlay.id
            });
            angular.merge(dashmapVm.layers.overlays[data[j].overlay.id], data[j].overlay);
          }

        }

      }
    }

    function disableControls() {
      var disabled = dashmapVm.loading.length > 0;

      return disabled;
    }

    function addBaselayer(style) {
      if (angular.isUndefined(style)) {
        $log.error('baselayer undefined');
        return;
      }

      baselayerFactory.buildLayer(style)
        .then(function(layer) {
          var temp = {};
          temp[style.id] = layer;
          $timeout(function() {
            refreshMapSize(250);
            dashmapVm.layers.baselayers = temp;
          });
        });
    }

    function showBasins (event) {

      var position = $mdPanel.newPanelPosition()
        .relativeTo('.basin-list')
        .addPanelPosition($mdPanel.xPosition.ALIGN_END, $mdPanel.yPosition.BELOW);

      var config = {
        attachTo: angular.element($document[0].body),
        controller: basinListController,
        controllerAs: 'panelCtrl',
        template:
          '<md-content style="height:300px; width: 250px;">'+
            '<section ng-repeat="affiliation in panelCtrl.basinsFull">'+
              '<md-subheader class="md-primary">{{affiliation[0].description}}</md-subheader>'+
              '<md-list>'+
                '<md-list-item ng-click="panelCtrl.addScenario({id: basin.id, displayId: basin.description})" ng-repeat="basin in affiliation.slice(1)">'+
                  '{{basin.description}}'+
                '</md-list-item>'+
              '</md-list>'+
            '</section>'+
          '</md-content>',
        panelClass: 'scenario-list-panel',
        position: position,
        locals: {
          'addScenario': dashmapVm.addScenario,
          'basinsFull': dashmapVm.basinsFull
        },
        openFrom: event,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 100
      };

      $mdPanel.open(config);
    }

    /*@ngInject*/
    function basinListController(mdPanelRef){
      dashmapVm.panel = mdPanelRef;
    }

    function togglePanel (type) {
      if (type === 'components') {
        dashmapVm.showPanel = !dashmapVm.showPanel;
      } else {
        dashmapVm.showPanel = false;
      }

      refreshMapSize();
    }

    function refreshMapSize(d) {
      var delay = d || 25;

      if (angular.isDefined(map)) {
        $timeout(function() {
          map.invalidateSize();
          if(angular.isDefined(p2nMap)) p2nMap.invalidateSize();
        }, delay);
      }
    }

    function reorientMap () {
      $timeout(function() {
        map.invalidateSize();
        map.fitBounds(dashmapVm.mapBounds);
        map.closePopup();
      });
    }

    function hyetograph(event, args) {
      var marker = args.model,
        leafletObject = args.leafletObject,
        duration = +dashmapVm.layers.overlays.gauges.legend.settings.activeLayers,
        toDate = timeFactory.getLastInterval(15, dashmapVm.nowTime),
        fromDate = new Date(toDate);

      fromDate.setHours(fromDate.getHours() - duration);
      dashmapVm.hyetoLoading = true;

      var range = {
        fromDate: fromDate,
        toDate: toDate
      };
      var width = hyetoFactory.getChartWidth(range);
      var popOptions = {
        minWidth: width,
        maxWidth: 600,
        maxHeight: 300,
        autoPan: false,
        closeButton: true,
        className: 'gauge-popup'
      };
      var e = $compile(
        '<div class="chart-popup">'+
          '<h3>'+ marker.name +'</h3>'+
          '<p><span>'+ marker.feed +'</span><span class="no-line">Gauge ID: <strong>'+ marker.id +'</strong></span></p>'+
          '<div class="md-whiteframe-1dp hyeto-height" layout="column" layout-align="center center">'+
            '<md-progress-circular md-diameter=60px md-mode=indeterminate ng-show="dashmapVm.hyetoLoading"></md-progress-circular>'+
            '<div id="hyeto-chart" ng-show="!dashmapVm.hyetoLoading"></div>'+
          '</div>'+
        '</div>'
      )($scope);

      var popup = L.popup(popOptions).setContent(e[0]);
      leafletObject.bindPopup(popup).openPopup();
      map.panTo(leafletObject.getLatLng(), { duration: 0.3 });

      hyetoFactory.getGauge(marker.id, range, 'austin-grid').then(function(data){
        var c3Settings = hyetoFactory.getChart(data, range);
        c3Settings.bindto = '#hyeto-chart';
        hyetoChart = c3.generate(c3Settings);
        dashmapVm.hyetoLoading = false;
      });
    }

    function removeScenario() {
      map.removeLayer(dashmapVm.basinMask);
      dashmapVm.selectedScenario = undefined;
    }

    function addScenario(basin) {
      if (dashmapVm.panel) {
        dashmapVm.panel.close();
      }

      if (basin.id) {
        processScenario(basin);
      } else {
        var requests = [ p2nMapFactory.getScenario() ];

        $q.all(requests).then(function(data) {
          processScenario(data[0]);
        });
      }

      return;

      function processScenario(basin) {
        dashmapVm.selectedScenario = basin;
        // dashmapVm.selectedScenario.summary = dashmapVm.scenarioSummaries[basin.id];
        basinGeo.getClippedGeo(basin.id).then(function(d) {
          var polygonOptions = {
            color: 'black',
            stroke: true,
            fillOpacity: 0.7,
            weight: 1,
            className: 'basinMask'
          };
          if (map.hasLayer(dashmapVm.basinMask)) {
            map.removeLayer(dashmapVm.basinMask);
          }
          dashmapVm.basinMask = L.polygon(d, polygonOptions);
          map.addLayer(dashmapVm.basinMask);

          var bounds = new L.polygon(d[1]).getBounds();
          map.fitBounds(bounds);
        });
      }
    }

    function mapClickLoading(latlng) {
      var deferred = $q.defer();

      var tmp ='<div layout layout-align="center center"><md-progress-circular></md-progress-circular></div>';

      var popOptions = {
        minWidth: 400,
        minHeight: 350,
        autoPan: false
      };

      var e = $compile(tmp)($scope);

      L.popup(popOptions)
        .setLatLng(latlng)
        .setContent(e[0])
        .openOn(map);

      $timeout(function(){
        deferred.resolve();
      }, 100);

      return deferred.promise;
    }

    function mapClickPopup(latlng, results) {
      dashmapVm.results = results;
      var tmp ='<map-click-pop results="dashmapVm.results" basins="dashmapVm.basinMap" now-time="dashmapVm.nowTime"></map-click-pop>';

      var popOptions = {
        minWidth: 400,
        maxHeight: 350,
        autoPan: false,
        closeButton: true,
        className: 'map-click',
        closeOnClick: false
      };

      var e = $compile(tmp)($scope);

      infoPopup.el = L.popup(popOptions)
        .setLatLng(latlng)
        .setContent(e[0])
        .openOn(map);
    }

    // for replay mode
    function toggleReplay() {
      map.closePopup();
      dashmapVm.replay.isActive = dashmapVm.replay.mdSwitch;
      if(!dashmapVm.replay.mdSwitch) {
        dashmapVm.nowTime = timeFactory.getLastInterval();
        delete dashmapVm.replay.time;
        startUpdateCheck();
        endReplay();
        loadOverlays(dashmapVm.directory);
        notificationFactory.clearNotifications();
        return;
      } else {
        openReplayDialog();
      }
    }

    function openReplayDialog() {
      /* dialog explaining how the page will change */
      var confirm = {
        clickOutsideToClose: true,
        templateUrl: 'app/components/dashboard/dashmap/replay/replayDialog.tmpl.html',
        scope: $scope,
        locals: {
          maxTime: dashmapVm.latestInundationTime,
          replay: dashmapVm.replay
        },
        preserveScope: true,
        controller: replayController,
        controllerAs: 'rVm'
      };

      $mdDialog.show(confirm).then(startReplay, endReplay);
    }

    function startReplay(replayDate) {
      replayDate = timeFactory.getLastInterval(15, replayDate);
      updateBasinSummaries(replayDate);
      dashmapVm.replay.isActive = true;
      dashmapVm.replay.mdSwitch = true;
      dashmapVm.replay.time = replayDate;
      replayFactory.setActive(true);
      dashmapVm.nowTime = replayDate;
      stopUpdateCheck();
      var directory = {
        dashboard: []
      };

      sessionStorage.setItem('rp', replayDate);

      if (dashmapVm.directory) {
        for (var i = 0; i < dashmapVm.directory.dashboard.length; i++) {
          if(dashmapVm.directory.dashboard[i].hasHistory)
            directory.dashboard.push(dashmapVm.directory.dashboard[i]);
        }

        loadOverlays(directory);
      }
      notificationFactory.sendReplayNotification(replayDate);
    }

    function endReplay() {
      updateBasinSummaries();
      dashmapVm.replay.isActive = false;
      dashmapVm.replay.mdSwitch = false;
      replayFactory.setActive(false);
      sessionStorage.removeItem('rp');
    }

    /*@ngInject*/
    function replayController($scope, $mdDialog, maxTime, replay) {
      var rVm = this;
      angular.extend(rVm, {
        time: {
          selected: new Date(replay.time || maxTime),
          maxDate: new Date(maxTime)
        },
        load: load,
        mdDialog: $mdDialog
      });

      function load() {
        $mdDialog.hide(rVm.time.selected)
      }
    }

    function frameChange(isAniNext) {
      var minutes = dashmapVm.nowTime.getMinutes();

      if (isAniNext)
        dashmapVm.nowTime.setMinutes(minutes + 15);
      else
        dashmapVm.nowTime.setMinutes(minutes - 15);

      var time = dashmapVm.nowTime.getTime();

      updateBasinSummaries(dashmapVm.nowTime);
      var markers = [];

      angular.forEach(dashmapVm.layers.overlays, function (val) {
        if (val.layerOptions.time) {
          val.layerOptions.time = time;
          if (val.layerOptions.layers && val.layerOptions.layers.constructor === Array) {
            for (var i = 0; i < val.layerOptions.layers.length; i++) {
              val.layerOptions.layers[i].layerOptions.time = time;
              val.layerOptions.layers[i].doRefresh = true;
            }
          }
          val.doRefresh = true;
        } else if (val.layerParams.time) {
          val.layerParams.time = time;
          val.doRefresh = true;
        } else if (val.id === 'garr') {
          var duration = dashmapVm.layers.overlays.gauges.legend.settings.activeLayers;
          val.layerOptions.endTime = time;
          val.layerOptions.startTime = time - (1000 * 60 * 60 * duration);
          val.doRefresh = true;
        }

        if(val.layerType === 'marker') markers.push(val);
      });

      markersUpdateCheck(markers);
    }

    function openNav() {
      $mdSidenav('left').open();
    }

    function updateError(error) {

      if (!error.error) {
        if (dashmapVm.layers.errors.length === 0) {
          return;
        }
        removeError(error.id);
        return;
      }

      if (isUnique(error)) {
        addError(error);
        toastNotification(error);
      } else {
        removeDuplicates(error);
      }

      function isUnique(errorObject) {
        var check = dashmapVm.layers.errors.findIndex(function(d) {
          return d.id === errorObject.id;
        });
        if (check < 0) {
          return true;
        } else {
          return false;
        }
      }

      function removeDuplicates(errorObject) {
        removeError(errorObject.id)
        addError(errorObject);
      }

      function addError(errorObject) {
        dashmapVm.layers.errors.push(errorObject);
      }

      function removeError(errorID) {
        dashmapVm.layers.errors = dashmapVm.layers.errors.filter(function(d) {
          return d.id !== errorID;
        });
      }

      function toastNotification(errorObject) {
        notificationFactory.sendError(errorObject);
      }
    }

    // register leaflet listeners
    function startMapListeners() {
      $window.addEventListener('visibilitychange', function() {
        if(!dashmapVm.replay.isActive) {
          if ($document[0].visibilityState === 'hidden') {
            stopUpdateCheck();
          } else {
            startUpdateCheck(true);
          }
        }
      });

      deregCallbacks = [
        $scope.$on('leafletDirectiveMarker.dashmap.click', clickMarker),
        $scope.$on('leafletDirectiveMap.dashmap.click', clickMap),
        $scope.$on('leafletDirectiveMap.dashmap.layeradd', layeradd),
        $scope.$on('leafletDirectiveMap.dashmap.popupclose', popupclose),
        $scope.$on('leafletDirectiveMap.dashmap.mousedown', mousedown),
        $scope.$on('leafletDirectiveMap.dashmap.mouseup', mouseup),
        $scope.$on('leafletDirectiveMap.dashmap.mouseover', mouseover),
        $scope.$on('leafletDirectiveMap.dashmap.mouseout', mouseout),
        $scope.$on('leafletDirectiveMap.dashmap.mousemove', mousemove),
        $scope.$on('Scenario', addScenario),
        $scope.$on('toggle-panel', togglePanel),
        $scope.$on('Scenario', addScenario),
        $scope.$on('updateInundation', inundationUpdateCheck)
      ];
    }

    function saveBounds() {
      var currentBounds = map.getBounds()
      var formattedBounds = [currentBounds.getSouthWest(), currentBounds.getNorthEast()];
      sessionStorage.setItem('lastZoomLevel', angular.toJson(formattedBounds));
      flashSuccessIcon();
    }

    function reorientBounds() {
      var lastZoomLevel = angular.fromJson(sessionStorage.getItem('lastZoomLevel'));
      map.fitBounds(lastZoomLevel);
      map.closePopup();
    }

    function flashSuccessIcon() {
      dashmapVm.flashSuccess = true;
      $timeout(function(){
        dashmapVm.flashSuccess = false;
      }, 3000);
    }

    function hasBookmark() {
      return sessionStorage.getItem('lastZoomLevel') !== null;
    }

    function clickMarker(event, args) {
      infoPopup.loaded = false;
      isMarkerClicked = true;
      if (args.layerName === 'gauges') {
        hyetograph(event, args);
      } else if (args.layerName === 'watchpoints') {
        $rootScope.$broadcast('wpClick', args);
      }
    }

    function clickMap(event, args) {
      map.closePopup();
      if (isMarkerClicked || angular.isDefined(infoPopup.el)) {
        isMarkerClicked = false;
        return;
      }
      var latLng = args.leafletEvent.latlng;

      mapClickLoading(latLng).then(function() {
        mapClickHandler.sendRequest(latLng, dashmapVm.replay.isActive ? dashmapVm.nowTime : undefined).then(function(d){
          mapClickPopup(latLng, d);
          infoPopup.loaded = true;
        });
      });
    }

    function layeradd(event, data) {
      var layer = data.leafletEvent.layer;
      if (layer instanceof L.TileLayer && !layer.options.isBaselayer) {
        dashmapVm.loading.push(layer);
        dashmapVm.layers.overlays[layer.options.attribution].legend.loading = true;

        layer.on('load', function() {
          var index = dashmapVm.loading.indexOf(layer);
          dashmapVm.loading.splice(index, 1);
          if ((dashmapVm.loading.indexOf(layer) < 0) && dashmapVm.layers.overlays[layer.options.attribution]) {
            dashmapVm.layers.overlays[layer.options.attribution].legend.loading = false;
          }
          layer.on('loading', function() {
            dashmapVm.layers.overlays[layer.options.attribution].legend.loading = true;
          });
        });

        layer.on('tileerror', function(error) {
          updateError({
            'error': error,
            'id': layer._url
          });
        });

        layer.on('tileload', function() {
          updateError({
            'id': layer._url
          });
        });
      }

      if (layer instanceof L.GeoJSON && angular.isDefined(layer.options.attribution)) {
        dashmapVm.layers.overlays[layer.options.attribution].legend.loading = false;
      }
    }

    function popupclose() {
      if (hyetoChart !== null) hyetoChart = hyetoChart.destroy();
      if (angular.isDefined(infoPopup.el)) infoPopup.el = undefined;
    }

    function mousedown() {
      map.scrollWheelZoom.disable();
    }

    function mouseup() {
      map.scrollWheelZoom.enable();
    }

    function mouseover() {
      if (SmartPhone.isAny()) {
        dashmapVm.showCoordinatesDiv = false;
        return;
      }
      dashmapVm.showCoordinatesDiv = true;
    }

    function mouseout() {
      dashmapVm.showCoordinatesDiv = false;
    }

    function mousemove(ngEvent, leafletEvent) {
      var mouseCoordinates = [leafletEvent.leafletEvent.latlng.lng, leafletEvent.leafletEvent.latlng.lat];
      var conversion = proj4(proj4('ESRI:102739'), mouseCoordinates);
      dashmapVm.showCoordinates = conversion;
    }

    // deregister leaflet listeners
    function onDestroy() {
      for (var i = 0; i < deregCallbacks.length; i++) {
        deregCallbacks[i]();
      }
      $interval.cancel(updateCheck);
    }

    function searchAddress (ev) {
      $mdDialog.show({
        controller: searchService.searchController,
        controllerAs: 'sc',
        templateUrl: 'app/components/dashboard/dashmap/search/search.tmpl.html',
        parent: angular.element($document[0].body),
        targetEvent: ev,
        escapeToClose: true,
        clickOutsideToClose:true,
        center: dashmapVm.center,
        gauges: dashmapVm.markers.gauges,
        mapBounds: dashmapVm.mapBounds
      })
      .then(function(item) {
        if(angular.isDefined(item)) {
          angular.extend(dashmapVm.center, {
            lat: item.lat,
            lng: item.lng,
            zoom: 14
          });

          L.popup()
            .setLatLng([item.lat, item.lng])
            .setContent('<div class="temp-popup"><span>' + item.name + '</span><br><span>' + (item.id ? item.id : '') + '</span></div>')
            .openOn(map);
        }
      });
    }
  }
})();

(function() {
    'use strict';

    angular.module('ack', []);
})();

(function() {
  'use strict';

  var component = {
    controller: AckController,
    controllerAs: 'ackVm',
    templateUrl: templateUrl,
    bindings: {
      alertItem: '<'
    }
  }

  angular.module('ack').component('ackComponent', component);

  /*@ngInject*/
  function templateUrl($attrs){
    var path = 'app/components/alerts/ack-component/';
    return path + ($attrs.type === 'icon' ? 'ackIcon' : 'ack') + '.tmpl.html';
  }

  /*@ngInject*/
  function AckController($rootScope, $scope, $auth, $mdDialog,
      userFactory, alertStatusFactory) {
    var ackVm = this;
    var listeners = [];

    angular.extend(ackVm, {
      $onInit: onInit,
      $onChanges: onChanges,
      $onDestroy: onDestroy,
      setAck: setAck,
      tokenInfo: $auth.getPayload() // token meta (for sub and admin)
    });

    function onInit() {
      userFactory.getMe().then(function(res) {
        ackVm.canEdit = res.data.permissions.notifications.edit;
      });
      startListeners();
    }

    function onChanges(changes) {
      if(changes.alertItem.currentValue !== null &&
        angular.isDefined(changes.alertItem.currentValue)) {
        ackVm.recentStatus = {};
        ackVm.error = false;
        getStatus();
      }
    }

    function getStatus() {
      if(ackVm.alertItem.ackStatus.length > 0) {
        ackVm.recentStatus = ackVm.alertItem.ackStatus[ackVm.alertItem.ackStatus.length - 1];
      } else {
        ackVm.recentStatus = {};
      }
    }

    function setAck(ev) {
      var confirm = $mdDialog.prompt()
        .title('Acknowledge alert as ' + ackVm.tokenInfo.sub + '?')
        .placeholder('Additional Comments')
        .ariaLabel('Alert Comments')
        .targetEvent(ev)
        .ok('Submit')
        .cancel('Cancel');

      $mdDialog.show(confirm).then(function(comments) {
        ackVm.loading = true;
        var options = {
          comments: comments,
          status: ackVm.alertItem.isAck ? 'UNACKNOWLEDGED' : 'ACKNOWLEDGED'
        };

        alertStatusFactory.acknowledge(ackVm.alertItem, options).then(function(data) {
          if (data[0].opResult === 'SUCCESS') {
            ackVm.loading = false;
            $rootScope.$broadcast('updateAlert', data[0]);
          }
        }, function(error) {
          ackVm.loading = false;
          ackVm.error = error.status + ' : ' + (error.statusText || 'ERROR') ;
        });
      });
    }

    function startListeners() {
      listeners.push($scope.$on('updateAlert', updateAlert));
    }

    function updateAlert(event, info) {
      if(info.entryID === ackVm.alertItem.entryID) {
        ackVm.alertItem.ackStatus.push(info);
        ackVm.recentStatus = info;
        ackVm.alertItem.isAck = info.status === 'ACKNOWLEDGED' ? true : false;
      }
    }

    function onDestroy() {
      // unregister listeners
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('fews')
    .factory('wpFactory', wpFactory);

  /*@ngInject*/
  function wpFactory($http, $q, $log, $filter, $httpParamSerializer, $window,
      $state, $auth, debounce, API_URL, VDS_URL) {
    var threeHours = 1000 * 60 * 60 * 3;
    var authToken = $auth.getToken();
    var handleAuth = debounce(fnHandleAuth, 2000, false);
    var factory = {
      retrieve: retrieve,
      markers: markers,
      statusUpdate: statusUpdate,
      rawData: rawData,
      info: info,
      imageUrl: imageUrl,
      thumbsUrl: thumbsUrl,
      chartConfig: chartConfig,
      getReadings: getReadings,
      updateWithRecent: updateWithRecent
    };

    return factory;

    function retrieve() {

      var req = {
        method: 'GET',
        url: API_URL + 'watchpoints/retrieve',
        headers: { 'Content-Type': 'application/json' },
        cache: true
      }

      return $http(req).then(function(response) {
        for (var i = 0; i < response.data.watchPoints.length; i++) {
          response.data.watchPoints[i].spriteOrder = i;
        }

        return $q.resolve(response.data);
      }, xhrFailed);
    }

    function info(point) {

      var req = {
        method: 'GET',
        url: API_URL + VDS_URL + 'watchpoints/point',
        headers: { 'Content-Type': 'application/json' },
        params: { pointid: point }
      }

      return $http(req).then(xhrComplete, xhrFailed);
    }

    function statusUpdate(useCache, timeParams) {
      if (useCache === null)
        useCache = false;

      var req = {
        method: 'GET',
        url: API_URL + 'hydrographs/height/status',
        headers: {
          'Content-Type': 'application/json'
        },
        cache: useCache
      };

      if (timeParams) {
        req.params = timeParams;
      }

      return $http(req).then(xhrComplete, xhrFailed);
    }

    function rawData(id, time) {
      var params = {};

      if (time) {
        if (time instanceof Date) {
          time = time.getTime();
          params.start = time - threeHours;
          params.end = time;
        } else {
          params = time;
        }
      }

      var req = {
        method: 'GET',
        url: API_URL + 'hydrographs/' + id + '/height_chart.json',
        headers: {
          'Content-Type': 'application/json'
        },
        params: params
      }

      return $http(req).then(xhrComplete, xhrFailed);
    }

    function thumbsUrl(newParams) {
      var dpr = $window.devicePixelRatio,
          checkedDPR = dpr < 1 ? 1 : Math.floor(dpr),
          params = {
            ghostLines: true,
            pixelRatio: checkedDPR,
            style: 'THUMBNAIL',
            height: 75,
            width: 100,
            accesstoken: authToken
          },
          queryParams = '';

      params = angular.extend({}, params, newParams);
      queryParams += $httpParamSerializer(params);

      return API_URL + 'hydrographs/height_chart.png?' + queryParams;
    }

    function imageUrl(point, timeParams) {
      var dpr = $window.devicePixelRatio,
          checkedDPR = dpr < 1 ? 1 : Math.floor(dpr);
      var defaultParams = {
        all: {
          ghostLines: true,
          pixelRatio: checkedDPR
        },
        ani: timeParams.ani,
        static: timeParams.static
      };

      var response = {
        url: API_URL + 'hydrographs/' + point.id + '/height_chart',
        ani: $httpParamSerializer(defaultParams.all) + '&' + $httpParamSerializer(defaultParams.ani),
        static: $httpParamSerializer(defaultParams.all) + '&' + $httpParamSerializer(defaultParams.static)
      };

      return response;
    }

    function markers(markerData, clustering) {
      var wp = markerData.watchPoints;
      var wpMarkers = {};
      var overlay = {
        layerOptions: {
          disableClusteringAtZoom: clustering ? false : 0.1,
          iconCreateFunction: iconCreateFunction
        },
        legend: {
          markerCount: wp.length
        }
      };


      angular.forEach(wp, function(m) {
        var wpKey = 'wp' + m.id.replace(/\W+/g, '').toLowerCase();
        wpMarkers[wpKey] = {
          zIndexOffset: 500,
          layer: 'watchpoints',
          lat: m.latitude,
          lng: m.longitude,
          // message: getMessage(m),
          name: m.displayName,
          id: m.id,
          icon: {
            type: 'div',
            iconSize: [12, 12],
            className: 'md-whiteframe-1dp watchpoint',
            iconAnchor: [6, 6]
          },
          popupOptions: {
            maxWidth: 320,
            autoPan: false,
            closeButton: false,
            offset: [0, -2],
            className: 'popup-watchpoint'
          },
          label: {
            message: '',
            options: {
              clickable: false,
              noHide: true,
              className: 'latest-wp-reading' + (m.hasElevation ? ' underline' : ''),
              offset: [-17, 8]
            }
          }
        }
      });

      var response = {
        type: 'watchpoints',
        overlay: overlay,
        markers: wpMarkers
      };

      return $q.resolve(response);

      /////////////////

      function iconCreateFunction(cluster) {
        var childCount = cluster.getChildCount();
        var markers = cluster.getAllChildMarkers();
        var maxVal = 0;
        var className = 'false';

        for (var i = markers.length - 1; i >= 0; i--) {
          var tempVal = parseFloat(markers[i].label._content);
          if (tempVal > maxVal) {
            maxVal = tempVal;
            className = markers[i].label.options.className;
          }
        }

        return new L.DivIcon({
          html: '<div><span>' + childCount +
                '</span><div class="label-val '+ className +'">' +
                (maxVal === 0 ? parseFloat(maxVal.toFixed(2)) : maxVal) +
                '</div></div>',
          className: 'marker-cluster cluster-watchpoint',
          iconSize: new L.Point(32, 32)
        });
      }

      // function getMessage(data) {
      //   var cacheControl = Date.now();
      //
      //   var html = '<div class="watchpoint-marker-info" layout="column">' +
      //     '<div class="md-whiteframe-1dp chart">'+
      //       '<img src="assets/images/loading_icon.gif" ng-src="' + imageUrl(data) +'&style=THUMBNAIL&height=124&width=280&r=' + cacheControl + '" err-src="/assets/images/error_icon.png" width="280" />' +
      //       '<div class="button-container">'+
      //       '<md-button class="md-fab" aria-label="Fullscreen" ng-click="wpVm.infoDialog(wpVm.selected, $event)">'+
      //           '<md-icon>fullscreen</md-icon>'+
      //       '</md-button>'+
      //       '<md-button class="md-fab" aria-label="Download" download ng-href="{{wpVm.selected.url}}&style=COMPLICATED&height=720&width=1280&download=true">'+
      //           '<md-icon>file_download</md-icon>'+
      //       '</md-button>'+
      //       '</div>'+
      //     '</div>'+
      //     '<div class="info">' + data.displayName + '</div>' +
      //     '<div class="info">' + data.id + '</div>' +
      //     // ('<div class="address">' + data.address + '</div>') +
      //     // '<div class="title" layout="column">' +
      //     // data.agency_responsible +
      //     // '<span>' + moment(data.requested_datetime).format('HH:mm YYYY/MM/DD') + '</span>' +
      //     // '</div>' +
      //     '</div>';
      //
      //   return html;
      // }
    }

    function chartConfig(anchorName) {
      return {
        bindto: anchorName || '#wp-chart',
        data: {
          columns: [],
          order: null
        },
        axis: {
          x: {
            type: 'timeseries',
            tick: {
              fit: false,
              //format: function (d) {return moment.tz(d, timezone).format('HH:mm MM/DD');},
              format: '%H:%M %m/%d',
              width: 50,
              outer:false
            }
          },
          y: {
            tick: {
              format: d3.format('.1f'),
              outer:false
            },
            padding: { top:0, bottom:0 }
          }
        },
        legend: { show: true },
        grid: {
          x: {
            show:true,
            lines: []
          },
          y: { show:true }
        },
        padding: {
          top: 4,
          right: 8,
          bottom: 8,
          left: 35
        },
        transition: { duration: null }
      };
    }

    // Get Single Most Observed Stage Data
    function getReadings(start, end, point, basin) {
      var req = {
        method: 'GET',
        url: API_URL + 'hydrographs/observed/height/recentReading',
        headers: { 'Content-Type': 'application/json' },
        cache: true,
        params: {
          start: start,
          end: end,
          point: point,
          basin: basin
        }

      }

      return $http(req).then(function(response) {
        var result = {};

        for (var i = response.data.length - 1; i >= 0; i--) {
          result['wp' + response.data[i].id] = response.data[i];
        }

        return $q.resolve(result);
      }, xhrFailed);
    }

    function updateWithRecent (points, maxes) {
      angular.forEach(maxes, function(d){
        var wpKey = 'wp' + d.id.replace(/\W+/g, '').toLowerCase();
        // if marker exists
        if (points[wpKey]) {
          if (d.value != null) {
            var value = $filter('number')(d.value, 2);
            points[wpKey].label.message = value.toString();
          } else {
            points[wpKey].label.message = 'N/A';
          }
        }
      });

      return points;
    }

    function xhrComplete(response) {
      return $q.resolve(response.data);
    }

    function xhrFailed(error) {
      if (error.status === 403 || error.status === 401) {
        handleAuth();
      }

      $log.error(error);
      return $q.reject(error);
    }

    function fnHandleAuth() {
      $state.go('logout');
    }

  }

})();

(function() {
    'use strict';
    angular
        .module('fews')
        .factory('uuid', uuid);

    /*@ngInject*/
    function uuid($window) {
        var service = {
            generate: generate
        };
        return service;
        ////////////////

        function generate() {
            var d = new Date().getTime();
            if($window.performance && angular.isFunction($window.performance.now)){
                d += performance.now(); //use high-precision timer if available
            }
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });

            return uuid;
        }
    }
})();
(function() {
  'use strict';

  angular
    .module('fews')
    .factory('userFactory', userFactory);

  /*@ngInject*/
  function userFactory($http, $q, API_URL) {
    var me;
    var factory = {
      requestReset: requestReset,
      setPassword: setPassword,
      tokenCheck: tokenCheck,
      getMe: getMe,
      me: function() { return me; }
    };

    return factory;

    function requestReset(data) {
      return $http({
        method: 'POST',
        url: API_URL + 'user-management/request-password-reset',
        data: { emailAddress: data }
      });
    }

    function setPassword(data) {
      return $http({
        method: 'POST',
        url: API_URL + 'user-management/set-password-token',
        data: {
          newPassword: data.password,
          token: data.key
        }
      });
    }

    function tokenCheck(token) {
      return $http({
        method: 'POST',
        url: API_URL + 'user-management/validate-password-token',
        data: { token: token }
      });
    }

    function getMe(isCached) {
      return $http({
        method: 'GET',
        // url: 'assets/' + localStorage.username + '.json',
        url: API_URL + 'user-management/get-user',
        cache: isCached === false ? false : true,
        params: { username: localStorage.username }
      });
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('fews')
        .factory('timeFactory', timeFactory);

    /*@ngInject*/
    function timeFactory ($http, $q) {
        var oneMin = 1000 * 60 * 60;
        var factory = {
            timeArray: timeArray,
            getLastInterval: getLastInterval
        };

        return factory;
        ///////////////

        function timeArray(nowTime) {
            if(!angular.isDate(nowTime)){
                return $q.reject('param not a date obj');
            }
            var threeHr = 6e4 * 60 * 3;
            var startTime = nowTime.getTime() - threeHr;
            var endTime = nowTime.getTime() + threeHr;
            var timeArray = [];

            for (var i = startTime; i <= endTime; i += (oneMin * 15)) {
                timeArray.push(i);
            }

            return $q.resolve(timeArray);
        }

        function getLastInterval(interval, ts) {
            interval = interval || 5;
            var nowTime = ts ? new Date(ts) : new Date();
            var nowMin = nowTime.getMinutes();
            var leftoverMin = nowMin % interval;
            var newMin;

            // not used
            // if (ts && leftoverMin !== 0 && leftoverMin > (interval / 2)) {
            //   newMin = nowMin + (interval - leftoverMin);
            // } else {

            newMin = nowMin - leftoverMin;

            nowTime.setMinutes(newMin, 0, 0);

            return nowTime;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('fews')
        .factory('tileCoords', tileCoords);

    /*@ngInject*/
    function tileCoords($q) {
        var service = {
            getVisible: getVisible
        };
        return service;
        ////////////////
        function getVisible(tileLayer, map, zoom) {
            var bounds = map.getBounds(),
                min = map.project(bounds.getNorthWest(), zoom).divideBy(256).floor(),
                max = map.project(bounds.getSouthEast(), zoom).divideBy(256).floor(),
                urls = [];

            for (var i = min.x; i <= max.x; i++) {
                for (var j = min.y; j <= max.y; j++) {

                    var coords = new L.Point(i, j);
                    coords.z = zoom;

                    var tileUrl = tileLayer.getTileUrl(coords);
                    urls.push(tileUrl);

                }
            }

            return $q.resolve(urls);

        }
    }
})();
(function() {
    'use strict';
    angular
        .module('fews')
        .factory('screenFactory', screenFactory);

    /*@ngInject*/
    function screenFactory($window) {
        var service = {
            isHighDensity: isHighDensity
        };
        return service;
        ////////////////
        function isHighDensity(){
            return (($window.matchMedia &&
              (
                $window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches ||
                $window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches)) ||
                ($window.devicePixelRatio && $window.devicePixelRatio > 1.3)
              );
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('fews')
    .factory('replayFactory', replayFactory);

  /*@ngInject*/
  function replayFactory() {
    var replayIsActive = false;
    var factory = {
      setActive: setActive,
      isActive: isActive
    };

    return factory;

    function setActive(a) {
      if(typeof(a) === "boolean") {
        replayIsActive = a;
      }
    }

    function isActive() {
      return replayIsActive;
    }
  }

})();

(function() {
    'use strict';

    angular
        .module('fews')
        .factory('projectInfo', projectInfo);

    /*@ngInject*/
    function projectInfo($q, $http, $log, $auth, $state, debounce, API_URL) {
        var factory = {
          getBasins: getBasins,
          getDetails: getDetails,
          getDomainBounds: getDomainBounds
        };
        return factory;
        ////////////////
        function getBasins(affiliation) {
          var req = {
              method: 'GET',
              url: API_URL + 'project/basins/' + (affiliation || 'Inundation'),
              headers: {'Content-Type':'application/json'},
              params: {},
              cache: true
          };

          return $http(req).then(function(response){
              for (var i = response.data.length - 1; i >= 0; i--) {
                  if(response.data[i].inundation)
                      response.data[i].latestTimeOfSimulation = 0;
              }

              return $q.resolve(response.data);
          }, xhrFailed);
        }

        function getDetails() {
            var req = {
                method: 'GET',
                url: API_URL + 'project/details',
                headers: {'Content-Type':'application/json'},
                params: {},
                cache: true
            };

            return $http(req).then(xhrComplete, xhrFailed);
        }

        function getDomainBounds (basins) {
            var maxLats = [],
                maxLons = [],
                minLats = [],
                minLons = [],
                bounds = [];

            for (var i = basins.length - 1; i >= 0; i--) {
                maxLats.push(basins[i].bounds.maxLat);
                maxLons.push(basins[i].bounds.maxLon);
                minLats.push(basins[i].bounds.minLat);
                minLons.push(basins[i].bounds.minLon);
            }

            bounds = [
                [Math.min.apply(null, minLats), Math.min.apply(null, minLons)],
                [Math.max.apply(null, maxLats), Math.max.apply(null, maxLons)]
            ];

            return $q.resolve(bounds);
        }

        function xhrComplete(response) {
          return $q.resolve(response.data);
        }

        function xhrFailed(error) {
          $log.error(error);
          return $q.reject(error);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('fews')
        .factory('tileFactory', tileFactory);

    function tileFactory ( $q, $rootScope, $log ) {
        // I manage the preloading of image objects. Accepts an array of image URLs.
        function Preloader( imageLocations ) {
            // I am the image SRC values to preload.
            this.imageLocations = imageLocations;
            // As the images load, we'll need to keep track of the load/error
            // counts when announing the progress on the loading.
            this.imageCount = this.imageLocations.length;
            this.loadCount = 0;
            this.errorCount = 0;
            // I am the possible states that the preloader can be in.
            this.states = {
                PENDING: 1,
                LOADING: 2,
                RESOLVED: 3,
                REJECTED: 4
            };
            // I keep track of the current state of the preloader.
            this.state = this.states.PENDING;
            // When loading the images, a promise will be returned to indicate
            // when the loading has completed (and / or progressed).
            this.deferred = $q.defer();
            this.promise = this.deferred.promise;
        }
        // ---
        // STATIC METHODS.
        // ---
        // I reload the given images [Array] and return a promise. The promise
        // will be resolved with the array of image locations.
        Preloader.preloadImages = function( imageLocations ) {
            var preloader = new Preloader( imageLocations );
            return( preloader.load() );
        };
        // ---
        // INSTANCE METHODS.
        // ---
        Preloader.prototype = {
            // Best practice for "instnceof" operator.
            constructor: Preloader,
            // ---
            // PUBLIC METHODS.
            // ---
            // I determine if the preloader has started loading images yet.
            isInitiated: function isInitiated() {
                return( this.state !== this.states.PENDING );
            },
            // I determine if the preloader has failed to load all of the images.
            isRejected: function isRejected() {
                return( this.state === this.states.REJECTED );
            },
            // I determine if the preloader has successfully loaded all of the images.
            isResolved: function isResolved() {
                return( this.state === this.states.RESOLVED );
            },
            // I initiate the preload of the images. Returns a promise.
            load: function load() {
                // If the images are already loading, return the existing promise.
                if ( this.isInitiated() ) {
                    return( this.promise );
                }
                this.state = this.states.LOADING;
                for ( var i = 0 ; i < this.imageCount ; i++ ) {
                    this.loadImageLocation( this.imageLocations[ i ] );
                }
                // Return the deferred promise for the load event.
                return( this.promise );
            },
            // ---
            // PRIVATE METHODS.
            // ---
            // I handle the load-failure of the given image location.
            handleImageError: function handleImageError( imageLocation ) {
                this.errorCount++;
                // If the preload action has already failed, ignore further action.
                if ( this.isRejected() ) {
                    return;
                }
                this.state = this.states.REJECTED;
                this.deferred.reject( imageLocation );
            },
            // I handle the load-success of the given image location.
            handleImageLoad: function handleImageLoad( imageLocation ) {
                this.loadCount++;
                // If the preload action has already failed, ignore further action.
                if ( this.isRejected() ) {
                    return;
                }
                // Notify the progress of the overall deferred. This is different
                // than Resolving the deferred - you can call notify many times
                // before the ultimate resolution (or rejection) of the deferred.
                this.deferred.notify({
                    percent: Math.ceil( this.loadCount / this.imageCount * 100 ),
                    imageLocation: imageLocation
                });
                // If all of the images have loaded, we can resolve the deferred
                // value that we returned to the calling context.
                if ( this.loadCount === this.imageCount ) {
                    this.state = this.states.RESOLVED;
                    this.deferred.resolve( this.imageLocations );
                }
            },
            // I load the given image location and then wire the load / error
            // events back into the preloader instance.
            // --
            // NOTE: The load/error events trigger a $digest.
            loadImageLocation: function loadImageLocation( imageLocation ) {
                var preloader = this;
                // When it comes to creating the image object, it is critical that
                // we bind the event handlers BEFORE we actually set the image
                // source. Failure to do so will prevent the events from proper
                // triggering in some browsers.
                var image = angular.element( new Image() )
                    .bind('load',
                        function( event ) {
                            // Since the load event is asynchronous, we have to
                            // tell AngularJS that something changed.
                            $rootScope.$apply(
                                function() {
                                    preloader.handleImageLoad( event.target.src );
                                    // Clean up object reference to help with the
                                    // garbage collection in the closure.
                                    preloader = image = event = null;
                                }
                            );
                        }
                    )
                    .bind('error',
                        function( event ) {
                            // Since the load event is asynchronous, we have to
                            // tell AngularJS that something changed.
                            $rootScope.$apply(
                                function() {
                                    preloader.handleImageError( event.target.src );
                                    // Clean up object reference to help with the
                                    // garbage collection in the closure.
                                    preloader = image = event = null;
                                }
                            );
                        }
                    )
                    .attr('src', imageLocation );

                if(!image)
                    $log.error(image);
            }
        };
        // Return the factory instance.
        return( Preloader );
    }
})();

(function() {
    'use strict';
    angular
        .module('fews')
        .factory('notificationFactory', notificationFactory);

    /*@ngInject*/
    function notificationFactory($mdToast, $timeout) {
      var notificationList = [];
      var service = {
          getNotifications: getNotifications,
          addNotification: addNotification,
          sendNotifications: sendNotifications,
          sendReplayNotification: sendReplayNotification,
          sendGenericMessage: sendGenericMessage,
          sendGenericError: sendGenericError,
          sendError: sendError,
          clearNotifications: clearNotifications
      };

      return service;
      ////////////////

      function getNotifications() {
        return this.notificationList;
      }

      function addNotification(type, count) {
        var notification = {
          id: type,
          msg: count
        }
        notificationList.push(notification);
      }

      function dedupe(firstList) {
        var fixedList = [];

        angular.forEach(firstList, function(obj) {
          if (fixedList.indexOf(obj) < 0) {
            fixedList.push(obj)
          }
        });

        return fixedList;
      }

      function sendNotifications() {
        var msgList = dedupe(notificationList);
        var message;
        for (var x = 0; x < msgList.length; x++) {
            if (angular.isDefined(message)) {
              message = message + ', ' + msgList[x].msg + ' ' + msgList[x].id;
            } else {
              message = msgList[x].msg + ' ' + msgList[x].id;
            }
        }

        if (angular.isDefined(message)) {
          var notification = $mdToast
            .simple()
            .textContent(message + ' added to feed.')
            .position('bottom left')
            .toastClass('info')
            .hideDelay(10000);
          $mdToast.show(notification);
        }
        clearNotifications();
      }

      function sendReplayNotification(replayDate) {
        var notification = $mdToast
          .simple()
          .textContent('Replay mode active for ' + replayDate)
          .position('bottom left')
          .toastClass('watch')
          .hideDelay(5000);
        $mdToast.show(notification);
        sleep(5000).then( function() {
          sendNotifications()
        });
      }

      function sendGenericMessage(message) {
        var notification = $mdToast
          .simple()
          .textContent(message)
          .toastClass('info');
        $mdToast.show(notification);
      }

      function sendError(errorObject) {
        var notification = $mdToast
          .simple()
          .textContent('We encountered a problem while loading: ' + errorObject.id)
          .position('bottom left')
          .toastClass('error')
          .hideDelay(4000);
        $mdToast.show(notification);
      }

      function sendGenericError() {
        var notification = $mdToast
          .simple()
          .textContent('Error retrieving notifications. Trying again in 15 seconds.')
          .position('bottom left')
          .toastClass('error')
          .hideDelay(4000);
        $mdToast.show(notification);
      }

      function sleep(time) {
        return new Promise(function(resolve) { $timeout(resolve, time)});
      }

      function clearNotifications() {
        notificationList = [];
      }

    }


})();

(function() {
    'use strict';

    angular
        .module('fews')
        .factory('navigationFactory', navigationFactory);

    /*@ngInject*/
    function navigationFactory() {

        var currentPage = null;
        var factory = {
            getPage: getPage,
            setPage: setPage
        }

        return factory;

        function getPage () {
            return currentPage;
        }

        function setPage (page) {
            currentPage = page;
        }
    }
})();
(function() {
  'use strict';
  angular.module('fews').factory('mapClickHandler', mapClickHandler);

  /*@ngInject*/
  function mapClickHandler($http, $q, $log, API_URL) {

    var factory = {
      sendRequest: sendRequest
    }

    return factory;

    /**
       * send request to api for particular lat and long
       * @param  object latLng {lat, lng}
       * @return promise with formatted results
       */
    function sendRequest(latLng, nowTime) {
      var deferred = $q.defer();
      var results = [];
      var requests = [vieuxRequest(latLng, nowTime)];
      var nowCoastResults = {
        display: 'Watches and Warnings',
        id: 'ww',
        data: []
      };

      /**
        * NOTE: this section is disabled and needs work/testing before enabling
        */
      // var nowCOASTCalls = [
      //   {
      //     'id': 'wwa_meteoceanhydro_shortduration_hazards_watches_time',
      //     'layers': 'visible:0,1,2'
      //   }, {
      //     'id': 'wwa_meteoceanhydro_shortduration_hazards_warnings_time',
      //     'layers': 'visible:1,3,4'
      //   }
      // ];
      // nowCOASTCalls.forEach(function(d) {
      //   requests.push(nowCOASTIdentify(latLng, d));
      // });

      $q.all(requests).then(function(d) {
        var nameKey = {
          'inundationGrid': 'Inundation',
          'buildings': 'Buildings',
          'bridges': 'Bridges'
        };

        // structure the data for the popup tabs
        var vieuxData = d[0];
        var timeOfSimulation = vieuxData.timeOfSimulation;
        for (var data in vieuxData) {
          if (!nameKey[data]) {
            continue;
          }
          if (vieuxData.hasOwnProperty(data) && vieuxData[data]) {

            var structured = {
              id: data,
              display: nameKey[data],
              data: vieuxData[data]
            };
            if (data === 'buildings' || data === 'bridges') {
              structured.timeOfSimulation = timeOfSimulation
            }
            results.push(structured);
          }
        }

        d.slice(1).forEach(function(b) {
          if (!b)
            return;

          if (b.results) {
            if (b.results.length < 1)
              return;
            nowCoastResults.data = nowCoastResults.data.concat(b.results);
          } else {
            results = results.concat(b);
          }

          return;
        });

        if (nowCoastResults.data.length) {
          results.push(nowCoastResults);
        }
        deferred.resolve(results);
      });

      return deferred.promise;
    }

    /**
       * send request to cop backend with a lat and long
       * return results for layers which contain the point
       * @param  object latLng {lat, lng}
       * @return $http promise
       */
    function vieuxRequest(latLng, nowTime) {

      var params = {
        latitude: latLng.lat,
        longitude: latLng.lng
      };

      // if nowTime isn't included in request, don't add time-of-simulation
      if (angular.isDefined(nowTime)) {
        params['time-of-simulation'] = (angular.isDate(nowTime) ? nowTime.getTime() : nowTime);
      }

      var req = {
        method: 'GET',
        url: API_URL + 'location/master',
        headers: { 'Content-Type': 'application/json' },
        params: params
      }

      return $http(req).then(xhrComplete, function(error) {
        if (error.status === 404) {
          return $q.resolve();
        }
        return $q.reject(error);
      });
    }

    /**
       * send request to nowcoast to retrieve any service specified
       * NOTE: this service is disabled and needs work/testing before enabling
       * @param  object latLng {lat, lng}
       * @return $http promise
       */

    // function nowCOASTIdentify(latLng, service) {
    //
    //   var url = API_URL.slice(0, -4) + 'arcgis/rest/services/nowcoast/' + service.id + '/MapServer/identify?';
    //   var geometry = latLng.lng + ',' + latLng.lat;
    //   var degreeExtent = .5;
    //   var mapExtent = (latLng.lng - degreeExtent) + ',' + (latLng.lat - degreeExtent) + ',' + (latLng.lng + degreeExtent) + ',' + (latLng.lat + degreeExtent);
    //
    //   var req = {
    //     method: 'JSONP',
    //     url: url,
    //     params: {
    //       callback: 'JSON_CALLBACK',
    //       f: 'pjson',
    //       tolerance: 8,
    //       returnGeometry: false,
    //       imageDisplay: '100,50,96',
    //       geometry: geometry,
    //       geometryType: 'esriGeometryPoint',
    //       sr: 4326,
    //       mapExtent: mapExtent,
    //       layers: service.layers,
    //       time: Date.now() + ',' + Date.now()
    //     }
    //   }
    //   return $http(req).then(xhrComplete, xhrFailed);
    // }

    function xhrComplete(response) {
      return $q.resolve(response.data);
    }
  }
})();

(function() {
    'use strict';
    angular
        .module('fews')
        .factory('leafletFactory', leafletFactory);

    /*@ngInject*/
    function leafletFactory($log) {
        var service = {
            disableInteraction: disableInteraction
        };
        return service;
        ////////////////
        function disableInteraction(el) {
            if(el) {
                if (!L.Browser.touch) {
                    L.DomEvent.disableClickPropagation(el);
                    L.DomEvent.on(el, 'mousewheel', L.DomEvent.stopPropagation);
                } else {
                    L.DomEvent.on(el, 'click', L.DomEvent.stopPropagation);
                }
            } else {
                $log.error('leafletFactory.disableInteraction: missing element');
            }
        }
    }
})();
(function() {
  'use strict';

  angular
    .module('fews')
    .factory('jurisdictionFactory', jurisdictionFactory);

  /*@ngInject*/
  function jurisdictionFactory($http, $q, $log, API_URL) {
    var factory = {
      jurisdictions: [],
      defaultJurisdictions: [],
      getJurisdiction: getJurisdiction,
      getJurisdictionOptions: getJurisdictionOptions,
      setJurisdiction: setJurisdiction,
      setDefaultJurisdictions: setDefaultJurisdictions,
      getDefaultJurisdictions: getDefaultJurisdictions,
      toggleDefaultJurisdictions: toggleDefaultJurisdictions
    };

    return factory;

      function getJurisdiction() {
        return this.jurisdictions;
      }

      function setJurisdiction(jurisdiction) {
        this.jurisdictions = jurisdiction;
      }

      function setDefaultJurisdictions(jurisdictions) {
        this.defaultJurisdictions = jurisdictions;
      }

      function getDefaultJurisdictions() {
        return this.defaultJurisdictions;
      }

      function toggleDefaultJurisdictions() {
        this.jurisdictions = this.defaultJurisdictions
      }

      function getJurisdictionOptions() {
        var req = {
          method: 'GET',
          url: API_URL + 'atx-lowwater-crossings/jurisdictions'
        }

        return $http(req).then(xhrComplete, xhrFailed);
      }

      function xhrComplete(response) {
        return $q.resolve(response.data);
      }

      function xhrFailed(error) {
        $log.error(error);
        return $q.reject(error);
      }

    }
})();

(function() {
  'use strict';

  angular
    .module('fews')
    .factory('gaugeFactory', gaugeFactory);

  function gaugeFactory ($http, $q, $log, API_URL, VDS_URL) {

    var data = { GaugeOrder: '' };
    var factory = {
      getStatus: getStatus,
      getDetails: getDetails,
      getDetailsInactive: true,
      getGauge: getGauge,
      getGaugeMarkers: getGaugeMarkers,
      getGaugeOrder: getGaugeOrder,
      setGaugeOrder: setGaugeOrder,
      getGaugeByTime: getGaugeByTime,
      baseUrl: API_URL + VDS_URL
    };

    return factory;

    //////////////////////

    function getStatus () {
      return $http.get(factory.baseUrl + 'gaugestatus/overview')
        .then(xhrComplete, xhrFailed);
    }

    function getDetails () {
      // return out if already making call
      if (factory.getDetailsInactive === false) return $q.reject();

      factory.getDetailsInactive = false;

      var req = {
        method: 'GET',
        url: factory.baseUrl + 'gaugestatus/details',
        headers: {
            'Content-Type': 'application/json'
        },
        params: { allDurations: true }
      };

      return $http(req)
          .then(function(response) {
            response.data.forEach(function(gauge){
              gauge.sums.forEach(function(sum){
                if (sum.sum === null) {
                  sum.sum = -1;
                }
              })
            });

            factory.getDetailsInactive = true;
            return $q.resolve(response);
          }, xhrFailed);
    }

    function getGaugeMarkers() {
      var req = {
        method: 'GET',
        url: factory.baseUrl + 'gauges/location/markers',
        headers: {
          'Content-Type': 'application/json'
        },
        cache: true
      }

      return $http(req).then(xhrComplete, xhrFailed);
    }

    function getGaugeByTime (startTime, endTime) {
      var req = {
        method: 'GET',
        url: factory.baseUrl + 'rainvieux/gaugedata/range/'+ startTime +'/'+ endTime +'/data',
        headers: {
          'Content-Type': 'application/json'
        },
        cache: true
      }

      return $http(req).then(xhrComplete, xhrFailed);

    }

    function getGauge (gaugeId) {
        return $http.get(factory.baseUrl + 'gaugestatus/details/' + gaugeId)
            .then(function(response) {
                return xhrComplete(response);
            }, xhrFailed);
    }

    function getGaugeOrder () {
        return data.GaugeOrder;
    }

    function setGaugeOrder (gaugeOrder) {
        data.GaugeOrder = gaugeOrder;
    }

    function xhrComplete(response) {
        return $q.resolve(response);
    }

    function xhrFailed(error) {
        $log.error(error);
        return $q.reject(error);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('fews')
    .factory('debounce', debounce);

  /*@ngInject*/
  function debounce($timeout, $q) {
    // The service is actually this function, which we call with the func
    // that should be debounced and how long to wait in between calls
    return function debounce(func, wait, immediate) {
      var timeout;
      // Create a deferred object that will be resolved when we need to
      // actually call the func
      var deferred = $q.defer();
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if(!immediate) {
            deferred.resolve(func.apply(context, args));
            deferred = $q.defer();
          }
        };
        var callNow = immediate && !timeout;
        if ( timeout ) {
          $timeout.cancel(timeout);
        }
        timeout = $timeout(later, wait);
        if (callNow) {
          deferred.resolve(func.apply(context,args));
          deferred = $q.defer();
        }
        return deferred.promise;
      };
    };
  }
})();

(function() {
  'use strict';

  angular.module('fews').factory('basinGeo', basinGeo);

  function basinGeo($http, $q, $log, API_URL) {

    var factory = {
      baseUrl: API_URL,
      getGeo: getGeo,
      getList: getList,
      getClippedGeo: getClippedGeo,
      layerMap: layerMap
    };

    return factory;

    //////////////////////

    function getGeo(basinid) {
      var req = {
        method: 'GET',
        url: factory.baseUrl + 'layers/' + basinid + '/outline.json',
        headers: {'Content-Type':'application/json'},
        cache: true
      }

      return $http(req).then(xhrComplete, xhrFailed);
    }

    function getList() {
      function comparator(a, b) {
        a = a.description.split(' ')[0].toUpperCase();
        b = b.description.split(' ')[0].toUpperCase();
        if (a < b) {
          return -1;
        }
        if (a > b) {
          return 1;
        }
        return 0;
      }

      var req = {
        method: 'GET',
        url: factory.baseUrl + 'project/details',
        headers: {'Content-Type':'application/json'},
        cache: true
      }
      var deferred = $q.defer();

      $http(req).then(function(d){
        var basins = d.data.basins;
        var lists = [];
        for (var basin in basins) {
          if (basins.hasOwnProperty(basin)) {
            basins[basin].affiliations.forEach(function(b){
              if (!lists[b]) {
                lists[b] = [];
              }
              lists[b].push({id: basins[basin].id, description: basins[basin].description});
            });
          }
        }

        var arrays = Object.keys(lists).map(function(key) {
          var sorted = lists[key].sort(comparator);
          sorted.unshift({id: 'h2', description: key});
          return sorted;
        });

        // lists = [].concat.apply([], arrays);
        return deferred.resolve(arrays);
      });

      return deferred.promise;
    }

    function getClippedGeo(basinid) {
      var polygon = [];
      var worldLatlngs = [
        [90, 180],
        [90, -180],
        [-90, -180],
        [-90, 180]
      ];
      polygon.push(worldLatlngs);

      var deferred = $q.defer();
      factory.getGeo(basinid).then(function(d) {
        d.data.features[0].geometry.coordinates[0].forEach(function(d) {
          return d.reverse();
        });
        polygon.push(d.data.features[0].geometry.coordinates[0]);
        deferred.resolve(polygon);
      });

      return deferred.promise;
    }

    function layerMap() {

      var req = {
        method: 'GET',
        url: API_URL + '/layers/masterAffialiationLayerMap',
        headers: {'Content-Type':'application/json'},
        cache: true
      }

      return $http(req).then(xhrComplete, xhrFailed);
    }

    function xhrComplete(response) {
      return $q.resolve(response);
    }

    function xhrFailed(error) {
      $log.error(error);
      return $q.reject(error);
    }
  }
})();

(function() {
    'use strict';
    angular
        .module('fews')
        .factory('aniFactory', aniFactory);

    /*@ngInject*/
    function aniFactory($q, $log) {

        var timeline = {
            frames: [],
            currentTime: 0,
            currentFrame: 0
        },
        service = {
            setTimeline: setTimeline,
            getTimeline: getTimeline
        };
        return service;
        ////////////////

        function setTimeline (hoursAgo, hoursAhead) {
            var frames = [],
                NowTime = new Date(),
                intervalLengthMinutes = 5,
                pastIntervals = 12 * hoursAgo,
                futureIntervals = 12 * hoursAhead,
                intervalMillis = intervalLengthMinutes * (1000 * 60),
                tempTime;

            NowTime.setMinutes(NowTime.getMinutes() - (NowTime.getMinutes() % 5));
            NowTime.setSeconds(0,0);

            tempTime = angular.copy(NowTime);
            for (var i = 0; i <= pastIntervals; i++) {
                frames.unshift(tempTime.getTime());
                tempTime.setTime(tempTime.getTime() - intervalMillis);
            }

            tempTime = angular.copy(NowTime);
            for (var j = 0; j < futureIntervals; j++) {
                tempTime.setTime(tempTime.getTime() + intervalMillis);
                frames.push(tempTime.getTime());
            }

            timeline = {
                frames: frames,
                currentFrame: frames.indexOf(NowTime.getTime()),
                nowTime: NowTime.getTime()
            };

            return $q.resolve(timeline);
        }

        function getTimeline () {
            if (timeline.frames.length > 0)
                return $q.resolve(timeline);
            else {
                $log.error(timeline);
                return $q.reject('setTimeline first');
            }
        }
    }
})();
(function() {
  'use strict';
  angular
    .module('fews')
    .factory('alertStatusFactory', alertStatusFactory);

  /*@ngInject*/
  function alertStatusFactory($http, $log, $q, $auth, API_URL) {
    var service = {
      acknowledge: acknowledge,
      getThreshStatus: getThreshStatus,
      getIcon: getIcon,
      getMessage: getMessage
    };

    return service;
    ////////////////

    function acknowledge(alert, options) {
      if (angular.isUndefined(options)) options = {};

      var data = {
        entryID: alert.entryID,
        serviceRequestID: alert.service_request_id,
        user: options.user || $auth.getPayload().sub,
        status: options.status || 'ACKNOWLEDGED',
        comments: options.comments
      };
      var endpoint = alert.service_request_id ? '311/' : 'alerts/';
      var req = {
        method: 'POST',
        url: API_URL + endpoint + 'status/save',
        headers: { 'Content-Type': 'application/json' },
        data: angular.toJson([data])
      };

      return $http(req)
        .then(function(response) {
          if (response.data === 'Status has been saved.') {
            response.data = [{
              time: Date.now(),
              opResult: 'SUCCESS'
            }];
          }

          angular.extend(response.data[0], data);

          return xhrComplete(response);
        }, xhrFailed);
    }

    function getThreshStatus (alert) {
      var status;
        if (angular.isDefined(alert) && angular.isDefined(alert.dataType)) {
          if (alert.dataType.indexOf('SIMULATED') >=0 && alert.aboveThresh == true) {
            status = 'forecast_up';
          } else if (alert.dataType.indexOf('SIMULATED') >= 0 && alert.aboveThresh == false) {
            status = 'forecast_down';
          } else if (alert.aboveThresh == false) {
            status = 'down';
          } else {
            status = 'up';
          }
        } else {
          status = null;
        }
      return status;
    }

    function getIcon(alert) {
      var icon;
        if (angular.isDefined(alert) && angular.isDefined(alert.dataType)) {
          if (alert.dataType.indexOf('SIMULATED') >= 0 && alert.aboveThresh == true) {
            icon = null;
          } else if (alert.dataType.indexOf('SIMULATED') >= 0 && alert.aboveThresh == false ) {
            icon = null;
          } else if (alert.aboveThresh == false) {
            icon = 'trending_down';
          } else {
            icon = 'trending_up';
          }
        }
      return icon;
    }

    function getMessage(alert) {
      var message;
        if (angular.isDefined(alert) && angular.isDefined(alert.dataType)) {
          if (alert.dataType.indexOf('SIMULATED') >= 0 && alert.aboveThresh == true) {
            message = "Forecast Trending Up";
          } else if (alert.dataType.indexOf('SIMULATED') >= 0 && alert.aboveThresh == false) {
            message = "Forecast Trending Down";
          } else if (alert.aboveThresh == false) {
            message = "Observed Trending Down";
          } else {
            message = "Observed Trending Up";
          }
        } else {
          message = null;
        }

      return message;
    }

    function xhrComplete(response) {
        return $q.resolve(response.data);
    }

    function xhrFailed(error) {
        $log.error(error);
        return $q.reject(error);
    }
  }
})();

(function() {
    'use strict';
    angular
        .module('fews')
        .factory('alertFeedFactory', alertFeedFactory);

    /*@ngInject*/
    function alertFeedFactory($http, $q, $log, API_URL) {
      var service = {
          lastChecked: null,
          alerts: [],
          retreive: retreive,
          formatMarkers: formatMarkers
      };

      return service;
      ////////////////

      function retreive(params) {
        // for testing purposes during dry times
        // params.start -= (60000 * 60 * 24 * 14);
        // if (params.end) {
        //     params.end -= (60000 * 60 * 24 * 14);
        // }
        var req = {
          method: 'GET',
          url: API_URL + 'alerts/timeline',
          headers: {'Content-Type':'application/json'},
          params: params || {}
        };

        return $http(req).then(function(response){
          var tl = response.data.timeline;
          for (var i = 0; i < tl.length; i++) {
            tl[i].ackStatus = tl[i].status || [];
            tl[i].isAck = (tl[i].ackStatus.length > 0) &&
                          (tl[i].ackStatus[tl[i].ackStatus.length - 1].status === 'ACKNOWLEDGED');
          }
          service.lastChecked = response.data.lastTimeChecked;
          return $q.resolve(response.data)
        }, xhrFailed);
      }

      function formatMarkers(alerts, time) {
        var markers = [];
        var overlay = {
          name: 'Alerts (' + alerts.length + ')',
          type: 'markercluster',
          visible: true,
          layerParams: {
            showOnSelector: false,
            zIndex: 5
          },
          layerOptions: {
            maxClusterRadius: 50,
            time: new Date(time).getTime(),
            type: 'alerts'
          }
        }

        return $q.resolve({
          markers: markers,
          overlay: overlay
        });
      }

      function xhrFailed(error) {
        $log.error(error);
        return $q.reject(error);
      }
    }
})();


(function() {
    'use strict';

    angular
        .module('fews')
        .filter('truncateNum', truncateNum);

    function truncateNum() {
        return function(input) {
            return Math.trunc(input);
        };
    }

})();

(function(){
  'use strict';

  angular.module('fews')
    .filter('readable', readable);

  function readable() {
    return function(statusString) {
      if (!statusString) {
        return;
      }
      return statusString.replace(/([A-Z])/g, ' $1').replace(/^./, function(str) {
        return str.toUpperCase();
      }).trim();
    }
  }

})();

(function(){
  'use strict';

  angular.module('fews')
    .filter('orderByObject', orderByObject);

    function orderByObject() {
      return function(items, field, reverse) {
        var filtered = [];
        angular.forEach(items, function(item) {
          filtered.push(item);
        });
        filtered.sort(function(a, b) {
          return (a[field] > b[field] ? 1 : -1);
        });
        if (reverse) {
          filtered.reverse();
        }
        return filtered;
      };
    }

})();


(function() {
    'use strict';

    angular
        .module('fews')
        .filter('obj2Array', obj2Array);

    function obj2Array () {
        return function(input) {
            var out = [];
            for(var i in input){
                out.push(input[i]);
            }
            return out;
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('fews')
        .filter('nospace', nospace)
        .filter('humanizeDoc', humanizeDoc)
        .filter('directiveBrackets', directiveBrackets)
        .filter('isEmpty', isEmpty)
        .filter('noDecimal', noDecimal)
        .filter('testFilename', testFilename)
        .filter('inArray', inArray);

    function noDecimal () {
      return function(number) {
        return parseInt(number);
      }
    }

    function testFilename() {
      return function(string) {
        var regex = /[^.]*/;
        var found = string.match(regex);
        return found[0];
      }
    }

    function nospace () {
        return function (value) {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    function humanizeDoc() {
        return function(doc) {
            if (!doc) return;
            if (doc.type === 'directive') {
                return doc.name.replace(/([A-Z])/g, function($1) {
                    return '-'+$1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

    function directiveBrackets() {
        return function(str) {
            if (str.indexOf('-') > -1) {
                return '<' + str + '>';
            }
            return str;
        };
    }

    function isEmpty() {
        return function (obj) {
            for (var bar in obj) {
                if (obj.hasOwnProperty(bar)) {
                    return false;
                }
            }
            return true;
        };
    }

    function inArray($filter){
        return function(list, arrayFilter, element){
            if(arrayFilter){
                return $filter("filter")(list, function(listItem){
                    return arrayFilter.indexOf(listItem[element]) !== -1;
                });
            }
        };
    }

})();

(function() {
  'use strict';

  angular
    .module('fews')
    .directive('errSrc', errSrc);

  function errSrc() {
    return {
      link: function(scope, element, attrs) {
        element.bind('error', function() {
          if (attrs.src != attrs.errSrc) {
            attrs.$set('src', attrs.errSrc);
          }
        });
      }
    }
  }

})();

(function() {
    'use strict';

    angular
        .module('fews')
        .directive('menuToggle', menuToggle);

    /*@ngInject*/
    function menuToggle ($document, $timeout, $mdUtil) {
        return {
            scope: {
                section: '='
            },
            templateUrl: 'app/main/menu/menu-toggle.tmpl.html',
            link: function($scope, $element) {
                var controller = $element.parent().controller();

                $scope.isOpen = function() {
                    return controller.isOpen($scope.section);
                };
                $scope.toggle = function() {
                    controller.toggleOpen($scope.section);
                };

                $mdUtil.nextTick(function() {
                    $scope.$watch(
                        function () {
                            return controller.isOpen($scope.section);
                        },
                        function (open) {
                            // We must run this in a next tick so that the getTargetHeight function is correct
                            $mdUtil.nextTick(function() {
                                var $ul = $element.find('ul');
                                var $li = $ul[0].querySelector('a.active');
                                var docsMenuContent = $document[0].querySelector('.docs-menu').parentNode;
                                var targetHeight = open ? getTargetHeight() : 0;

                                $timeout(function () {
                                    // Set the height of the list
                                    $ul.css({height: targetHeight + 'px'});

                                    // If we are open and the user has not scrolled the content div; scroll the active
                                    // list item into view.
                                    if (open && $li && $ul[0].scrollTop === 0) {
                                        $timeout(function() {
                                            var activeHeight = $li.scrollHeight;
                                            var activeOffset = $li.offsetTop;
                                            var parentOffset = $li.offsetParent.offsetTop;

                                            // Reduce it a bit (2 list items' height worth) so it doesn't touch the nav
                                            var negativeOffset = activeHeight * 2;
                                            var newScrollTop = activeOffset + parentOffset - negativeOffset;

                                            $mdUtil.animateScrollTo(docsMenuContent, newScrollTop);
                                        }, 350, false);
                                    }
                                }, 0, false);

                                function getTargetHeight() {
                                    var targetHeight;
                                    $ul.addClass('no-transition');
                                    $ul.css('height', '');
                                    targetHeight = $ul.prop('clientHeight');
                                    $ul.css('height', 0);
                                    $ul.removeClass('no-transition');
                                    return targetHeight;
                                }
                            }, false);
                        }
                    );
                });

                var parentNode = $element[0].parentNode.parentNode.parentNode;
                if(parentNode.classList.contains('parent-list-item')) {
                    var heading = parentNode.querySelector('h2');
                    $element[0].firstChild.setAttribute('aria-describedby', heading.id);
                }
            }
        };
    }
})();
(function () {
  'use strict';

  angular
    .module('fews')
    .component('menuLink', {
      bindings: {
        section: '=',
        permissions: '<'
      },
      controller: MenuLinkController,
      controllerAs: 'linkVm',
      templateUrl: 'app/main/menu/menu-link.tmpl.html'
    });

  /*@ngInject*/
  function MenuLinkController($scope, $element) {
    var vm = this;
    var controller = $element.parent().controller();

    vm.isDisabled = isDisabled;

    vm.isSelected = function () {
      return controller.isSelected(vm.section);
    };

    function isDisabled(state) {
      switch (state){
        case 'fews.rules':
          return !vm.permissions.rules.view;
        case 'fews.alerts':
          return !vm.permissions.notifications.view;
        case 'fews.gauges':       
          return !vm.permissions.rain_gauges;
        case 'fews.ddf':        
          return !vm.permissions.ddf;
        case 'fews.aar':        
          return !vm.permissions.aar.view;
        case 'fews.watchpoints':        
          return !vm.permissions.watchpoints;
        default:
          return false;
      }
    }

    vm.focusSection = function () {
      // set flag to be used later when
      // $locationChangeSuccess calls openPage()
      controller.autoFocusContent = true;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('fews')
    .factory('menuFactory', menuFactory);

  /*@ngInject*/
  function menuFactory($location, $rootScope) {
    var sections = [
      {
        name: 'Dashboard',
        state: 'fews.dashboard',
        url: '/dashboard',
        type: 'link',
        icon: 'dashboard'
      },
      {
        name: 'Rules Manager',
        state: 'fews.rules',
        url: '/rules',
        type: 'link',
        icon: 'playlist_add'
      },
      {
        name: 'Notifications',
        state: 'fews.alerts',
        url: '/alerts',
        type: 'link',
        icon: 'notifications'
      },
      {
        name: 'Rain Gauges',
        state: 'fews.gauges',
        url: '/gauges',
        type: 'link',
        icon: 'local_drink'
      },
      {
        name: 'DDF',
        state: 'fews.ddf',
        url: '/ddf',
        type: 'link',
        icon: 'format_align_left'
      },
      {
        name: 'After Action Reports',
        state: 'fews.aar',
        url: '/after-action-reports',
        type: 'link',
        icon: 'description'
      },
      {
        name: 'Watchpoints',
        state: 'fews.watchpoints',
        url: '/watchpoints',
        type: 'link',
        icon: 'place'
      },
      {
        name: 'Groups & Users',
        state: 'fews.usermanager',
        url: '/user-manager',
        type: 'link',
        icon: 'group'
      }
    ];

    var deregistrationCallback = $rootScope.$on('$viewContentLoading', onLocationChange);
    $rootScope.$on('$destroy', deregistrationCallback);

    var self = {
      sections: sections,

      selectSection: function (section) {
        self.openedSection = section;
      },
      toggleSelectSection: function (section) {
        self.openedSection = (self.openedSection === section ? null : section);
      },
      isSectionSelected: function (section) {
        return self.openedSection === section;
      },
      selectPage: function (section, page) {
        self.currentSection = section;
        self.currentPage = page;
      },
      isPageSelected: function (page) {
        return self.currentPage === page;
      }
    };

    return self;

    function onLocationChange() {
      var path = $location.path();

      var matchPage = function (section, page) {
        if (path.indexOf(page.url) !== -1) {
          self.selectSection(section);
          self.selectPage(section, page);
        }
      };

      sections.forEach(function (section) {
        if (section.children) {
          // matches nested section toggles, such as API or Customization
          section.children.forEach(function (childSection) {
            if (childSection.pages) {
              childSection.pages.forEach(function (page) {
                matchPage(childSection, page);
              });
            }
          });
        } else if (section.pages) {
          // matches top-level section toggles, such as Demos
          section.pages.forEach(function (page) {
            matchPage(section, page);
          });
        } else if (section.type === 'link') {
          // matches top-level links, such as "Getting Started"
          matchPage(section, section);
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('fews').component('appMenu', {
    controller: appMenuController,
    controllerAs: 'appMenuVm',
    templateUrl: 'app/main/app-menu/app-menu.tmpl.html'
  });

  /*@ngInject*/
  function appMenuController($mdDialog, $mdMedia, $document, $auth,
      resourcesFactory, API_URL) {
    var appMenuVm = this;

    angular.extend(appMenuVm, {
      openResources: openResources,
      name: $auth.getPayload().name,
      API_URL: API_URL
    });

    function openResources(event) {
      $mdDialog.show({
        controller: 'ResourcesController',
        controllerAs: 'vm',
        templateUrl: 'app/main/app-menu/resources/resources.tmpl.html',
        parent: angular.element($document[0].body),
        targetEvent: event,
        clickOutsideToClose: true,
        escapeToClose: true,
        fullscreen: $mdMedia('xs'),
        locals: {
          list: resourcesFactory.getResources().then(function(d) {
            var result = [];

            for (var variable in d) {
              if (d.hasOwnProperty(variable)) {
                result = result.concat(d[variable]);
              }
            }

            return result;
          })
        }
      });
    }

  }

})();

(function() {
  'use strict';
  angular.module('watchpoints', [
    'ngAria',
    'ngMaterial',
    'angularMoment'
  ]);
})();

(function() {
  'use strict';

  var component = {
    controller: watchpointsController,
    controllerAs: 'wc',
    templateUrl: 'app/components/watchpoints/watchpoints.tmpl.html'
  };

  angular.module('watchpoints')
    .component('watchpointsPage', component);

  /*@ngInject*/
  function watchpointsController( $q, $interval, $log, $mdSidenav, $mdMedia,
      $auth, wpFactory, projectInfo) {
    var vm = this,
      checkInterval,
      checkTime = 300000;

    angular.extend(vm, {
      $onInit: activate,
      $mdMedia: $mdMedia,
      init: false,
      wpsByBasin: [],
      wps: [],
      query: '',
      openDetails: openDetails,
      closeDetails: closeDetails,
      cacheBust: cacheBust,
      selected: undefined,
      basins: undefined,
      selectedLoading: true,
      showInteractive: false,
      accesstoken: $auth.getToken(),
      thumbsUrl: wpFactory.thumbsUrl({width:240, height:135})
    });

    // activate
    function activate() {
      var nowTime = Date.now();
      var timeParams = {
        static: {
          start: nowTime - (1000 * 60 * 60 * 6),
          fakeNow: nowTime,
          end: nowTime + (1000 * 60 * 60 * 14)
        }
      };

      $q.all([
        wpFactory.retrieve(),
        wpFactory.statusUpdate(true, timeParams),
        projectInfo.getDetails()
      ]).then(wpLoad, wpFail);
    }

    // wp successful load create basins data structure
    function wpLoad(data) {
      var status = data[1].status;
      var reverseKeyValue = reverseKeyValues(data[1].typePriority);
      var watchpoints = data[0].watchPoints;
      vm.basins = data[2].basins;

      vm.wps = updateStatuses(watchpoints, status, reverseKeyValue);

      vm.wpsByBasins = vm.wps.reduce(function(basins, value) {
        var basinId = value.basin;
        if (basinId in basins) {
          basins[basinId].wps.push(value);
          basins[basinId].wps.sort(sortWPByStream);
          basins[basinId].streamOrder = vm.basins[basinId].streamOrder;
        } else {
          basins[basinId] = {
            wps: [value],
            streamOrder: vm.basins[basinId].streamOrder,
            name: vm.basins[basinId].description
          };
        }
        return basins;
      }, {});

      vm.init = true;
      updateCheck();
    }

    // wp failure
    function wpFail(error) {
      vm.error = error;
      vm.init = true;
    }

    // update statuses
    function updateStatuses(watchpointsArray, statusArray, statusKeyMap) {
      return watchpointsArray.map(function(wp) {
        wp.sortStatus = statusKeyMap[statusArray[wp.id].status];
        wp.status = statusArray[wp.id].status;
        wp.maximums = Object.keys(statusArray[wp.id].maximums).map(function(key) {
          return statusArray[wp.id].maximums[key];
        });
        return wp;
      });
    }

    // update check
    function updateCheck() {
      if (angular.isDefined(checkInterval)) {
        $interval.cancel(checkInterval);
        checkInterval = undefined;
        return;
      }

      var nowTime = Date.now();
      var timeParams = {
        static: {
          start: nowTime - (1000 * 60 * 60 * 6),
          fakeNow: nowTime,
          end: nowTime + (1000 * 60 * 60 * 14)
        }
      };

      checkInterval = $interval(function() {
        wpFactory.statusUpdate(true, timeParams).then(function(statusData) {
          var status = statusData.status;
          var reverseKeyValue = reverseKeyValues(statusData.typePriority);
          vm.wps = updateStatuses(vm.wps, status, reverseKeyValue);
        });
      }, checkTime);
    }

    // open detail
    function openDetails(watchpoint) {
      vm.selectedloading = true;
      var time = Date.now();
      var timeParams = {
        ani: {
          start: time - (1000 * 60 * 60 * 6),
          fakeNowStart: time - (1000 * 60 * 60 * 2),
          fakeNowEnd: time,
          end: time + (1000 * 60 * 60 * 14)
        },
        static: {
          start: time - (1000 * 60 * 60 * 6),
          fakeNow: time,
          end: time + (1000 * 60 * 60 * 14)
        }
      };
      vm.selected = watchpoint;
      vm.selected.endpoint = wpFactory.imageUrl(watchpoint, timeParams);
      $mdSidenav('wpDetails').open().then(switchChart);
    }

    // close detail
    function closeDetails() {
      $mdSidenav('wpDetails').close().then(function(){
        vm.chart = undefined;
      });
    }

    function reverseKeyValues(object) {
      var reversed = {};
      for (var key in object) {
        if (object.hasOwnProperty(key)) {
          reversed[object[key]] = +key;
        }
      }
      return reversed;
    }

    function sortWPByStream(a, b) {
      if (a.streamOrderWithinBasin < b.streamOrderWithinBasin) {
        return -1;
      } else if (a.streamOrderWithinBasin > b.streamOrderWithinBasin) {
        return 1;
      } else {
        return 0;
      }
    }

    function cacheBust() {
      return Date.now();
    }

    function switchChart() {
      wpFactory.rawData(vm.selected.id).then(function(raw) {
        var config = wpFactory.chartConfig('#c3Hydro');
        var chartRegions = createChartRegionConfig();
        angular.merge(config, {
          data: raw.data,
          axis: {
            y: {
              label: 'Stage (ft)',
              min: raw.axis.y.min,
              max: raw.axis.y.max
            }
          },
          grid: {
            x: {
              lines: [
                {
                  value: new Date(),
                  text: 'Now: ' + new moment().format('HH:mm')
                }
              ]
            },
            y: raw.grid ? { lines: raw.grid.y.lines.map(function(l) {
              l.class = 'rule';
              return l;
            }) } : {}
          },
          regions: chartRegions,
          zoom: { enabled: true }
        });

        vm.chart = c3.generate(config);
        vm.selectedloading = false;
      });
    }

    function createChartRegionConfig () {
      //Form chart's watch and warning region display config
      var chartRegions = [];
      if (vm != null && vm.selected != null) {
        var watchLevel = vm.selected.stageWatchLevel;
        var warningLevel = vm.selected.stageWarningLevel;
        if (watchLevel != null) {
          //Add watch region
          if (warningLevel != null) {
            chartRegions.push({
              axis: 'y',
              start: watchLevel,
              end: warningLevel,
              class: 'wp-watch'
            });
          } else {
            chartRegions.push({
              axis: 'y',
              start: watchLevel,
              class: 'wp-watch'
            });
          }
        }
        if (warningLevel != null) {
          //Add warning region
          chartRegions.push({
            axis: 'y',
            start: warningLevel,
            class: 'wp-warn'
          });
        }
      }
      return chartRegions;
    }

  }

})();

(function() {
  'use strict';

  var component = {
    controller: singleWatchpoint,
    controllerAs: 'swp',
    templateUrl: 'app/components/watchpoints/swp.tmpl.html',
    bindings: {
      point: '<'
    }
  };

  angular.module('watchpoints')
    .component('singleWatchpoint', component);

  /*@ngInject*/
  function singleWatchpoint($window, $auth, wpFactory) {
    var vm = this;
    angular.extend(vm, {
      $onInit: activate,
      cacheBust: Date.now(),
      endpoint: undefined,
      imageWidth: $window.innerWidth - 30,
      accesstoken: $auth.getToken()
    });

    function activate() {
      var time = vm.cacheBust;
      var timeParams = {
        ani: {
          start: time - (1000 * 60 * 60 * 6),
          fakeNowStart: time - (1000 * 60 * 60 * 2),
          fakeNowEnd: time,
          end: time + (1000 * 60 * 60 * 14)
        },
        static: {
          start: time - (1000 * 60 * 60 * 6),
          fakeNow: time,
          end: time + (1000 * 60 * 60 * 14)
        }
      };
      vm.endpoint = wpFactory.imageUrl(vm.point, timeParams);
    }
  }

})();

(function() {
    'use strict';
  
    angular.module('fews')
      .factory('userManagerFactory', userManagerFactory);
  
    function userManagerFactory($rootScope, $http, $q, $mdDialog, API_URL) {
      var factory = {
        getGroups: getGroups,
        alertDialog: alertDialog,
        getNewGroup: getNewGroup,
        addGroup: addGroup,
        deleteGroup: deleteGroup,
        updateGroup: updateGroup,
        getNewMember: getNewMember,
        addMember: addMember,
        updateMember: updateMember,
        deleteMember: deleteMember,
        getPermissionsList: getPermissionsList,
        getConfirmDialog: getConfirmDialog,
        roleCount: roleCount
      };
  
      return factory;
  
      //////////////////////

      function getGroups() {
        var req = {
          method: 'GET',
          url: API_URL + 'user-management/get-groups'
        };
        
        return $http(req);
      }

      function alertDialog(msg, ev) {
        $mdDialog.show(
          $mdDialog.alert()
            .clickOutsideToClose(true)
            .title('There was an error')
            .targetEvent(ev)
            .textContent(msg || 'There was an error')
            .ariaLabel('Alert Dialog')
            .ok('Got it!')
        );
      }

      function addGroup(group) {
        delete group.members;
        
        var req = {
          method: 'POST',
          url: API_URL + 'user-management/create-group',
          data: group
        };

        return $http(req).then(
          function(res) {
            group.groupId = res.data;
            group.members = [];
            var data = {
              type: 'group:added',
              group: group
            };
            notify(data);
            return $q.resolve(data);
          }, function(error) {
            return $q.reject(error);
          }
        );
      }

      function deleteGroup(id, ev) {
        var req = {
          method: 'DELETE',
          url: API_URL + 'user-management/delete-group/' + id
        };

        return $http(req).then(
          function() {
            var data = {
              event: ev,
              type: 'group:deleted',
              id: id
            };

            notify(data);
            return $q.resolve(data);
          }, function(error) {
            return $q.reject(error);
          }
        );
      }

      function updateGroup(group) {
        // weird stuff about modify service
        var reqGroup = angular.copy(group);
        delete reqGroup.members; // service doesn't like this.
        
        var req = {
          method: 'POST',
          url: API_URL + 'user-management/modify-group',
          data: reqGroup
        };

        return $http(req).then(
          function() {
            var data = {
              type: 'group:updated',
              group: group
            };
            notify(data);
            return $q.resolve(data);
          }, function(error) {
            return $q.reject(error);
          }
        );
      }

      function addMember(member) {
        var req = {
          method: 'POST',
          url: API_URL + 'user-management/create-user',
          data: member
        };

        return $http(req).then(
          function(res) {
            member.memberId = res.data;
            var data = {
              type: 'member:added',
              member: member
            };
            notify(data);
            return $q.resolve(data);
          }
        );
      }

      function updateMember(member) {
        // weird stuff about modify service
        var reqMember = angular.copy(member);
        delete reqMember.memberId; // service doesn't like this.

        var req = {
          method: 'POST',
          url: API_URL + 'user-management/modify-user',
          data: angular.extend({}, reqMember, {
            username: member.username || member.email
          })
        };

        return $http(req).then(
          function() {
            var data = {
              type: 'member:updated',
              member: member
            };
            notify(data);
            return $q.resolve(data);
          }
        );
      }

      function deleteMember(groupId, username) {
        var req = {
          method: 'DELETE',
          url: API_URL + 'user-management/delete-user/' + username
        };

        return $http(req).then(
          function() {
            var data = {
              type: 'member:deleted',
              groupId: groupId,
              username: username
            };

            notify(data);
            return $q.resolve(data);
          }, function(error) {
            return $q.reject(error);
          }
        );
      }

      function getPermissionsList() {
        var req = {
          method: 'GET',
          url: 'assets/permissions-list.json',
          cache: true
        };
        
        return $http(req);
      }      

      function getNewGroup() {
        var req = {
          method: 'GET',
          url: 'assets/new-group.tmpl.json',
          cache: true
        };
        
        return $http(req);
      }    

      function getNewMember() {
        var req = {
          method: 'GET',
          url: 'assets/new-member.tmpl.json',
          cache: true
        };
        
        return $http(req);
      }

      function getConfirmDialog(ev, params) {
        return $mdDialog.confirm()
          .title(params.title)
          .textContent(params.textContent)
          .ariaLabel('Confirmation Dialog')
          .targetEvent(ev)
          .ok('OK')
          .cancel('CANCEL');
      }

      function notify(data) {
        $rootScope.$broadcast('user-manager', data);
      }

      function roleCount(members, countAdmins) {
        if(angular.isUndefined(members)) return 0;
        
        return members
            .filter(function(member) {
              return countAdmins ? (member.role !== 'User') : (member.role === 'User');
            }).length;
      }
    }
})();

(function() {
    'use strict';

    var component = {
      controller: UserManagerController,
      controllerAs: 'umVm',
      templateUrl: 'app/components/user-manager/user-manager.tmpl.html'
    };

    angular.module('fews').component('userManager', component);

    /*@ngInject*/
    function UserManagerController($scope, $timeout, $mdMedia, $mdDialog,
        $mdToast, userFactory, userManagerFactory) {
      var umVm = this;

      angular.extend(umVm, {
        $onInit: activate,
        $mdMedia: $mdMedia,
        $mdDialog: $mdDialog,
        factory: userManagerFactory,
        model: { loading: true },
        selectGroup: selectGroup,
        groupListClass: groupListClass,
        addGroup: addGroup,
        groupFilter: groupFilter
      });

      ////////////////////////

      function activate() {
        userFactory.getMe().then(function(mRes) {
          umVm.me = mRes.data;
          umVm.factory.getGroups().then(function (gRes) {
            umVm.model.groups = gRes.data;
            umVm.model.loading = false;
            if (!$mdMedia('xs')) {
              selectGroup(
                umVm.model.groups.find(
                  function(el) {
                    return el.groupId === umVm.me.groupId;
                  }
                )
              );
            }
          }, function() {
            umVm.error = 'Please try again later.';
          });
        });
      }

      function groupFilter(el) {
        if(umVm.me.role === 'Proj_Admin') {
          if(umVm.me.groupId === '10') {
            return el.displayName !== 'Vieux Team';
          }
          return true;
        } else {
          return umVm.me.groupId === el.groupId;
        }
      }

      function selectGroup(group, ev) {
        delete umVm.model.selectedGroup;
        // timeout needed for digest
        $timeout(function(){
          umVm.model.selectedGroup = angular.copy(group);
          if ($mdMedia('xs') && ev) {
            groupDetailsDialog(ev);
          }
        });
      }

      function groupDetailsDialog(ev) {
        $mdDialog.show({
          templateUrl: 'app/components/user-manager/group-dialog-container.tmpl.html',
          targetEvent: ev,
          controller: DialogController,
          locals: {
            selectedGroup: umVm.model.selectedGroup
          },
          fullscreen: true
        }).then(function() {
          delete umVm.model.selectedGroup;
        });
        function DialogController($scope, $mdDialog, selectedGroup) {
          $scope.selectedGroup = selectedGroup;
          $scope.closeDialog = function() {
            $mdDialog.hide();
          };
        }
      }

      function groupListClass(group) {
        if (umVm.model.selectedGroup &&
           (umVm.model.selectedGroup.groupId === group.groupId)) {
          return 'selected';
        }
      }

      function addGroup(ev) {
        $mdDialog.show({
          controller: 'GroupDialogController',
          controllerAs: 'ngVm',
          templateUrl: 'app/components/user-manager/group-dialog/group-dialog.tmpl.html',
          targetEvent: ev,
          fullscreen: !$mdMedia('gt-xs')
        })
        .then(function(group) {
          umVm.addingGroup = group.displayName;
          umVm.factory.addGroup(group).then(function(data) {
            $mdToast.show($mdToast
              .simple()
              .textContent(group.displayName + ' Group Added')
            );
            delete umVm.addingGroup;
            umVm.model.groups.push(data.group);
            selectGroup(umVm.model.groups[umVm.model.groups.length - 1]);
          }, function() {
            delete umVm.addingGroup;
            $mdToast.show($mdToast.simple()
              .textContent('Error Adding Group ' + group.displayName)
              .toastClass('error')
            );
          });
        });
      }

      function deleteGroup(id, ev) {
        var index = umVm.model.groups.findIndex(function(element) {
          return id === element.groupId;
        });

        var newIndex = index > 0 ? index - 1 : index + 1;

        if(index !== -1) {
          umVm.model.groups.splice(index, 1);
          selectGroup(umVm.model.groups[newIndex]);
        } else {
          umVm.factory.alertDialog('Try refreshing the page and deleting your group again.', ev);
        }
      }

      function deleteMember(groupId, username) {
        var groupIndex = getGroupIndex(groupId);
        var memberIndex = umVm.model.groups[groupIndex].members
          .findIndex(function(element) {
            return username === element.username;
          });

        if(angular.isDefined(groupIndex) && memberIndex !== -1) {
          umVm.model.groups[groupIndex].members.splice(memberIndex, 1);
        } else {
          umVm.factory.alertDialog('Try refreshing the page.');
        }
      }

      function updateMember(member) {
        var groupIndex = getGroupIndex(member.groupId);
        var memberIndex = umVm.model.groups[groupIndex].members
          .findIndex(function(element) {
            return member.username === element.username;
          });

        if(angular.isDefined(groupIndex) && memberIndex !== -1) {
          umVm.model.groups[groupIndex].members[memberIndex] = angular.copy(member);
        } else {
          umVm.factory.alertDialog('Try refreshing the page.');
        }
      }

      function addMember(member) {
        var groupIndex = getGroupIndex(member.groupId);

        if(angular.isDefined(groupIndex)) {
          umVm.model.groups[groupIndex].members.push(member);
        } else {
          umVm.factory.alertDialog('Try refreshing the page.');
        }
      }

      function getGroupIndex(id) {
        var groupIndex;
        for (var i = 0; i < umVm.model.groups.length; i++) {
          var group = umVm.model.groups[i];
          if(group.groupId === id) {
            groupIndex = i;
            break;
          }
        }
        return groupIndex;
      }

      function updateGroup(data) {
        var index = umVm.model.groups.findIndex(function(group) {
          return group.groupId === data.groupId;
        });

        angular.merge(umVm.model.groups[index], data);
      }

      // listeners
      $scope.$on('user-manager', function(e, data) {
        switch (data.type){
          case 'group:deleted':
            deleteGroup(data.id, data.event);
            break;
          case 'group:updated':
            updateGroup(data.group);
            break;
          case 'member:deleted':
            deleteMember(data.groupId, data.username);
            break;
          case 'member:updated':
            updateMember(data.member);
            break;
          case 'member:added':
            addMember(data.member);
            break;
          default:
              // other events don't impact this component
        }
      });
    }
})();
(function() {
  'use strict';

  angular.module('fews')
    .factory('prefFactory', prefFactory);

  function prefFactory($q, $http, $log, API_URL) {
    var factory = {
      saveState: saveState,
      restoreState: restoreState,
      getPreferences: getPreferences,
      getBaselayer: getBaselayer,
      isSaved: isSaved,
      getPreferenceByID: getPreferenceByID,
      clearState: clearState,
      getClustering: getClustering
    };

    return factory;

    //////////////////////

    function getPreferences() {
      if (angular.isUndefined(factory.preferences)) {
        return getRemotePrefs();
      } else {
        return $q.resolve(factory.preferences);
      }
    }

    function getPreferenceByID(id) {
      var promise = getPreferences();
      return $q.resolve(promise).then(function (data) {
        var search = data.general.find(function(d){
          return d.id === id;
        });
        return search;
      });
    }

    function getClustering() {
      var promise = getPreferenceByID('clustering');
      return $q.resolve(promise).then(function (data) {
        var clustering = data.value;
        return clustering;
      });
    }

    function getBaselayer() {
      var promise = getPreferences();
      return $q.resolve(promise).then(function (data) {
        var search = data.general.find(function(d){
          return d.id === 'defaultbl';
        });
        var baselayer = search.data.find(function(d){
          return d.id === search.value;
        });

        return {
          baselayer: baselayer,
          styles: search.data
        };
      });
    }

    function saveState(preferences) {
      preferences.lastSaved = new Date().toISOString();

      syncGARR(preferences.dashboard);

      var req = {
        method: 'POST',
        url: API_URL + 'preferences/save',
        data: {
          username: localStorage.username.toLowerCase(),
          project: 'austin',
          preferences: angular.toJson(preferences)
        }
      };

      return $http(req)
        .then(function() {
          factory.preferences = preferences;
        }, xhrFailed);
    }

    function syncGARR(dash) {
      var garrLayer, gaugesLayer;
      for (var i = 0; i < dash.length; i++) {
        var layer = dash[i];
        if(layer.id === 'garr') {
          garrLayer = layer;
        } else if (layer.id === 'gauges') {
          gaugesLayer = layer;
        }
      }

      garrLayer.legend.settings.activeLayers = gaugesLayer.legend.settings.activeLayers;
    }

    //Find and remove the user preferences for the AFD tweets layer, which has been removed
    //We can delete this function once the 'afd' layer is no longer present in the 'user_preferences' dynamodb table entries
    function removeAfdTweetsLayer(dash) {
      var afdLayerIndex;
      for (var i = 0; i < dash.length; i++) {
        if(dash[i].id === 'afd') {
          afdLayerIndex = i;
          break;
        }
      }

      if (angular.isDefined(afdLayerIndex)) {
        dash.splice(afdLayerIndex, 1);
      }
    }

    function restoreState() {
      clearState();
      return getPreferences();
    }

    function isSaved() {
      return true;
    }

    function clearState() {
      delete factory.preferences;
    }

    function getRemotePrefs() {

      // updates prefs from backend if there's a new
      // save time otherwise, use angular's cache
      var time = factory.preferences ? factory.preferences.lastSaved : 0;
      var cacheBuster = new Date(time).getTime();

      var req = {
        method: 'GET',
        cache: true,
        url: API_URL + 'preferences/retrieve?r=' + cacheBuster,
        data: {
          username: localStorage.username.toLowerCase()
        }
      }

      return $http(req)
        .then(function(response) {
          if (response.status === 200) {
            if(response.data.version === defaultPrefs.version) {
              factory.preferences = response.data;
            } else {
              factory.preferences = mergePrefs(response.data);
            }

            syncGARR(factory.preferences.dashboard);

            removeAfdTweetsLayer(factory.preferences.dashboard);

            return $q.resolve(factory.preferences);
          } else {
            return $q.resolve(defaultPrefs);
          }
        }, xhrFailed)

    }

    function mergePrefs(oldPrefs) {
      var newPrefs = angular.copy(defaultPrefs);

      newPrefs.dashboard = idArrayMerge(defaultPrefs.dashboard, oldPrefs.dashboard);
      newPrefs.general = idArrayMerge(defaultPrefs.general, oldPrefs.general);

      return newPrefs;
    }

    function idArrayMerge(obj1, obj2) {
      var newArray = [];
      var item;
      for (var i = 0; i < obj1.length; i++) {
        for (var j = 0; j < obj2.length; j++) {
          if (obj2[j].id === obj1[i].id) {
            item = angular.merge(obj1[i], obj2[j]);
          }
        }

        if (!item) {
          item = obj1[i];
        }

        newArray.push(item);
        item = false;
      }

      return newArray;
    }

    function xhrFailed(error) {
      $log.error(error);
      return $q.reject(error);
    }

  }

  var gaugeDurations = [
      {
        value: 1,
        label: 'Last 1 hour',
        active: true
      },
      { value: 3, label: 'Last 3 hours' },
      { value: 6, label: 'Last 6 hours' },
      { value: 12, label: 'Last 12 hours' },
      { value: 24, label: 'Last 24 hours' },
      { value: 48, label: 'Last 2 days' },
      { value: 72, label: 'Last 3 days' },
      { value: 120, label: 'Last 5 days' },
      { value: 168, label: 'Last 7 days' }
    ];

  var defaultPrefs = {
    dashboard: [
      {
        id: 'austin311',
        name: 'Austin 311',
        type: 'markercluster',
        layerType: 'marker',
        visible: true,
        hasHistory: true,
        legend: {
          visible: true,
          icon: 'phone',
          imageUrl: 'austin311.marker.gif',
          checkDuration: '3 hours',
          settings: {
            opacity: false,
            activeLayers: null
          },
          loading: true
        },
        layerParams: {
          showOnSelector: false,
          zIndex: 14,
          attribution: 'austin311'
        }
      },
      {
        id: 'afdstations',
        name: 'AFD Stations',
        type: 'group',
        layerType: 'marker',
        visible: false,
        legend: {
          visible: false,
          icon: 'svg',
          iconUrl: '/assets/images/icons/afd-icon.svg',
          imageUrl: 'afdStations.marker.gif',
          settings: {
            opacity: false
          },
          loading: true
        },
        layerParams: {
          showOnSelector: false,
          zIndex: 12,
          attribution: 'afdstations'
        }
      },
      {
        id: 'afdflood',
        name: 'AFD Flood Maps',
        type: 'geoJSON',
        layerType: 'geoJSON',
        visible: false,
        legend: {
          visible: false,
          icon: 'svg',
          iconUrl: '/assets/images/icons/afd-icon.svg',
          imageUrl: 'afd.marker.gif',
          settings: {
            opacity: false,
            activeLayers: null
          },
          loading: true
        },
        layerParams: {
          showOnSelector: false,
          zIndex: 11,
          attribution: 'afdflood'
        }
      },
      {
        id: 'atx',
        name: 'ATX Low Water Crossings',
        type: 'markercluster',
        layerType: 'marker',
        visible: true,
        hasHistory: true,
        legend: {
          visible: true,
          icon: 'remove_circle',
          imageUrl: 'atx.marker.gif',
          color: '#FFCA28',
          checkDuration: '3 days',
          settings: {
            opacity: false,
            activeLayers: 'closed',
            layers: [
              { value: 'opened_or_closed', label: 'Opened and Closed' },
              { value: 'closed', label: 'Closed Only' },
              { value: 'opened', label: 'Open Only' }
            ],
            params: [
              {
                type: 'switch',
                value: true,
                display: 'Show COA only',
                key: 'jurisdictions',
                arrayValue: [
                  'COA',
                  'TCO',
                  'WLH'
                ]
              }
            ]
          },
          loading: true
        },
        layerParams: {
          showOnSelector: false,
          zIndex: 10,
          attribution: 'atx'
        }
      },
      {
        id: 'watchpoints',
        name: 'WatchPoints',
        type: 'markercluster',
        layerType: 'marker',
        visible: true,
        hasHistory: true,
        legend: {
          visible: true,
          icon: 'star',
          imageUrl: 'watchpoints.marker.gif',
          settings: {
            opacity: false
          },
          loading: true
        },
        layerParams: {
          showOnSelector: false,
          zIndex: 9,
          attribution: 'watchpoints'
        }
      },
      {
        id: 'gauges',
        name: 'Rain Gauges',
        type: 'markercluster',
        layerType: 'marker',
        visible: true,
        hasHistory: true,
        legend: {
          visible: true,
          icon: 'local_drink',
          imageUrl: 'gauges.marker.gif',
          settings: {
            activeLayers: 1,
            layers: gaugeDurations
          },
          loading: true
        },
        layerParams: {
          showOnSelector: false,
          zIndex: 8,
          attribution: 'gauges'
        }
      },
      {
        id: 'garr',
        name: 'GARR',
        type: 'xyz',
        inundationLayer: false,
        visible: true,
        hasHistory: true,
        legend: {
          visible: true,
          icon: 'view_module',
          imageUrl: 'garr.tileLayer.gif',
          settings: {
            opacity: true,
            opacityValue: 0.50
          },
          loading: true
        },
        layerParams: {
          showOnSelector: false,
          zIndex: 7,
          attribution: 'garr'
        }
      },
      {
        id: 'reflectivity',
        name: 'Radar Reflectivity',
        type: 'xyz',
        visible: true,
        hasHistory: true,
        legend: {
          visible: true,
          icon: 'radar',
          imageUrl: 'rmint.tileLayer.jpg',
          scale: true,
          settings: {
            activeLayers: 1,
            opacity: true,
            opacityValue: 0.65
          }
        },
        layerParams: {
          showOnSelector: false,
          zIndex: 6,
          attribution: 'reflectivity'
        }
      },
      {
        id: 'vaiStructures',
        name: 'Structures',
        type: 'xyz',
        layerType: 'inundation',
        inundationLayer: true,
        visible: true,
        hasHistory: true,
        legend: {
          visible: true,
          icon: 'svg',
          iconUrl: 'assets/images/icons/vai_structures_black_24px.svg',
          imageUrl: 'vaiStructures.tileLayer.gif',
          settings: {
            opacity: true,
            opacityValue: 1,
            activeLayers: null,
            layers: [
              { value: null,
                label: 'Buildings and Bridges',
                active: true
              },
              { value: 'buildings/', label: 'Buildings Only' },
              { value: 'bridges/', label: 'Bridges Only' }
            ],
            params: [
              {
                type: 'switch',
                display: 'Show Only Inundated',
                key: 'onlyInundated',
                value: true
              }
            ]
          },
          loading: true
        },
        layerParams: {
          showOnSelector: false,
          zIndex: 5,
          attribution: 'vaiStructures'
        }
      },
      {
        id: 'inundation',
        name: 'Inundation',
        type: 'group',
        layerType: 'inundation',
        inundationLayer: true,
        visible: true,
        hasHistory: true,
        legend: {
          visible: true,
          icon: 'svg',
          iconUrl: 'assets/images/icons/vai_inundation_black_24px.svg',
          imageUrl: 'inundation.tileLayer.gif',
          scale: true,
          settings: {
            opacity: true,
            opacityValue: 1,
            params: [
              {
                type: 'switch',
                display: 'Display Contour',
                key: 'contour',
                value: true
              }
            ]
          },
          loading: true
        },
        layerParams: {
          showOnSelector: false,
          zIndex: 4,
          attribution: 'inundation'
        }
      },
      {
        id: 'rmint',
        name: 'NOAA/NWS Reflectivity',
        type: 'wms',
        layerType: 'nowcoast',
        visible: false,
        hasHistory: false,
        service: [
          'radar_meteo_imagery_nexrad_time'
        ],
        legend: {
          visible: false,
          icon: 'svg',
          iconUrl: '/assets/images/icons/noaa_logo.svg',
          imageUrl: 'rmint.tileLayer.jpg',
          scale: true,
          settings: {
            activeLayers: 1,
            opacity: true,
            opacityValue: 0.5
          },
          loading: true
        },
        layerParams: {
          showOnSelector: false,
          zIndex: 3,
          attribution: 'rmint'
        }
      },
      {
        id: 'watchWarn',
        name: 'NOAA/NWS Watches/Warnings',
        type: 'group',
        layerType: 'nowcoast',
        visible: false,
        hasHistory: false,
        service: [
          'wwa_meteoceanhydro_shortduration_hazards_watches_time',
          'wwa_meteoceanhydro_shortduration_hazards_warnings_time'
        ],
        legend: {
          visible: false,
          icon: 'svg',
          iconUrl: '/assets/images/icons/noaa_logo.svg',
          imageUrl: 'watchWarn.tileLayer.jpg',
          keys: [
            { name: 'Flood Watch', color: '#338A59' },
            { name: 'Flood Warning', color: '#29FD2F' },
            { name: 'Flash Flood Warning', color: '#890309' },
            { name: 'Severe Thunderstorm Watch', color: '#D97193' },
            { name: 'Severe Thunderstorm Warning', color: '#FDA429' },
            { name: 'Tornado Watch', color: '#FFFD38' },
            { name: 'Tornado Warning', color: '#FC0D1B' }
          ],
          settings: {
            activeLayers: 0,
            opacity: true,
            opacityValue: 0.65
          },
          loading: true
        },
        layerParams: {
          showOnSelector: false,
          zIndex: 2,
          attribution: 'watchWarn'
        }
      },
      {
        id: 'smigt',
        name: 'Satellite Imagery',
        type: 'wms',
        layerType: 'nowcoast',
        visible: false,
        hasHistory: false,
        service: [
          'sat_meteo_imagery_time'
        ],
        legend: {
          visible: false,
          icon: 'svg',
          iconUrl: '/assets/images/icons/noaa_logo.svg',
          imageUrl: 'smigt.tileLayer.jpg',
          settings: {
            opacity: true,
            opacityValue: 0.65,
            activeLayers: 9
          },
          loading: true
        },
        layerParams: {
          showOnSelector: false,
          zIndex: 1,
          attribution: 'smigt'
        }
      }
    ],
    general: [
      {
        id: 'defaultbl',
        name: 'Default Baselayer',
        type: 'select',
        icon: 'layers',
        value: 'dark',
        options: [
          { label: 'Dark', value: 'dark' },
          { label: 'Light', value: 'light' },
          { label: 'Outdoors', value: 'outdoors' },
          { label: 'Satellite', value: 'satellite' },
          { label: 'Streams', value: 'streams' },
          { label: 'COA Watersheds', value: 'watersheds' }
        ],
        data: [
          {
            id: 'dark',
            name: 'Dark',
            styleUrl: 'ciwnwi97g00522pplqboi9i91'
          },
          {
            id: 'light',
            name: 'Light',
            styleUrl: 'cihezdxeo00lijnkxn9sshjl2'
          },
          {
            id: 'outdoors',
            name: 'Outdoors',
            styleUrl: 'ciqcpdtye0010bxnn2i22y58c'
          },
          {
            id: 'satellite',
            name: 'Satellite',
            styleUrl: 'cihezy2vk00n26vm53rpa7q4w'
          },
          {
            id: 'streams',
            name: 'Streams',
            styleUrl: 'cj4y9l56z3lre2so26addel84'
          },
          {
            id: 'watersheds',
            name: 'COA Watersheds',
            styleUrl: 'cj6tbtqgz0ka32rmgodlr3hkr'
          }
        ]
      },
      {
        id: 'wp-gif',
        name: 'Watchpoint GIF by Default',
        type: 'switch',
        value: true
      },
      {
        id: 'sidebar',
        name: 'Sidebar Open by Default',
        type: 'switch',
        value: true
      },
      {
        id: 'clustering',
        name: 'Marker Clustering',
        type: 'switch',
        value: true
      }
    ],
    version: '0.9',
    lastSaved: '2021-05-03T16:00:00.000Z'
  }
})();

(function() {
  'use strict';

  var component = {
    controller: PrefController,
    controllerAs: 'pc',
    templateUrl: 'app/components/preferences/pref.tmpl.html'
  }

  angular.module('fews').component('preferences', component);

  /*@ngInject*/
  function PrefController($mdMedia, $rootScope, $scope, $mdSidenav, $mdToast, $state, $timeout, prefFactory) {
    var pc = this,
      notification = $mdToast.simple().position('bottom left');

    angular.extend(pc, {
      $onInit: activate,
      loading: false,
      savePreferences: savePreferences,
      cancelPreferences: cancelPreferences,
      restoreDefault: restoreDefault,
      $mdMedia: $mdMedia
    });

    ////////////////////////

    function activate() {
      prefFactory.getPreferences().then(function(d) {
        pc.preferences = angular.copy(d);
      });
    }

    function savePreferences() {
      pc.loading = true;
      prefFactory.saveState(pc.preferences).then(function() {
        pc.loading = false;
        $mdToast.show(notification.textContent('Preferences Saved'));
        $state.go('fews.dashboard');
      });
    }

    function cancelPreferences() {
      if (!prefFactory.isSaved()) {
        restoreDefault()
        return;
      }
      pc.preferences = prefFactory.restoreState();
      $timeout(function() {
        $state.go('fews.dashboard');
      }, 300);
    }

    function restoreDefault() {
      prefFactory.getPreferences();
      activate();
      $mdToast.show(notification.textContent('Preferences Reset to Default'));
    }
  }
})();

(function() {
    'use strict';
    angular
        .module('fews')
        .factory('ddfFactory', ddfFactory);

    /*@ngInject*/
    function ddfFactory($http, $q, $log, $filter, API_URL, VDS_URL) {
        var orderBy = $filter('orderBy'); // orderBy(array, predicate, reverse)
        var service = {
            tabs: tabs,
            status: status,
            sortDurations: sortDurations,
            getOutline: getOutline,
            getGeoJSON: getGeoJSON,
            getDetails: getDetails
        };
        return service;
        ////////////////

        function tabs() {
            var req = {
                method: 'GET',
                url: API_URL + VDS_URL + 'ddf/tabs',
                headers: {'Content-Type':'application/json'},
                cache: true
            };

            return $http(req).then(function(response) {

              for (var i = 0; i < response.data.tables.length; i++) {
                angular.forEach(response.data.legends[response.data.tables[i].legend].categories, function(value) {
                  if (value.color === '#FFFFFF') {
                    value.color = '#DDD';
                  }
                });
                response.data.tables[i].legend = response.data.legends[response.data.tables[i].legend];
              }
              delete response.data.legends;

              return $q.resolve(response.data);
            }, xhrFailed);
        }

        function status(options) {
            var req = {
                method: 'GET',
                url: API_URL + VDS_URL + 'ddf/status/' + options.id + '/' + options.startDate.getTime() + '/' + options.endDate.getTime(),
                headers: {'Content-Type':'application/json'},
                cache: true
            };

            return $http(req).then(function(durations) {
              if (angular.isDefined(durations.data[0].label)) {
                durations.data = populateDurationAny(durations.data);
              }
              return $q.resolve(durations.data);
            }, xhrFailed);
        }

        function sortDurations (durations) {
          for (var i = durations.length - 1; i >= 0; i--) {
            if (durations[i].hasThreats) {
              durations[i].ids = orderBy(durations[i].ids, ['-threatId', '-percentToNextThreat']);
            } else {
              durations[i].ids = orderBy(durations[i].ids, ['-frequencyId', '-percentToNextFrequency']);
            }
          }
          return durations;
        }

        function getOutline(table, binId) {
          var req = {
            method: 'GET',
            url: API_URL + VDS_URL + 'ddf/outline/' + table + '/outline.json',
            headers: {'Content-Type':'application/json'},
            params: { binId: binId },
            cache: true
          };

          return $http(req).then(function(response) {
            var domain = {
                name: 'geoJSON ' + binId,
                type: 'geoJSONShape',
                visible: true,
                data: response.data,
                doRefresh: true,
                layerParams: {showOnSelector: false},
                style: {
                  fillOpacity: 0.25,
                  fillColor: '#FFF',
                  weight: 2,
                  opacity: 1,
                  color: '#FFF'
                }
            };
            domain.data.properties = {};
            return $q.resolve(domain);
          }, xhrFailed);
        }

        function getGeoJSON(filename) {
          var req = {
            method: 'GET',
            url: API_URL + 'ddf/maps/floodplain/'+ filename +'.json',
            headers: {'Content-Type':'application/json'}
          };

          return $http(req).then(function(response){
            var geoJSON = {
              name: 'extent geoJSON',
              type: 'geoJSONShape',
              visible: true,
              data: response.data,
              doRefresh: true,
              layerParams: {showOnSelector: false},
              style: {
                fillOpacity: 0.1,
                weight: 2,
                opacity: 0.75
              }
            };
            return $q.resolve(geoJSON);
          }, xhrFailed);
        }

        function getDetails (table, id, start, end) {
          if (angular.isFunction(start.getMonth)) {
            start = start.getTime();
          }
          if (angular.isFunction(end.getMonth)) {
            end = end.getTime();
          }
          var req = {
              method: 'GET',
              url: API_URL + VDS_URL + 'ddf/details/' + table + '/' + id + '/' + start + '/' + end,
              headers: { 'Content-Type': 'application/json' },
              cache: true
          };

          return $http(req).then(xhrComplete, xhrFailed);
        }

        function populateDurationAny(durations) {
          if(angular.isDefined(durations[0].label)) {
            var array = durations[0].ids;
            var durationMap = durations.reduce(function ( total, current ) {
              if (current.duration) {
                total[ 'd' + current.duration ] = current;
              }
              return total;
            }, {});

            for (var i = array.length - 1; i >= 0; i--) {
              for (var j = durationMap['d' + array[i].duration].ids.length - 1; j >= 0; j--) {
                if(durationMap['d' + array[i].duration].ids[j].id === array[i].id) {
                  angular.merge(array[i], durationMap['d' + array[i].duration].ids[j]);
                }
              }
            }

            durations[0].ids = array;
          }

          return durations;
        }

        function xhrComplete(response) {
            return $q.resolve(response.data);
        }

        function xhrFailed(error) {
            $log.error(error);
            return $q.reject(error);
        }
    }
})();

(function() {
  'use strict';

  var component = {
    controller: DdfController,
    controllerAs: 'ddfVm',
    templateUrl: 'app/components/ddf/ddf.tmpl.html'
  };

  angular
    .module('fews')
    .component('ddfList', component);

  /*@ngInject*/
  function DdfController($q, $scope, $document, $timeout, $mdDialog, $mdSidenav,
      $mdMedia, leafletData, leafletBoundsHelpers, ddfFactory, timeFactory,
      prefFactory, baselayerFactory, API_URL) {
    var ddfVm = this;
    var map;

    angular.extend(ddfVm, {
      $onInit: activate,
      API_URL: API_URL,
      loading: true,
      activeTab: 0,
      list: {},
      selected: {},
      map: {
        defaults: {
          attributionControl: false,
          doubleClickZoom: false,
          zoomControl: false,
          touchZoom: true,
          scrollWheelZoom: true,
          tap: false,
          fadeAnimation: false
        },
        layers: {
          baselayers: {}
        },
        bounds: {},
        geoJson: {},
        initialized: false
      },
      openTimeDialog: openTimeDialog,
      loadList: loadList,
      hideDetails: hideDetails,
      showDetails: showDetails,
      showMapExtent: showMapExtent,
      loadDuration: loadDuration,
      getCategoryLabel: getCategoryLabel,
      $mdMedia: $mdMedia
    });
    ////////////////
    function activate() {
      leafletData.getMap('ddf-map')
        .then(function(mapData) { map = mapData; });

      prefFactory.getBaselayer().then(
        function(res) {
          var style = res.baselayer;
          baselayerFactory.buildLayer(style).then(
            function(data) {
              ddfVm.map.layers.baselayers[style.id] = data;
            }
          );
        }
      );

      ddfFactory.tabs().then(tabsSuccess, tabsFail);

      function tabsSuccess(response) {
        var oneYear = 31536e6;
        var sessionTime = sessionStorage.getItem('rp');
        var initialTime = sessionTime ?
          new Date(sessionTime) : timeFactory.getLastInterval(15);
        var milliTime = initialTime.getTime();
        ddfVm.times = {
          startDate: new Date(milliTime - (60000 * 60)),
          endDate: new Date(milliTime),
          minDate: new Date(milliTime - oneYear),
          maxDate: new Date(milliTime),
          isSameDay: function() {
            return this.startDate.toDateString() === this.endDate.toDateString();
          }
        };

        angular.merge(ddfVm, response);

        loadDurations();
      }

      function tabsFail() { ddfVm.text = 'Error'; }
    }

    function setColors(ids) {
      for (var i = 0; i < ids.length; i++) {
        var category = (ids[i].threatId || ids[i].frequencyId);
        ids[i].style = {
          'background-color': ddfVm.tables[ddfVm.activeTab].legend.categories['cat' + category].color,
          'border-right-color': ddfVm.tables[ddfVm.activeTab].legend.categories['cat' + (category + 1)].color
        };
      }
    }

    function loadDurations(times) {
      ddfVm.loading = true;
      var options = angular.merge({ id: ddfVm.tables[ddfVm.activeTab].id }, (times || ddfVm.times));
      ddfFactory.status(options).then(function(durations){
        durations = prepDurations(durations);
        ddfVm.durations = ddfFactory.sortDurations(durations);
        loadList(ddfVm.durations[0], 0);
        if(times) {
          ddfVm.times = times;
          if (sessionStorage.getItem('rp')) {
            sessionStorage.setItem('rp', times.endDate);
          }
        }
        $timeout(function(){$document[0].querySelectorAll("#ddf-list")[0].scrollTop = 0;});
        ddfVm.loading = false;
      });
    }

    function openTimeDialog(ev) {
      $mdDialog.show({
        clickOutsideToClose: true,
        templateUrl: 'app/components/ddf/times.tmpl.html',
        scope: $scope,
        locals: {
          vtimes: ddfVm.times
        },
        preserveScope: true,
        targetEvent: ev,
        controller: timeController
      }).then(loadDurations);
    }

    function timeController($scope, $mdDialog, vtimes) {
      $scope.times = angular.copy(vtimes);
      $scope.close = function() {
        $mdDialog.cancel();
      };
      $scope.load = function() {
        $mdDialog.hide($scope.times);
      };
    }

    function showMapExtent(ev, category, color) {
      $mdDialog.show({
        clickOutsideToClose: true,
        templateUrl: 'app/components/ddf/mapExtent.tmpl.html',
        locals: {
          category: category,
          color: color
        },
        targetEvent: ev,
        controller: mapExtentController,
        fullscreen: $mdMedia('xs')
      });
    }

    /*@ngInject*/
    function mapExtentController($scope, $mdDialog, category, color) {
      $scope.loading = true;
      $scope.category = category;
      $scope.geojson = '';
      $scope.layers = {
        baselayers: ddfVm.map.layers.baselayers
      };
      $scope.defaults = {
        attributionControl: false,
        doubleClickZoom: false,
        zoomControl: false,
        touchZoom: true,
        scrollWheelZoom: true,
        tap: false,
        fadeAnimation: false
      };
      $scope.cancel = function(){
        $mdDialog.cancel();
      };

      var filename = category.extentKML.split('.')[0];
      var extentMap;
      leafletData.getMap('extent').then(function(d){
        extentMap = d;
        return;
      });

      ddfFactory.getGeoJSON(filename).then(function(d){
        d.style.fillColor = color;
        d.style.color = color;
        $scope.geojson = d;
        extentMap.invalidateSize();
        extentMap.fitBounds(L.geoJson(d.data).getBounds());
        $scope.loading = false;
        return;
      });
    }

    function loadList(duration, index) {
      setColors(duration.ids);
      duration.selected = true;
      ddfVm.list.selected = false;
      ddfVm.list = duration;
      ddfVm.selected.durationIndex = index;
    }

    function hideDetails() {
      $mdSidenav('ddfDetails').close()
        .then(function(){
          delete ddfVm.selected.id;
      });
    }

    function showDetails(item) {
      ddfVm.map.initialized = false;
      ddfVm.selected.item = item;
      ddfVm.map.geoJson = {};
      loadDuration(0);
      ddfVm.selected.item.category = getCategory(item);
      $mdSidenav('ddfDetails').open()
        .then(function(){
          var promises = [
            ddfFactory.getOutline(ddfVm.tables[ddfVm.activeTab].id, ddfVm.selected.item.id),
            ddfFactory.getDetails(ddfVm.tables[ddfVm.activeTab].id, ddfVm.selected.item.id, ddfVm.times.startDate, ddfVm.times.endDate)
          ];
          $q.all(promises).then(function(res) {
            addOutline(res[0]);
            addDetailData(res[1]);
            setCurrentColor();
          });
      });

      function addOutline(data) {
        ddfVm.map.bounds = leafletBoundsHelpers.createBoundsFromLeaflet( L.geoJson(data.data).getBounds() );
        map.invalidateSize();
        ddfVm.map.geoJson = data;
      }

      function addDetailData(details) {
        ddfVm.selected.item = angular.merge({}, details, ddfVm.selected.item);
        ddfVm.selected.item.initialized = true;
        if (ddfVm.hasAnyDuration) {
          ddfVm.selected.item.durations.unshift(getDurationByTime(ddfVm.selected.item.duration));
          ddfVm.selected.item.durations[0].label = 'Any';
        }
      }

      function setCurrentColor() {
          var durIndx = ddfVm.selected.durationIndex;
          var threatFreqId = ddfVm.selected.item.durations[durIndx].threatId || ddfVm.selected.item.durations[durIndx].frequencyId;
          var cat = 'cat' + threatFreqId;
          ddfVm.map.geoJson.style.fillColor = ddfVm.tables[ddfVm.activeTab].legend.categories[cat].color;
          ddfVm.map.geoJson.doRefresh = true;
          ddfVm.map.initialized = true;
      }

      function getDurationByTime (time) {
        var selectedDuration = null;

        for (var i = ddfVm.selected.item.durations.length - 1; i >= 0; i--) {
          if (ddfVm.selected.item.durations[i].lengthMS === time) {
            selectedDuration = angular.copy(ddfVm.selected.item.durations[i]);
            return selectedDuration;
          }
        }
      }
    }

    function loadDuration(durationIndex) {
      if (ddfVm.selected.durationIndex) {
        ddfVm.selected.duration.selected = false;
        ddfVm.durations[ddfVm.selected.durationIndex].selected = false;
      }
      ddfVm.selected.durationIndex = durationIndex;
      ddfVm.selected.duration = ddfVm.durations[durationIndex];
      ddfVm.selected.duration.selected = true;
    }

    // Auburn Dam only has 2 alert level labels, 0 & 1.
    // If Auburn Dam and the legend's label has "2", return "1".
    function getCategoryLabel() {
        if(ddfVm.selected.item) {
          if (ddfVm.selected.item.category.label === "2")
            return "1";
          else
            return ddfVm.selected.item.category.label;
        }
    }

    function getCategory (item) {
      var categories = ddfVm.tables[ddfVm.activeTab].legend.categories;
      if(ddfVm.hasThreats)
        return categories['cat' + item.threatId];
      else
        return categories['cat' + item.frequencyId];
    }

    function prepDurations ( durations ) {
      for (var i = durations.length - 1; i >= 0; i--) {

          if ( durations[i].label === 'Any' ) {
              ddfVm.hasAnyDuration = true;
              durations[i].ids = setupAnyDuration(durations[i].ids);
              continue;
          } else {
              ddfVm.hasAnyDuration = false;
          }

          ddfVm.hasThreats = durations[i].hasThreats;

          // for each item in each duration add nextFrequencyId property,
          for (var j = durations[i].ids.length - 1; j >= 0; j--) {

              if(ddfVm.hasThreats) {
                  // if item's threatId is the same as categoryHigh
                  if(durations[i].ids[j].threatId === ddfVm.tables[ddfVm.activeTab].legend.categoryHigh)
                      durations[i].ids[j].nextFrequencyId = durations[i].ids[j].threatId; // nextFrequencyId is the same as threatId
                  else
                      durations[i].ids[j].nextFrequencyId = durations[i].ids[j].threatId + 1; // else nextFrequencyId is threatId + 1
              } else {
                  // if item's frequencyId is the same as categoryHigh
                  if(durations[i].ids[j].frequencyId === ddfVm.tables[ddfVm.activeTab].legend.categoryHigh)
                      durations[i].ids[j].nextFrequencyId = durations[i].ids[j].frequencyId; // nextFrequencyId is the same as frequencyId
                  else
                      durations[i].ids[j].nextFrequencyId = durations[i].ids[j].frequencyId + 1; // else nextFrequencyId is frequencyId + 1
              }
          }
      }

      return durations;

      function setupAnyDuration (anyIds) {

          for (var i = anyIds.length - 1; i >= 0; i--) {
              var durationObj = findDurationObj(anyIds[i]);
              angular.extend(anyIds[i], durationObj);
          }

          return anyIds;
      }

      function findDurationObj (anyId) {
          for (var i = durations.length - 1; i >= 0; i--) {
              if (durations[i].duration === anyId.duration) {
                  for (var j = durations[i].ids.length - 1; j >= 0; j--) {
                      if (durations[i].ids[j].id === anyId.id)
                          return durations[i].ids[j];
                  }
              }
          }
      }
    }

    $scope.$watch('ddfVm.activeTab', function(newVal, oldVal) {
      if (newVal !== oldVal) {
        loadDurations();
      }
    });
  }
})();

(function() {
    'use strict';

    angular
        .module('fews')
        .controller('LoginController', LoginController);

    /*@ngInject*/
    function LoginController($state, $log, $document, notificationFactory, $auth) {
        var vm = this;

        vm.user = {
            username: '',
            password: ''
        };

        vm.remember = true;

        vm.submit = submit;
        vm.setStorageType = setStorageType;

        activate();

        function activate() {
            vm.setStorageType();
        }

        function submit () {
            $auth.login(vm.user)
                .then(function() {
                    if (vm.error) $log.error(vm.error);
                    if (vm.error) delete vm.error;
                    notificationFactory.sendGenericMessage('You have successfully signed in!');
                    delete localStorage.username;
                    localStorage.username = vm.user.username;
                    $state.go('fews.dashboard');
                }, function(error) {
                    vm.user.password = null;
                    angular.element($document[0].querySelector('#password')).focus();

                    if(error.status === 401) {
                        vm.error = 'The username and password you entered don\'t match.';
                      } else {
                        notificationFactory.sendGenericMessage('There was a problem with your login.'); }
                });
        }

        function setStorageType() {
            if(vm.remember === true) {
                $auth.setStorageType('localStorage');
                if (Modernizr.localstorage) {
                  localStorage.storageType = 'localStorage';
                } else {
                  vm.error = 'LocalStorage is not supported on this browser or mode. Some features may not work properly for you.';
                  alert('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.');
                }
            } else {
                $auth.setStorageType('sessionStorage');
                localStorage.storageType = 'sessionStorage';
            }
        }
    }
})();

(function() {
  'use strict';

  angular.module('fews').controller('GaugeController', GaugeController);

  /* @ngInject */
  function GaugeController($scope, $document, $filter, $mdDialog, gaugeFactory) {

    var vm = this;

    vm.query = {
      lastUpdated: new Date(),
      order: 'name',
      limit: 5,
      page: 1
    };

    activate();

    //////////////////

    function activate() {
      vm.gaugeOrder = 'status';
      vm.initialized = false;
      vm.getDetailsFail = false;
      delete vm.gauges;

      return getGauges().then(function() {
        vm.initialized = true;
      }, function() {
        vm.initialized = false;
        vm.getDetailsFail = true;
      });

    }

    function getGauges() {
      vm.query.loadingLastUpdated = true;
      return gaugeFactory.getDetails().then(function(details) {
        vm.gauges = details.data;

        var reformattedArray = vm.gauges.map(function(obj) {
          return obj.feedType;
        });

        vm.feedTypes = reformattedArray.filter(function(item, i) {
          return reformattedArray.indexOf(item) === i;
        });

        vm.query.loadingLastUpdated = false;
        vm.query.lastUpdated = new Date();
      });
    }

    $scope.$watch(function() {
      return gaugeFactory.getGaugeOrder();
    }, function(newValue, oldValue) {
      if (newValue !== oldValue)
        vm.gaugeOrder = newValue;
      }
    );

    var orderBy = $filter('orderBy');

    vm.getActive = function(group) {
      var total = 0;
      for (var i = 0; i < group.length; i++) {
        var status = group[i].status;
        if (status == 1)
          total += 1;
        }
      return total;
    };

    vm.showGauge = function(ev, orderedGauges, index) {
      if (angular.isUndefined(index)) {
        orderedGauges = vm.gauges;
      }
      $mdDialog.show({
        fullscreen: true,
        clickOutsideToClose: true,
        parent: angular.element($document[0].body),
        targetEvent: ev,
        templateUrl: 'app/components/gauges/gauge-details/gauge-details.tmpl.html',
        locals: {
          orderedGauges: orderedGauges,
          timezone: vm.timezone,
          index: index
        },
        controller: 'gaugeDetailController',
        controllerAs: 'gdc'
      }).then(function() {
        vm.selectedGauge = false;
      }, function() {
        vm.selectedGauge = false;
      });
    };

    vm.order = function(predicate, reverse) {
      vm.gauges = orderBy(vm.gauges, predicate, reverse);
    };

    vm.order('feedType', false);

    $scope.$on('activeProject:updated', function() {
      activate();
    });

    $scope.$on('update:gaugestat', function() {
      if (gaugeFactory.getDetailsInactive)
        getGauges();
      }
    );

  }
})();

(function() {
    'use strict';

    angular
        .module('rules')
        .factory('rulesFactory', rulesFactory);

    /*@ngInject*/
    function rulesFactory ($http, $q, $log, API_URL) {

        var factory = {
            getDetails: getDetails,
            getWatchpoints: getWatchpoints,
            getNewRule: getNewRule,
            saveRule: saveRule,
            deleteRule: deleteRule
        };

        return factory;

        //////////////////////

        function getDetails () {

            var req = {
                method: 'GET',
                url: API_URL + 'rules/retrieve',
                headers: {'Content-Type': 'application/json'}
            };

            return $http(req)
                .then(function(response) {
                    for (var i = response.data.length - 1; i >= 0; i--) {
                        if (angular.isString(response.data[i].payload)) {
                            response.data[i].payload = angular.fromJson(response.data[i].payload);
                            if (angular.isString(response.data[i].payload)) {
                                response.data[i].payload = {
                                    mapAlerts: []
                                };
                            }
                        }
                    }

                    return $q.resolve(response.data);
                }, xhrFailed);
        }

        function getWatchpoints () {

            var req = {
                method: 'GET',
                url: API_URL + 'watchpoints/retrieve',
                headers: { 'Content-Type': 'application/json' }
            };

            return $http(req)
                .then(xhrComplete, xhrFailed);
        }

        function getNewRule () {
            return {
                title: "",
                description: "",
                active: false,
                modifiedBy: "",
                createdBy: "",
                source: {
                    id: "",
                    displayName: "",
                    basin: "",
                    inputs: [],
                    threshold: null
                },
                payload: {
                    mapAlerts: []
                }
            };
        }

        function saveRule (rule) {
            var rulecopy = prepRule(rule),
                req = {
                method: 'POST',
                url: API_URL + 'rules/update',
                headers: { 'Content-Type': 'application/json' },
                data: angular.toJson(rulecopy)
            };

            return $http(req)
                .then(xhrComplete, xhrFailed);
        }

        function deleteRule (rule) {
            var req = {
                method: 'DELETE',
                url: API_URL + 'rules/delete/' + rule.id,
                headers: { 'Content-Type': 'application/json' }
            };
            return $http(req).then(xhrComplete, xhrFailed);
        }

        function prepRule (rule) {
            var rulecopy = angular.copy(rule);
            rulecopy.payload = angular.toJson(rulecopy.payload);
            if (rule.source.basinDisplayName) delete rulecopy.source.basinDisplayName;
            if (rule.source.queryName) delete rulecopy.source.queryName;
            if (rule.source.latitude) delete rulecopy.source.latitude;
            if (rule.source.longitude) delete rulecopy.source.longitude;
            if (rule.source.unit) delete rulecopy.source.unit;
            if (rule.source.inputDisplayName) delete rulecopy.source.inputDisplayName;

            return rulecopy;
        }

        function xhrComplete(response) {
            return $q.resolve(response.data);
        }

        function xhrFailed(error) {
            $log.error(error);
            return $q.reject(error);
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('rules')
    .controller('RulesController', RulesController);

  /*@ngInject*/
  function RulesController($q, $scope, $timeout, $document, $mdMedia,
    $mdDialog, $mdSidenav, rulesFactory, projectInfo, myInfo,
    notificationFactory, wpFactory, uuid) {

    var vm = this;
    angular.extend(vm, {
      searchText: '',
      selectRule: selectRule,
      loadDetails: loadDetails,
      closeDetails: closeDetails,
      openAlert: openAlert,
      deleteAlert: deleteAlert,
      confirmDelete: confirmDelete,
      toggleActive: toggleActive,
      saveDisabled: saveDisabled,
      dialogSaveDisabled: dialogSaveDisabled,
      saveRule: saveRule,
      deleteRule: deleteRule,
      duplicateRule: duplicateRule,
      buttonDisabled: buttonDisabled,
      isEditable: isEditable,
      querySearch: querySearch,
      getFilterObj: getFilterObj,
      disableDataType: disableDataType,
      getSelectedUnit: getSelectedUnit,
      watchpoints: [],
      dataTypeMap: {},
      rules: [],
      selected: {
        rule: undefined,
        index: null,
        location: null
      },
      tableQuery: {
        order: 'title',
        pagination: {
          limit: 200,
          page: 1
        },
        selectedOption: {
          label: 'Rule Title',
          value: 'title'
        },
        type: [{
            label: 'Rule Title',
            value: 'title'
          },
          {
            label: 'Basin',
            value: 'basinDisplayName'
          },
          {
            label: "Location",
            value: 'displayName'
          },
          {
            label: 'Input Data',
            value: 'inputDisplayName'
          }
        ],
        inputText: ''
      },
      ruleChanged: false,
      $mdMedia: $mdMedia,
      createRule: createRule,
      canEdit: myInfo.permissions.rules.edit
    });

    activate();

    ////////////////////

    function activate() {
      var promises = [
        rulesFactory.getDetails(),
        projectInfo.getDetails(),
        wpFactory.retrieve()
      ];

      $q.all(promises).then(function (data) {
        loadWatchpoints(data[2]);
        vm.basins = data[1].basins;
        updateRuleList(data[0]);
      });

    }

    function loadDetails(rule) {
      if (angular.isUndefined(rule)) {
        vm.selected.rule = undefined;
        togglePanel(rule);
        newRuleDialog();
        return;
      }

      // duplicates
      if (angular.isUndefined(rule.id)) {
        togglePanel(rule);
        newRuleDialog();
        return;
      }

      if (angular.isDefined(vm.selected.rule)) {
        if (rule.id === vm.selected.rule.id) {
          return;
        }
      }

      togglePanel(rule);
    }

    function createRule() {
      vm.selected.rule = undefined;
      togglePanel();
      newRuleDialog();
    }

    function loadWatchpoints(data) {
      vm.watchpoints = getList(data.watchPoints);
      vm.dataTypeMap = data.dataTypeMap;

      function getList(data) {
        return data.map(function (point) {
          point.queryName = point.displayName.toLowerCase() + ' (' + point.id.toLowerCase() + ')';
          return point;
        });
      }
    }

    function togglePanel(rule) {
      if ($mdSidenav('details').isOpen()) {
        if ($scope.ruleForm.$pristine && vm.ruleChanged === false) {
          selectRule(rule);
        } else {
          var confirm = $mdDialog.confirm()
            .title('Discard changes?')
            .ariaLabel('Close Rule')
            .ok('Yes')
            .cancel('No');

          $mdDialog.show(confirm).then(function () {
            selectRule(rule);
          });
        }
      } else {
        $mdSidenav('details').open()
        selectRule(rule);
      }
    }

    function selectRule(rule) {
      if (angular.isDefined(rule)) {
        loadSelectedLocation(rule.source.id);
        if (angular.isUndefined(vm.selected.rule) || vm.selected.rule.id !== rule.id) {
          vm.selected = {
            rule: angular.copy(rule),
            index: null,
            location: getWatchpoint(rule.source.id)
          };
        }
      } else {
        loadSelectedLocation();
        vm.selected = {
          rule: rulesFactory.getNewRule(),
          index: null
        };
      }
      vm.ruleChanged = false;
      $timeout(function () {
        $scope.ruleForm.$setPristine();
      });
    }

    function getWatchpoint(id) {
      return vm.watchpoints.find(function (d) {
        return d.id == id;
      });
    }

    function closeDetails() {
      if ($scope.ruleForm.$pristine) {
        resetSelected();
      } else {
        var confirm = $mdDialog.confirm()
          .title('Discard Changes?')
          .ariaLabel('Close Rule')
          .ok('Yes')
          .cancel('No');

        $mdDialog.show(confirm).then(resetSelected);
      }

      function resetSelected() {
        $scope.ruleForm.$setPristine();
        $mdSidenav('details').close();
        // vm.openSidenav = false;
        vm.selected.rule = undefined;
        vm.selected.index = null;
        vm.ruleChanged = false;
      }
    }

    function openAlert(alert, ev) {
      var WPobj = getWatchpoint(vm.selected.rule.source.id)
      $mdDialog.show({
          controller: 'AlertController',
          controllerAs: 'alertVm',
          locals: {
            alert: alert,
            lat: WPobj.latitude,
            lon: WPobj.longitude
          },
          templateUrl: 'app/components/rules/alert-dialog/alert.tmpl.html',
          parent: angular.element($document[0].body),
          targetEvent: ev,
          clickOutsideToClose: false,
          escapeToClose: false,
          fullscreen: $mdMedia('xs')
        })
        .then(addAlert);
    }

    function addAlert(alert) {
      $scope.ruleForm.$setDirty();
      if (alert.isNew) {
        alert.updated.alertID = uuid.generate();
        vm.selected.rule.payload.mapAlerts.push(alert.updated);
      } else {
        angular.forEach(vm.selected.rule.payload.mapAlerts, function (value, key) {
          if (alert.original.alertID === value.alertID)
            vm.selected.rule.payload.mapAlerts[key] = angular.copy(alert.updated);
        });
      }

      vm.ruleChanged = true;
    }

    function confirmDelete(ev) {
      var confirm = $mdDialog.confirm()
        .title('Are you sure?')
        .textContent(vm.selected.rule.title + ' will be permanantly deleted.')
        .ariaLabel('Delete Rule')
        .targetEvent(ev)
        .ok('Yes')
        .cancel('No');

      $mdDialog.show(confirm).then(function () {
        deleteRule();
      });
    }

    function deleteAlert(alert) {
      $scope.ruleForm.$setDirty();
      vm.ruleChanged = true;
      for (var i = 0; i < vm.selected.rule.payload.mapAlerts.length; i++) {
        if (angular.equals(vm.selected.rule.payload.mapAlerts[i], alert))
          vm.selected.rule.payload.mapAlerts.splice(i, 1);
      }
    }

    function buttonDisabled(rule) {
      if (angular.isUndefined(rule)) {
        return false;
      }
      return angular.isUndefined(rule.id);
    }

    function dialogSaveDisabled(state) {
      return state;
    }

    function saveDisabled(ruleForm) {
      var pristine = ruleForm.$pristine;
      var invalid = !ruleForm.$valid;
      var error = ruleForm.$error;

      return invalid || pristine || !error;
    }

    function isEditable(rule) {
      if (!rule) {
        return;
      }
      if (rule.id) {
        return true;
      } else {
        return false;
      }
    }

    function duplicateRule() {
      if (vm.selected.rule.id) {
        delete vm.selected.rule.id;
      }
      notificationFactory.sendGenericMessage('Rule Duplicated');
      vm.selected.rule.title += ' "duplicate"';
      loadDetails(vm.selected.rule);
    }

    function saveRule() {
      if (vm.selected.location !== null) {
        if (vm.selected.rule.source.id !== vm.selected.location.id) {
          vm.selected.rule.source.id = vm.selected.location.id;
          vm.selected.rule.source.basin = vm.selected.location.basinModelKey;
          vm.selected.rule.source.displayName = vm.selected.location.displayName;
        }

        rulesFactory.saveRule(vm.selected.rule).then(function (data) {
          notificationFactory.sendGenericMessage('Rule Saved');
          if (angular.isUndefined(vm.selected.rule.id)) vm.selected.rule.id = data.split(': ')[1];
          $scope.ruleForm.$setPristine();
          vm.ruleChanged = false;
          rulesFactory.getDetails().then(updateRuleList);
        });
      }
    }

    function deleteRule() {
      rulesFactory.deleteRule(vm.selected.rule).then(function () {
        notificationFactory.sendGenericMessage('Rule Deleted');
        vm.rules.splice(vm.selected.index, 1);
        closeDetails();
        rulesFactory.getDetails().then(updateRuleList);
      });
    }

    function getSelectedUnit() {
      if (angular.isDefined(vm.selected.rule.source.inputs)) {
        vm.selected.rule.source.unit = vm.dataTypeMap[vm.selected.rule.source.inputs[0]].units;
      }
    }

    function updateRuleList(data) {
      angular.forEach(data, function (val) {
        val.source.unit = vm.dataTypeMap[val.source.inputs[0]].units;
        val.source.inputDisplayName = vm.dataTypeMap[val.source.inputs[0]].displayName;
        for (var x = 1; x < val.source.inputs.length; x++) {
          val.source.inputDisplayName += ", " + vm.dataTypeMap[val.source.inputs[x]].displayName;
        }
      });
      vm.rules = data;
    }

    function toggleActive() {
      $scope.ruleForm.$setDirty();
      vm.selected.rule.active = !vm.selected.rule.active;
      vm.ruleChanged = true;
    }

    function loadSelectedLocation(id) {
      if (id === null) {
        vm.selected.location = null;
        return;
      }

      for (var i = vm.watchpoints.length - 1; i >= 0; i--) {
        if (vm.watchpoints[i].id === id)
          vm.selected.location = vm.watchpoints[i];
      }
    }

    function querySearch(query) {
      return vm.watchpoints.filter(createFilterFor(query));
    }

    function getFilterObj() {
      var searchObj = {};

      if (vm.tableQuery.selectedOption.value !== 'title') {
        searchObj.source = {};
        searchObj.source[vm.tableQuery.selectedOption.value] = vm.tableQuery.inputText;
      } else {
        searchObj[vm.tableQuery.selectedOption.value] = vm.tableQuery.inputText;
      }

      return searchObj;
    }

    // handles the disabled logic on input data types options
    function disableDataType(type) {

      // more than one input type is flow.
      var re = /FLOW/;
      var selected = vm.selected.rule;
      var inputs = selected.source.inputs;

      // if the rule source inputs is undefined or the inputs length is less than one
      if (angular.isUndefined(selected) ||
        angular.isUndefined(inputs) ||
        inputs.length < 1) {

        // when rule is not saved but selecting a flow input
        if (angular.isDefined(selected.id) && re.test(type)) {
          return true;
        }

        return false;
      } else {
        // else the rule source inputs is defined and the inputs length greater than 1

        // if the rule is already saved and the type is stage or flow
        // rule.active doesn't determine if it has been saved.
        if (angular.isDefined(selected.id) && re.test(type)) {
          return true;
        }

        // if the units are not equal
        // flow is in a different set of units than the rest
        if (vm.dataTypeMap[inputs[0]].units !== vm.dataTypeMap[type].units) {
          return true;
        }

        return false;
      }

    }

    /*
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(watchpoint) {
        if (angular.isUndefined(lowercaseQuery))
          return true;
        else
          return (watchpoint.queryName.indexOf(lowercaseQuery) >= 0);
      };

    }

    function newRuleDialog($event) {

      var dialogue = {
        targetEvent: $event,
        templateUrl: 'app/components/rules/new-rule-dialog/new-rule.tmpl.html',
        controller: 'newRuleDialogController',
        controllerAs: 'newRuleVm',
        clickOutsideToClose: false,
        escapeToClose: false,
        locals: {
          rulesVm: vm
        }
      };

      $mdDialog
        .show(dialogue)
        .finally(function () {
          dialogue = undefined;
        });

    }

  }

}());

(function () {
  'use strict';

  var component = {
    controller: DashController,
    controllerAs: 'dashVm',
    templateUrl: 'app/components/dashboard/dashboard.tmpl.html'
  };

  angular
    .module('dashboard')
    .component('dashboard', component);

  /*@ngInject*/
  function DashController(replayFactory) {
    var vm = this;
    angular.extend(vm, {
      replay: {
        isActive: replayFactory.isActive
      }
    });

    activate();

    function activate() {}
  }
})();

(function() {
  'use strict';

  angular
    .module('fews')
    .controller('AlertsController', AlertsController);

  /*@ngInject*/
  function AlertsController(
      $scope, $q, $log, $window, $mdDialog, $mdSidenav, $mdMedia, $auth,
      alertFeedFactory, projectInfo, wpFactory, leafletData, baselayerFactory,
      alertStatusFactory, prefFactory, API_URL) {

    var vm = this;
    var MIN = 1000 * 60;
    var HOUR = MIN * 60;
    var DAY = HOUR * 24;
    var WEEK = DAY * 7;
    var YEAR = WEEK * 52;
    var map;

    angular.extend(vm, {
      $onInit: activate,
      accesstoken: $auth.getToken(),
      getItemAtIndex: getItemAtIndex,
      getLength: getLength,
      openTimeDialog: openTimeDialog,
      alertTimeController: alertTimeController,
      showDetail: showDetail,
      hideDetail: hideDetail,
      times: undefined,
      startTime: 0,
      endTime: 0,
      pivotTime: 0,
      minStartDate: new Date(2015, 4, 1),
      timeSubtract: (YEAR * .25),
      alerts: [],
      ruleMap: {},
      dataTypeMap: undefined,
      counter: 0,
      loading: true,
      page: 1,
      selected: undefined,
      map: {
        defaults: {
          attributionControl: false,
          doubleClickZoom: false,
          zoomControl: true,
          touchZoom: true,
          scrollWheelZoom: true,
          tap: false,
          fadeAnimation: false
        },
        layers: {
          baselayers: {},
          overlays: {}
        },
        initialized: false
      },
      $mdMedia: $mdMedia,
      initMap: initMap,
      rangeActive: false,
      clearResults: clearResults
    });

    ////////////////////

    function activate() {

      initMap();
      resetTime();

      vm.times = {
        startDate: new Date(vm.startTime),
        endDate: new Date(vm.endTime),
        minDate: new Date(vm.minStartDate),
        maxDate: new Date(Date.now()),
        isSameDay: function() {
          return this.startDate.toDateString() === this.endDate.toDateString();
        }
      }

      vm.times.startDate.setMilliseconds(0);
      vm.times.startDate.setMinutes(0);
      vm.times.startDate.setSeconds(0);
      vm.times.endDate.setMilliseconds(0);
      vm.times.endDate.setMinutes(0);
      vm.times.endDate.setSeconds(0);

      var promises = [projectInfo.getDetails(), wpFactory.retrieve()];

      $q.all(promises).then(function(data) {
        vm.basinsMap = data[0].basins;
        vm.dataTypeMap = data[1].dataTypeMap;
        fetchMoreAlerts(vm.startTime, vm.endTime);
      });

    }

    function resetTime() {
      var sessionTime = sessionStorage.getItem('rp');
      vm.endTime = new Date(sessionTime).getTime() || Date.now();
      vm.startTime = vm.endTime - vm.timeSubtract;
      vm.pivotTime = vm.startTime;
    }

    function hideDetail() {
      $mdSidenav('alertDetails').close();
    }

    function showDetail(alert) {
      vm.map.kill = false;
      vm.selected = angular.extend({}, alert, {
        loading: true,
        startTime: alert.notifyTime - (HOUR * 2),
        endTime: alert.notifyTime + (HOUR * 6),
        rule: lookUpRule(alert.ruleID),
        imageUrl: '/assets/images/loading_icon.gif',
        dataTime: alert.referenceTime
      });

      var mapAlerts = vm.selected.rule.payload;

      $mdSidenav('alertDetails').onClose(function () {
        delete vm.selected;
      }).open().then(function() {

        renderMapAlerts(mapAlerts, alert);

        var height = $mdMedia('xs') ? 400 : 250;
        var dpr = $window.devicePixelRatio,
            checkedDPR = dpr < 1 ? 1 : Math.floor(dpr);

        vm.selected.imageUrl = API_URL +
          'hydrographs/' + vm.selected.rule.source.id +
          '/height_chart.png?style=COMPLICATED&pixelRatio='+ checkedDPR +
          '&width=600&height='+ height +
          '&ghostLines=true&start=' + vm.selected.startTime +
          '&end=' + vm.selected.endTime +
          '&fakeNow=' + vm.selected.dataTime +
          '&accesstoken=' + vm.accesstoken;

        vm.selected.loading = false;
      });
    }

    function initMap() {
      leafletData.getMap('alerts-map').then(function(mapData) {
        map = mapData;
      });

      baselayerFactory.getDirectory().then(function(directory) {
        var style = directory.styles[0];
        if ( prefFactory.isSaved() ) {
          $q.resolve(prefFactory.getBaselayer()).then(function(data) {
            style = data.baselayer;
          });
        }
        baselayerFactory.buildLayer(style).then(function(data) {
          vm.map.layers.baselayers[directory.styles[0].id] = data;
        });
      });
    }

    function renderMapAlerts(payload, alert) {
      map.invalidateSize();
      var geoJson = angular.fromJson(payload);
      if (!geoJson.mapAlerts.length > 0) {
        vm.map.kill = true;
        map.setView([
          30.30, -97.73
        ], 11);
        delete vm.map.layers.overlays.geojson;
        return;
      }
      vm.map.initialized = false;
      var layers = [];
      var mapAlerts = new L.FeatureGroup();

      for (var i = 0; i < geoJson.mapAlerts.length; i++) {

        for (var j = 0; j < geoJson.mapAlerts[i].geoJSON.features.length; j++) {
          angular.extend(geoJson.mapAlerts[i].geoJSON.features[j].properties, {
            vaiName: geoJson.mapAlerts[i].name,
            vaiMessage: geoJson.mapAlerts[i].message,
            timing: geoJson.mapAlerts[i].timing,
            delay: geoJson.mapAlerts[i].delay,
            crossThreshAt: alert.crossThreshAt
          });
        }

        L.geoJson(geoJson.mapAlerts[i].geoJSON, {
          onEachFeature: function(feature, layer) {
            mapAlerts.addLayer(layer);
          }
        });

        layers.push({
          name: 'alert-' + i,
          data: geoJson.mapAlerts[i].geoJSON,
          type: 'geoJSONShape',
          visible: true,
          layerOptions: {
            onEachFeature: onEachFeature,
            className: (geoJson.mapAlerts[0].geoJSON.features[0].properties.crossThreshAt === null) ? 'pointer-grab-hand' : null,
            style: {
              weight: 2,
              color: "#ffb103",
              opacity: 1,
              fillColor: "#ffe37c",
              fillOpacity: 0.4,
              dashArray: 3
            }
          }
        });
      }

      vm.map.layers.overlays.geojson = {
        name: 'Rule Alerts',
        type: 'group',
        visible: true,
        doRefresh: true,
        legend: {
          icon: 'place'
        },
        layerParams: {
          showOnSelector: false
        },
        layerOptions: {
          layers: layers
        }
      };

      centerJSON(mapAlerts);
      vm.map.initialized = true;

      function onEachFeature(feature, layer) {
        var prop = feature.properties;
        if (prop.crossThreshAt) {
          var time = moment(prop.crossThreshAt).format('HH:mm YYYY/MM/DD');
          var html = '<h4>' + prop.vaiName + '</h4><p>' +
            (prop.vaiMessage ? (prop.vaiMessage + '<br/>') : '') +
            (prop.timing === 'during' ? ('At ' + time) : (prop.delay + ' minutes ' + prop.timing + ' ' + time)) + '</p>';
          layer.bindPopup(html, {className: 'alert-popup'});
        }
      }
    }

    function centerJSON(geoJson) {
      map.fitBounds(geoJson.getBounds());
    }

    function getItemAtIndex(index) {
      if (vm.rangeActive) {
        return;
      }

      if (index + 10 >= (vm.alerts.length - 1) && vm.pivotTime > vm.minStartDate.getTime()) {
        var start = vm.pivotTime - vm.timeSubtract;
        var end = vm.pivotTime;
        fetchMoreAlerts(start, end);
        vm.pivotTime -= vm.timeSubtract;
        vm.startTime = vm.pivotTime;
        return null;
      }

      return vm.alerts[index];
    }

    function getLength() {
      return vm.alerts.length;
    }

    function fetchMoreAlerts(start, end) {
      vm.loading = true;

      var params = {
        start: start,
        end: end,
        filterPriorToStart: true,
        inclusiveStart: false
      };

      alertFeedFactory.retreive(params).then(function(data) {
        addAlerts(data);
        vm.loading = false;
      }, function(error) {
        $log.error(error);
      })
    }

    function addAlerts(data) {
      if (!data.timeline.length) return;

      vm.alerts = vm.alerts.concat(data.timeline);
      vm.alerts = vm.alerts.sort(function(a, b) {
        if (a.notifyTime < b.notifyTime) {
          return 1;
        }
        if (a.notifyTime > b.notifyTime) {
          return -1;
        }
        return 0;
      });

      angular.merge(vm.ruleMap, data.ruleMap);
      return null;
    }

    function lookUpRule(ruleID) {
      return vm.ruleMap[ruleID];
    }

    function clearResults() {
      vm.rangeActive = false;
      resetTime();
      vm.alerts = [];
      fetchMoreAlerts(vm.startTime, vm.endTime);
    }

    function openTimeDialog(ev) {
      $mdDialog.show({
        clickOutsideToClose: true,
        templateUrl: 'app/components/alerts/times.tmpl.html',
        scope: $scope,
        locals: {
          times: vm.times
        },
        preserveScope: true,
        targetEvent: ev,
        controller: alertTimeController
      }).then(function(times) {
        vm.loading = true;
        vm.alerts = [];
        vm.startTime = times.startDate.getTime();
        vm.endTime = times.endDate.getTime();
        sessionStorage.setItem('rp', times.endDate);
        vm.rangeActive = true;
        fetchMoreAlerts(times.startDate.getTime(), times.endDate.getTime());
      });
    }

    function alertTimeController($scope, $mdDialog, times) {
      $scope.times = angular.copy(times);
      $scope.close = $mdDialog.cancel;
      $scope.load = function() {
        $mdDialog.hide($scope.times);
      };
    }

    vm.getStatus = function(alert) {
      if (alert !== null)
        return alertStatusFactory.getThreshStatus(alert);
    };

    vm.getIcon = function(alert) {
      if (alert !== null)
        return alertStatusFactory.getIcon(alert);
    };

    vm.getMessage = function(alert) {
      if (alert !== null)
        return alertStatusFactory.getMessage(alert);
    };

  }

}());

(function() {
  'use strict';

  angular.module('fews').factory('aarFactory', aarFactory);

  /*@ngInject*/
  function aarFactory($log, $q, $http, API_URL) {

    var service = {
      submitRequest: submitRequest,
      requestStatus: requestStatus,
      getReports: getReports,
      deleteReport: deleteReport
    };

    return service;
    /////////

    function submitRequest(start, end, jurisdictions){
      var req = {
        method: 'POST',
        url: API_URL + 'reports',
        params: {
          from: start.toISOString(),
          to: end.toISOString(),
          jurisdictions: jurisdictions
        }
      }

      return $http(req).then(xhrComplete, xhrFailed);
    }

    function getReports(){
      var req = {
        method: 'GET',
        url: API_URL + 'reports'
      }

      return $http(req).then(xhrComplete, xhrFailed);
    }

    function deleteReport(id) {
      var req = {
        method: 'DELETE',
        url: API_URL + 'reports/' + id
      }

      return $http(req).then(xhrComplete, xhrFailed);
    }

    function requestStatus(id){
      var req = {
        method: 'GET',
        url: API_URL + 'reports/' + id
      }

      return $http(req).then(xhrComplete, xhrFailed);
    }

    function xhrComplete(response) {
      return $q.resolve(response.data);
    }

    function xhrFailed(error) {
      $log.error(error);
      return $q.reject(error);
    }

  }

}());

(function() {
  'use strict';

  angular
    .module('fews')
    .controller('AarController', aarController);

  /*@ngInject*/
  function aarController($log, $timeout, $mdMedia, $mdDialog, aarFactory,
    jurisdictionFactory, myInfo) {

    var vm = this,
      statusCheck;

    angular.extend(vm, {
      canEdit: myInfo.permissions.aar.edit,
      $onInit: activate,
      $onDestroy: onDestroy,
      $mdMedia: $mdMedia,
      toggleCheck: toggleCheck,
      exists: exists,
      isAllChecked: isAllChecked,
      toggleAll: toggleAll,
      selectedJurisdictions: [],
      jurisdictions: [],
      updateToDate: updateToDate,
      preventToDate: preventToDate,
      fromMaxDate: new Date(),
      toMaxDate: undefined,
      loading: false,
      percentComplete: 0,
      requestTo: new Date(),
      requestFrom: new Date(),
      minDate: new Date(2015, 4, 1),
      report: report,
      status: undefined,
      requestID: undefined,
      statusInterval: 1500,
      prevReports: [],
      deleteReport: deleteReport,
      prevLoading: true,
      loadingError: false
    });

    ////////////////////

    function activate() {
      vm.requestFrom.setDate(vm.requestFrom.getDate() - 7);
      // clean up the format for the inputs
      vm.requestTo.setMinutes(0, 0, 0);
      vm.requestFrom.setMinutes(0, 0, 0);

      jurisdictionFactory.getJurisdictionOptions().then(function(res){
        vm.jurisdictions = res.jurisdictions;
        vm.toggleAll();
      });

      aarFactory.getReports().then(function(d) {
        vm.prevReports = d;
        vm.prevLoading = false;
        return;
      });
    }

    function report() {
      vm.loading = true;
      vm.loadingError = false;
      var condensedJurisdictions = vm.selectedJurisdictions.toString();

      aarFactory.submitRequest(vm.requestFrom, vm.requestTo, [condensedJurisdictions]).then(function(response) {
        vm.percentComplete = response.percentComplete;
        vm.status = response.statusDetails;
        vm.requestID = response.requestID;

        if (response.percentComplete === 100) {
          vm.loading = false;
          return;
        }

        // check the request status at specified interval
        // cancel timeout when pdf is complete or failure
        function check() {
          aarFactory.requestStatus(response.requestID).then(function(d) {
            if (d.status !== "NOTFOUND") {
              //Quick fix - don't update anything if the status is NOTFOUND, which happens when
              //  the load balancer has spun up multiple COP backend instances - only the one instance
              //  that received our initial submission will know about this report

              if (d.percentComplete < 0) {

                vm.loadingError = true;
                vm.loading = false;
                vm.status = 'There was an error. Please try again.';

                $timeout.cancel(statusCheck);
                return;
              }

              if (d.percentComplete === 100) {
                vm.status = '...';

                aarFactory.getReports().then(function(d) {
                  angular.merge(vm.prevReports, d);
                  vm.loading = false;
                });

                $timeout.cancel(statusCheck);
                return;
              }

              vm.percentComplete = d.percentComplete;
              vm.status = d.statusDetails;
              vm.loadingError = false;
            }

            // recursion to keep checking after a response
            statusCheck = $timeout(check, vm.statusInterval);
          }).catch(function(err) {
            $log.error(err);
            $log.error('There was an error when requesting:' + response.requestID);

            vm.loadingError = true;
            vm.loading = false;
            vm.status = 'There was an error. Please try again.';

            $timeout.cancel(statusCheck);
          });
        }

        check();

      }).catch(function(err) {
        $log.error(err);
        $log.error('There was an error when submitting the request.');

        vm.loadingError = true;
        vm.loading = false;
        vm.status = 'There was an error with the request. Please try again.';
      });

    }

    function deleteReport(id) {
      var confirm = $mdDialog.confirm().title('Warning. Deleting a report cannot be undone. Do you wish to delete this report?').ariaLabel('Delete Report').ok('Delete').cancel('Cancel');

      $mdDialog.show(confirm).then(function() {
        aarFactory.deleteReport(id).then(function() {
          aarFactory.getReports().then(function(d) {
            vm.prevReports = d;
            return;
          });
          return;
        });
      });
    }

    function isAllChecked() {
      return vm.selectedJurisdictions.length === vm.jurisdictions.length;
    }

    function toggleAll() {
      if (vm.selectedJurisdictions.length === vm.jurisdictions.length) {
        vm.selectedJurisdictions = [];
      } else if (vm.selectedJurisdictions.length === 0 || vm.selectedJurisdictions.length > 0) {
        vm.selectedJurisdictions = vm.jurisdictions.slice(0);
      }
    }

    function toggleCheck (item, list) {
      var index = list.indexOf(item);
      if (index > -1) {
        list.splice(index, 1);
      } else {
        list.push(item);
      }
    }

    function exists (item, list) {
      return list.indexOf(item) > -1;
    }

    function updateToDate() {
      vm.toMaxDate = new Date(vm.requestFrom);
      vm.toMaxDate.setDate(vm.toMaxDate.getDate() + 7);
      if (!vm.requestTo) {
        vm.requestTo = new Date();
        vm.requestTo.setMilliseconds(0);
        vm.requestTo.setMinutes(0);
        vm.requestTo.setSeconds(0);
      }
      if (vm.requestTo > vm.toMaxDate || vm.requestTo < vm.requestFrom) {
        vm.requestTo = vm.toMaxDate;
      }
      return;
    }

    function preventToDate() {
      if (vm.requestTo > new Date()) {
        vm.toMaxDate = new Date();
      }
      return;
    }

    function onDestroy() {
      if (statusCheck) {
        $timeout.cancel(statusCheck);
      }
    }

  }

}());

(function() {
    'use strict';

    angular
        .module('fews')
        .controller('LogoutController', LogoutController);

    /*@ngInject*/
    function LogoutController ($state, $auth, notificationFactory, prefFactory) {

        if (!$auth.isAuthenticated()) {
          return;
        }

        $auth.logout()
            .then(function() {
                delete localStorage.username;
                notificationFactory.sendGenericMessage('You have been logged out');
                $state.go('login');

        });

        prefFactory.clearState();

    }

})();

(function() {
  'use strict';

  angular
    .module('fews')
    .controller('MainController', MainController);

  /*@ngInject*/
  function MainController($rootScope, $timeout, $location, $document, $q,
      $mdSidenav, $mdDialog, projectInfo, menuFactory, myInfo) {
    var vm = this;

    angular.extend(vm, {
      openMenu: openMenu,
      closeMenu: closeMenu,
      openPage: openPage,
      focusMainContent: focusMainContent,
      currentPath: currentPath,
      menu: menuFactory,
      isSelected: isSelected,
      isOpen: isOpen,
      toggleOpen: toggleOpen,
      menuIsOpen: false,
      autoFocusContent: false,
      legalInfo: legalInfo,
      myInfo: myInfo
    });

    var mainContentArea = $document[0].querySelector("[role='main']");

    activate();
    ////////////////////////

    function activate() {
      projectInfo.getDetails().then(function(data) {
        vm.projectInfo = data;
      });
    }

    // *********************
    // Internal methods
    // *********************

    function closeMenu() {
      $timeout(function() { $mdSidenav('left').close(); });
    }

    function openMenu() {
      $timeout(function() { $mdSidenav('left').open(); });
    }

    function currentPath() {
      return $location.path();
    }

    function openPage(a, b) {
      if ((b.indexOf('logout') <= 0) && (b.indexOf('login') <= 0)) {
        closeMenu();
      }

      if (vm.autoFocusContent) {
        focusMainContent();
        vm.autoFocusContent = false;
      }
    }

    function focusMainContent() {
      // prevent skip link from redirecting
      // if ($event) { $event.preventDefault(); }

      $timeout(function(){
        mainContentArea.focus();
      },90);

    }

    function isSelected(page) {
      return menuFactory.isPageSelected(page);
    }

    function isOpen(section) {
      return menuFactory.isSectionSelected(section);
    }

    function toggleOpen(section) {
      menuFactory.toggleSelectSection(section);
    }

    function legalInfo(ev) {
      $mdDialog.show({
         targetEvent: ev,
         templateUrl: 'app/main/menu/legal/legal.tmpl.html',
         controller: LegalInfoController,
         controllerAs: 'liVm'
      });

      function LegalInfoController($scope, $mdDialog) {
        var vm = this;
        vm.closeDialog = function() {
          $mdDialog.hide();
        }
        vm.thisYear = new Date().getFullYear();
      }
    }

    var deregistrationCallback = $rootScope.$on('$locationChangeSuccess', openPage);
    $rootScope.$on('$destroy', deregistrationCallback);
  }
})();

/* global moment:false */
(function() {
    'use strict';

    angular
        .module('fews')
        .constant('API_URL', 'https://fews.vieuxinc.com/api/')
})();

(function() {
    'use strict';

    angular
        .module('fews')
        .run(runBlock);

    /*@ngInject*/
    function runBlock ($rootScope, $state) {
        $rootScope.$state = $state;

        //polyfill for IE
        if (!Array.prototype.find) {
            Array.prototype.find = function(predicate) {
                'use strict';
                if (this == null) {
                    throw new TypeError('Array.prototype.find called on null or undefined');
                }
                if (angular.isFunction(predicate)) {
                    throw new TypeError('predicate must be a function');
                }
                var list = Object(this);
                var length = list.length >>> 0;
                var thisArg = arguments[1];
                var value;

                for (var i = 0; i < length; i++) {
                    value = list[i];
                    if (predicate.call(thisArg, value, i, list)) {
                        return value;
                    }
                }

                return undefined;
            };
        }
    }

})();

(function() {
  'use strict';

  angular
    .module('fews')
    .config(routerConfig);

  /*@ngInject*/
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('login', {
        url: '/login',
        title: 'Login',
        templateUrl: 'app/components/login/login.html',
        controller: 'LoginController',
        controllerAs: 'loginVm',
        resolve: {
          skipIfLoggedIn: skipIfLoggedIn
        }
      })
        .state('request', {
          url: '/login/request',
          title: 'Request Reset',
          templateUrl: 'app/components/login/request/request.html',
          controller: 'RequestController',
          controllerAs: 'requestVm',
          resolve: {
            skipIfLoggedIn: skipIfLoggedIn
          }
        })
        .state('reset', {
          url: '/login/reset',
          title: 'Reset Password',
          templateUrl: 'app/components/login/reset/reset.html',
          controller: 'ResetController',
          controllerAs: 'resetVm',
          resolve: {
            skipIfLoggedIn: skipIfLoggedIn
          }
        })
      .state('logout', {
        url: '/logout',
        title: 'Logout',
        controller: 'LogoutController',
        controllerAs: 'logoutVm'
      })
      .state('fews', {
        templateUrl: 'app/main/main.tmpl.html',
        controller: 'MainController',
        controllerAs: 'mainVm',
        abstract: true,
        resolve: {
          myInfo: myInfo
        }
      })
        .state('fews.dashboard', {
          url: '/dashboard',
          title: 'Dashboard',
          template: '<dashboard layout flex></dashboard>',
          resolve: {
            loginRequired: loginRequired
          }
        })
        .state('fews.rules', {
          url: '/rules',
          title: 'Rules Manager',
          controller: 'RulesController',
          controllerAs: 'rulesVm',
          templateUrl: 'app/components/rules/rules.tmpl.html',
          resolve: {
            loginRequired: loginRequired,
            permissionRequired: permissionRequired
          }
        })
        .state('fews.gauges', {
          url: '/gauges',
          title: 'Rain Gauges',
          templateUrl: 'app/components/gauges/gauges.tmpl.html',
          controller: 'GaugeController',
          controllerAs: 'gc',
          resolve: {
            loginRequired: loginRequired,
            permissionRequired: permissionRequired
          }
        })
        .state('fews.alerts', {
          url: '/alerts',
          title: 'Notifications',
          controller: 'AlertsController',
          controllerAs: 'alertsVm',
          templateUrl: 'app/components/alerts/alerts.tmpl.html',
          resolve: { loginRequired: loginRequired,
            permissionRequired: permissionRequired }
        })
        .state('fews.aar', {
          url: '/after-action-reports',
          title: 'After Action Reports',
          controller: 'AarController',
          controllerAs: 'aarVm',
          templateUrl: 'app/components/aar/aar.tmpl.html',
          resolve: { loginRequired: loginRequired,
            permissionRequired: permissionRequired }
        })
        .state('fews.ddf', {
          url: '/ddf',
          title: 'DDF',
          template: '<ddf-list layout flex></ddf-list>',
          resolve: {
            loginRequired: loginRequired,
            permissionRequired: permissionRequired
          }
        })
        .state('fews.preferences', {
          url: '/preferences',
          title: 'Preferences',
          template: '<preferences layout flex></preferences>',
          resolve: {
            loginRequired: loginRequired
          }
        })
        .state('fews.usermanager', {
          url: '/user-manager',
          title: 'Groups & Users',
          template: '<user-manager layout flex></user-manager>',
          resolve: {
            loginRequired: loginRequired
          }
        })
        .state('fews.watchpoints', {
          url: '/watchpoints',
          title: 'WatchPoints',
          template: '<watchpoints-page layout flex></watchpoints-page>',
          resolve: {
            loginRequired: loginRequired,
            permissionRequired: permissionRequired
          }
      });

    $urlRouterProvider.otherwise('/login');

    function myInfo(userFactory) { 
      return userFactory.getMe().then(function(res) {
        return res.data;
      });
    }

    function skipIfLoggedIn($q, $location, $auth) {
      var defer = $q.defer();
      if (localStorage.storageType) $auth.setStorageType(localStorage.storageType);
      if ($auth.isAuthenticated()) {
        $location.path('/dashboard');
      } else {
        defer.resolve();
      }
      return defer.promise;
    }

    function loginRequired($q, $location, $auth) {
      var defer = $q.defer();
      if (localStorage.storageType) {
        $auth.setStorageType(localStorage.storageType);
      }

      if ($auth.isAuthenticated()) {
        defer.resolve();
      } else {
        $location.path('/login');
      }
      return defer.promise;
    }

    function permissionRequired($q, $location, userFactory) {
      return userFactory.getMe().then(function(res) {
        var defer = $q.defer();
        var path = $location.path();
        var perm = res.data.permissions;
        var isAllowed = true;
        switch(path) {
          case '/rules':
            isAllowed = perm.rules.view;
            break;
          case '/alerts':
            isAllowed = perm.notifications.view;
            break;
          case '/gauges':
            isAllowed = perm.rain_gauges;
            break;
          case '/after-action-reports':
            isAllowed = perm.aar.view;
            break;
          case '/ddf':
            isAllowed = perm.ddf;
            break;
          case '/watchpoints':
            isAllowed = perm.watchpoints;
            break;
        }

        if(isAllowed)
          defer.resolve();
        else
          $location.path('/dashboard');

        return defer.promise;
      });
    }

    // // Strips "Authorization" in GET request headers from specified URLs
    // $httpProvider.interceptors.push(function() {
    //   return {
    //     'request': function(config) {
    //       if(config.url.startsWith('//311.austintexas.gov')) {
    //         // config.headers['X-App-Token'] = '12befdff45eceb38b6cb03d96031cf7c';
    //         delete config.headers.Authorization;
    //       }
    //       return config;
    //     }
    //   };
    // });
  }

})();

/* global moment:false */
(function() {
    'use strict';

    angular
        .module('fews')
        .constant('moment', moment)
        .constant('VDS_URL', 'vieux-data-services/austin/')
        .constant('MAPBOX_TOKEN', 'pk.eyJ1IjoiamVhbnZpZXV4IiwiYSI6Iksxc0Z3dTAifQ.enIr_jXRCpLAfZQa8rmdjA')
        .constant('ESRI102739','+proj=lcc +lat_1=30.11666666666667 +lat_2=31.88333333333333 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=700000 +y_0=3000000 +datum=NAD83 +units=us-ft +no_defs')
        .constant('angularMomentConfig', {timezone: 'America/Chicago'})
        .constant('DATE_FORMAT', 'YYYY/MM/DD HH:mm');
})();

(function() {
    'use strict';

    angular
        .module('fews')
        .config(config);

    /*@ngInject*/
    function config($httpProvider, $logProvider, $mdGestureProvider, $mdThemingProvider, $authProvider, API_URL) {
        // Enable log
        $logProvider.debugEnabled(true);

        // fixes leaflet zoom buttons not working on mobile
        $mdGestureProvider.skipClickHijack();

        // Set theme options
        $mdThemingProvider.theme('form-dark', 'default')
            .primaryPalette('amber')
            .backgroundPalette('indigo')
            .dark();

        $mdThemingProvider.theme('default')
            .primaryPalette('indigo')
            .accentPalette('amber');

        // Set up authentication
        $authProvider.loginUrl = API_URL + 'login';

        // Configire MomentJS
        moment.updateLocale('en', {
            calendar : {
              sameDay: 'HH:mm',
              lastDay: '[Yesterday at] HH:mm',
              lastWeek: '[Last] dddd [at] HH:mm',
              sameElse: 'DD/MM/YYYY'
            },
            relativeTime : {
              mm: function (number) {return number + ' min';},
              h:  "1 hr",
              hh: function (number) {return number + ' hr';},
              d:  "24 hr",
              dd: function (number) {return number + ' days';}
            }
        });
    }

})();

angular.module("fews").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.tmpl.html","<md-sidenav id=main-menu class=\"md-sidenav-left md-whiteframe-z2 main-menu\" layout=column md-component-id=left md-is-open=mainVm.menuIsOpen><md-toolbar layout layout-align=\"center center\" class=nav-title ng-click=mainVm.closeMenu()><div>fews<span>cop</span></div></md-toolbar><md-content layout-padding hide-gt-xs><md-button ng-click=mainVm.closeMenu() class=md-primary>Close Sidenav</md-button></md-content><md-content role=navigation flex layout=column><ul class=main-menu flex=noshrink><li ng-repeat=\"section in mainVm.menu.sections\" class=\"parent-list-item {{section.className || \'\'}}\" ng-class=\"{\'parentActive\' : isSectionSelected(section)}\"><h2 class=\"menu-heading md-subhead\" ng-if=\"section.type === \'heading\'\" id=\"heading_{{ section.name | nospace }}\">{{section.name}}</h2><menu-link section=section ng-if=\"section.type === \'link\' && !section.hidden\" permissions=mainVm.myInfo.permissions></menu-link><menu-toggle section=section ng-if=\"section.type === \'toggle\' && !section.hidden\"></menu-toggle><ul ng-if=section.children class=menu-nested-list><li ng-repeat=\"child in section.children\" ng-class=\"{\'childActive\' : isSectionSelected(child)}\"><menu-link section=child ng-if=\"child.type === \'link\'\"></menu-link><menu-toggle section=child ng-if=\"child.type === \'toggle\'\"></menu-toggle></li></ul></li></ul><div class=nav-foot><a href=# ng-click=mainVm.legalInfo($event)>Disclaimer &amp; Licensing</a></div></md-content></md-sidenav><md-content layout=column role=main flex><md-toolbar class=\"md-whiteframe-z1 site-content-toolbar\" ng-hide=\"$state.current.name === \'fews.dashboard\'\"><div class=md-toolbar-tools><md-button class=md-icon-button ng-click=mainVm.openMenu() aria-label=Navigation><md-icon>menu</md-icon></md-button><h2>{{$state.current.title}}</h2><span flex></span><app-menu></app-menu></div></md-toolbar><ui-view flex layout></ui-view></md-content>");
$templateCache.put("app/main/app-menu/app-menu.tmpl.html","<md-menu md-offset=\"0 60\"><md-button class=md-icon-button aria-label=\"Account Info\" ng-click=$mdMenu.open($event)><md-icon>settings_applications</md-icon></md-button><md-menu-content width=4 class=app-menu><md-menu-item><md-button md-autofocus ui-sref=fews.preferences><md-icon>settings</md-icon>Preferences</md-button></md-menu-item><md-menu-item ng-click=appMenuVm.openResources($event)><md-button aria-label=\"Open Resources List\"><md-icon>list</md-icon>AFD Flood Maps</md-button></md-menu-item><md-menu-item><md-button ng-href=/help/index.html><md-icon>help</md-icon>FEWS Help</md-button></md-menu-item><md-menu-item><md-button ui-sref=logout><md-icon>exit_to_app</md-icon><div class=sign-out-text layout=column layout-align=\"center start\" flex><span>Sign Out</span><div class=name ng-bind=::appMenuVm.name></div></div></md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("app/main/menu/menu-link.tmpl.html","<md-button class=\"v-theme main-menu\" ng-class=\"{\'active\' : linkVm.isSelected()}\" ui-sref={{linkVm.section.state}} ng-click=linkVm.focusSection() ng-disabled=linkVm.isDisabled(linkVm.section.state)><md-icon>{{linkVm.section.icon}}</md-icon>{{linkVm.section | humanizeDoc}}</md-button>");
$templateCache.put("app/main/menu/menu-toggle.tmpl.html","<md-button class=md-button-toggle ng-click=toggle() aria-controls=\"docs-menu-{{section.name | nospace}}\" aria-expanded={{isOpen()}}><div flex layout=row>{{section.name}} <span flex></span> <span aria-hidden=true class=md-toggle-icon ng-class=\"{\'toggled\' : isOpen()}\"><md-icon md-svg-icon=md-toggle-arrow></md-icon></span></div><span class=md-visually-hidden>Toggle {{isOpen()? \'expanded\' : \'collapsed\'}}</span></md-button><ul id=\"docs-menu-{{section.name | nospace}}\" class=menu-toggle-list><li ng-repeat=\"page in section.pages\"><menu-link section=page></menu-link></li></ul>");
$templateCache.put("app/components/aar/aar.tmpl.html","<div class=reports layout=column><md-content layout-padding><md-card ng-if=aarVm.canEdit flex=100 flex-gt-sm=40 layout-padding><form name=aarForm><!-- <p class=\"spacing-fix\">Please choose a start and end date to generate a new report. Currently, a seven day period is the maximum allowed duration for a report.</p> --><div flex><md-input-container class=\"spacing-fix top\"><label>From:</label><md-icon>event</md-icon><input type=datetime-local name=requestFromField ng-disabled=aarVm.loading ng-model=aarVm.requestFrom ng-min=aarVm.minDate ng-max=aarVm.fromMaxDate ng-change=aarVm.updateToDate() required><div ng-messages=aarForm.requestFromField.$error><div ng-message=valid>The entered value is not a time!</div><div ng-message=required>This time is required!</div><div ng-message=min>Time is too early!</div><div ng-message=max>Time is too late!</div></div></md-input-container></div><div flex><md-input-container class=\"spacing-fix bottom\"><label>To:</label><md-icon>event</md-icon><input type=datetime-local name=requestToField ng-disabled=aarVm.loading ng-model=aarVm.requestTo ng-min=aarVm.requestFrom ng-max=aarVm.toMaxDate ng-change=aarVm.preventToDate() required><div ng-messages=aarForm.requestToField.$error><div ng-message=valid>The entered value is not a time!</div><div ng-message=required>This time is required!</div><div ng-message=min>Time is too early!</div><div ng-message=max>Time is too late!</div></div></md-input-container></div><div class=filter><md-button class=\"filter__expand-btn md-secondary\" ng-click=\"showJurisdictions = !showJurisdictions\">Filter Road Closures<md-icon ng-show=showJurisdictions>keyboard_arrow_up</md-icon><md-icon ng-show=!showJurisdictions>keyboard_arrow_down</md-icon></md-button><div flex=100 flex-gt-sm=100 layout=column><div ng-show=showJurisdictions><fieldset class=filter__fieldset><legend>&nbsp;<md-checkbox aria-label=\"Select All\" class=filter__select-all ng-checked=aarVm.isAllChecked() ng-click=aarVm.toggleAll()>Select All Jurisdictions</md-checkbox>&nbsp;</legend><div layout=row layout-wrap flex><div flex=25 ng-repeat=\"jurisdiction in aarVm.jurisdictions\"><md-checkbox ng-checked=\"aarVm.exists(jurisdiction, aarVm.selectedJurisdictions)\" ng-click=\"aarVm.toggleCheck(jurisdiction, aarVm.selectedJurisdictions)\">{{ jurisdiction.toUpperCase() }}</md-checkbox></div></div></fieldset></div></div></div><div flex><md-button ng-disabled=\"aarVm.loading || !aarForm.$valid\" class=\"md-raised md-primary\" ng-click=aarVm.report() aria-label=\"Generate new report\"><span>Generate New Report</span></md-button></div></form></md-card><span class=md-subhead>Previous Reports</span><md-card flex=100 flex-gt-sm=40><md-card-content><div flex layout layout-align=\"center center\" ng-show=aarVm.prevLoading><md-progress-circular md-mode=indeterminate md-diameter=40></md-progress-circular></div><md-list class=md-dense flex ng-class=\"{\'xs\' : aarVm.$mdMedia(\'xs\')}\"><md-list-item class=md-2-line ng-if=\"aarVm.loading || aarVm.loadingError\"><md-icon class=pdf-icon ng-if=\"aarVm.percentComplete == 100\">done</md-icon><div class=md-list-item-text><h3>{{aarVm.requestFrom | date:\'MM/dd/yyyy HH:mm\'}} — {{aarVm.requestTo | date:\'MM/dd/yyyy HH:mm\'}}</h3><p>{{aarVm.status}}</p><md-progress-linear ng-if=!aarvm.loadingError md-mode=determinate value={{aarVm.percentComplete}}></md-progress-linear><p class=error ng-if=aarvm.loadingError>There was an error on the request.</p></div><md-divider md-inset></md-divider></md-list-item><md-list-item ng-class=\"report.linkToFile ? \'md-3-line\' : \'md-2-line\'\" ng-repeat=\"report in aarVm.prevReports | orderBy:\'lastModified\':true\"><md-icon class=\"md-avatar-icon pdf-icon\">picture_as_pdf</md-icon><div class=md-list-item-text ng-if=report.linkToFile><h3>{{report.reportFrom | date:\'MM/dd/yyyy HH:mm\'}} — {{report.reportTo | date:\'MM/dd/yyyy HH:mm\'}}</h3><h4>Created by: {{report.createdBy}} on {{report.lastModified | date:\'MM/dd/yyyy HH:mm\'}}</h4><p>File size: {{report.fileSize}}</p></div><div class=md-list-item-text ng-if=!report.linkToFile><h3>{{report.reportFrom | date:\'MM/dd/yyyy HH:mm\'}} — {{report.reportTo | date:\'MM/dd/yyyy HH:mm\'}}</h3><h4>File being created...</h4></div><md-button download ng-href={{report.linkToFile}} class=\"md-icon-button md-secondary\"><md-icon>file_download</md-icon><md-tooltip>Download</md-tooltip></md-button><md-button ng-href={{report.linkToFile}} target=_blank class=\"md-icon-button md-secondary\"><md-icon>open_in_new</md-icon><md-tooltip>Open in New Window</md-tooltip></md-button><md-button ng-if=aarVm.canEdit ng-click=aarVm.deleteReport(report.reportID) class=\"md-icon-button md-secondary\"><md-icon>delete</md-icon><md-tooltip>Delete Report</md-tooltip></md-button><md-divider md-inset ng-hide=$last></md-divider></md-list-item></md-list></md-card-content></md-card></md-content></div>");
$templateCache.put("app/components/alerts/alerts.tmpl.html","<div class=alerts-page layout=column layout-align=\"start stretch\" flex><div flex layout layout-align=\"center center\" ng-show=alertsVm.loading><md-progress-circular md-mode=indeterminate md-diameter=40></md-progress-circular></div><md-content ng-hide=alertsVm.loading flex layout=column><md-table-container class=alerts-table><table md-table><thead md-head><tr md-row><th class=ten md-column>Status</th><th class=thirty md-column>Title</th><th class=twenty md-column>Description</th><th class=twenty md-column>Data Type</th><th class=twenty md-column>Notification Time</th></tr></thead></table></md-table-container><div class=height-correction><md-virtual-repeat-container ng-hide=alertsVm.rangeActive><div class=cell-row md-virtual-repeat=\"alert in alertsVm\" md-on-demand ng-click=alertsVm.showDetail(alert)><div class=\"cell ten first\"><ack-component type=icon alert-item=alert></ack-component><md-icon class=md-avatar-icon ng-class=alertsVm.getStatus(alert)>{{ alertsVm.getIcon(alert) }}</md-icon><md-tooltip>{{ alertsVm.getMessage(alert) }}</md-tooltip></div><div class=\"cell thirty\">{{alertsVm.ruleMap[alert.ruleID].title}}</div><div class=\"cell twenty\">{{alertsVm.ruleMap[alert.ruleID].description}}</div><div class=\"cell twenty\">{{alertsVm.dataTypeMap[alert.dataType].displayName}}</div><div class=\"cell twenty\"><span am-time-ago=alert.notifyTime><md-tooltip md-direction=top md-delay=1000>{{alert.notifyTime | date:\'MM/dd/yyyy HH:mm\'}}</md-tooltip></span></div></div></md-virtual-repeat-container><div ng-show=alertsVm.rangeActive class=overflow><div class=cell-row ng-repeat=\"alert in alertsVm.alerts\" ng-click=alertsVm.showDetail(alert)><div class=\"cell ten first\"><ack-component type=icon alert-item=alert></ack-component><md-icon class=md-avatar-icon ng-class=alertsVm.getStatus(alert)>{{ alertsVm.getIcon(alert) }}</md-icon><md-tooltip>{{ alertsVm.getMessage(alert) }}</md-tooltip></div><div class=\"cell thirty\">{{alertsVm.ruleMap[alert.ruleID].title}}</div><div class=\"cell twenty\">{{alertsVm.ruleMap[alert.ruleID].description}}</div><div class=\"cell twenty\">{{alertsVm.dataTypeMap[alert.dataType].displayName}}</div><div class=\"cell twenty\"><span am-time-ago=alert.notifyTime><md-tooltip md-direction=top md-delay=1000>{{alert.notifyTime | date:\'MM/dd/yyyy HH:mm\'}}</md-tooltip></span></div></div></div></div></md-content><md-toolbar class=controls><div class=md-toolbar-tools><div flex><p>Showing {{alertsVm.alerts.length}} alerts from <span class=time-ago>{{alertsVm.startTime | amDateFormat:\'YYYY/MM/DD HH:mm\'}}</span> to <span>{{alertsVm.endTime | amDateFormat:\'YYYY/MM/DD HH:mm\'}}</span>.</p></div><md-button ng-if=alertsVm.rangeActive ng-click=alertsVm.clearResults() class=md-icon-button aria-label=\"Clear Time Range\"><md-icon>restore</md-icon><md-tooltip md-delay=300 md-direction=top>Clear Search Results</md-tooltip></md-button><md-button ng-click=alertsVm.openTimeDialog($event) class=md-icon-button aria-label=\"Time Range\"><md-icon>date_range</md-icon><md-tooltip md-delay=300 md-direction=top>Search by Date Range</md-tooltip></md-button></div></md-toolbar></div><ng-include src=\"\'app/components/alerts/details.tmpl.html\'\"></ng-include>");
$templateCache.put("app/components/alerts/details.tmpl.html","<md-sidenav layout=column class=\"md-sidenav-right md-whiteframe-4dp alert-detail\" ng-class=\"{\'gt-md\': alertsVm.$mdMedia(\'gt-sm\'), \'xs\' : alertsVm.$mdMedia(\'xs\')}\" md-component-id=alertDetails><md-toolbar layout=row><div class=md-toolbar-tools><h4 flex>{{alertsVm.selected.rule.title | limitTo : 96}}{{alertsVm.selected.rule.title.length > 96 ? \'...\' : \'\'}}</h4><md-button class=md-icon-button md-no-ink ng-click=alertsVm.hideDetail()><md-icon>close</md-icon></md-button></div></md-toolbar><div md-scroll-y layout=column flex=noshrink><leaflet ng-hide=alertsVm.map.kill id=alerts-map defaults=alertsVm.map.defaults layers=alertsVm.map.layers height=200px width=100%><div class=loading ng-show=!alertsVm.map.initialized><md-progress-circular md-mode=indeterminate md-diameter=40></md-progress-circular></div></leaflet><div flex layout layout-align=\"center center\" ng-show=alertsVm.selected.loading><md-progress-circular md-mode=indeterminate md-diameter=40></md-progress-circular></div><div ng-hide=alertsVm.selected.loading md-scroll-y layout=column flex=noshrink><div class=section-head>Hydrograph</div><md-content flex layout-padding class=hydrograph-content><img ng-src={{alertsVm.selected.imageUrl}}></md-content><div class=section-head>{{alertsVm.selected.rule.description}}</div><md-content flex layout-padding><p class=line-height-fix>{{alertsVm.selected.rule.source.displayName}} ({{alertsVm.selected.rule.source.id}})<br>Notification Time: {{alertsVm.selected.notifyTime | amDateFormat:\'YYYY/MM/DD HH:mm\'}}<br><span ng-if=alertsVm.selected.crossThreshAt>Threshold Crossing Time: {{alertsVm.selected.crossThreshAt | amDateFormat:\'YYYY/MM/DD HH:mm\'}}</span> Basin: {{alertsVm.basinsMap[alertsVm.selected.rule.source.basin].description}}<br>Threshold: {{alertsVm.selected.rule.source.threshold}}{{alertsVm.dataTypeMap[alertsVm.selected.rule.source.inputs[0]].units}}</p></md-content><div class=section-head>Rule Input Data Types</div><md-content flex layout-padding><md-list><md-list-item ng-repeat=\"item in alertsVm.selected.rule.source.inputs\"><div class=md-list-item-text layout=row>{{alertsVm.dataTypeMap[item].displayName}} &nbsp;<strong ng-if=\"alertsVm.selected.dataType === alertsVm.dataTypeMap[item].name\">- Alert Trigger</strong></div></md-list-item></md-list></md-content><ack-component alert-item=alertsVm.selected flex></ack-component></div><div class=bottom flex></div></div></md-sidenav>");
$templateCache.put("app/components/alerts/times.tmpl.html","<md-dialog class=alerts-times-container aria-label=\"Alerts Time Range Picker\"><form name=alertsForm layout=column flex-gt-xs><md-dialog-content class=md-dialog-content><div class=md-dialog-content-body><div class=times layout><md-input-container><label>Start Time</label><md-icon>event</md-icon><input type=datetime-local name=startTimeField ng-model=times.startDate ng-min=times.minDate ng-max=\"times.endDate || times.maxDate\" required><div ng-messages=alertsForm.startTimeField.$error><div ng-message=valid>The entered value is not a time!</div><div ng-message=required>This time is required!</div><div ng-message=min>Time is too early!</div><div ng-message=max>Time is too late!</div></div><!-- <md-datepicker ng-model=\"times.startDate\" md-placeholder=\"Start Time\"\r\n              md-min-date=\"times.minDate\" md-max-date=\"times.endDate || times.maxDate\"></md-datepicker> --></md-input-container></div><div class=times layout><md-input-container><label>End Time</label><md-icon>event</md-icon><input type=datetime-local name=endTimeField ng-model=times.endDate ng-min=times.startDate ng-max=times.maxDate required><div ng-messages=alertsForm.endTimeField.$error><div ng-message=valid>The entered value is not a time!</div><div ng-message=required>This time is required!</div><div ng-message=min>Time is too early!</div><div ng-message=max>Time is too late!</div></div><!-- <md-datepicker ng-model=\"times.endDate\" md-placeholder=\"End Time\"\r\n              md-min-date=\"times.startDate\" md-max-date=\"times.maxDate\"></md-datepicker> --></md-input-container></div></div></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=close() md-autofocus class=md-primary>Cancel</md-button><md-button type=submit ng-click=load() ng-disabled=\"(alertsForm.$pristine || !alertsForm.$valid)\" md-autofocus class=md-primary>Load</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dashboard/dashboard.tmpl.html","<dashmap flex layout ng-class=\"dashVm.replay.isActive() ? \'replay\' : \'\'\"></dashmap>");
$templateCache.put("app/components/gauges/gauges.tmpl.html","<md-content id=gauges flex layout=column><div flex layout=column layout-align=\"center center\" ng-show=!gc.initialized><md-progress-circular md-mode=indeterminate md-diameter=30 ng-if=!gc.getDetailsFail></md-progress-circular><div ng-if=gc.getDetailsFail>No Gauges Available</div></div><!-- Mobile Only --><section hide-gt-xs class=main-list ng-if=gc.initialized><md-list class=gauge-list ng-show=!hideDetails><md-list-item class=md-2-line md-no-ink ng-repeat-start=\"gauge in gc.gauges\" ng-click=\"gc.showGauge($event, gc.gauges, $index)\"><md-icon class=\"material-icons status1\" ng-if=\"gauge.status === 1\">done</md-icon><md-icon class=\"material-icons status2\" ng-if=\"gauge.status === 2\">warning</md-icon><md-icon class=\"material-icons status3\" ng-if=\"gauge.status === 3\">error</md-icon><md-icon class=\"material-icons status0\" ng-if=\"gauge.status > 3 || gauge.status < 1 || !gauge.status\">help</md-icon><div class=md-list-item-text><div class=text-top layout=row layout-align=\"center center\"><h3>{{gauge.name || \'n/a\' | limitTo:35}}<span ng-show=\"gauge.name.length > 35\">...</span></h3><div flex></div><span am-time-ago=gauge.timeRaw title=\"{{ gauge.timeRaw | amTimezone:\'America/Chicago\' | amDateFormat: \'dddd, MMMM Do YYYY, h:mm a\' }}\"></span></div><p>{{gauge.vaiId || \'n/a\'}} | {{gauge.clientId || \'n/a\'}}</p></div></md-list-item><md-divider md-inset ng-if=!$last ng-repeat-end></md-divider></md-list><md-divider></md-divider></section><!-- / Mobile Only --><section hide-xs class=main-table ng-if=gc.initialized><md-subheader class=md-no-sticky><div layout layout-align=\"start center\" flex=noshrink class=last-updated><div class=updated-text layout layout-align=\"start center\"><strong>Last Updated: </strong>{{gc.query.lastUpdated | amTimezone:v2.timezone | amDateFormat: \'YYYY-MM-DD HH:mm\'}}</div><div class=progress-container><md-progress-circular md-mode=indeterminate md-diameter=40 ng-show=gc.query.loadingLastUpdated></md-progress-circular></div></div></md-subheader><md-table-container><table md-table md-progress=promise><thead md-head md-order=gc.query.order><tr md-row><th md-column md-order-by=name><span>Name</span></th><th md-column md-order-by=grouping><span>Basin</span></th><th md-column md-order-by=feedType><span>Feed</span></th><th md-column md-desc md-numeric md-order-by=sums[0].sum>1 Hour</th><th md-column md-desc md-numeric md-order-by=sums[1].sum>6 Hours</th><th md-column md-desc md-numeric md-order-by=sums[2].sum>24 Hours</th><th md-column md-desc md-numeric md-order-by=sums[3].sum>48 Hours</th><th md-column md-desc md-numeric md-order-by=sums[4].sum>72 Hours</th></tr></thead><tbody md-body><tr md-row ng-click=\"gc.showGauge($event, orderedGauges, $index)\" ng-repeat=\"gauge in orderedGauges = (gc.gauges | orderBy: gc.query.order)\" ng-class=\"{1:\'status-1\', 2:\'status-2\', 3:\'status-3\'}[gauge.status]\"><td md-cell>{{gauge.name}}</td><td md-cell>{{gauge.grouping}}</td><td md-cell>{{gauge.feedType}}</td><td md-cell ng-repeat=\"sum in gauge.sums\">{{ sum.sum &lt; 0 ? \'n/a\' : (sum.sum | number : 2) }}</td></tr></tbody></table></md-table-container></section></md-content>");
$templateCache.put("app/components/preferences/pref.tmpl.html","<div id=preferences layout=column flex ng-class=\"{ \'small\' : pc.$mdMedia(\'xs\') }\"><md-content layout-padding><form name=prefForm><span class=md-subhead>General</span><md-card flex=100 flex-gt-sm=50><md-card-content><md-list><md-list-item ng-repeat=\"field in pc.preferences.general\"><md-icon class=material-icons ng-if=field.icon>{{field.icon}}</md-icon><p>{{field.name}}</p><div ng-switch on=field.type><div ng-switch-when=switch><md-switch md-secondary ng-model=field.value></md-switch></div><div ng-switch-when=select><md-select ng-model=field.value md-no-underline aria-label={{field.name}} md-container-class=zfix><md-option ng-repeat=\"option in field.options\" ng-value=option.value>{{option.label}}</md-option></md-select></div><div ng-switch-when=slider><md-slider-container flex><md-slider flex min={{field.options.min}} max={{field.options.max}} ng-model=field.value aria-label={{field.name}}></md-slider></md-slider-container></div><div ng-switch-when=input><md-input-container class=md-block><input ng-model=field.value placeholder={{field.options.placeholder}}></md-input-container></div><div ng-switch-when=radio><md-radio-group ng-model=field.value layout=row><md-radio-button ng-repeat=\"option in field.options\" ng-value=option.value class=md-primary aria-label={{option.name}}>{{option.label}}</md-radio-button></md-radio-group></div><div ng-switch-default><p>There was an error.</p></div></div><md-divider ng-if=!$last></md-divider></md-list-item></md-list></md-card-content></md-card><span class=md-subhead>Dashboard</span><md-card flex=100 flex-gt-sm=50><md-card-content><div ng-repeat=\"overlay in pc.preferences.dashboard\" class=pref-row><div flex layout=row layout-align=\"start center\" class=pref-row--header><md-icon ng-if=\"overlay.legend.icon !== \'svg\'\">{{overlay.legend.icon}}</md-icon><md-icon md-svg-src={{overlay.legend.iconUrl}} class=s24 ng-if=\"overlay.legend.icon === \'svg\'\"></md-icon><h4 flex>{{overlay.name}}</h4></div><md-checkbox ng-model=overlay.legend.visible ng-change=\"overlay.visible=overlay.legend.visible\" aria-label=\"{{overlay.name}} visibility\" flex>Show {{overlay.name}} when initially loaded.</md-checkbox><div ng-if=overlay.legend.settings.params layout=row><div ng-repeat=\"param in overlay.legend.settings.params\"><md-switch ng-if=\"param.type === \'switch\'\" ng-model=param.value aria-label={{param.display}}>{{param.display}}</md-switch></div></div><div ng-if=overlay.legend.settings.layers><p>Default layer setting:</p><md-radio-group ng-model=overlay.legend.settings.activeLayers><md-radio-button ng-repeat=\"layer in overlay.legend.settings.layers\" ng-value=layer.value class=md-primary>{{layer.label}}</md-radio-button></md-radio-group></div><div ng-if=overlay.legend.settings.opacity layout=row><p flex=30>Default layer opacity:</p><md-slider-container flex><md-slider md-discrete min=0 max=1 step=0.05 flex ng-model=overlay.legend.settings.opacityValue aria-label=\"{{overlay.name}} opacity\"></md-slider></md-slider-container></div></div></md-card-content></md-card></form></md-content><md-toolbar><div ng-hide=pc.loading class=md-toolbar-tools layout=row layout-align=\"start center\"><md-button aria-label=\"Restore Defaults\" ng-click=pc.cancelPreferences()>Cancel &amp; Exit</md-button><md-button aria-label=\"Restore Defaults\" ng-click=pc.restoreDefault()>Default</md-button><md-button aria-label=\"Restore Defaults\" ng-click=pc.savePreferences()>Save &amp; Exit</md-button></div><div ng-show=pc.loading class=md-toolbar-tools layout=row layout-align=\"start center\">Loading...</div></md-toolbar></div>");
$templateCache.put("app/components/ddf/ddf.tmpl.html","<div layout=column flex><div flex layout layout-align=\"center center\" ng-show=ddfVm.loading><md-progress-circular md-mode=indeterminate md-diameter=40></md-progress-circular></div><md-content id=ddf-list ng-hide=ddfVm.loading flex=nogrow><md-list><md-list-item ng-repeat=\"id in ddfVm.list.ids\" ng-click=ddfVm.showDetails(id)><div class=ddf-bar><div class=\"outer-color md-whiteframe-1dp\" ng-style=id.style layout layout-align=\"center center\"><div class=spacer flex></div><div class=inner-color ng-style=\"{\'width\': 100 - (id.percentToNextThreat || id.percentToNextFrequency) + \'%\'}\"></div></div><div class=text layout flex><div class=name flex>{{id.displayId}}</div><div class=percent>{{ id.percentToNextThreat || id.percentToNextFrequency | truncateNum }}%</div></div></div></md-list-item></md-list></md-content><md-toolbar class=controls><div class=md-toolbar-tools><span ng-show=ddfVm.loading flex>Loading...</span><div class=info ng-hide=ddfVm.loading layout=column layout-align=\"center start\" flex><md-select ng-model=ddfVm.activeTab class=md-no-underline aria-label=Tables><md-option ng-repeat=\"tab in ddfVm.tables\" ng-value=$index>{{tab.title}}</md-option></md-select><span>{{ddfVm.times.startDate | date:\'yyyy/MM/dd HH:mm\'}} - <span ng-if=!ddfVm.times.isSameDay()>{{ddfVm.times.endDate | date:\'yyyy/MM/dd\'}}</span> {{ddfVm.times.endDate | date:\'HH:mm\'}} <span ng-if=ddfVm.list.label>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{{ddfVm.list.label}} Duration</span> <span ng-if=\"!ddfVm.list.label && ddfVm.list.duration\">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{{ddfVm.list.duration | amDurationFormat : \'milliseconds\'}} Duration</span></span></div><md-button ng-click=ddfVm.openTimeDialog($event) ng-disabled=ddfVm.loading class=md-icon-button aria-label=\"Time Range\"><md-icon>date_range</md-icon><md-tooltip md-direction=top>Time Range</md-tooltip></md-button><md-menu><md-button ng-click=$mdMenu.open($event) ng-disabled=\"ddfVm.loading || ddfVm.durations.length < 2\" class=md-icon-button aria-label=Durations><md-icon>timer</md-icon><md-tooltip md-direction=top>Durations</md-tooltip></md-button><md-menu-content><md-menu-item ng-repeat=\"dur in ddfVm.durations\"><md-button ng-click=ddfVm.loadList(dur)><md-icon>{{ dur.selected ? \'check_box\' : \'check_box_outline_blank\' }}</md-icon><span ng-if=dur.label>{{dur.label}}</span> <span ng-if=!dur.label>{{dur.duration | amDurationFormat : \'milliseconds\'}}</span></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar></div><ng-include src=\"\'app/components/ddf/details.tmpl.html\'\"></ng-include>");
$templateCache.put("app/components/ddf/details.tmpl.html","<md-sidenav class=\"md-sidenav-right md-whiteframe-4dp ddf-details\" ng-class=\"{\'gt-md\': ddfVm.$mdMedia(\'gt-sm\')}\" md-component-id=ddfDetails layout=column><md-toolbar layout=row><div class=md-toolbar-tools><h4 flex>{{ddfVm.selected.item.displayId}}</h4><md-button class=md-icon-button md-no-ink ng-click=ddfVm.hideDetails()><md-icon>close</md-icon></md-button></div></md-toolbar><md-content md-scroll-y layout=column flex=noshrink><leaflet id=ddf-map layers=ddfVm.map.layers defaults=ddfVm.map.defaults bounds=ddfVm.map.bounds geojson=ddfVm.map.geoJson height=180px width=100%><div class=loading ng-show=!ddfVm.map.initialized><md-progress-circular md-mode=indeterminate md-diameter=40></md-progress-circular></div></leaflet><div layout=column layout-align=\"center center\" ng-show=!ddfVm.selected.item.initialized flex><md-progress-circular md-mode=indeterminate md-diameter=40></md-progress-circular></div><div ng-show=ddfVm.selected.item.initialized md-scroll-y layout=column flex=noshrink><div class=\"general md-padding\" layout=column><md-whiteframe class=\"cat-info md-whiteframe-2dp\"><div class=\"ddf-bar clickable\" ng-click=\"hideDescription = !hideDescription\"><div class=outer-color layout=row layout-align=\"center center\" ng-class=\"{\'closed\':hideDescription}\" ng-style=ddfVm.selected.item.style><div class=spacer flex></div><div class=inner-color ng-style=\"{\'width\': 100 - (ddfVm.selected.item.durations[ddfVm.selected.durationIndex].percentNextThreat || ddfVm.selected.item.durations[ddfVm.selected.durationIndex].percentNextFrequency) + \'%\'}\"></div></div><div class=text layout=row layout-align=\"space-between center\"><div class=name flex><md-icon ng-if=\"ddfVm.tables[ddfVm.activeTab].legend.categories[\'cat\' + (ddfVm.selected.item.durations[ddfVm.selected.durationIndex].threatId || ddfVm.selected.item.durations[ddfVm.selected.durationIndex].frequencyId)].description\">{{hideDescription? \'arrow_drop_up\' : \'arrow_drop_down\'}}</md-icon>{{ ddfVm.selected.item.categorizationLabel }}:<!-- Auburndale Dam special case --> {{ ddfVm.selected.item.displayId === \'Auburndale Dam\' ? ddfVm.getCategoryLabel() : ddfVm.selected.item.category.label }}</div><div class=percent>{{ddfVm.selected.item.durations[ddfVm.selected.durationIndex].percentNextThreat || ddfVm.selected.item.durations[ddfVm.selected.durationIndex].percentNextFrequency | truncateNum}}% to next</div></div></div><div ng-show=\"!hideDescription && ddfVm.tables[ddfVm.activeTab].legend.categories[\'cat\' + (ddfVm.selected.item.durations[ddfVm.selected.durationIndex].threatId || ddfVm.selected.item.durations[ddfVm.selected.durationIndex].frequencyId)].description\"><md-divider></md-divider><p ng-bind-html=\"ddfVm.tables[ddfVm.activeTab].legend.categories[\'cat\' + (ddfVm.selected.item.durations[ddfVm.selected.durationIndex].threatId || ddfVm.selected.item.durations[ddfVm.selected.durationIndex].frequencyId)].description\"></p></div></md-whiteframe><div class=info layout layout-align=\"space-between start\"><div class=details layout=column flex=50 flex-xs=75><div layout><span>from:</span><div flex></div><div class=time>{{ddfVm.selected.item.durations[ddfVm.selected.durationIndex].startOfRainfall | amDateFormat:\'YYYY/MM/DD HH:mm\'}}</div></div><div layout><span>to:</span><div flex></div><div class=time>{{ddfVm.selected.item.durations[ddfVm.selected.durationIndex].endOfRainfall | amDateFormat:\'YYYY/MM/DD HH:mm\'}}</div></div><div layout><span>Rainfall:</span><div flex></div><div>{{ddfVm.selected.item.durations[ddfVm.selected.durationIndex].rainfall}} in</div></div><div ng-if=\"ddfVm.selected.duration.label === \'Any\'\" layout><span>Duration:</span><div flex></div><div>{{ddfVm.selected.item.durations[ddfVm.selected.durationIndex].lengthMS | amDurationFormat : \'milliseconds\'}}</div></div></div><div flex></div><div class=durations><p class=title>Duration:</p><md-menu ng-if=\"ddfVm.selected.item.durations.length > 1\"><md-button class=md-raised ng-click=$mdMenu.open($event)><span ng-if=ddfVm.selected.item.durations[ddfVm.selected.durationIndex].label>{{ddfVm.selected.duration.label}}</span> <span ng-if=\"! ddfVm.selected.item.durations[ddfVm.selected.durationIndex].label\">{{ddfVm.selected.item.durations[ddfVm.selected.durationIndex].lengthMS | amDurationFormat : \'milliseconds\'}}</span><md-icon>arrow_drop_down</md-icon></md-button><md-menu-content><md-menu-item ng-repeat=\"duration in ddfVm.durations\"><md-button ng-click=ddfVm.loadDuration($index) aria-label=\"Load Duration\"><p ng-if=duration.label>{{duration.label}}</p><p ng-if=\"! duration.label\">{{duration.duration | amDurationFormat : \'milliseconds\'}}</p></md-button></md-menu-item></md-menu-content></md-menu><p ng-if=\"ddfVm.selected.item.durations.length < 2\">{{ddfVm.selected.item.duration | amDurationFormat : \'milliseconds\'}}</p></div></div></div><md-list class=interval-table><md-divider></md-divider><md-list-item class=\"md-1-line header\"><div class=md-list-item-text layout=row><div>{{ddfVm.selected.item.tableLabel}}</div><div flex></div><div>Depth (in)</div><div class=threat-color-spacer></div></div></md-list-item><md-divider></md-divider><md-list-item class=md-1-line ng-repeat=\"row in ddfVm.selected.item.durations[ddfVm.selected.durationIndex].categories\" ng-show=\"row.depth > 0\"><div class=md-list-item-text layout=row layout-align=\"start center\"><div>{{row.description}}</div><div flex></div><span ng-if=row.extentKML ng-click=\"ddfVm.showMapExtent($event, row, ddfVm.tables[ddfVm.activeTab].legend.categories[\'cat\' + (row.threatId || row.frequencyId)].color)\"><md-icon hide show-gt-sm>map</md-icon>Web Map</span> <a ng-if=\"row.extentKML && !ddfVm.$mdMedia(\'xs\')\" ng-href={{ddfVm.API_URL}}ddf/maps/floodplain/{{row.extentKML}}><md-icon hide show-gt-sm>file_download</md-icon>KMZ</a> <span>{{row.depth}}</span><div class=\"threat-color md-whiteframe-1dp\" ng-style=\"{\'background-color\': ddfVm.tables[ddfVm.activeTab].legend.categories[\'cat\' + (row.threatId || row.frequencyId)].color}\"></div></div><md-divider ng-if=!$last></md-divider></md-list-item></md-list></div><div class=bottom flex></div></md-content></md-sidenav>");
$templateCache.put("app/components/ddf/mapExtent.tmpl.html","<md-dialog class=ddf-geojson><md-dialog-content flex layout=column><md-toolbar><div class=md-toolbar-tools><h2>{{category.description}}</h2><span flex></span><md-button class=md-icon-button ng-click=cancel()><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><leaflet id=extent layers=layers geojson=geojson defaults=defaults flex layout-fill><div class=loading><md-progress-circular ng-show=loading md-mode=indeterminate></md-progress-circular></div></leaflet></md-dialog-content></md-dialog>");
$templateCache.put("app/components/ddf/times.tmpl.html","<md-dialog class=ddf-times-container aria-label=\"DDF Time Range Picker\"><form name=ddfForm layout=column flex-gt-xs><md-dialog-content class=md-dialog-content><div class=md-dialog-content-body><div class=times layout><md-input-container><label>Start Time</label><md-icon>event</md-icon><input md-autofocus type=datetime-local name=startTimeField ng-model=times.startDate ng-min=times.minDate ng-max=\"times.endDate || times.maxDate\" required><div ng-messages=ddfForm.startTimeField.$error><div ng-message=valid>The entered value is not a time!</div><div ng-message=required>This time is required!</div><div ng-message=min>Time is too early!</div><div ng-message=max>Time is too late!</div></div></md-input-container></div><div class=times layout><md-input-container><label>End Time</label><md-icon>event</md-icon><input type=datetime-local name=endTimeField ng-model=times.endDate ng-min=\"times.startDate || times.minDate\" ng-max=times.maxDate required><div ng-messages=ddfForm.endTimeField.$error><div ng-message=valid>The entered value is not a time!</div><div ng-message=required>This time is required!</div><div ng-message=min>Time is too early!</div><div ng-message=max>Time is too late!</div></div></md-input-container></div></div></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button ng-click=close() class=md-primary>Cancel</md-button><md-button type=submit ng-click=load() ng-disabled=\"(ddfForm.$pristine || !ddfForm.$valid)\" class=md-primary>Load</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/login/login.html","<div class=login layout layout-fill><span class=line></span><md-content class=half-bg layout=row layout-align=\"center center\" layout-fill><div class=float-container layout layout-align=\"center center\" flex=75 flex-gt-xs=40 flex-gt-sm=30 flex-gt-md=20 flex-gt-lg=15><md-card flex><div class=md-card-image layout layout-align=\"center center\" flex=none><img src=/assets/images/logo-fews.svg class=logo alt=\"vieux fews logo\"></div><div class=error ng-show=loginVm.error>{{loginVm.error}}</div><form name=loginForm novalidate><md-card-content layout=column><md-input-container><label>Username</label><input name=username ng-model=loginVm.user.username type=text autofocus required><div ng-messages=loginForm.username.$error><div ng-message=required>A username is required.</div></div></md-input-container><md-input-container><label>Password</label><input name=password ng-model=loginVm.user.password type=password id=password required><div ng-messages=loginForm.password.$error><div ng-message=required>A password is required.</div></div></md-input-container></md-card-content><md-card-actions layout=column layout-align=\"center center\"><md-button ng-click=loginVm.submit() class=\"md-raised md-primary login-btn\" type=submit ng-disabled=loginForm.$invalid>Login</md-button></md-card-actions><div class=additional layout layout-align=\"space-between center\"><md-checkbox ng-model=loginVm.remember ng-change=loginVm.setStorageType()>Stay signed in</md-checkbox><a ui-sref=request>Forgot password?</a></div></form></md-card></div></md-content></div>");
$templateCache.put("app/components/rules/rules.tmpl.html","<div class=rules-page layout layout-fill><div class=hover-button ng-if=rulesVm.canEdit layout><div flex layout layout-align=\"end center\"><md-button class=\"md-fab new_rule\" aria-label=\"Create New Rule\" ng-click=rulesVm.loadDetails() ng-disabled=\"rulesVm.ruleChanged || !ruleForm.$pristine\"><md-icon>add_alert</md-icon></md-button></div><div ng-show=rulesVm.openSidenav flex=40 flex-lg=30 flex-xl=20></div></div><md-content class=rules-list-container flex layout=column><div class=rules-filter flex=noshrink layout><md-input-container flex><label>Filter Rules by {{rulesVm.tableQuery.selectedOption.label}}</label><md-icon>filter_list</md-icon><input name=filterText class=md-no-underline type=text ng-model=rulesVm.tableQuery.inputText aria-label=\"Filter Text\"></md-input-container><md-input-container><label>Filter By</label><md-select class=md-no-underline ng-model=rulesVm.tableQuery.selectedOption ng-model-options=\"{trackBy: \'$value.value\'}\" aria-label=\"Filter Type\"><md-option ng-repeat=\"option in rulesVm.tableQuery.type\" ng-value=option value={{option.value}}>{{option.label}}</md-option></md-select></md-input-container><div hide-xs layout=column layout-align=\"center center\" class=showing><div>showing</div>{{filterResults.length + \' of \' + rulesVm.rules.length}}</div></div><md-table-container class=rules-list><table md-table><thead md-head md-order=rulesVm.tableQuery.order><tr md-row><th md-column md-order-by=active>Active</th><th md-column hide-gt-md>Rule Title, Threshold, & Location</th><th md-column hide-xs hide-sm hide-md show-gt-md md-order-by=title>Rule Title</th><th md-column hide-xs hide-sm show-gt-sm md-order-by=source.basin>Basin</th><th md-column hide-xs hide-sm hide-md show-gt-md md-order-by=source.displayName>Location</th><th md-column hide-xs hide-sm hide-md show-gt-md md-order-by=source.inputDisplayName>Input Data</th><th md-column hide-xs hide-sm hide-md show-gt-md>Threshold (unit)</th><th md-column hide-xs hide-sm hide-md show-gt-md md-order-by=payload.mapAlerts.length>Map Alert(s)</th></tr></thead><tbody md-body><tr md-row ng-repeat=\"rule in rulesVm.rules | orderBy: rulesVm.tableQuery.order | limitTo: rulesVm.tableQuery.pagination.limit: (rulesVm.tableQuery.pagination.page -1) * rulesVm.tableQuery.pagination.limit | filter:rulesVm.getFilterObj() as filterResults\" ng-click=rulesVm.loadDetails(rule) ng-class=\"{\'selected\' : rulesVm.selected.rule.id === rule.id}\"><!-- rule.active --><td md-cell><md-icon class=md-avatar-icon ng-class=\"{\'md-primary\':rule.active}\"><md-tooltip>{{rule.active ? \'active\' : \'inactive\'}}</md-tooltip>{{rule.active ? \'notifications\' : \'notifications_none\'}}</md-icon></td><td md-cell hide-gt-md><strong>{{rule.title}}</strong><br><strong>{{rule.source.threshold + \' \' + rule.source.unit}}</strong> | {{rule.source.displayName}} ({{rule.source.id}})</td><td md-cell hide-xs hide-sm hide-md show-gt-md>{{rule.title}}</td><td md-cell hide-xs hide-sm show-gt-sm>{{rule.source.basinDisplayName}}</td><td md-cell hide-xs hide-sm hide-md show-gt-md>{{rule.source.displayName}} ({{rule.source.id}})</td><td md-cell hide-xs hide-sm hide-md show-gt-md>{{rule.source.inputDisplayName}}</td><td md-cell hide-xs hide-sm hide-md show-gt-md>{{rule.source.threshold + \' (\' + rule.source.unit + \')\'}}</td><td md-cell hide-xs hide-sm hide-md show-gt-md>{{rule.payload.mapAlerts.length}}</td></tr></tbody></table><md-table-pagination ng-if=\"rulesVm.rules.length > rulesVm.tableQuery.pagination.limit\" md-limit=rulesVm.tableQuery.pagination.limit md-page=rulesVm.tableQuery.pagination.page md-total={{rulesVm.rules.length}}></md-table-pagination></md-table-container></md-content></div><md-sidenav class=\"rule-detail md-sidenav-right\" ng-class=\"{\'gt-md\': rulesVm.$mdMedia(\'gt-sm\')}\" md-component-id=details layout=column layout-align=\"space-between none\"><form name=ruleForm class=\"md-inline-form rule-form\" layout=column><md-content md-theme=form-dark class=rule-header layout=column><div class=close-btn layout><div flex></div><md-button class=md-icon-button ng-click=rulesVm.closeDetails()><md-icon>close</md-icon></md-button></div><md-input-container class=\"md-block rule-title\"><label>Title</label><input ng-disabled=!rulesVm.canEdit ng-model=rulesVm.selected.rule.title md-select-on-focus required></md-input-container><md-input-container class=md-block><label>Description</label><textarea ng-disabled=!rulesVm.canEdit ng-model=rulesVm.selected.rule.description></textarea></md-input-container></md-content><md-content class=rule-body layout=column flex><div layout-gt-sm=row layout-wrap><h2>Data Source</h2><p flex=100>{{rulesVm.selected.location.displayName}} {{rulesVm.selected.location.id}}</p><md-input-container flex=100 class=mobile-block><label>Input Data Type(s)</label><md-select ng-disabled=!rulesVm.canEdit name=inputData ng-model=rulesVm.selected.rule.source.inputs ng-disabled=\"rulesVm.selected.location === null\" md-on-close=rulesVm.getSelectedUnit() multiple required><md-option ng-repeat=\"input in rulesVm.selected.location.inputs\" ng-disabled=\"rulesVm.openSidenav && rulesVm.disableDataType(input)\" ng-value=input>{{rulesVm.dataTypeMap[input].displayName}}</md-option></md-select><div class=errors ng-messages=ruleForm.inputData.$error><div ng-message=required>Required</div></div></md-input-container><md-input-container flex=50 class=mobile-block><label>Threshold <span ng-show=\"rulesVm.selected.rule.source.inputs.length > 0\">({{rulesVm.selected.rule.source.unit}})</span></label><input ng-disabled=!rulesVm.canEdit ng-model=rulesVm.selected.rule.source.threshold ng-disabled=\"rulesVm.selected.rule.source.inputs.length < 1\" required></md-input-container></div><md-content class=\"md-whiteframe-1dp rule-alerts\" layout=column><div class=alert-header layout layout-align=\"space-between center\"><h2>Map Alerts</h2><md-button ng-if=rulesVm.canEdit ng-click=\"rulesVm.openAlert(null, $event)\"><md-icon>add_location</md-icon>New Alert</md-button></div><md-divider md-inset></md-divider><div class=alert-list><div class=\"alert-list-item empty\" ng-hide=rulesVm.selected.rule.payload.mapAlerts.length layout layout-align=\"center center\">No Alerts</div><div class=alert-list-item ng-repeat=\"alert in rulesVm.selected.rule.payload.mapAlerts\" layout layout-align=\"start center\"><md-icon><md-tooltip>{{ { \'custom\':\'Custom Location(s)\', \'lwc\':\'Road Closure\' } [alert.alertType] }}</md-tooltip>{{ { \'custom\':\'pin_drop\', \'lwc\':\'not_interested\' } [alert.alertType] }}</md-icon><div class=details flex>{{alert.name}} <span>{{ { \'during\': \'instant\', \'before\': alert.delay + \' minutes before\', \'after\': alert.delay + \' minutes after\' } [alert.timing] }}</span></div><div class=md-secondary layout><md-button ng-disabled=!rulesVm.canEdit class=md-icon-button ng-click=\"rulesVm.openAlert(alert, $event)\"><md-icon>edit</md-icon><md-tooltip md-delay=500>edit</md-tooltip></md-button><md-button ng-disabled=!rulesVm.canEdit class=md-icon-button ng-click=rulesVm.deleteAlert(alert)><md-icon>delete</md-icon><md-tooltip md-delay=500>delete</md-tooltip></md-button></div></div></div></md-content></md-content></form><div ng-if=rulesVm.canEdit class=command-bar layout=row layout-align=\"space-between center\" ng-class=\"{\'xs\': rulesVm.$mdMedia(\'xs\')}\"><md-button ng-click=rulesVm.toggleActive()><md-icon class=md-avatar-icon ng-class=\"{\'md-primary\':rule.active}\"><md-tooltip md-delay=500 md-direction=top>{{rulesVm.selected.rule.active ? \'Deactivate\' : \'Activate\'}}</md-tooltip>{{rulesVm.selected.rule.active ? \'notifications\' : \'notifications_none\'}}</md-icon></md-button><md-button ng-disabled=rulesVm.buttonDisabled(rulesVm.selected.rule) ng-click=rulesVm.duplicateRule()><md-icon>content_copy</md-icon><md-tooltip md-delay=500 md-direction=top>Duplicate Rule</md-tooltip></md-button><md-button ng-disabled=rulesVm.buttonDisabled(rulesVm.selected.rule) ng-click=rulesVm.confirmDelete($event)><md-icon>delete</md-icon><md-tooltip md-delay=500 md-direction=top>Delete Rule</md-tooltip></md-button><md-button class=\"md-raised md-primary\" ng-disabled=rulesVm.saveDisabled(ruleForm) ng-click=rulesVm.saveRule() type=submit><md-icon>save</md-icon><md-tooltip md-delay=500 md-direction=top>Save</md-tooltip></md-button></div></md-sidenav>");
$templateCache.put("app/components/user-manager/group-dialog-container.tmpl.html","<md-dialog aria-label=\"group details dialog\"><md-dialog-content flex><div class=md-dialog-content><group-details group=selectedGroup></group-details></div></md-dialog-content><md-dialog-actions><md-divider></md-divider><md-button ng-click=closeDialog() class=md-primary>Close Dialog</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/user-manager/user-manager.tmpl.html","<div flex ng-if=umVm.model.loading layout layout-align=\"center center\"><md-progress-circular></md-progress-circular></div><div class=group-container layout=column layout-align=\"start stretch\" ng-if=!umVm.model.loading flex flex-sm=40 flex-md=30 flex-lg=20 flex-xl=15><md-content ng-if=!umVm.model.loading><md-list><md-list-item class=md-2-line ng-class=umVm.groupListClass(group) ng-repeat=\"group in umVm.model.groups | filter:umVm.groupFilter\" ng-click=\"umVm.selectGroup(group, $event)\"><md-icon>group</md-icon><div class=md-list-item-text><h3>{{group.displayName}}</h3><p>{{umVm.factory.roleCount(group.members, true)}} Admin{{umVm.factory.roleCount(group.members, true) === 1 ? \'\' : \'s\'}} | {{umVm.factory.roleCount(group.members, false)}} User{{umVm.factory.roleCount(group.members, false) === 1 ? \'\' : \'s\'}}</p></div></md-list-item><md-list-item ng-if=umVm.addingGroup class=adding-group><md-progress-circular md-diameter=24></md-progress-circular><p>Adding {{umVm.addingGroup}} Group</p></md-list-item></md-list><div class=no-groups ng-if=\"umVm.model.groups.length === 0\"><h3>Add a group to get started!</h3></div></md-content><div ng-if=\"umVm.me.role === \'Proj_Admin\'\" class=add-group><div ng-hide=\"umVm.$mdMedia(\'gt-xs\')\" class=fab-container><md-button class=\"md-fab md-secondary\" ng-click=umVm.addGroup($event) ng-disabled=umVm.model.loading><md-icon>add</md-icon></md-button></div><div ng-show=\"umVm.$mdMedia(\'gt-xs\')\" layout=column class=raised-btn-container><md-divider></md-divider><md-button class=\"md-raised md-primary\" ng-click=umVm.addGroup($event) ng-disabled=umVm.model.loading><md-icon>add</md-icon>Add Group<md-icon class=transparent>add</md-icon></md-button></div></div></div><md-content ng-if=\"!umVm.model.loading && umVm.$mdMedia(\'gt-xs\')\" class=right-container flex flex-sm=60 flex-md=50 flex-lg=40 flex-xl=30><md-card><md-card-content><group-details group=umVm.model.selectedGroup delete-user=umVm.deleteUser(user)></group-details></md-card-content></md-card></md-content>");
$templateCache.put("app/components/watchpoints/details.tmpl.html","<md-sidenav class=\"md-sidenav-right md-whiteframe-z2 watchpoint-details\" ng-class=\"{\'small\':wc.$mdMedia(\'max-width: 800px\')}\" md-component-id=wpDetails layout=column flex><md-toolbar layout=row><div class=md-toolbar-tools><h4 flex>{{wc.selected.displayName}}</h4><md-button class=md-icon-button md-no-ink ng-click=wc.closeDetails()><md-icon>close</md-icon></md-button></div></md-toolbar><md-content flex><div class=header layout layout-align=\"space-between center\"><div class=title><p><span>{{wc.selected.id}}</span><span>{{wc.basins[wc.selected.basin].description}}</span>{{wc.selected.owner}}</p></div><div class=secondary-elements layout layout-align=\"center center\"><md-button class=md-icon-button download ng-href=\"{{wc.selected.endpoint.url}}.png?{{wc.selected.endpoint.static}}&style=COMPLICATED&height=720&width=1280&download=true\"><md-icon>file_download</md-icon><md-tooltip md-direction=left>download chart</md-tooltip></md-button></div></div><div id=wp-chart class=md-whiteframe-1dp layout layout-align=\"center center\"><md-progress-circular ng-if=wc.selectedloading md-mode=indeterminate></md-progress-circular><div ng-hide=wc.selectedloading id=c3Hydro flex></div></div><div class=point-table-container><md-list class=point-table><md-list-item class=md-1-line><div class=md-list-item-text><span>Status:</span> {{wc.selected.status|readable}}<md-divider></md-divider></div></md-list-item><md-list-item class=md-2-line ng-repeat=\"item in wc.selected.maximums\"><div class=md-list-item-text><h3>{{item.displayName}}: {{item.max}} {{item.units}}</h3></div><div class=md-secondary><span>Time of Max:</span> {{item.timeOfMax | date:\'HH:mm\'}}<md-tooltip>{{item.timeOfMax | date:\'MM/dd/yyyy HH:mm\'}}</md-tooltip></div><md-divider ng-hide=$last></md-divider></md-list-item></md-list></div></md-content></md-sidenav>");
$templateCache.put("app/components/watchpoints/swp.tmpl.html","<div class=wp-container id=get-width ng-class=\"{1:\'alert a-1\', 2:\'alert a-2\', 3:\'alert a-3\', 4:\'alert a-4\', 5:\'alert a-5\'}[swp.point.sortStatus]\"><div class=wp-title layout=row layout-align=\"space-between center\"><div class=name flex>{{swp.point.displayName}}</div></div><div class=wp-button layout=row><md-button md-no-ink aria-label={{swp.point.displayName}}><img src=assets/images/loading_icon.gif err-src=/assets/images/error_icon.png ng-src=\"{{swp.endpoint.url}}.png?&style=STANDARD&{{swp.endpoint.static}}&width={{swp.imageWidth}}&height=200&r={{swp.cacheBust}}&accesstoken={{swp.accesstoken}}\" alt=\"Watchpoint Hydrograph\"></md-button></div></div>");
$templateCache.put("app/components/watchpoints/watchpoints.tmpl.html","<section id=watchpoints-page flex layout-fill layout><div flex layout=column layout-fill layout-align=\"center center\" ng-if=!wc.init><md-progress-circular md-mode=indeterminate md-diameter=40></md-progress-circular></div><div flex layout layout-fill layout-align=\"center center\" ng-if=wc.error><div class=error>{{wc.error.message}}</div></div><md-content class=xs-sm ng-show=wc.init ng-if=\"::!wc.$mdMedia(\'gt-sm\')\" flex><div class=search-box layout=row layout-align=\"space-between center\"><input placeholder=\"Search WatchPoints\" ng-model=wc.query flex><md-icon>search</md-icon></div><md-divider></md-divider><section layout=column class=group ng-repeat=\"(key, value) in wc.wpsByBasins | orderByObject:\'streamOrder\':false\"><div class=wp-header layout=row ng-click=\"hideDetails = ! hideDetails\" ng-show=!wc.query><h3>{{value.name}} ({{value.wps.length}})</h3><span flex></span><md-icon>{{hideDetails?\'expand_less\':\'expand_more\'}}</md-icon></div><div class=wp-list ng-show=!hideDetails><single-watchpoint ng-repeat=\"wp in value.wps | filter:wc.query | orderBy:\'streamOrderWithinBasin\'\" point=wp ng-click=wc.openDetails(wp)></single-watchpoint></div><md-divider ng-show=!wc.query></md-divider></section></md-content><md-content class=gt-sm ng-show=wc.init ng-if=\"::wc.$mdMedia(\'gt-sm\')\" flex layout=row layout-wrap><section class=basin ng-repeat=\"(key, value) in wc.wpsByBasins | orderByObject:\'streamOrder\':false\"><h3>{{value.name}} ({{value.wps.length}})</h3><md-button class=\"md-whiteframe-1dp wp-image wp-alert\" ng-class=\"\'a-\'+point.sortStatus\" ng-repeat=\"point in value.wps | orderByObject:\'streamOrderWithinBasin\':false\" ng-click=wc.openDetails(point) aria-label=\"Open Details for {{point.name}}\"><img ng-src={{wc.thumbsUrl}} err-src=assets/images/error_icon.png ng-style=\"{ \'margin-top\': (-135 * point.spriteOrder) + \'px\' }\"><div class=name layout layout-align=\"start center\"><span flex>{{point.displayName}}</span></div></md-button></section></md-content></section><ng-include src=\"\'app/components/watchpoints/details.tmpl.html\'\"></ng-include>");
$templateCache.put("app/main/app-menu/resources/resources.tmpl.html","<div layout=column layout-fill class=resources><md-toolbar layout=row layout-align=\"end center\"><md-button class=md-icon-button aria-label=\"Close additional links.\" ng-click=vm.close()><md-icon>clear</md-icon></md-button></md-toolbar><md-list flex><md-list-item class=md-2-line ng-repeat=\"item in vm.list\"><md-icon class=md-avatar-icon>picture_as_pdf</md-icon><div class=md-list-item-text><h3>{{item.name}}</h3><p>{{item.group}}</p></div><md-button download={{item.name}}.pdf ng-href={{item.url}} class=\"md-icon-button md-secondary\" ng-if=\"!vm.$mdMedia(\'xs\')\"><md-icon>file_download</md-icon><md-tooltip>download</md-tooltip></md-button><md-button ng-href={{item.url}} target=_blank class=\"md-icon-button md-secondary\"><md-icon>open_in_new</md-icon><md-tooltip>open in new window</md-tooltip></md-button></md-list-item></md-list></div>");
$templateCache.put("app/main/menu/legal/legal.tmpl.html","<md-dialog id=legal-dialog aria-label=\"Legal Information\" flex=90 flex-sm=50 flex-md=40 flex-lg=30 flex-xl=20><md-dialog-content><div class=disclaimer md-padding><h4>Disclaimer</h4><p>Vieux &amp; Associates\' products and services include the integration and complex processing of data from multiple sources.</p><p>Vieux &amp; Associates, Inc. does not control these sources and cost constraints do not permit the implementation of all conceivable protections and redundancies.</p><p>For these reasons Vieux &amp; Associates, Inc., while always striving to meet or exceed the highest professional standards, cannot guarantee the absolute accuracy, accessibility, or timeliness of the information provided.</p></div><div class=licensing md-padding><h4>Licensing</h4><p>This application uses several different third party software libraries (each a “Third Party Library”). Each Third Party Library is licensed pursuant to its own separate terms and may only be redistributed under these terms. A link to the license for each Third Party Library is provided below. Source code for applicable Third Party Libraries may be downloaded from the URLs provided; should any of these URLs no longer provide source code, contact Vieux & Associates, Inc. directly to be provided with source code.</p><md-list role=list><md-list-item role=listitem class=md-no-proxy><div class=\"md-list-item-text layout-column\" layout=column><a href=https://www.mapbox.com/about/maps/ target=_blank>Mapbox</a><p>Copyright ©</p></div></md-list-item><md-list-item role=listitem class=md-no-proxy><div class=\"md-list-item-text layout-column\" layout=column><a href=http://www.openstreetmap.org/copyright target=_blank>OpenStreetMap</a><p>Copyright ©</p></div></md-list-item><md-list-item role=listitem class=md-no-proxy><div class=\"md-list-item-text layout-column\" layout=column><a href=http://angularjs.org target=_blank>AngularJS</a><p>Copyright © 2010-{{liVm.thisYear}} Google, Inc.</p></div></md-list-item><md-list-item role=listitem class=md-no-proxy><div class=\"md-list-item-text layout-column\" layout=column><a href=https://github.com/angular/material target=_blank>angular material</a><p>Copyright © 2014-{{liVm.thisYear}} Google, Inc.</p></div></md-list-item><md-list-item role=listitem class=md-no-proxy><div class=\"md-list-item-text layout-column\" layout=column><a href=http://github.com/urish/angular-moment target=_blank>angular moment</a><p>Copyright © 2013-{{liVm.thisYear}} Uri Shaked and contributors</p></div></md-list-item><md-list-item role=listitem class=md-no-proxy><div class=\"md-list-item-text layout-column\" layout=column><a href=https://github.com/angular-ui/ui-router target=_blank>UI Router</a><p>Copyright © 2013-{{liVm.thisYear}} The AngularUI Team, Karsten Sperling</p></div></md-list-item><md-list-item role=listitem class=md-no-proxy><div class=\"md-list-item-text layout-column\" layout=column><a href=https://github.com/masayuki0812/c3 target=_blank>c3js</a><p>Copyright © 2013 Masayuki Tanaka</p></div></md-list-item><md-list-item role=listitem class=md-no-proxy><div class=\"md-list-item-text layout-column\" layout=column><a href=https://github.com/mbostock/d3 target=_blank>d3js</a><p>Copyright © 2010-{{liVm.thisYear}}, Michael Bostock</p></div></md-list-item><md-list-item role=listitem class=md-no-proxy><div class=\"md-list-item-text layout-column\" layout=column><a href=https://github.com/Leaflet/Leaflet target=_blank>leaflet</a><p>Copyright © 2010-{{liVm.thisYear}}, Vladimir Agafonkin</p></div></md-list-item><md-list-item role=listitem class=md-no-proxy><div class=\"md-list-item-text layout-column\" layout=column><a href=https://github.com/Leaflet/Leaflet.markercluster target=_blank>Leaflet Markercluster</a><p>Copyright © 2012 David Leaver</p></div></md-list-item><md-list-item role=listitem class=md-no-proxy><div class=\"md-list-item-text layout-column\" layout=column><a href=https://github.com/angular-ui/ui-leaflet target=_blank>UI Leaflet</a><p>Copyright ©</p></div></md-list-item></md-list></div></md-dialog-content><md-dialog-actions><md-button ng-click=liVm.closeDialog() class=md-primary>Close Dialog</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/alerts/ack-component/ack.tmpl.html","<div class=status-wrapper ng-class=\" ackVm.alertItem.isAck ? \'hasAck\' : \'\' \"><h3>Status: {{ ackVm.alertItem.isAck ? ackVm.recentStatus.status : \'NOT ACKNOWLEDGED\' }}</h3><div class=status-content flex layout layout-align=\"center center\" ng-show=\"ackVm.loading && !ackVm.error\"><md-progress-circular md-diameter=40></md-progress-circular></div><div class=status-content flex layout layout-align=\"start center\" ng-show=\"!ackVm.loading && !ackVm.error\"><md-icon>{{ackVm.alertItem.isAck ? \'check\' : \'close\'}}</md-icon><div layout=column flex><div class=status-info><p><span class=label>User:</span> {{ackVm.recentStatus.user}}</p><p><span class=label>Time:</span> {{ackVm.recentStatus.time | date:\'yyyy/MM/dd HH:mm\'}}</p><p ng-show=\"ackVm.recentStatus.comments !== null && ackVm.recentStatus.comments !== undefined\"><span class=label>Comments:</span> {{ackVm.recentStatus.comments}}</p></div><div class=status-actions><md-button ng-click=ackVm.setAck($event) ng-disabled=!ackVm.canEdit class=md-raised>Acknowledge</md-button></div></div></div><div class=status-content flex layout layout-align=\"start center\" ng-show=ackVm.error><p>{{ackVm.error}}</p></div></div>");
$templateCache.put("app/components/alerts/ack-component/ackIcon.tmpl.html","<div class=ack-icon-wrapper ng-show=ackVm.alertItem.isAck><md-icon class=\"md-whiteframe-1dp md-avatar-icon\">done</md-icon></div>");
$templateCache.put("app/components/dashboard/dashpanel/dashpanel.tmpl.html","<md-tabs md-border-bottom md-stretch-tabs=always flex><md-tab label=layers><md-tab-content class=layer-menu layout=column md-on-select=\"dpanelVm.onTabSelected(\'layers\')\"><status errors=dpanelVm.errors check-time=dpanelVm.checkTime check-duration=dpanelVm.checkDuration ng-if=!dpanelVm.replayActive></status><md-list class=md-dense><md-list-item class=\"md-2-line layer-item\" ng-repeat-start=\"overlay in dpanelVm.overlays | obj2Array | orderBy:\'layerParams.zIndex\':true\" ng-show=overlay.legend.visible ng-class=\"overlay.visible ? \'\' : \'disabled\'\"><div class=layer-loading ng-if=overlay.legend.loading><md-progress-circular md-diameter=24></md-progress-circular></div><md-button class=\"md-icon-button visibility-btn\" ng-click=dpanelVm.iconClick(overlay) ng-show=!overlay.legend.loading aria-label=\"hide/show layer\"><md-icon class=layer-icon ng-if=\"overlay.legend.icon !== \'svg\'\">{{overlay.legend.icon}}</md-icon><md-icon class=\"layer-icon s24\" md-svg-src={{overlay.legend.iconUrl}} ng-if=\"overlay.legend.icon === \'svg\'\"></md-icon><md-icon class=visi-icon>{{overlay.legend.hide ? \'check_box_outline_blank\' : \'check_box\'}}</md-icon></md-button><div class=md-list-item-text><h3>{{ overlay.name }} {{overlay.legend.markerCount > 0 ? \'(\' + overlay.legend.markerCount + \')\' : \'\'}}</h3><p><span ng-if=\"overlay.id !== \'gauges\' && overlay.id !== \'garr\'\" ng-bind=dpanelVm.getLegendMessage(overlay)><md-tooltip ng-if=dpanelVm.displayDataTime(overlay) ng-bind=dpanelVm.getLegendTooltip(overlay)></md-tooltip></span><span ng-if=\"overlay.id === \'gauges\' || overlay.id === \'garr\'\">{{ overlay.legend.settings.activeLayers > 24 ? ((overlay.legend.settings.activeLayers / 24) + \' day \') : (overlay.legend.settings.activeLayers + \' hr\') }} duration ending <span am-time-ago=dpanelVm.displayDataTime(overlay)></span><md-tooltip ng-bind=dpanelVm.getLegendTooltip(overlay)></md-tooltip></span></p></div><div class=md-secondary layout layout-align=\"end center\"><md-menu ng-if=dpanelVm.needsMarkerList(overlay) md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdMenu.open($event) ng-disabled=!overlay.visible><md-icon>list</md-icon></md-button><md-menu-content><md-menu-item ng-repeat=\"marker in dpanelVm.lfmarkers[overlay.id]\"><md-button ng-click=dpanelVm.centerMarker(marker)>{{marker.name}}</md-button></md-menu-item></md-menu-content></md-menu><md-menu ng-if=overlay.inundationLayer md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdMenu.open($event) ng-disabled=!overlay.visible><md-icon>access_time</md-icon></md-button><md-menu-content><md-menu-item class=basin-times ng-repeat=\"basin in dpanelVm.basins\" ng-if=basin.inundation layout=column><div layout layout-align=\"space-between center\"><div class=name>{{basin.description}}:</div><div class=time>{{basin.latestTimeOfSimulation | date:\'HH:mm yyyy/MM/dd\'}}</div></div><md-divider md-inset ng-hide=$last></md-divider></md-menu-item></md-menu-content></md-menu><md-button class=md-icon-button ng-click=\"dpanelVm.openSettings(overlay, $index, $event)\" ng-disabled=!overlay.visible ng-class=\"(\'layer-settings-\' + $index)\"><md-icon>settings</md-icon></md-button></div></md-list-item><div class=scale ng-class=\"overlay.name === \'Inundation\' ? \'vai\' : \'\'\" ng-if=\"overlay.legend.scale && dpanelVm.showPanel\" ng-show=overlay.visible layout layout-align=\"center center\"><img ng-src=\"{{\r\n                            {\r\n                                \'rmint\': \'http://nowcoast.noaa.gov/images/legends/radar.png\',\r\n                                \'inundation\': dpanelVm.getScale()\r\n                            }[overlay.id]\r\n                        }}\"></div><md-divider ng-if=\"overlay.type !== \'utfGrid\'\" ng-show=overlay.legend.visible ng-repeat-end></md-divider><md-list-item class=\"md-2-line md-with-secondary\"><md-icon>layers</md-icon><div class=md-list-item-text><h3>{{dpanelVm.currentBaselayer.name}}</h3><p>Base Layer</p></div><md-menu class=md-secondary><md-button class=md-icon-button ng-click=$mdMenu.open($event)><md-icon>settings</md-icon></md-button><md-menu-content width=3><md-menu-item ng-repeat=\"layer in dpanelVm.availableBaselayers\"><md-button ng-disabled=\"layer === dpanelVm.currentBaselayer\" ng-click=dpanelVm.setBaselayer(layer)>{{layer.name}}</md-button></md-menu-item></md-menu-content></md-menu></md-list-item><md-divider></md-divider></md-list><md-button class=\"md-primary md-raised\" ng-click=dpanelVm.openLayersDialog($event)><md-icon>playlist_add</md-icon>Layer Manager</md-button><div flex></div></md-tab-content></md-tab><md-tab md-active=true label=components md-on-select=\"dpanelVm.onTabSelected(\'components\')\"><md-tab-content layout=column><watch-points ng-show=dpanelVm.myInfo.permissions.dashboard.watchpoints now-time=dpanelVm.nowTime.getTime() layout=column flex></watch-points><md-divider class=z1></md-divider><alert-feed ng-show=dpanelVm.myInfo.permissions.dashboard.notifications.view add-overlay=\"dpanelVm.addOverlay($payload, $alert)\" remove-overlay=dpanelVm.removeOverlay() ng-class=\"dpanelVm.myInfo.permissions.dashboard.watchpoints === false ? \'big\' : \'\'\" now-time=dpanelVm.nowTime.getTime() my-info=dpanelVm.myInfo layout=column flex></alert-feed><md-divider class=z1></md-divider><p2n-map ng-show=dpanelVm.myInfo.permissions.dashboard.ddf now-time=dpanelVm.nowTime.getTime() layout=column layout-align=\"center center\"></p2n-map></md-tab-content></md-tab></md-tabs>");
$templateCache.put("app/components/dashboard/dashmap/dashmap.tmpl.html","<div flex layout=column><leaflet id=dashmap lf-center=dashmapVm.center defaults=dashmapVm.defaults layers=dashmapVm.layers markers=dashmapVm.markers markers-nested=true flex><md-toolbar class=\"md-whiteframe-z1 site-content-toolbar dash-toolbar\"><div class=md-toolbar-tools><md-button class=md-icon-button ng-click=dashmapVm.openNav() aria-label=Navigation><md-icon>menu</md-icon></md-button><h2>Dashboard {{(dashmapVm.replay.isActive && dashmapVm.replay.mdSwitch) ? \'Replay\' : \'\'}}</h2><span flex></span><div hide-xs class=replay-control layout layout-align=\"center center\"><md-switch ng-model=dashmapVm.replay.mdSwitch ng-change=dashmapVm.replay.toggleReplay() aria-label=\"Replay Mode\" ng-disabled=\"dashmapVm.latestInundationTime === 0\" md-invert><md-icon>replay</md-icon>Replay</md-switch></div><md-button aria-label=\"Open Basin List Menu\" class=\"basin-list md-icon-button\" ng-click=dashmapVm.showBasins($event) ng-class=\"{\'small\': dashmapVm.mdMedia(\'xs\')}\"><md-icon md-menu-origin>collections_bookmark</md-icon><md-tooltip>Scenario Bookmarks</md-tooltip></md-button><md-button aria-label=\"Address Search\" class=\"basin-list md-icon-button\" ng-click=dashmapVm.searchAddress($event)><md-icon>search</md-icon><md-tooltip>Address Search</md-tooltip></md-button><app-menu></app-menu></div></md-toolbar><div class=control-bar><md-button id=reorient-map class=md-raised ng-click=dashmapVm.reorientMap()><md-icon>settings_overscan</md-icon></md-button><md-menu id=save-location class=bookmark md-offset=\"0 35\"><md-button ng-class=\"{\'bookmark__btn-saved\': dashmapVm.hasBookmark()}\" class=md-raised ng-click=$mdMenu.open($event) aria-label=\"Save View\"><md-icon ng-show=!dashmapVm.flashSuccess>my_location</md-icon><svg ng-show=dashmapVm.flashSuccess class=checkmark xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 52 52\"><circle class=checkmark__circle cx=26 cy=26 r=25 fill=none /><path class=checkmark__check fill=none d=\"M14.1 27.2l7.1 7.2 16.7-16.8\"/></svg><md-tooltip md-direction=right>{{dashmapVm.hasBookmark() ? \'A Location Has Been Saved\' : \'Remember Location\'}}</md-tooltip></md-button><md-menu-content><md-menu-item><md-button ng-click=dashmapVm.saveBounds()><md-icon>save</md-icon><span>Save New Location</span></md-button></md-menu-item><md-menu-item><md-button ng-click=dashmapVm.reorientBounds() ng-disabled=!dashmapVm.hasBookmark()><md-icon>my_location</md-icon><span>Load Location</span></md-button></md-menu-item></md-menu-content></md-menu><md-progress-circular md-mode=indeterminate ng-if=dashmapVm.loading.length md-diameter=30 class=\"md-accent small-loader\"></md-progress-circular></div><div class=top-right><!-- <md-button class=\"md-raised md-icon-button dashpanel-button\" ng-click=\"dashmapVm.showPanel = !dashmapVm.showPanel\" ng-show=\"!dashmapVm.showPanel\">\r\n                <md-icon>chrome_reader_mode</md-icon>\r\n            </md-button> --><div class=show-summary ng-show=\"dashmapVm.selectedScenario !== undefined\" ng-class=\"{\'small\': dashmapVm.mdMedia(\'xs\')}\"><h3 ng-click=dashmapVm.removeScenario()><md-icon>bookmark</md-icon>{{dashmapVm.selectedScenario.displayId}} Overview<md-icon class=btn-close>clear</md-icon></h3><div ng-if=\"dashmapVm.scenarioSummaries[dashmapVm.selectedScenario.id].rulesSummary.totalNumRulesAvailable > 0\"><p><strong>Rules</strong><br>Last Checked: <span am-time-ago=dashmapVm.scenarioSummaries[dashmapVm.selectedScenario.id].rulesSummary.timeChecked></span><br>{{dashmapVm.scenarioSummaries[dashmapVm.selectedScenario.id].rulesSummary.totalNumActiveAlerts}}/{{dashmapVm.scenarioSummaries[dashmapVm.selectedScenario.id].rulesSummary.totalNumRulesAvailable}} triggered</p></div><div ng-if=\"dashmapVm.scenarioSummaries[dashmapVm.selectedScenario.id].inundationSummary.totNumBuildingsAvailable > 0 || dashmapVm.scenarioSummaries[dashmapVm.selectedScenario.id].inundationSummary.totalNumBridgesAvailable > 0\"><p><strong>Inundation</strong><br>Solve Time: <span am-time-ago=dashmapVm.scenarioSummaries[dashmapVm.selectedScenario.id].inundationSummary.inundationSolveTime></span><br>{{dashmapVm.scenarioSummaries[dashmapVm.selectedScenario.id].inundationSummary.totalNumInundatedBridges}}/{{dashmapVm.scenarioSummaries[dashmapVm.selectedScenario.id].inundationSummary.totalNumBridgesAvailable}} bridges<br>{{dashmapVm.scenarioSummaries[dashmapVm.selectedScenario.id].inundationSummary.totalNumInundatedBuildings}}/{{dashmapVm.scenarioSummaries[dashmapVm.selectedScenario.id].inundationSummary.totNumBuildingsAvailable}} buildings</p></div></div><div class=show-coordinates ng-class=\"dashmapVm.showCoordinatesDiv ? \'show\' : \'hide\'\" ng-show=dashmapVm.showCoordinates.length>{{dashmapVm.showCoordinates[0] | noDecimal}} fE<br>{{dashmapVm.showCoordinates[1] | noDecimal}} fN</div></div><div class=bottom-right><md-button class=\"md-raised dashpanel-toggle\" ng-class=\"{\'gt-sm\':dashmapVm.mdMedia(\'gt-sm\')}\" ng-click=\"dashmapVm.togglePanel(\'components\')\"><md-icon>{{dashmapVm.showPanel ? \'chevron_right\' : \'chevron_left\'}}</md-icon><md-tooltip md-direction=left md-delay=1e3>{{dashmapVm.showPanel ? \'Hide Components\' : \'Show Components\'}}</md-tooltip></md-button></div><vai-player ng-if=\"dashmapVm.replay.isActive && dashmapVm.replay.mdSwitch\" timeline=dashmapVm.timeline frames=dashmapVm.frames to-next=dashmapVm.frameChange(true) to-prev=dashmapVm.frameChange(false) toggle-ani=dashmapVm.aniToggle() disable-controls=dashmapVm.disableControls() now-time=dashmapVm.nowTime overlays=dashmapVm.aniOverlays open-replay-dialog=dashmapVm.openReplayDialog() layout layout-align=\"center center\"></vai-player></leaflet></div><dashpanel class=md-whiteframe-6dp directory=dashmapVm.directory overlays=dashmapVm.layers.overlays lfmarkers=dashmapVm.markers baselayer=dashmapVm.layers.baselayers basins=dashmapVm.basins show-panel=dashmapVm.showPanel check-time=dashmapVm.checkTime check-duration=dashmapVm.checkDuration now-time=dashmapVm.nowTime latest-inundation-time=dashmapVm.latestInundationTime refresh-markers=dashmapVm.loadOverlays($set) replay-active=\"dashmapVm.replay.isActive && dashmapVm.replay.mdSwitch\" add-baselayer=dashmapVm.addBaselayer($style) toggle-panel=dashmapVm.togglePanel($type) errors=dashmapVm.layers.errors ng-show=dashmapVm.showPanel layout=column flex=30 flex-xs=90 flex-sm=50 flex-xl=20></dashpanel>");
$templateCache.put("app/components/login/reset/reset.html","<div class=login layout layout-fill><span class=line></span><md-content class=half-bg layout=row layout-align=\"center center\" layout-fill><div class=float-container layout=column layout-align=\"center center\" flex=75 flex-gt-xs=40 flex-gt-sm=30 flex-gt-md=20 flex-gt-lg=15><md-card flex=noshrink><div class=md-card-image layout layout-align=\"center center\" flex=none><img src=/assets/images/logo-fews.svg class=logo alt=\"vieux fews logo\"></div><div class=error ng-show=\"resetVm.error || resetVm.badToken\"><div ng-show=resetVm.badToken><h3 style=margin:0>Invalid link.</h3>Redirecting to login in {{resetVm.seconds}} second{{resetVm.seconds>1?\'s\':\'\'}}...</div>{{resetVm.error}}</div><form name=loginForm novalidate ng-hide=resetVm.hideForm><md-card-content layout=column><md-input-container><label>Password</label><input type=password name=passwordOne ng-model=resetVm.passwordOne ng-minlength=8 ng-maxlength=64 required><div ng-messages=loginForm.passwordOne.$error><div ng-message=required>A password is required.</div><div ng-message=minlength>Your password should be more than 8 characters long.</div><div ng-message=maxlength>Your password should be less than 64 characters long.</div></div></md-input-container><md-input-container><label>Confirm Password</label><input type=password name=passwordTwo ng-model=resetVm.passwordTwo ng-pattern=resetVm.passwordOne ng-minlength=8 ng-maxlength=64 required><div ng-messages=loginForm.passwordTwo.$error><div ng-message=required>Password confirmation is required.</div><div ng-message=minlength>Your password should be more than 8 characters long.</div><div ng-message=maxlength>Your password should be less than 64 characters long.</div><div ng-message=pattern>The passwords you entered do not match.</div></div></md-input-container></md-card-content><md-card-actions layout=column layout-align=\"center center\"><md-button ng-click=resetVm.submit() class=\"md-raised md-primary login-btn\" type=submit ng-disabled=loginForm.$invalid>Change Password</md-button></md-card-actions></form><div ng-show=resetVm.success layout-padding><h3>Your password has been reset. In a few seconds you will now be redirected to the login page.</h3></div><div class=additional layout layout-align=\"end center\"><a ui-sref=login>back to login</a></div></md-card></div></md-content></div>");
$templateCache.put("app/components/login/request/request.html","<div class=\"login reset-request\" layout layout-fill><span class=line></span><md-content class=half-bg layout=row layout-align=\"center center\" layout-fill><div class=float-container layout layout-align=\"center center\" flex=75 flex-gt-xs=40 flex-gt-sm=30 flex-gt-md=20 flex-gt-lg=15><md-card flex=noshrink><div class=instructions layout-padding><h1>Password Reset</h1><p>To request a password reset,<br>enter the email address associated with your FEWS account.</p></div><div class=error ng-show=requestVm.error>{{requestVm.error}}</div><div ng-show=requestVm.message layout-padding><h3>{{requestVm.message}}</h3></div><form name=resetForm novalidate ng-hide=requestVm.hideForm><md-card-content layout=column><md-input-container><label>Email address</label><input name=username ng-model=requestVm.email type=email required><div ng-messages=resetForm.username.$error><div ng-message=required>An email is required.</div></div></md-input-container></md-card-content><md-card-actions layout=column layout-align=\"center center\"><md-button ng-click=requestVm.submit() class=\"md-raised md-primary reset-btn\" type=submit ng-disabled=resetForm.$invalid>Submit</md-button></md-card-actions><div class=additional layout layout-align=\"end center\"><a href=#>back to login</a></div></form></md-card></div></md-content></div>");
$templateCache.put("app/components/gauges/gauge-details/gauge-details.tmpl.html","<md-dialog aria-label={{gdc.gauge.name}} class=gauge-details flex-gt-sm=60 ng-keydown=gdc.keyListener($event)><md-toolbar ng-show=gdc.ready layout layout-align=\"space-between center\" class=text-top><span class=name>{{gdc.gauge.name || \'No Name Assigned\'}}</span><md-button class=md-icon-button ng-click=gdc.closeDialog()><md-icon>close</md-icon></md-button></md-toolbar><md-divider></md-divider><md-dialog-content ng-show=gdc.ready><div class=\"hyeto-chart md-whiteframe-1dp\" layout layout-align=\"center center\"><md-progress-circular md-diameter=40 ng-show=!gdc.interactiveReady></md-progress-circular><div id=chart ng-show=gdc.interactiveReady></div></div><md-divider></md-divider><div class=info><ul><li layout=row><div flex=50 class=left>Client ID</div><div flex=50 class=right>{{gdc.gauge.clientId || \'n/a\'}}</div></li><li layout=row><div flex=50 class=left>VAI ID</div><div flex=50 class=right>{{gdc.gauge.vaiId || \'n/a\'}}</div></li><li layout=row><div flex=50 class=left>Feed</div><div flex=50 class=right>{{gdc.gauge.feedType || \'n/a\'}}</div></li><li layout=row><div flex=50 class=left>Most Recent<br>Raw Time</div><div flex=50 class=right>{{gdc.gauge.timeRaw | amTimezone:v2.timezone | amDateFormat:\'YYYY/MM/DD HH:mm z\' || \'n/a\'}}</div></li><li layout=row><div flex=50 class=left>Most Recent<br>Filtered Time</div><div flex=50 class=right>{{gdc.gauge.timeFiltered | amTimezone:v2.timezone | amDateFormat:\'YYYY/MM/DD HH:mm z\' || \'n/a\'}}</div></li></ul></div><div class=recent-rainfall ng-if=\"gdc.gauge.sums.length > 0\"><md-subheader>Recent Rainfall (inches)</md-subheader><ul layout=row><li layout=column ng-repeat=\"rainfall in gdc.gauge.sums\" flex><p>{{rainfall.hours}}h</p><span>{{rainfall.sum === null ? \'n/a\' : (rainfall.sum | number: 2)}}</span></li></ul></div></md-dialog-content><md-dialog-actions layout=row ng-show=gdc.ready class=btn-fix><md-button class=left ng-show=\"gdc.previous !== undefined\" ng-click=\"gdc.loadDetails(gdc.orderedGauges[gdc.previous].vaiId, gdc.previous)\"><md-icon>keyboard_arrow_left</md-icon>Previous Gauge</md-button><span flex></span><md-button class=right ng-show=\"gdc.next !== undefined\" ng-click=\"gdc.loadDetails(gdc.orderedGauges[gdc.next].vaiId, gdc.next)\">Next Gauge<md-icon>keyboard_arrow_right</md-icon></md-button><md-dialog-content ng-show=!gdc.ready layout layout-align=\"center center\" style=\"padding: 40px\"><md-progress-circular md-mode=indeterminate md-diameter=60></md-progress-circular></md-dialog-content></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/rules/alert-dialog/alert.tmpl.html","<md-dialog class=alert-dialog aria-label=\"{{::alertVm.isNew ? \'New \' : \'\'}}Map Alert\" flex=40><form name=alertForm><md-toolbar><div class=md-toolbar-tools><h2>{{::alertVm.isNew ? \'New \' : \'\'}}Map Alert</h2><div flex></div></div></md-toolbar><md-dialog-content><div class=md-dialog-content><md-input-container class=md-block><label>Title</label><input ng-model=alertVm.alert.name required></md-input-container><div layout><md-input-container flex><label>Event Timing</label><md-select ng-model=alertVm.alert.timing aria-label=\"time relative to threshold\" required><md-option ng-repeat=\"timing in alertVm.threshTiming\" value={{timing.systemName}}>{{timing.displayName}}</md-option></md-select></md-input-container><div flex class=timing><md-input-container ng-if=\"alertVm.alert.timing !== \'during\'\"><label>Minutes {{alertVm.alert.timing}}</label><textarea ng-model=alertVm.alert.delay required></textarea></md-input-container></div></div><md-input-container class=md-block><label>Select from Presets</label><md-select ng-change=alertVm.updatePresets() ng-model=alertVm.presets.chosen multiple><md-option ng-repeat=\"lwc in alertVm.lwcs\" value={{lwc}}>{{lwc.properties.crossing_d}}</md-option></md-select></md-input-container></div><leaflet id=alertmap defaults=alertVm.map.defaults lf-center=alertVm.map.center layers=alertVm.map.layers lf-draw=alertVm.map.drawOptions ng-show=\"alertVm.alert.alertType === \'custom\'\"><div class=loading ng-hide=alertVm.map.isInit layout layout-align=\"center center\"><md-progress-circular md-mode=indeterminate md-diameter=80></md-progress-circular></div></leaflet></md-dialog-content><md-dialog-actions layout><div ng-class=\"alertVm.map.featureCount > 0 ? \'\' : \'error\'\" flex>{{alertVm.map.featureCount > 0 ? alertVm.map.featureCount + \' Alert Locations\' : \'A location is required for map alerts.\'}}</div><md-button ng-click=alertVm.cancel()>Cancel</md-button><md-button ng-disabled=alertVm.disableAlertSave(alertForm.$pristine) ng-click=\"alertForm.$valid ? alertVm.submit(alertVm.isNew) : angular.noop()\" type=submit>Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/rules/new-rule-dialog/new-rule.tmpl.html","<md-dialog class=new-rule-dialog flex-gt-lg=20 flex-gt-sm=30 flex=90><md-toolbar><div class=md-toolbar-tools><h2>{{newRuleVm.isNew(newRuleVm.rulesVm.selected) ? \'New \' : \'Duplicate \'}} Rule</h2><div flex></div></div></md-toolbar><md-dialog-content class=md-dialog-content layout=column><p>Begin by selecting the new rule\'s input data source and type. Once a rule is saved these options can not be changed.</p><h4>Data Source</h4><form name=ruleForm layout-gt-sm=row layout-wrap><div flex=100><md-autocomplete name=watchpoint md-selected-item=newRuleVm.rulesVm.selected.location md-items=\"item in newRuleVm.rulesVm.querySearch(newRuleVm.rulesVm.searchText)\" md-item-text=\"item.displayName + \' (\' + item.id + \')\'\" md-search-text=newRuleVm.rulesVm.searchText md-min-length=0 md-select-on-focus placeholder=\"Choose a WatchPoint (required)\" required><md-item-template><span md-highlight-text=newRuleVm.rulesVm.searchText md-highlight-flags=ig>{{item.displayName}} ({{item.id}})</span></md-item-template><md-not-found>No locations matching \"{{newRuleVm.rulesVm.searchText}}\" were found.</md-not-found></md-autocomplete><div class=errors ng-messages=ruleForm.watchpoint.$error><div ng-message=required>Required</div></div></div><md-input-container flex=100 class=mobile-block><label>Input Data Type(s)</label><md-select name=inputData ng-model=newRuleVm.rulesVm.selected.rule.source.inputs ng-disabled=\"newRuleVm.rulesVm.selected.location === null\" md-on-close=newRuleVm.rulesVm.getSelectedUnit() multiple required><md-option ng-repeat=\"input in newRuleVm.rulesVm.selected.location.inputs\" ng-disabled=newRuleVm.rulesVm.disableDataType(input) ng-value=input>{{newRuleVm.rulesVm.dataTypeMap[input].displayName}}</md-option></md-select><div class=errors ng-messages=ruleForm.inputData.$error><div ng-message=required>Required</div></div></md-input-container><md-dialog-actions flex=100><div class=float-right><md-button ng-click=newRuleVm.cancelDialog()>Cancel</md-button><md-button ng-disabled=newRuleVm.rulesVm.dialogSaveDisabled(ruleForm.$invalid) ng-click=newRuleVm.continueDialog()>Continue</md-button></div></md-dialog-actions></form></md-dialog-content></md-dialog>");
$templateCache.put("app/components/user-manager/group-details/group-details.tmpl.html","<div class=title-container layout layout-align=\"space-between center\"><div class=header-text layout=column><span class=group-title>{{gdVm.group.displayName}}</span> <span class=group-subhead>{{gdVm.group.description}}</span></div><md-button ng-if=\"!gdVm.loading.includes(\'updatingGroup\') && gdVm.me.role !== \'User\'\" ng-click=gdVm.editGroupDialog($event) class=\"md-raised md-secondary\">Edit Group</md-button><div class=loading ng-if=\"gdVm.loading.includes(\'updatingGroup\')\"><md-progress-circular md-diameter=24></md-progress-circular></div></div><div class=group-content><role-list rl-group=gdVm.group rl-role-type=Admin></role-list><role-list rl-group=gdVm.group rl-role-type=User></role-list></div>");
$templateCache.put("app/components/user-manager/group-dialog/group-dialog.tmpl.html","<md-dialog class=group-dialog aria-label=\"Group Dialog\" flex flex-sm=50 flex-md=40 flex-lg=30 flex-xl=25><form name=groupForm ng-submit=ngVm.submit() ng-cloak><md-dialog-content><div class=md-dialog-content layout=column><div class=title-container layout layout-align=\"space-between center\"><h1>{{ ::ngVm.isNew ? \'New Group\' : (\'Edit \' + ngVm.model.displayName)}}</h1><div><md-button class=\"md-raised md-secondary\" ng-click=ngVm.deleteGroup($event) ng-disabled=::ngVm.hasMembers() ng-if=\"::(!ngVm.isNew && ngVm.me.role === \'Proj_Admin\')\">remove group</md-button><md-tooltip ng-if=::ngVm.hasMembers()>remove members first</md-tooltip></div></div><md-input-container><label>Name</label><input name=name ng-model=::ngVm.model.displayName ng-pattern=ngVm.reName ng-minlength=1 md-autofocus=ngVm.isNew required><div ng-messages=groupForm.name.$error><div ng-message=required>This is required!</div><div ng-message=pattern>Group names should only contain letters these special characters: &amp; \' ) ( \\ : ; - . ,</div></div></md-input-container><md-input-container><label>Description</label><textarea name=description ng-model=ngVm.model.description placeholder=\"Describe your group here\"></textarea></md-input-container><permission-picker class=in-dialog pp-model=ngVm.model.permissions pp-type=group></permission-picker></div><md-divider></md-divider></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button ng-click=ngVm.cancel()>cancel</md-button><md-button type=submit ng-disabled=\"groupForm.$invalid || groupForm.$pristine\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/user-manager/role-list/role-list.tmpl.html","<div class=list-header-container layout layout-align=\"space-between center\"><h2>{{rlVm.roleType === \'Admin\' ? \'Administrators\' : \'Users\'}}</h2><div class=secondary><button ng-click=rlVm.openMemberDialog($event) ng-if=\"rlVm.me.role.includes(\'Admin\')\" class=no-style>+ new {{rlVm.roleType}}</button></div></div><md-divider></md-divider><md-list class=md-dense><div class=member-item ng-repeat=\"member in rlVm.group.members | filter:rlVm.listFilter\"><md-list-item class=md-2-line ng-click=\"rlVm.openMemberDialog($event, member)\"><md-icon>{{rlVm.roleMap[rlVm.roleType].icon}}</md-icon><div class=md-list-item-text ng-class=\"{\'true\':\'disabled\'}[rlVm.loading.includes(\'member:\' + member.memberId)]\"><h3>{{member.firstName + \' \' + member.lastName}}</h3><p>{{member.username}}</p></div><md-button class=\"md-secondary md-icon-button\" ng-click=\"rlVm.deleteMemberDialog($event, member)\" ng-if=\"rlVm.me.role.includes(\'Admin\') && rlVm.me.memberId !== member.memberId\" ng-disabled=\"rlVm.loading.includes(\'member:\' + member.memberId)\"><md-icon>delete</md-icon></md-button></md-list-item><md-progress-linear md-diameter=24px class=md-accent ng-if=\"rlVm.loading.includes(\'member:\' + member.memberId)\"></md-progress-linear></div><md-list-item ng-if=\"rlVm.factory.roleCount(rlVm.group.members, (rlVm.roleType === \'Admin\')) === 0\"><p>There are currently no {{rlVm.roleType === \'Admin\' ? \'administrators\' : \'users\'}}.</p></md-list-item></md-list>");
$templateCache.put("app/components/user-manager/member-dialog/member.tmpl.html","<md-dialog class=member-dialog aria-label=\"Member Dialog\" flex flex-sm=50 flex-md=40 flex-lg=30 flex-xl=25><form name=memberForm ng-submit=mcVm.submit() ng-cloak><md-dialog-content><div class=md-dialog-content layout=column><div class=title-bar layout layout-align=\"space-between center\"><h1>{{ mcVm.model.memberId ? \'Member Details\' : \'New \' + mcVm.model.role }}</h1><md-button class=md-icon-button ng-click=mcVm.closeDialog()><md-icon>close</md-icon></md-button></div><div layout><md-input-container flex><label for=fname>first name (required)</label><input name=fname ng-model=mcVm.model.firstName ng-pattern=mcVm.reName ng-disabled=\"mcVm.me.role === \'User\'\" ng-minlength=1 required><div ng-messages=memberForm.fname.$error><div ng-message=required>Please enter a name</div><div ng-message=pattern>Names should only contain letters these special characters: &amp; \' ) ( \\ : ; - . ,</div></div></md-input-container><md-input-container flex><label for=lname>last name (required)</label><input name=lname ng-model=mcVm.model.lastName ng-pattern=mcVm.reName ng-disabled=\"mcVm.me.role === \'User\'\" ng-minlength=1 required><div ng-messages=memberForm.lname.$error><div ng-message=required>Please enter a name</div><div ng-message=pattern>Names should only contain letters these special characters: &amp; \' ) ( \\ : ; - . ,</div></div></md-input-container></div><md-input-container flex><label for=username>user name (required)</label><input name=username ng-model=mcVm.model.username ng-pattern=mcVm.username ng-disabled=\"mcVm.me.role === \'User\'\" md-maxlength=100 md-autofocus=mcVm.isNew required><div class=hint>Username is case sensitive.</div><div ng-messages=memberForm.fname.$error><div ng-message=required>Please enter a user name</div><div ng-message=pattern>User names may only contain letters and these special characters: - .</div><div ng-message=md-maxlength></div></div></md-input-container><div layout><md-input-container flex><label for=email>email (required)</label><input name=email ng-model=mcVm.model.email ng-pattern=mcVm.rePatterns.email ng-disabled=\"mcVm.me.role === \'User\'\" required><div ng-messages=memberForm.email.$error><div ng-message=required>Please enter an email address</div><div ng-message=pattern>Please enter a valid email address</div></div></md-input-container></div><md-input-container ng-if=mcVm.isNew flex><label for=pass>password (required)</label><input type=password name=pass ng-model=mcVm.model.password ng-minlength=8 ng-disabled=\"mcVm.me.role === \'User\'\" required><div ng-messages=memberForm.pass.$error><div ng-message=required>Please enter a password</div><div ng-message=minlength>Password must contain 8 or more characters</div></div></md-input-container><permission-picker pp-model=mcVm.model.permissions pp-type=member pp-to-show=mcVm.groupPermissions></permission-picker></div><md-divider></md-divider></md-dialog-content><md-dialog-actions ng-if=\"mcVm.me.role !== \'User\'\" layout=row><span flex></span><md-button ng-click=mcVm.closeDialog()>cancel</md-button><md-button type=submit ng-click=mcVm.saveChanges() ng-disabled=\"memberForm.$pristine || memberForm.$invalid\">save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/user-manager/permission-picker/permission-picker.tmpl.html","<div class=list-header-container layout layout-align=\"space-between center\"><div class=primary><h2>{{ppVm.type}} Permissions</h2></div><div class=secondary><div class=labels><span>edit</span> <span>view</span></div></div></div><md-divider></md-divider><md-list class=\"md-dense permissions\" flex><div ng-repeat=\"item in ppVm.listItems\"><md-list-item class=md-no-proxy ng-hide=\"ppVm.toShow[item.key] === false || ppVm.toShow[item.key].view === false\"><span>{{ item.displayName }}</span><div class=\"md-secondary checkbox-wrapper\"><md-checkbox ng-model=ppVm.model[item.key].edit aria-label=\"Edit {{item.displayName}}\" ng-disabled=\"ppVm.disableAll || ppVm.model[item.key].view === false || ppVm.me.role === \'User\'\" ng-if=\"item.hasEdit && ppVm.toShow[item.key].edit !== false\"></md-checkbox><md-tooltip ng-if=\"ppVm.model[item.key].view === false\">View must be active for editing</md-tooltip></div><md-checkbox class=md-secondary ng-change=ppVm.switchEdit(ppVm.model[item.key]) ng-model=ppVm.model[item.key].view aria-label=\"View {{item.displayName}}\" ng-disabled=\"ppVm.disableAll || ppVm.me.role === \'User\'\" ng-if=\"ppVm.model[item.key].view !== undefined && item.key !== \'dashboard\'\"></md-checkbox><md-checkbox class=md-secondary ng-model=ppVm.model[item.key] aria-label=\"View {{item.displayName}}\" ng-disabled=\"ppVm.disableAll || ppVm.me.role === \'User\'\" ng-if=\"ppVm.model[item.key] === true || ppVm.model[item.key] === false\"></md-checkbox></md-list-item><div ng-if=\"item.key === \'dashboard\'\"><md-list-item class=\"md-no-proxy sub-item\" ng-if=\"ppVm.model[item.key].watchpoints !== undefined && ppVm.toShow[item.key].watchpoints !== false\"><span>- WatchPoints List</span><md-checkbox class=md-secondary ng-model=ppVm.model[item.key].watchpoints aria-label=\"View {{item.displayName}}\" ng-disabled=\"ppVm.disableAll || ppVm.model[item.key].view === false || ppVm.me.role === \'User\'\"></md-checkbox></md-list-item><md-list-item class=\"md-no-proxy sub-item\" ng-if=\"ppVm.model[item.key].notifications !== undefined && ppVm.toShow[item.key].notifications.view !== false\"><span>- Notifications Feed</span><div class=\"md-secondary checkbox-wrapper\"><md-checkbox ng-model=ppVm.model[item.key].notifications.edit ng-hide=\"ppVm.toShow[item.key].notifications.edit === false\" ng-disabled=\"ppVm.disableAll || ppVm.model[item.key].notifications.view === false || ppVm.model[item.key].view === false || ppVm.me.role === \'User\'\" aria-label=\"Edit Notifications Feed\"></md-checkbox><md-tooltip ng-if=\"ppVm.model[item.key].notifications.view === false\">View must be active for editing</md-tooltip></div><md-checkbox class=md-secondary ng-change=ppVm.switchEdit(ppVm.model[item.key].notifications) ng-model=ppVm.model[item.key].notifications.view aria-label=\"View Notifications Feed\" ng-disabled=\"ppVm.disableAll || ppVm.model[item.key].view === false || ppVm.me.role === \'User\'\"></md-checkbox></md-list-item><md-list-item class=\"md-no-proxy sub-item\" ng-if=\"ppVm.model[item.key].ddf !== undefined && ppVm.toShow[item.key].ddf !== false\"><span>- DDF/PreVieux Map</span><md-checkbox class=md-secondary ng-model=ppVm.model[item.key].ddf aria-label=\"View DDF/PreVieux Map\" ng-hide=\"ppVm.toShow[item.key].ddf === false\" ng-disabled=\"ppVm.disableAll || ppVm.model[item.key].view === false || ppVm.me.role === \'User\'\"></md-checkbox></md-list-item></div></div></md-list>");
$templateCache.put("app/components/dashboard/dashmap/components/map-popup.tmpl.html","<md-tabs md-dynamic-height md-border-bottom ng-if=\"popVm.results.length > 0\"><md-tab ng-repeat=\"result in popVm.results\" label={{result.display}}><md-content class=md-padding ng-switch on=result.id><div ng-switch-when=inundationGrid><img ng-src=\"{{popVm.API_URL}}inundation/timeseries/{{result.data.watershed}}/{{result.data.x}}/{{result.data.y}}.png?accesstoken={{popVm.token}}&amp;width=370&amp;style=SIMPLE&amp;pixelRatio=1&amp;basin={{result.data.watershed + \'\' + (popVm.isReplay() ? \'&time-of-simulation=\' + popVm.nowTime.getTime() : \'\')}}\" alt=\"Inundation chart\"><p>Inundation: {{result.data.inundation | number:2}} (ft)<br>Time of Simulation: {{result.data.timeOfSimulation | amDateFormat:\'HH:mm YYYY/MM/DD\'}}<br>Basin: {{popVm.basins[result.data.watershed].description}}</p></div><div ng-switch-when=bridges><md-list flex><md-list-item class=md-2-line ng-repeat=\"bridge in result.data\"><div class=md-list-item-text layout=column><img ng-src=\"{{popVm.API_URL}}structures/bridges/{{bridge.id}}/timeseries.png?accesstoken={{popVm.token}}&amp;width=370&amp;style=SIMPLE&amp;pixelRatio=1{{(popVm.isReplay() ? \'&time-of-simulation=\' + popVm.nowTime.getTime() : \'\')}}\"><h3>Address: {{bridge.streetAddress}}</h3><p>High Chord: {{bridge.highChordDepth | number:2}} (ft)<br>Low Chord: {{bridge.lowChordDepth | number:2}} (ft)<br>Basin Time: {{result.timeOfSimulation | amDateFormat:\'HH:mm YYYY/MM/DD\'}}<br>Basin: {{popVm.basins[bridge.watershed].description}}</p></div></md-list-item></md-list></div><div ng-switch-when=buildings><md-list flex><md-list-item class=md-2-line ng-repeat=\"building in result.data\"><div class=md-list-item-text layout=column><img ng-src=\"{{popVm.API_URL}}structures/buildings/{{building.id}}/timeseries.png?accesstoken={{popVm.token}}&amp;width=370&amp;style=SIMPLE&amp;pixelRatio=1{{(popVm.isReplay() ? \'&time-of-simulation=\' + popVm.nowTime.getTime() : \'\')}}\"><h3>Address: {{building.streetAddress}}</h3><p>First Floor Elevation: {{building.firstFloorElevationFt|number:2}} (ft)<br>Basin Time: {{result.timeOfSimulation | amDateFormat:\'HH:mm YYYY/MM/DD\'}}<br>Basin: {{popVm.basins[building.watershed].description}}</p></div></md-list-item></md-list></div><div ng-switch-default><md-list flex><md-list-item class=md-3-line ng-repeat=\"ww in result.data\"><div class=\"box-legend md-avatar {{ww.attributes.vteccode}}\"></div><div class=md-list-item-text layout=column><h3 ng-if=!ww.attributes.url>{{ww.attributes.prod_type}}</h3><h3 ng-if=ww.attributes.url><a href={{ww.attributes.url}} target=_blank>{{ww.attributes.prod_type}}</a></h3><p>Start: {{ww.attributes.starttime}}<br>End: {{ww.attributes.endtime}}</p></div></md-list-item></md-list></div></md-content></md-tab></md-tabs><div class=no-data ng-if=\"popVm.results.length === 0\"><h3>There is no information for this area.</h3><p>Zoom in to the map for more accuracy.</p></div>");
$templateCache.put("app/components/dashboard/dashpanel/layer-info/afdflood.tmpl.html","<p>Placeholder...</p>");
$templateCache.put("app/components/dashboard/dashpanel/layer-info/atx.tmpl.html","<p>These markers are retrieved from the <a href=https://atxfloods.com/dashboard/phpsqlajax_genxml.php target=_blank>Closures XML</a> provided by the ATXFloods webapp. This data are saved on COP servers at 5 minute intervals. On startup, the map will display data from the last 3 days. This means that <strong>any road status changes from the last 3 days</strong> will be displayed, but the current status (if it has remained unchanged) may not. The web application then checks for new changes every 2.5 minutes.</p><img class=marker ng-src=assets/images/layers/{{layer.legend.imageUrl}}><p>This feed has 2 different colored markers. One yellow with a minus symbol and one with a plus symbol. The minus symbol represents a road that has closed and the plus represents a road that has opened.</p>");
$templateCache.put("app/components/dashboard/dashpanel/layer-info/austin311.tmpl.html","<p>These markers are retrieved from the <a href=\"http://311.austintexas.gov/?service_id=544d151b6018273abe00003d\" target=_blank>311 Austin API</a> provided through the ATXFloods webapp. On startup, the map will display 311 requests with a \"services\" parameter that matches \"Flooding Current (Non-Emergency)\" that have been opened in the <strong>last 3 hours</strong>. The web application then checks for new requests every 2.5 minutes.</p><img class=marker ng-src=assets/images/layers/{{layer.legend.imageUrl}}><p>If a new request is detected, it is displayed as a white, circular marker with a green phone in the center. The new marker will include a popup with additional information, like the address and timestamp.</p>");
$templateCache.put("app/components/dashboard/dashpanel/layer-info/gauges.tmpl.html","<p>These markers are retrieved from VAI servers. On startup, the map will display the latest available data for each rain gauge. If two gauges are located closely together, the markers will be grouped into a larger two-tone blue marker.</p><img class=marker ng-src=assets/images/layers/{{layer.legend.imageUrl}}><p>The markers for each gauge are blue with a white outline. Each marker includes the current 1 hour total displayed above the gauge. If a value is unavailable at the time, the gauge total will not be displayed.</p>");
$templateCache.put("app/components/dashboard/dashpanel/layer-info/inundation.tmpl.html","<p>This layer displays maximum inundation data for basins. The data are processed and saved on COP servers at 15 minute intervals. The data are divided into basins and each watershed is processed separately, causing basins to update at different times. The web application then checks for new data every 2.5 minutes.</p><img class=tile-layer ng-src=assets/images/layers/{{layer.legend.imageUrl}}><p>Inundation for each watershed is signified by polygons. Each polygon is colored on a scale from white (0 feet) to blue (greater than 10 feet). By clicking on a polygon of inundation, a popup with additional information is available.</p>");
$templateCache.put("app/components/dashboard/dashpanel/layer-info/layer-info.tmpl.html","<md-dialog class=info-dialog aria-label=\"{{layer.name}} Layer Info &amp; Legend\" flex=90 flex-sm=50 flex-md=40 flex-lg=30 flex-xl=20><md-dialog-content><div class=info-text><h3><md-icon ng-show=\"layer.legend.icon !== \'svg\'\">{{layer.legend.icon}}</md-icon><md-icon ng-show=\"layer.legend.icon === \'svg\'\" md-svg-src={{layer.legend.iconUrl}} class=s24></md-icon>{{layer.name}}</h3><ng-include src=\"\'app/components/dashboard/dashpanel/layer-info/\' + layer.id + \'.tmpl.html\'\"></ng-include></div></md-dialog-content><md-dialog-actions><md-button ng-click=$mdDialog.hide() class=md-primary>Close Dialog</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dashboard/dashpanel/layer-info/reflectivity.tmpl.html","<p>This layer displays a radar mosaic of KGRK &amp; KEWX. The data are updated every 5 minutes.</p>");
$templateCache.put("app/components/dashboard/dashpanel/layer-info/rmint.tmpl.html","<p>This nowCOAST&trade; layer displays a Multi-Radar/Multi-Sensor (MRMS) mosaic of quality-corrected base reflectivity. The radar data itself is updated by the NWS every 10 minutes during non-precipitation mode, but every 2-6 minutes during precipitation mode. The web application then checks for new data every 2.5 minutes.</p><img class=tile-layer ng-src=assets/images/layers/{{layer.legend.imageUrl}}><p>The colors on the map represent the strength of the energy reflected back toward the radar. The reflected intensities (echoes) are measured in dBZ (decibels of z). The color scale is the same as used in the NWS RIDGE2 map viewer, however dBZ values are rounded down to the integer during processing in order to improve display performance.</p><p><a href=//nowcoast.noaa.gov/arcgis/rest/services/nowcoast/radar_meteo_imagery_nexrad_time/MapServer target=_blank>Visit nowCOAST for more information on this layer.</a></p>");
$templateCache.put("app/components/dashboard/dashpanel/layer-info/smigt.tmpl.html","<p>This nowCOAST&trade; layer displays visible, infrared, and water vapor imagery composited from NOAA/NESDIS GOES-EAST and GOES-WEST. The horizontal resolutions of the IR, visible, and water vapor composite images are approximately 1km and 4km, respectively. The GOES composite images are updated in the nowCOAST&trade; map service every 30 minutes. The web application then checks for new data every 2.5 minutes.</p><img class=tile-layer ng-src=assets/images/layers/{{layer.legend.imageUrl}}><p>The visible and IR imagery depict the location of clouds. The water vapor imagery indicates the amount of water vapor contained in the mid to upper levels of the troposphere.</p><p><a href=http://nowcoast.noaa.gov/arcgis/rest/services/nowcoast/sat_meteo_imagery_time/MapServer target=_blank>Visit nowCOAST for more information on this layer.</a></p>");
$templateCache.put("app/components/dashboard/dashpanel/layer-info/vaiStructures.tmpl.html","<p>This layer displays information for structures based on inundation. The data are processed and saved on COP servers at 15 minute intervals. The data are divided into basins and each basin is processed separately, causing basins to update at different times. The web application then checks for new data every 2.5 minutes.</p><img class=tile-layer ng-src=assets/images/layers/{{layer.legend.imageUrl}}><p>This layer has polygonal shapes for buildings and point shapes for bridges. Bridge points are marked with a circle and X. Buildings polygons are empty outlines. Buildings have 2 statuses (red and green) to show whether or not the structure is flooded. Bridges have red, yellow, and green statuses. A red bridge signifies water has reached the high chord. A yellow bridge signifies water has reached the low chord, but hasn\'t reached the high. A green bridge signifies the water is below the low chord.</p>");
$templateCache.put("app/components/dashboard/dashpanel/layer-info/watchWarn.tmpl.html","<p>This nowCOAST&trade; layer displays the latest NWS gridded weather watches, warnings, and advisories for short-duration hazards (tornadoes, severe thunderstorms, flash floods, special marine warning) for OCONUS, Alaska, HI, PR, and Guam which are issued as needed by WFO forecasters. The data are updated in the nowCOAST™ map service every 10 minutes for watches and 1 minute for warnings. The web application then checks for new data every 2.5 minutes.</p><img class=tile-layer ng-src=assets/images/layers/{{layer.legend.imageUrl}}><p>The NWS threat-based polygon or storm-based warnings are issued by NWS Weather Forecast Offices (WFOs) to depict the type of short-duration weather or hydrological hazard which is in progress, imminent or has a very high probability of occurring for a specified geographic area. The colors used to identify the different warnings are the same colors used by the NWS on their map at <a href=http://www.weather.gov>weather.gov</a>.</p><p><a href=http://nowcoast.noaa.gov/arcgis/rest/services/nowcoast/wwa_meteoceanhydro_shortduration_hazards_warnings_time/MapServer target=_blank>Visit nowCOAST for more information on this layer.</a></p><ul class=ww-key><li ng-repeat=\"key in layer.legend.keys\"><span class=color-key style=\"background-color: {{key.color}}\"></span>{{key.name}}</li></ul>");
$templateCache.put("app/components/dashboard/dashpanel/layer-info/watchpoints.tmpl.html","<p>In the Vieux &amp; Associates, Inc. flood prediction system, a \'watch point\' is a location where stage and/or discharge values are monitored, based on observed or simulated data, or both. The WatchPoints application allows access the current status of the watch points, as well as the associated observed and/or simulated data.</p><img class=tile-layer ng-src=assets/images/layers/{{layer.legend.imageUrl}}><p>The markers are identified by a purple star and have a popup that includes a hydrograph for that location. Some watch points have \'watch\' and \'warning\' levels, indicating values that are exceptional or require action. Some watch points\' watch and warning levels are based on stage, and some are based on discharge. Status is indicated by color. Yellow indicates that the current level is above the watch level but below the warning level. Red indicates that the current level is above the watch level.</p>");
$templateCache.put("app/components/dashboard/dashpanel/layer-settings/layer-settings.tmpl.html","<div class=params ng-repeat=\"param in ctrl.options.params\"><md-switch ng-if=\"param.type === \'switch\'\" ng-change=ctrl.changeParam(param) ng-model=param.value aria-label={{param.display}}>{{param.display}}</md-switch></div><md-radio-group ng-model=ctrl.options.activeLayers ng-if=ctrl.options.layers><md-radio-button ng-repeat=\"l in ctrl.options.layers\" ng-value=l.value aria-label=\"{{ l.label }}\">{{ l.label }}</md-radio-button><md-divider></md-divider></md-radio-group><md-slider-container ng-if=ctrl.options.opacity class=opacity-container ng-disabled=isDisabled><md-icon>opacity</md-icon><md-slider class=opacity md-discrete ng-model=ctrl.opacity aria-label=\"Layer Opacity\" min=0 max=100 step=5 flex></md-slider></md-slider-container><div layout=column><md-button class=\"md-raised md-primary open-info\" ng-click=ctrl.infoButton($event)><md-icon>info</md-icon>Info</md-button></div>");
$templateCache.put("app/components/dashboard/dashpanel/layers-dialog/layers.tmpl.html","<md-dialog class=layers-dialog aria-label=\"Available Layers\"><md-toolbar><div class=md-toolbar-tools><h2>Layer Manager</h2><div flex></div></div></md-toolbar><md-dialog-content><md-content><md-list class=md-dense><md-list-item ng-repeat=\"overlay in vm.overlays | obj2Array | orderBy:\'layerParams.zIndex\':true\"><md-checkbox ng-model=overlay.legend.visible ng-change=\"overlay.visible=overlay.legend.visible\"></md-checkbox><p>{{overlay.name}}</p></md-list-item></md-list></md-content><md-divider></md-divider></md-dialog-content><md-dialog-actions layout><div flex></div><md-button ng-click=vm.cancel()>Cancel</md-button><md-button ng-disabled=\"\" ng-click=vm.submit() type=submit>Load</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dashboard/dashmap/replay/replayDialog.tmpl.html","<md-dialog id=replay-dialog layout=column aria-label=\"Replay Confirmation Dialog\" flex=90 flex-sm=60 flex-md=45 flex-lg=30 flex-xl=20><form name=replayForm layout=column flex-gt-xs><md-dialog-content layout=column flex><md-content class=replay-info><h3>Activating Replay Mode</h3><!-- <p>Choose a time prior to the time below. Layers will be restricted to </p> --><md-input-container><label>Replay Time</label><md-icon>event</md-icon><input md-autofocus type=datetime-local name=timeField ng-model=rVm.time.selected ng-max=rVm.time.maxDate aria-label=\"Time to Replay\" required><div ng-messages=replayForm.timeField.$error><div ng-message=valid>The entered value is not a time!</div><div ng-message=required>This time is required!</div><div ng-message=min>Time is too early!</div><div ng-message=max>Choose a time at or before {{rVm.time.maxDate | date:\'MM/dd/yyyy HH:mm\'}}</div></div></md-input-container></md-content><md-divider></md-divider></md-dialog-content><md-dialog-actions><md-button ng-click=rVm.mdDialog.cancel() class=md-primary>Cancel</md-button><md-button type=submit ng-click=rVm.load(rVm.time.selected) ng-disabled=!replayForm.$valid class=md-primary>Activate</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dashboard/dashmap/vai-player/vai-player.tmpl.html","<div id=vai-player class=md-whiteframe-1dp layout=column layout-align=\"center center\"><div class=time-bar flex=none><span class=location></span></div><div class=control-container layout layout-align=\"start center\" flex><md-button class=md-icon-button aria-label=\"Previous Frame\" ng-disabled=\"playerVm.playing || playerVm.disableControls\" ng-click=playerVm.toPrev()><md-icon>skip_previous</md-icon><md-tooltip md-direction=top>Previous</md-tooltip></md-button><div class=button-divider></div><div class=info layout layout-align=\"start center\" flex><button class=\"no-style details\" ng-click=playerVm.openReplayDialog() flex><h2 ng-bind=\"playerVm.nowTime | date:\'HH:mm\'\"></h2><span ng-bind=\"playerVm.nowTime | date:\'MMM. dd, yyyy\'\"></span></button></div><div class=button-divider></div><md-button class=md-icon-button aria-label=\"Next Frame\" ng-disabled=\"playerVm.playing || playerVm.disableControls\" ng-click=playerVm.toNext()><md-icon>skip_next</md-icon><md-tooltip md-direction=top>Next</md-tooltip></md-button></div></div>");
$templateCache.put("app/components/dashboard/dashmap/search/search.tmpl.html","<md-dialog aria-label=Search... class=search-dialog flex=90 flex-gt-xs=75 flex-gt-sm=40 flex-gt-md=30 flex-gt-lg=25><div class=\"md-whiteframe-4dp search-input-container\"><form ng-submit=$event.preventDefault()><md-autocomplete md-selected-item=sc.selectedItem md-selected-item-change=sc.selectedItemChange(item) md-search-text=sc.searchText md-items=\"item in sc.querySearch(sc.searchText)\" md-item-text=item.name md-autofocus=true md-min-length=3 md-delay=300 md-menu-class=search-template placeholder=\"Search gauges or places...\"><md-item-template><div layout layout-align=\"start center\"><md-icon class=search-result-icon>{{item.feed ? \'local_drink\' : \'place\'}}</md-icon><div class=item-text flex><span class=item-title md-highlight-text=sc.searchText md-highlight-flags=^i>{{item.name}}</span> <span class=item-metadata md-highlight-text=sc.searchText md-highlight-flags=^i class=item-metastat>{{item.id}}</span></div></div></md-item-template><md-not-found>No locations matching \"{{sc.searchText}}\" were found.</md-not-found></md-autocomplete></form></div></md-dialog>");
$templateCache.put("app/components/dashboard/dashpanel/components/p2n-map/p2nMap.tmpl.html","<div class=button-row layout=row><md-button ng-class=\"{ \'selected\' : !p2nVm.preActive }\" ng-click=p2nVm.activateDDF() ng-disabled=!p2nVm.preActive>DDF</md-button><md-button ng-class=\"{ \'selected\': p2nVm.preActive }\" ng-click=p2nVm.activatePrevieux() ng-disabled=\"p2nVm.replayActive() || p2nVm.preActive\">PREVIEUX</md-button></div><div layout=row flex layout-fill><leaflet id=p2n defaults=p2nVm.defaults layers=p2nVm.layers class=p2n-leaflet flex><div class=\"container top-left\"><md-select ng-show=p2nVm.preActive ng-change=p2nVm.activatePrevieux() class=radar-drop ng-model=p2nVm.previeux.activeRadar placeholder=\"PreVieux Radar\" class=md-no-underline md-no-asterisk=false><md-option ng-repeat=\"radar in p2nVm.previeux.radars\" value={{radar.id}}>{{radar.id|uppercase}}{{radar.status ? \'\' : \' IS UNAVAILABLE\'}}</md-option></md-select></div><div class=\"container bottom-left\" ng-show=\"p2nVm.preActive && p2nVm.getStatus(p2nVm.previeux.activeRadar)\"><md-button ng-if=p2nVm.previeux.animation class=\"md-fab md-mini md-primary\" ng-click=p2nVm.stopPrevieux()><md-icon>pause</md-icon></md-button><md-button ng-if=!p2nVm.previeux.animation class=\"md-fab md-mini md-primary\" ng-click=p2nVm.animatePrevieux()><md-icon>play_arrow</md-icon></md-button></div><div class=\"container top-right\"><div ng-hide=\"p2nVm.hoveredBasin === \'\' || p2nVm.preActive\" class=hover-basin>{{p2nVm.hoveredBasin}}</div><div ng-show=\"p2nVm.preActive && p2nVm.scaleUrl !== \'\'\" class=hover-basin>{{ p2nVm.previeux.visibleTime | amTimezone:v2.timezone | amDateFormat:\'HH:mm\' }}</div></div></leaflet><div class=minimap-legend ng-show=\"p2nVm.scaleUrl !== \'\'\"><img ng-src={{p2nVm.scaleUrl}}></div></div>");
$templateCache.put("app/components/dashboard/dashpanel/components/p2n-map/popup.tmpl.html","<md-button class=md-icon-button ng-click=p2nVm.activateScenario(p2nVm.selected) aria-label=\"Scenario Bookmarks\"><md-icon>collections_bookmark</md-icon></md-button><div class=text-container flex><h4>{{p2nVm.selected.displayId}}</h4><p>Threat Category: <strong>{{p2nVm.threatCategories[\'cat\'+p2nVm.selected.threatId].label || \'...\'}}</strong><br><strong>{{p2nVm.selected.percentToNextFrequency | truncateNum}}%</strong> to Next Freq.</p></div>");
$templateCache.put("app/components/dashboard/dashpanel/components/status/status.tmpl.html","<div class=status ng-class=\"statusVm.errors.length ? \'error\' : \'done\'\"><md-icon class=indicator>{{statusVm.errors.length ? \'report_problem\' : \'done\'}}</md-icon><div class=last-check><h3 ng-if=statusVm.errors.length>Update Error: {{statusVm.errors.length}} Layer{{statusVm.errors.length > 1 ? \'s\' : \'\'}}</h3><p>Data was last checked <span am-time-ago=statusVm.checkTime></span>.</p></div><md-progress-circular md-diameter=14px ng-if=!statusVm.errors.length md-mode=determinate value={{statusVm.calcTime}}></md-progress-circular><md-button ng-if=statusVm.errors.length class=\"md-icon-button error-more\" ng-click=\"statusVm.openErrorMore(statusVm.errors, $index, $event)\"><md-icon md-menu-origin>info_outline</md-icon></md-button></div>");
$templateCache.put("app/components/dashboard/dashpanel/components/status/statusPanel.tmpl.html","<md-list flex class=md-dense><md-list-item class=md-2-line ng-repeat=\"item in statusPanelCtrl.errors\" ng-href=https://httpstatuses.com/{{item.error.status}} target=_blank><md-icon>info_outline</md-icon><div class=md-list-item-text layout=column target=_blank><h3>{{statusPanelCtrl.lookupByID(item.id).name}}</h3><p>{{item.error.status}} Error: {{item.error.statusText}}</p></div></md-list-item></md-list>");
$templateCache.put("app/components/dashboard/dashpanel/components/alert-feed/311AlertItem.tmpl.html","<md-dialog class=alert-item-container aria-label=\"Live Notification Feed Information\" flex=80 aria-label=\"311 alert item\"><md-toolbar ng-class=\"{\'bottom-margin\': !alert.description}\"><div class=md-toolbar-tools><div><h2>311 - {{alert.address}}</h2></div></div></md-toolbar><md-dialog-content class=\"md-dialog-content border-bottom\"><div class=md-dialog-content-body><h4 ng-show=alert.description>\"{{alert.description}}\"</h4><p><strong>Status:</strong> {{alert.status}}</p><p><strong>Status Notes:</strong> {{alert.status_notes}}</p><br><p><strong>Agency Responsible:</strong> {{alert.agency_responsible}}</p><p><strong>Time Notified:</strong> @ {{alert.notifyTime | date:\'yyyy/MM/dd HH:mm\'}}</p><p><strong>Time Requested:</strong> @ {{alert.requested_datetime | date:\'yyyy/MM/dd HH:mm\'}}</p><p><strong>Time Updated:</strong> @ {{alert.updated_datetime | date:\'yyyy/MM/dd HH:mm\'}}</p><ack-component alert-item=alert></ack-component></div></md-dialog-content><md-dialog-actions><md-button ng-click=close() md-autofocus class=md-primary>Close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dashboard/dashpanel/components/alert-feed/alertFeed.tmpl.html","<div class=\"md-whiteframe-1dp notification-head\" layout layout-align=\"space-between center\"><div class=loading layout=column layout-align=\"center center\"><md-progress-circular md-mode=indeterminate md-diameter=20 ng-show=\"afVm.isLoading() && afVm.initialized\"></md-progress-circular><md-icon ng-show=\"afVm.error && afVm.isLoading() && afVm.initialized\">error</md-icon></div><h4>Live Notification Feed</h4><div class=spacing-fix layout layout-align=\"space-between center\"><md-button class=md-icon-button ng-click=afVm.componentInfo($event)><md-icon>info</md-icon></md-button><md-button class=md-icon-button ng-show=afVm.isEmpty(afVm.onMapAlerts) ng-click=afVm.toggleMapAlerts(afVm.showMapAlerts)><md-icon class=on-map ng-class=\"{ \'inactive\' : !afVm.showMapAlerts }\">pin_drop</md-icon><md-tooltip md-direction=left md-delay=300>{{!afVm.showMapAlerts ? \'Show\' : \'Hide\'}} on Map</md-tooltip></md-button></div></div><span class=hide>{{afVm.dataset}}</span><md-content layout=column ng-if=\"afVm.dataset.length > 0\" flex><md-list class=md-dense flex><div ng-repeat=\"alert in afVm.dataset | inArray:afVm.types.selected:\'type\' as filteredAlerts\" ng-switch on=alert.type><md-list-item ng-switch-when=atx class=md-2-line><md-icon class=md-avatar-icon ng-class=afVm.getATXClass(alert)>{{alert.comment.includes(\"open\") ? \"add_circle\" : \"remove_circle\"}}</md-icon><div class=md-list-item-text layout=column><h3>{{alert.address}}</h3><h4>{{alert.comment}}</h4><p>Notified <span am-time-ago=alert.notifyTime><md-tooltip md-direction=top md-delay=1000>{{alert.notifyTime | date:\'yyyy/MM/dd HH:mm\'}}</md-tooltip></span>.</p></div><md-button ng-disabled=\"::(!alert.longitude || !alert.latitude)\" class=\"md-secondary md-icon-button\" ng-class=md-primary ng-click=\"afVm.flyToLocation([alert.latitude, alert.longitude])\" aria-label=\"locate on map\"><md-icon>place</md-icon></md-button><md-button class=\"md-secondary md-icon-button\" aria-label=\"view rule\" ng-click=\"afVm.itemInfo(alert, $event)\"><md-icon>info</md-icon></md-button><md-divider md-inset ng-if=!$last></md-divider></md-list-item><md-list-item ng-switch-when=_311 class=md-2-line><ack-component type=icon alert-item=alert></ack-component><md-icon class=\"md-avatar-icon threeoneone\">phone</md-icon><div class=md-list-item-text layout=column><h3>{{alert.address}}</h3><h4>{{alert.status}}</h4><p>Notified <span am-time-ago=alert.notifyTime><md-tooltip md-direction=top md-delay=1000>{{alert.notifyTime | date:\'yyyy/MM/dd HH:mm\'}}</md-tooltip></span>.</p></div><md-button ng-disabled=\"::(!alert.lat || !alert.long)\" class=\"md-secondary md-icon-button\" ng-class=md-primary ng-click=\"afVm.flyToLocation([alert.lat, alert.long])\" aria-label=\"locate on map\"><md-icon>place</md-icon></md-button><md-button class=\"md-secondary md-icon-button\" aria-label=\"view rule\" ng-click=\"afVm.itemInfo(alert, $event)\"><md-icon>info</md-icon></md-button><md-divider md-inset ng-if=!$last></md-divider></md-list-item><md-list-item ng-switch-when=structure class=md-2-line><md-icon class=md-avatar-icon ng-class=afVm.getStructureClass(alert)>{{afVm.getStructureIcon(alert)}}</md-icon><div class=md-list-item-text layout=column><h3>{{alert.streetAddress}}</h3><h4>{{afVm.getStructureTypeDisplay(alert)}}</h4><p>Last simulated <span am-time-ago=alert.simulationTime><md-tooltip md-direction=top md-delay=1000>{{alert.simulationTime | date:\'yyyy/MM/dd HH:mm\'}}</md-tooltip></span>.</p></div><md-button ng-disabled=\"::(!alert.latitude || !alert.longitude)\" class=\"md-secondary md-icon-button\" ng-class=md-primary ng-click=\"afVm.flyToLocation([alert.latitude, alert.longitude])\" aria-label=\"locate on map\"><md-icon>place</md-icon></md-button><md-button class=\"md-secondary md-icon-button\" aria-label=\"view rule\" ng-click=\"afVm.itemInfo(alert, $event)\"><md-icon>info</md-icon></md-button><md-divider md-inset ng-if=!$last></md-divider></md-list-item><md-list-item ng-switch-when=alert class=md-2-line><ack-component type=icon alert-item=alert></ack-component><md-icon class=md-avatar-icon ng-class=afVm.getStatus(alert)>{{ afVm.getIcon(alert)}}<md-tooltip>{{ afVm.getMessage(alert)}}</md-tooltip></md-icon><div class=md-list-item-text layout=column><h3>{{afVm.ruleMap[alert.ruleID].title}}</h3><h4 ng-if=::alert.aboveThresh>Crossing threshold at {{::alert.crossThreshAt | date:\'HH:mm on yyyy/MM/dd\'}}</h4><p>Notified <span am-time-ago=alert.notifyTime><md-tooltip md-direction=top md-delay=1000>{{alert.notifyTime | date:\'yyyy/MM/dd HH:mm\'}}</md-tooltip></span>.</p></div><md-button ng-disabled=::!alert.hasGeoJson class=\"md-secondary md-icon-button\" ng-class=\"{\'md-primary\' : afVm.equals(alert, afVm.selected)}\" ng-click=afVm.locateOnMap(alert) aria-label=\"locate on map\"><md-icon>place</md-icon></md-button><md-button class=\"md-secondary md-icon-button\" ng-click=\"afVm.itemInfo(alert, $event)\" aria-label=\"view rule\"><md-icon>info</md-icon></md-button><md-divider md-inset ng-if=!$last></md-divider></md-list-item><md-list-item ng-switch-default><h1>We missed something!</h1></md-list-item></div><md-list-item class=end ng-if=\"filteredAlerts.length > 0\">end of notifications</md-list-item><md-list-item ng-if=\"filteredAlerts.length === 0\"><h1>No results found...</h1></md-list-item></md-list></md-content><md-content layout=column ng-if=\"afVm.dataset.length === 0\" layout-align=\"center center\" flex><div class=no-alerts layout=column layout-align=\"center center\" ng-show=\"!afVm.isLoading() && afVm.initialized\"><md-icon>sentiment_very_satisfied</md-icon><p>No notifications at this time.</p></div><div class=loading layout=column layout-align=\"center center\" ng-show=\"afVm.isLoading() && !afVm.initialized\"><md-progress-circular md-mode=indeterminate md-diameter=40></md-progress-circular></div></md-content>");
$templateCache.put("app/components/dashboard/dashpanel/components/alert-feed/alertInfo.tmpl.html","<md-dialog class=nf-info-container aria-label=\"Live Notification Feed Information\"><md-dialog-content class=md-dialog-content><h2 class=md-title>Live Notification Feed Information</h2><div class=md-dialog-content-body><p>Checking for new notifications every <strong>{{nfiVm.checkFreq}} minute(s)</strong>.</p><p><strong>Check Start:</strong> {{nfiVm.dataTimes.start | date:\'HH:mm yyyy/MM/dd\'}}<br><strong>Check End:</strong> {{nfiVm.dataTimes.end | date:\'HH:mm yyyy/MM/dd\'}}</p><p>Total: {{afVm.dataset.length}} Notifcation(s)</p></div><fieldset class=feed-filter><legend class=filter-legend>Shown Feed Items</legend><div class=filter-all layout layout-wrap flex><div flex=50><md-checkbox ng-click=nfiVm.toggleAll() aria-label=\"Select All\" ng-checked=nfiVm.isChecked() md-indeterminate=nfiVm.isIndeterminate()><span ng-if=nfiVm.isChecked()>Un-</span>Select All</md-checkbox></div><div class=filter-items flex=100 ng-repeat=\"item in nfiVm.types.items\"><md-checkbox ng-checked=\"nfiVm.exists(item, nfiVm.types.selected)\" ng-click=\"nfiVm.toggle(item, nfiVm.types.selected)\" aria-label=item>{{ nfiVm.types.map[$index] }}</md-checkbox></div></div></fieldset></md-dialog-content><md-dialog-actions><md-button ng-click=nfiVm.close() md-autofocus class=md-primary>Close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dashboard/dashpanel/components/alert-feed/alertItem.tmpl.html","<md-dialog class=alert-item-container aria-label=\"Live Notification Feed Information\" flex=80><md-toolbar><div class=md-toolbar-tools><div><h2>{{afVm.ruleMap[alert.ruleID].title | limitTo : 96}}{{afVm.ruleMap[alert.ruleID].title.length > 96 ? \'...\' : \'\'}}</h2></div></div></md-toolbar><md-dialog-content class=md-dialog-content><div class=alert-chart><img ng-src={{afVm.selected.imageUrl}}></div><div class=md-dialog-content-body><h4>{{afVm.ruleMap[alert.ruleID].description}}</h4><p>{{afVm.ruleMap[alert.ruleID].source.displayName}} ({{afVm.ruleMap[alert.ruleID].source.id}})</p><p>Notification Time: {{alert.notifyTime | date:\'yyyy/MM/dd HH:mm\'}}</p><p ng-if=::alert.aboveThresh>Threshold Crossing Time: {{alert.crossThreshAt | date:\'yyyy/MM/dd HH:mm\'}}</p><p>Basin: {{afVm.basins[afVm.ruleMap[alert.ruleID].source.basin].description}}</p><p>Threshold: {{afVm.ruleMap[alert.ruleID].source.threshold}}</p>Input Data:<div class=data-types ng-repeat=\"item in afVm.ruleMap[alert.ruleID].source.inputs\">{{afVm.wps.dataTypeMap[item].displayName}} <strong ng-if=\"alert.dataType === afVm.wps.dataTypeMap[item].name\">- Alert Trigger</strong><span ng-if=!$last>,&nbsp;</span></div><ack-component alert-item=alert></ack-component></div></md-dialog-content><md-dialog-actions><md-button ng-click=close() md-autofocus class=md-primary>Close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dashboard/dashpanel/components/alert-feed/atxAlertItem.tmpl.html","<md-dialog class=alert-item-container aria-label=\"Live Notification Feed Information\" flex=80 aria-label=\"afd alert item\"><md-toolbar ng-class=\"{\'bottom-margin\': !alert.description}\"><div class=md-toolbar-tools><div><h2>ATX Alert - {{alert.name}}</h2></div></div></md-toolbar><md-dialog-content class=\"md-dialog-content border-bottom\"><div class=md-dialog-content-body><h4 ng-show=alert.comment>\"{{alert.comment}}\"</h4><p><strong>Address:</strong> {{alert.address}}</p><p><strong>Jurisdiction:</strong> {{alert.Jurisdiction}}</p><p><strong>Id:</strong> {{alert.id}}</p><p><strong>Open:</strong> {{alert.open}}</p><br><p><strong>Time Changed:</strong> @ {{alert.changedTime | date:\'yyyy/MM/dd HH:mm\'}}</p><p><strong>Time Notified:</strong> @ {{alert.notifyTime | date:\'yyyy/MM/dd HH:mm\'}}</p><p><strong>Time Updated:</strong> @ {{alert.updateTime | date:\'yyyy/MM/dd HH:mm\'}}</p></div></md-dialog-content><md-dialog-actions><md-button ng-click=close() md-autofocus class=md-primary>Close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dashboard/dashpanel/components/alert-feed/structureAlertItem.tmpl.html","<md-dialog class=alert-item-container aria-label=\"Live Notification Feed Information\" flex=80 aria-label=\"structure alert item\"><md-toolbar ng-class=\"{\'bottom-margin\': !alert.description}\"><div class=md-toolbar-tools><div><h2>Inundated Structure - {{alert.streetAddress}}</h2></div></div></md-toolbar><md-dialog-content class=\"md-dialog-content border-bottom\"><div class=md-dialog-content-body><h4>{{afVm.getStructureTypeDisplay(alert)}}</h4><p><strong>Id:</strong> {{alert.id}}</p><p><strong>Basin:</strong> {{alert.basin}}</p><div ng-show=\"alert.structureType == \'building\'\"><p><strong>Damage Estimate:</strong> {{alert.damageEstimate}}</p><p><strong>Area (sq ft):</strong> {{alert.areaSqFt}}</p><p><strong>Depth (ft):</strong> {{alert.depth}}</p><p><strong>First Floor Elevation (ft):</strong> {{alert.ffeFt}}</p></div><div ng-show=\"alert.structureType == \'bridge\'\"><p><strong>Status:</strong> {{afVm.getBridgeStatusDisplay(alert)}}</p><p><strong>Depth (ft):</strong> {{alert.depth}}</p><p><strong>Low Chord (ft):</strong> {{alert.lowChordFt}}</p><p><strong>High Chord (ft):</strong> {{alert.highChordFt}}</p></div><br><p><strong>Time Simulated:</strong> @ {{alert.simulationTime | date:\'yyyy/MM/dd HH:mm\'}}</p></div></md-dialog-content><md-dialog-actions><md-button ng-click=close() md-autofocus class=md-primary>Close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dashboard/dashpanel/components/watchpoints/infoDialog.tmpl.html","<md-dialog class=wp-info-dialog layout=column aria-label=\"WatchPoint Info\" flex=90 flex-lg=75 flex-xl=60 ng-class=\"{\'small\':wpInfoVm.mdMedia(\'max-width: 800px\')}\"><md-dialog-content flex ng-hide=wpInfoVm.ready class=loading layout=column layout-align=\"center center\"><md-progress-circular md-diameter=40></md-progress-circular></md-dialog-content><md-dialog-content layout=column ng-show=wpInfoVm.ready flex><md-content flex><div class=header layout layout-align=\"space-between center\"><div class=title><h3>{{wpInfoVm.point.displayName}}</h3><p><span>{{wpInfoVm.point.id}}</span><span>{{wpInfoVm.basinDisplayName}}</span>{{wpInfoVm.point.owner}}</p></div><div class=secondary-elements layout layout-align=\"center center\"><md-button class=md-icon-button download ng-href=\"{{wpInfoVm.imageUrl}}&style=COMPLICATED&height=720&width=1280&download=true&accesstoken={{wpInfoVm.accesstoken}}\"><md-icon>file_download</md-icon><md-tooltip md-direction=left>download chart</md-tooltip></md-button><md-switch ng-model=wpInfoVm.interactive.show ng-change=wpInfoVm.switchChart() aria-label=Interactive>Interactive</md-switch></div></div><div id=wp-chart class=md-whiteframe-1dp layout layout-align=\"center center\"><img ng-hide=wpInfoVm.interactive.show src=assets/images/loading_icon.gif ng-src=\"{{wpInfoVm.endpoint.url}}.png?style=COMPLICATED&{{wpInfoVm.endpoint.static}}&height=300&width={{wpInfoVm.chartWidth}}{{wpInfoVm.cacheControl}}&accesstoken={{wpInfoVm.accesstoken}}\" err-src=assets/images/error_icon.png><md-progress-circular md-diameter=40 ng-show=\"wpInfoVm.interactive.show && !wpInfoVm.interactive.ready\"></md-progress-circular><div ng-show=\"wpInfoVm.interactive.show && wpInfoVm.interactive.ready\" id=c3Hydro flex></div></div><!-- <md-divider></md-divider> --><div class=point-table-container><md-list class=point-table><md-list-item class=md-1-line><div class=md-list-item-text><span>Status:</span> {{wpInfoVm.point.currentStatus}}<md-divider></md-divider></div></md-list-item><md-list-item class=md-2-line ng-repeat=\"item in wpInfoVm.point.maximums\"><div class=md-list-item-text><h3>{{item.displayName}}: {{item.max}} {{item.units}}</h3></div><div class=md-secondary><span>Time of Max:</span> {{item.timeOfMax | date:\'HH:mm\'}}<md-tooltip>{{item.timeOfMax | date:\'MM/dd/yyyy HH:mm\'}}</md-tooltip></div><md-divider ng-hide=$last></md-divider></md-list-item></md-list></div></md-content><md-divider></md-divider></md-dialog-content><md-dialog-actions><md-button ng-click=wpInfoVm.mdDialog.hide() class=md-primary>Close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dashboard/dashpanel/components/watchpoints/watchpoints.tmpl.html","<md-content id=wp-container class=hover-scrollbar ng-class=\"{\'blurred\':!wpVm.windowFocus}\" flex><div class=hero-wp ng-if=\"wpVm.$mdMedia(\'gt-xs\')\"><div class=header layout layout-align=\"space-between center\"><p>{{wpVm.selected.displayName}}</p><div layout><md-button class=\"md-icon-button sort-button\" aria-label=\"Open Sort Menu\" ng-click=wpVm.openSortMenu($event)><md-icon class=sort-icon ng-class=\"{ \'gray\' : (wpVm.sortOptions.selected.value === \'sortStatus\' && wpVm.sortOptions.direction === true) }\">sort</md-icon><md-tooltip>Open Sort Menu</md-tooltip></md-button><md-button ng-click=\"wpVm.showGrid = !wpVm.showGrid\" class=md-icon-button><md-icon>{{wpVm.showGrid ? \'grid_off\' : \'grid_on\'}}</md-icon><md-tooltip>{{wpVm.showGrid ? \'Turn Grid Off\' : \'Turn Grid On\'}}</md-tooltip></md-button></div></div><div class=\"md-whiteframe-1dp chart\"><img src=assets/images/loading_icon.gif ng-if=!wpVm.loadingNewTime height=150 ng-src=\"{{wpVm.selected.endpoint.url}}.{{wpVm.wpGIF?(\'gif?style=THUMBNAILGIF&\'+wpVm.selected.endpoint.ani):(\'png?style=THUMBNAIL&\'+wpVm.selected.endpoint.static)}}&height=150&width={{wpVm.container.width - 42}}{{wpVm.cacheControl}}&accesstoken={{wpVm.accesstoken}}\" err-src=assets/images/error_icon.png><div ng-hide=!wpVm.selected.id class=button-container layout=column layout-align=space-between><div layout=row layout-align=\"center center\" class=watchpoints-hover><md-button class=md-fab aria-label=Play/Pause ng-click=\"wpVm.wpGIF = !wpVm.wpGIF\"><md-icon>{{wpVm.wpGIF ? \'pause\' : \'play_arrow\'}}</md-icon><md-tooltip>{{wpVm.wpGIF ? \'Pause\' : \'Play\'}}</md-tooltip></md-button><md-button class=md-fab aria-label=\"More Info\" ng-click=\"wpVm.infoDialog(wpVm.selected, $event)\"><md-icon>info_outline</md-icon><md-tooltip>More Info</md-tooltip></md-button><md-button class=md-fab aria-label=\"Locate on Map\" ng-click=wpVm.locateOnMap(wpVm.selected)><md-icon>place</md-icon><md-tooltip>Locate on Map</md-tooltip></md-button><md-button class=md-fab aria-label=Download download ng-href=\"{{wpVm.selected.endpoint.url}}.png?style=COMPLICATED&height=720&width=1280&download=true{{\r\n            wpVm.replay.isActive() ? (\'&start=\' + wpVm.timeParams.static.start + \'&end=\' + wpVm.timeParams.static.end + \'&fakeNow=\' + wpVm.timeParams.static.fakeNow) : \'\'}}&accesstoken={{wpVm.accesstoken}}\"><md-icon>file_download</md-icon><md-tooltip>Download</md-tooltip></md-button></div><watchpoints-legend data=wpVm.selected dtmap=wpVm.dataTypeMap></watchpoints-legend></div></div></div><div class=\"md-whiteframe-1dp inner-container list\" ng-hide=\"wpVm.showGrid && wpVm.$mdMedia(\'gt-xs\')\" layout=column flex><md-list class=md-dense><md-list-item ng-repeat=\"point in wpVm.watchPoints | orderBy:wpVm.sortOptions.selected.value:wpVm.sortOptions.direction\" ng-click=\"wpVm.selectPoint(point, $event)\" ng-class=\"[(\'status-\' + point.status), (point.id === wpVm.selected.id ? \'selected\' : \'\')]\"><p>{{point.displayName}}</p><md-divider ng-if=!$last></md-divider></md-list-item></md-list></div><div class=\"inner-container grid\" ng-show=\"wpVm.showGrid && wpVm.$mdMedia(\'gt-xs\')\" layout-wrap layout layout-align=\"space-between center\"><md-button ng-click=\"wpVm.selectPoint(point, $event)\" class=\"md-whiteframe-1dp wp-image wp-alert a-{{point.sortStatus}}\" ng-repeat=\"point in wpVm.watchPoints | orderBy:wpVm.sortOptions.selected.value:wpVm.sortOptions.direction\" ng-style=\"{\'width\':(wpVm.thumbsWidth() + \'px\')}\" ng-class=\"point.id === wpVm.selected.id ? \'selected\' : \'\'\" aria-label=\"{{point.displayName}} WatchPoint\"><img src=assets/images/clear.gif ng-src={{wpVm.thumbsUrl()}}{{wpVm.cacheControl}} err-src=assets/images/error_icon.png ng-if=!wpVm.loadingNewTime ng-style=\"{ \'margin-top\':(-75 * point.spriteOrder) + \'px\' }\"><div class=name layout layout-align=\"start center\"><span flex>{{point.displayName}}</span></div></md-button></div></md-content>");
$templateCache.put("app/components/dashboard/dashpanel/components/watchpoints/selected-point/selected.tmpl.html","<div class=title layout layout-align=\"start center\"><div flex>{{vm.point.displayName}} <span ng-if=vm.point.hasError>Error</span></div><!-- <div class=\"button-container\">\r\n    <md-button class=\"md-icon-button\" ng-click=\"angular.foo()\"><md-icon>file_download</md-icon></md-button>\r\n      <md-button class=\"md-icon-button\" ng-click=\"angular.foo()\"><md-icon>fullscreen</md-icon></md-button>\r\n  </div> --></div><div ng-hide=\"vm.loading || vm.point.hasError\" id=wp-chart flex></div><div ng-show=vm.loading class=loading layout layout-align=\"center center\"><md-progress-circular md-mode=indeterminate md-diameter=40></md-progress-circular></div><div ng-show=vm.point.hasError class=error layout=column layout-align=\"center center\"><md-icon>error</md-icon><p>An error has occurred<br>while loading this watchpoint</p></div>");
$templateCache.put("app/components/dashboard/dashpanel/components/watchpoints/watchpoints-legend/wp-legend.tmpl.html","<div class=wp-legend-container layout-align=end><ul class=wp-legend><li class=\"wp-legend--item {{wpLegendVm.dtMap[type].name|lowercase}} {{$last && $even ? \'full\' : \'half\'}}\" ng-repeat=\"type in wpLegendVm.types\">{{wpLegendVm.dtMap[type].displayName}}</li></ul></div>");}]);